const tokens = {
  "breakpoints.sm": {
    "value": "20em",
    "variable": "var(--breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "30em",
    "variable": "var(--breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "48em",
    "variable": "var(--breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "64em",
    "variable": "var(--breakpoints-xl)"
  },
  "breakpoints.xxl": {
    "value": "80em",
    "variable": "var(--breakpoints-xxl)"
  },
  "sizes.breakpoint-sm": {
    "value": "20em",
    "variable": "var(--sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "30em",
    "variable": "var(--sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "48em",
    "variable": "var(--sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "64em",
    "variable": "var(--sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-xxl": {
    "value": "80em",
    "variable": "var(--sizes-breakpoint-xxl)"
  },
  "spacing.-25": {
    "value": "var(--spacing-25)",
    "variable": "var(--spacing-25)"
  },
  "spacing.-50": {
    "value": "var(--spacing-50)",
    "variable": "var(--spacing-50)"
  },
  "spacing.-100": {
    "value": "var(--spacing-100)",
    "variable": "var(--spacing-100)"
  },
  "spacing.-150": {
    "value": "var(--spacing-150)",
    "variable": "var(--spacing-150)"
  },
  "spacing.-200": {
    "value": "var(--spacing-200)",
    "variable": "var(--spacing-200)"
  },
  "spacing.-250": {
    "value": "var(--spacing-250)",
    "variable": "var(--spacing-250)"
  },
  "spacing.-300": {
    "value": "var(--spacing-300)",
    "variable": "var(--spacing-300)"
  },
  "spacing.-350": {
    "value": "var(--spacing-350)",
    "variable": "var(--spacing-350)"
  },
  "spacing.-400": {
    "value": "var(--spacing-400)",
    "variable": "var(--spacing-400)"
  },
  "spacing.-500": {
    "value": "var(--spacing-500)",
    "variable": "var(--spacing-500)"
  },
  "spacing.-600": {
    "value": "var(--spacing-600)",
    "variable": "var(--spacing-600)"
  },
  "spacing.-700": {
    "value": "var(--spacing-700)",
    "variable": "var(--spacing-700)"
  },
  "spacing.-800": {
    "value": "var(--spacing-800)",
    "variable": "var(--spacing-800)"
  },
  "spacing.-900": {
    "value": "var(--spacing-900)",
    "variable": "var(--spacing-900)"
  },
  "spacing.-1000": {
    "value": "var(--spacing-1000)",
    "variable": "var(--spacing-1000)"
  },
  "spacing.-1100": {
    "value": "var(--spacing-1100)",
    "variable": "var(--spacing-1100)"
  },
  "spacing.-1200": {
    "value": "var(--spacing-1200)",
    "variable": "var(--spacing-1200)"
  },
  "spacing.-1300": {
    "value": "var(--spacing-1300)",
    "variable": "var(--spacing-1300)"
  },
  "spacing.-1400": {
    "value": "var(--spacing-1400)",
    "variable": "var(--spacing-1400)"
  },
  "spacing.-1500": {
    "value": "var(--spacing-1500)",
    "variable": "var(--spacing-1500)"
  },
  "spacing.-1600": {
    "value": "var(--spacing-1600)",
    "variable": "var(--spacing-1600)"
  },
  "spacing.-1800": {
    "value": "var(--spacing-1800)",
    "variable": "var(--spacing-1800)"
  },
  "spacing.-2400": {
    "value": "var(--spacing-2400)",
    "variable": "var(--spacing-2400)"
  },
  "spacing.-negative-25": {
    "value": "var(--spacing-negative-25)",
    "variable": "var(--spacing-negative-25)"
  },
  "spacing.-zero": {
    "value": "var(--spacing-zero)",
    "variable": "var(--spacing-zero)"
  },
  "spacing.Accordion.gap.-header-toPanel": {
    "value": "var(--spacing--accordion-gap-header-to-panel)",
    "variable": "var(--spacing--accordion-gap-header-to-panel)"
  },
  "spacing.Accordion.gap.-betweenAccordions": {
    "value": "var(--spacing--accordion-gap-between-accordions)",
    "variable": "var(--spacing--accordion-gap-between-accordions)"
  },
  "spacing.Accordion.Header.gap.-leading": {
    "value": "var(--spacing--accordion--header-gap-leading)",
    "variable": "var(--spacing--accordion--header-gap-leading)"
  },
  "spacing.Accordion.Header.gap.-trailing": {
    "value": "var(--spacing--accordion--header-gap-trailing)",
    "variable": "var(--spacing--accordion--header-gap-trailing)"
  },
  "spacing.Accordion.Header.gap.-trailingLabel-toIcon": {
    "value": "var(--spacing--accordion--header-gap-trailing-label-to-icon)",
    "variable": "var(--spacing--accordion--header-gap-trailing-label-to-icon)"
  },
  "spacing.Accordion.Header.padding.-horz": {
    "value": "var(--spacing--accordion--header-padding-horz)",
    "variable": "var(--spacing--accordion--header-padding-horz)"
  },
  "spacing.Accordion.Header.padding.-vert": {
    "value": "var(--spacing--accordion--header-padding-vert)",
    "variable": "var(--spacing--accordion--header-padding-vert)"
  },
  "spacing.Accordion.Panel.padding.-horz": {
    "value": "var(--spacing--accordion--panel-padding-horz)",
    "variable": "var(--spacing--accordion--panel-padding-horz)"
  },
  "spacing.Accordion.Panel.padding.-top": {
    "value": "var(--spacing--accordion--panel-padding-top)",
    "variable": "var(--spacing--accordion--panel-padding-top)"
  },
  "spacing.Accordion.Panel.padding.-bottom": {
    "value": "var(--spacing--accordion--panel-padding-bottom)",
    "variable": "var(--spacing--accordion--panel-padding-bottom)"
  },
  "spacing.AdornedInput.sm.gap.-input-toAdornment": {
    "value": "var(--spacing--adorned-input-sm-gap-input-to-adornment)",
    "variable": "var(--spacing--adorned-input-sm-gap-input-to-adornment)"
  },
  "spacing.AdornedInput.sm.padding.-horz": {
    "value": "var(--spacing--adorned-input-sm-padding-horz)",
    "variable": "var(--spacing--adorned-input-sm-padding-horz)"
  },
  "spacing.AdornedInput.sm.padding.-horz-readOnly": {
    "value": "var(--spacing--adorned-input-sm-padding-horz-read-only)",
    "variable": "var(--spacing--adorned-input-sm-padding-horz-read-only)"
  },
  "spacing.AdornedInput.sm.padding.-vert": {
    "value": "var(--spacing--adorned-input-sm-padding-vert)",
    "variable": "var(--spacing--adorned-input-sm-padding-vert)"
  },
  "spacing.AdornedInput.md.gap.-input-toAdornment": {
    "value": "var(--spacing--adorned-input-md-gap-input-to-adornment)",
    "variable": "var(--spacing--adorned-input-md-gap-input-to-adornment)"
  },
  "spacing.AdornedInput.md.padding.-horz": {
    "value": "var(--spacing--adorned-input-md-padding-horz)",
    "variable": "var(--spacing--adorned-input-md-padding-horz)"
  },
  "spacing.AdornedInput.md.padding.-horz-readOnly": {
    "value": "var(--spacing--adorned-input-md-padding-horz-read-only)",
    "variable": "var(--spacing--adorned-input-md-padding-horz-read-only)"
  },
  "spacing.AdornedInput.md.padding.-vert": {
    "value": "var(--spacing--adorned-input-md-padding-vert)",
    "variable": "var(--spacing--adorned-input-md-padding-vert)"
  },
  "spacing.AdornedInput.lg.gap.-input-toAdornment": {
    "value": "var(--spacing--adorned-input-lg-gap-input-to-adornment)",
    "variable": "var(--spacing--adorned-input-lg-gap-input-to-adornment)"
  },
  "spacing.AdornedInput.lg.padding.-horz": {
    "value": "var(--spacing--adorned-input-lg-padding-horz)",
    "variable": "var(--spacing--adorned-input-lg-padding-horz)"
  },
  "spacing.AdornedInput.lg.padding.-horz-readOnly": {
    "value": "var(--spacing--adorned-input-lg-padding-horz-read-only)",
    "variable": "var(--spacing--adorned-input-lg-padding-horz-read-only)"
  },
  "spacing.AdornedInput.lg.padding.-vert": {
    "value": "var(--spacing--adorned-input-lg-padding-vert)",
    "variable": "var(--spacing--adorned-input-lg-padding-vert)"
  },
  "spacing.Alert.gap.-content-toActions": {
    "value": "var(--spacing--alert-gap-content-to-actions)",
    "variable": "var(--spacing--alert-gap-content-to-actions)"
  },
  "spacing.Alert.gap.-leading": {
    "value": "var(--spacing--alert-gap-leading)",
    "variable": "var(--spacing--alert-gap-leading)"
  },
  "spacing.Alert.gap.-trailing": {
    "value": "var(--spacing--alert-gap-trailing)",
    "variable": "var(--spacing--alert-gap-trailing)"
  },
  "spacing.Alert.gap.message.-toFlexArea": {
    "value": "var(--spacing--alert-gap-message-to-flex-area)",
    "variable": "var(--spacing--alert-gap-message-to-flex-area)"
  },
  "spacing.Alert.padding.-horz": {
    "value": "var(--spacing--alert-padding-horz)",
    "variable": "var(--spacing--alert-padding-horz)"
  },
  "spacing.Alert.padding.-vert": {
    "value": "var(--spacing--alert-padding-vert)",
    "variable": "var(--spacing--alert-padding-vert)"
  },
  "spacing.Alert.CloseButton.margin.-top": {
    "value": "var(--spacing--alert--close-button-margin-top)",
    "variable": "var(--spacing--alert--close-button-margin-top)"
  },
  "spacing.Alert.CloseButton.margin.-right": {
    "value": "var(--spacing--alert--close-button-margin-right)",
    "variable": "var(--spacing--alert--close-button-margin-right)"
  },
  "spacing.Anchor.-icon-toLabel": {
    "value": "var(--spacing--anchor-icon-to-label)",
    "variable": "var(--spacing--anchor-icon-to-label)"
  },
  "spacing.Avatar.Badge.padding.sm.-default": {
    "value": "var(--spacing--avatar--badge-padding-sm-default)",
    "variable": "var(--spacing--avatar--badge-padding-sm-default)"
  },
  "spacing.Avatar.Badge.padding.sm.-bare": {
    "value": "var(--spacing--avatar--badge-padding-sm-bare)",
    "variable": "var(--spacing--avatar--badge-padding-sm-bare)"
  },
  "spacing.Avatar.Badge.padding.md.-default": {
    "value": "var(--spacing--avatar--badge-padding-md-default)",
    "variable": "var(--spacing--avatar--badge-padding-md-default)"
  },
  "spacing.Avatar.Badge.padding.md.-bare": {
    "value": "var(--spacing--avatar--badge-padding-md-bare)",
    "variable": "var(--spacing--avatar--badge-padding-md-bare)"
  },
  "spacing.Avatar.Badge.padding.lg.-default": {
    "value": "var(--spacing--avatar--badge-padding-lg-default)",
    "variable": "var(--spacing--avatar--badge-padding-lg-default)"
  },
  "spacing.Avatar.Badge.padding.lg.-bare": {
    "value": "var(--spacing--avatar--badge-padding-lg-bare)",
    "variable": "var(--spacing--avatar--badge-padding-lg-bare)"
  },
  "spacing.Avatar.Badge.offset.sm.-horz": {
    "value": "var(--spacing--avatar--badge-offset-sm-horz)",
    "variable": "var(--spacing--avatar--badge-offset-sm-horz)"
  },
  "spacing.Avatar.Badge.offset.sm.-vert": {
    "value": "var(--spacing--avatar--badge-offset-sm-vert)",
    "variable": "var(--spacing--avatar--badge-offset-sm-vert)"
  },
  "spacing.Avatar.Badge.offset.md.-horz": {
    "value": "var(--spacing--avatar--badge-offset-md-horz)",
    "variable": "var(--spacing--avatar--badge-offset-md-horz)"
  },
  "spacing.Avatar.Badge.offset.md.-vert": {
    "value": "var(--spacing--avatar--badge-offset-md-vert)",
    "variable": "var(--spacing--avatar--badge-offset-md-vert)"
  },
  "spacing.Avatar.Badge.offset.lg.-horz": {
    "value": "var(--spacing--avatar--badge-offset-lg-horz)",
    "variable": "var(--spacing--avatar--badge-offset-lg-horz)"
  },
  "spacing.Avatar.Badge.offset.lg.-vert": {
    "value": "var(--spacing--avatar--badge-offset-lg-vert)",
    "variable": "var(--spacing--avatar--badge-offset-lg-vert)"
  },
  "spacing.Badge.gap.-label-toIcon": {
    "value": "var(--spacing--badge-gap-label-to-icon)",
    "variable": "var(--spacing--badge-gap-label-to-icon)"
  },
  "spacing.Badge.padding.-horz": {
    "value": "var(--spacing--badge-padding-horz)",
    "variable": "var(--spacing--badge-padding-horz)"
  },
  "spacing.Badge.padding.-vert": {
    "value": "var(--spacing--badge-padding-vert)",
    "variable": "var(--spacing--badge-padding-vert)"
  },
  "spacing.Banner.gap.-leading": {
    "value": "var(--spacing--banner-gap-leading)",
    "variable": "var(--spacing--banner-gap-leading)"
  },
  "spacing.Banner.gap.-trailing": {
    "value": "var(--spacing--banner-gap-trailing)",
    "variable": "var(--spacing--banner-gap-trailing)"
  },
  "spacing.Banner.gap.text-toActions.-horz": {
    "value": "var(--spacing--banner-gap-text-to-actions-horz)",
    "variable": "var(--spacing--banner-gap-text-to-actions-horz)"
  },
  "spacing.Banner.gap.text-toActions.-vert": {
    "value": "var(--spacing--banner-gap-text-to-actions-vert)",
    "variable": "var(--spacing--banner-gap-text-to-actions-vert)"
  },
  "spacing.Banner.padding.-horz": {
    "value": "var(--spacing--banner-padding-horz)",
    "variable": "var(--spacing--banner-padding-horz)"
  },
  "spacing.Banner.padding.-vert": {
    "value": "var(--spacing--banner-padding-vert)",
    "variable": "var(--spacing--banner-padding-vert)"
  },
  "spacing.Banner.CloseButton.margin.-top": {
    "value": "var(--spacing--banner--close-button-margin-top)",
    "variable": "var(--spacing--banner--close-button-margin-top)"
  },
  "spacing.Banner.CloseButton.margin.-right": {
    "value": "var(--spacing--banner--close-button-margin-right)",
    "variable": "var(--spacing--banner--close-button-margin-right)"
  },
  "spacing.ButtonGroup.gap.-horz": {
    "value": "var(--spacing--button-group-gap-horz)",
    "variable": "var(--spacing--button-group-gap-horz)"
  },
  "spacing.ButtonGroup.gap.-vert": {
    "value": "var(--spacing--button-group-gap-vert)",
    "variable": "var(--spacing--button-group-gap-vert)"
  },
  "spacing.ButtonGroup.conjoined.gap.-default": {
    "value": "var(--spacing--button-group-conjoined-gap-default)",
    "variable": "var(--spacing--button-group-conjoined-gap-default)"
  },
  "spacing.ButtonGroup.conjoined.gap.-offsetBorder": {
    "value": "var(--spacing--button-group-conjoined-gap-offset-border)",
    "variable": "var(--spacing--button-group-conjoined-gap-offset-border)"
  },
  "spacing.ButtonGroup.bare.gap.-horz": {
    "value": "var(--spacing--button-group-bare-gap-horz)",
    "variable": "var(--spacing--button-group-bare-gap-horz)"
  },
  "spacing.ButtonGroup.bare.gap.-vert": {
    "value": "var(--spacing--button-group-bare-gap-vert)",
    "variable": "var(--spacing--button-group-bare-gap-vert)"
  },
  "spacing.ButtonGroup.textButton.padding.padding.-horz": {
    "value": "var(--spacing--button-group-text-button-padding-padding-horz)",
    "variable": "var(--spacing--button-group-text-button-padding-padding-horz)"
  },
  "spacing.ButtonGroup.textButton.padding.padding.-vert": {
    "value": "var(--spacing--button-group-text-button-padding-padding-vert)",
    "variable": "var(--spacing--button-group-text-button-padding-padding-vert)"
  },
  "spacing.Button.xs.gap.-label-toIcon": {
    "value": "var(--spacing--button-xs-gap-label-to-icon)",
    "variable": "var(--spacing--button-xs-gap-label-to-icon)"
  },
  "spacing.Button.xs.padding.-horz": {
    "value": "var(--spacing--button-xs-padding-horz)",
    "variable": "var(--spacing--button-xs-padding-horz)"
  },
  "spacing.Button.xs.padding.-vert": {
    "value": "var(--spacing--button-xs-padding-vert)",
    "variable": "var(--spacing--button-xs-padding-vert)"
  },
  "spacing.Button.sm.gap.-label-toIcon": {
    "value": "var(--spacing--button-sm-gap-label-to-icon)",
    "variable": "var(--spacing--button-sm-gap-label-to-icon)"
  },
  "spacing.Button.sm.padding.bare.-horz": {
    "value": "var(--spacing--button-sm-padding-bare-horz)",
    "variable": "var(--spacing--button-sm-padding-bare-horz)"
  },
  "spacing.Button.sm.padding.-horz": {
    "value": "var(--spacing--button-sm-padding-horz)",
    "variable": "var(--spacing--button-sm-padding-horz)"
  },
  "spacing.Button.sm.padding.-vert": {
    "value": "var(--spacing--button-sm-padding-vert)",
    "variable": "var(--spacing--button-sm-padding-vert)"
  },
  "spacing.Button.md.gap.-label-toIcon": {
    "value": "var(--spacing--button-md-gap-label-to-icon)",
    "variable": "var(--spacing--button-md-gap-label-to-icon)"
  },
  "spacing.Button.md.padding.bare.-horz": {
    "value": "var(--spacing--button-md-padding-bare-horz)",
    "variable": "var(--spacing--button-md-padding-bare-horz)"
  },
  "spacing.Button.md.padding.-horz": {
    "value": "var(--spacing--button-md-padding-horz)",
    "variable": "var(--spacing--button-md-padding-horz)"
  },
  "spacing.Button.md.padding.-vert": {
    "value": "var(--spacing--button-md-padding-vert)",
    "variable": "var(--spacing--button-md-padding-vert)"
  },
  "spacing.Button.lg.gap.-label-toIcon": {
    "value": "var(--spacing--button-lg-gap-label-to-icon)",
    "variable": "var(--spacing--button-lg-gap-label-to-icon)"
  },
  "spacing.Button.lg.padding.bare.-horz": {
    "value": "var(--spacing--button-lg-padding-bare-horz)",
    "variable": "var(--spacing--button-lg-padding-bare-horz)"
  },
  "spacing.Button.lg.padding.-horz": {
    "value": "var(--spacing--button-lg-padding-horz)",
    "variable": "var(--spacing--button-lg-padding-horz)"
  },
  "spacing.Button.lg.padding.-vert": {
    "value": "var(--spacing--button-lg-padding-vert)",
    "variable": "var(--spacing--button-lg-padding-vert)"
  },
  "spacing.Calendar.Body.gap.-header-toDays": {
    "value": "var(--spacing--calendar--body-gap-header-to-days)",
    "variable": "var(--spacing--calendar--body-gap-header-to-days)"
  },
  "spacing.Calendar.Body.padding.-horz": {
    "value": "var(--spacing--calendar--body-padding-horz)",
    "variable": "var(--spacing--calendar--body-padding-horz)"
  },
  "spacing.Calendar.Controls.-gap": {
    "value": "var(--spacing--calendar--controls-gap)",
    "variable": "var(--spacing--calendar--controls-gap)"
  },
  "spacing.Calendar.Controls.padding.-horz": {
    "value": "var(--spacing--calendar--controls-padding-horz)",
    "variable": "var(--spacing--calendar--controls-padding-horz)"
  },
  "spacing.Calendar.DayOfWeek.padding.-bottom": {
    "value": "var(--spacing--calendar--day-of-week-padding-bottom)",
    "variable": "var(--spacing--calendar--day-of-week-padding-bottom)"
  },
  "spacing.Calendar.Day.margin.-horz": {
    "value": "var(--spacing--calendar--day-margin-horz)",
    "variable": "var(--spacing--calendar--day-margin-horz)"
  },
  "spacing.Calendar.Day.margin.-vert": {
    "value": "var(--spacing--calendar--day-margin-vert)",
    "variable": "var(--spacing--calendar--day-margin-vert)"
  },
  "spacing.Calendar.Root.gap.-controls-toBody": {
    "value": "var(--spacing--calendar--root-gap-controls-to-body)",
    "variable": "var(--spacing--calendar--root-gap-controls-to-body)"
  },
  "spacing.Calendar.YearSelect.padding.-left": {
    "value": "var(--spacing--calendar--year-select-padding-left)",
    "variable": "var(--spacing--calendar--year-select-padding-left)"
  },
  "spacing.Calendar.YearSelect.gap.-select-toButton": {
    "value": "var(--spacing--calendar--year-select-gap-select-to-button)",
    "variable": "var(--spacing--calendar--year-select-gap-select-to-button)"
  },
  "spacing.Card.Footer.margin.-to-Body": {
    "value": "var(--spacing--card--footer-margin-to--body)",
    "variable": "var(--spacing--card--footer-margin-to--body)"
  },
  "spacing.Card.Footer.padding.-from-Footer": {
    "value": "var(--spacing--card--footer-padding-from--footer)",
    "variable": "var(--spacing--card--footer-padding-from--footer)"
  },
  "spacing.Card.Header.margin.-to-Body": {
    "value": "var(--spacing--card--header-margin-to--body)",
    "variable": "var(--spacing--card--header-margin-to--body)"
  },
  "spacing.Card.Header.padding.-from-Header": {
    "value": "var(--spacing--card--header-padding-from--header)",
    "variable": "var(--spacing--card--header-padding-from--header)"
  },
  "spacing.Card.Root.-padding": {
    "value": "var(--spacing--card--root-padding)",
    "variable": "var(--spacing--card--root-padding)"
  },
  "spacing.Carousel.Heading.gap.-heading-toNav": {
    "value": "var(--spacing--carousel--heading-gap-heading-to-nav)",
    "variable": "var(--spacing--carousel--heading-gap-heading-to-nav)"
  },
  "spacing.Carousel.Heading.gap.-heading-toDescription": {
    "value": "var(--spacing--carousel--heading-gap-heading-to-description)",
    "variable": "var(--spacing--carousel--heading-gap-heading-to-description)"
  },
  "spacing.Carousel.Heading.gap.-betweenNav": {
    "value": "var(--spacing--carousel--heading-gap-between-nav)",
    "variable": "var(--spacing--carousel--heading-gap-between-nav)"
  },
  "spacing.Carousel.Heading.padding.-headingArea-toSlideArray": {
    "value": "var(--spacing--carousel--heading-padding-heading-area-to-slide-array)",
    "variable": "var(--spacing--carousel--heading-padding-heading-area-to-slide-array)"
  },
  "spacing.Carousel.Root.-gap-carousel-toButton": {
    "value": "var(--spacing--carousel--root-gap-carousel-to-button)",
    "variable": "var(--spacing--carousel--root-gap-carousel-to-button)"
  },
  "spacing.Carousel.SkipLink.-margin": {
    "value": "var(--spacing--carousel--skip-link-margin)",
    "variable": "var(--spacing--carousel--skip-link-margin)"
  },
  "spacing.Carousel.SlideArray.padding.-top": {
    "value": "var(--spacing--carousel--slide-array-padding-top)",
    "variable": "var(--spacing--carousel--slide-array-padding-top)"
  },
  "spacing.Carousel.SlideArray.padding.-bottom": {
    "value": "var(--spacing--carousel--slide-array-padding-bottom)",
    "variable": "var(--spacing--carousel--slide-array-padding-bottom)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.none.-padding-horz": {
    "value": "var(--spacing--carousel--slide-array-scroll-offset-none-padding-horz)",
    "variable": "var(--spacing--carousel--slide-array-scroll-offset-none-padding-horz)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.xs.-padding-horz": {
    "value": "var(--spacing--carousel--slide-array-scroll-offset-xs-padding-horz)",
    "variable": "var(--spacing--carousel--slide-array-scroll-offset-xs-padding-horz)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.sm.-padding-horz": {
    "value": "var(--spacing--carousel--slide-array-scroll-offset-sm-padding-horz)",
    "variable": "var(--spacing--carousel--slide-array-scroll-offset-sm-padding-horz)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.md.-padding-horz": {
    "value": "var(--spacing--carousel--slide-array-scroll-offset-md-padding-horz)",
    "variable": "var(--spacing--carousel--slide-array-scroll-offset-md-padding-horz)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.lg.-padding-horz": {
    "value": "var(--spacing--carousel--slide-array-scroll-offset-lg-padding-horz)",
    "variable": "var(--spacing--carousel--slide-array-scroll-offset-lg-padding-horz)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.xl.-padding-horz": {
    "value": "var(--spacing--carousel--slide-array-scroll-offset-xl-padding-horz)",
    "variable": "var(--spacing--carousel--slide-array-scroll-offset-xl-padding-horz)"
  },
  "spacing.Carousel.SlideArray.slideGap.-xxs": {
    "value": "var(--spacing--carousel--slide-array-slide-gap-xxs)",
    "variable": "var(--spacing--carousel--slide-array-slide-gap-xxs)"
  },
  "spacing.Carousel.SlideArray.slideGap.-xs": {
    "value": "var(--spacing--carousel--slide-array-slide-gap-xs)",
    "variable": "var(--spacing--carousel--slide-array-slide-gap-xs)"
  },
  "spacing.Carousel.SlideArray.slideGap.-sm": {
    "value": "var(--spacing--carousel--slide-array-slide-gap-sm)",
    "variable": "var(--spacing--carousel--slide-array-slide-gap-sm)"
  },
  "spacing.Carousel.SlideArray.slideGap.-md": {
    "value": "var(--spacing--carousel--slide-array-slide-gap-md)",
    "variable": "var(--spacing--carousel--slide-array-slide-gap-md)"
  },
  "spacing.Carousel.SlideArray.slideGap.-lg": {
    "value": "var(--spacing--carousel--slide-array-slide-gap-lg)",
    "variable": "var(--spacing--carousel--slide-array-slide-gap-lg)"
  },
  "spacing.Carousel.SlideArray.slideGap.-xl": {
    "value": "var(--spacing--carousel--slide-array-slide-gap-xl)",
    "variable": "var(--spacing--carousel--slide-array-slide-gap-xl)"
  },
  "spacing.ChipGroup.gap.-horz": {
    "value": "var(--spacing--chip-group-gap-horz)",
    "variable": "var(--spacing--chip-group-gap-horz)"
  },
  "spacing.ChipGroup.gap.vert.-default": {
    "value": "var(--spacing--chip-group-gap-vert-default)",
    "variable": "var(--spacing--chip-group-gap-vert-default)"
  },
  "spacing.ChipGroup.gap.vert.-tighter": {
    "value": "var(--spacing--chip-group-gap-vert-tighter)",
    "variable": "var(--spacing--chip-group-gap-vert-tighter)"
  },
  "spacing.ChipGroup.padding.-horz": {
    "value": "var(--spacing--chip-group-padding-horz)",
    "variable": "var(--spacing--chip-group-padding-horz)"
  },
  "spacing.ChipGroup.padding.-vert": {
    "value": "var(--spacing--chip-group-padding-vert)",
    "variable": "var(--spacing--chip-group-padding-vert)"
  },
  "spacing.ChipGroup.padding.screen.-leading": {
    "value": "var(--spacing--chip-group-padding-screen-leading)",
    "variable": "var(--spacing--chip-group-padding-screen-leading)"
  },
  "spacing.ChipGroup.padding.screen.-trailing": {
    "value": "var(--spacing--chip-group-padding-screen-trailing)",
    "variable": "var(--spacing--chip-group-padding-screen-trailing)"
  },
  "spacing.Chip.padding.-horz": {
    "value": "var(--spacing--chip-padding-horz)",
    "variable": "var(--spacing--chip-padding-horz)"
  },
  "spacing.Chip.padding.-vert": {
    "value": "var(--spacing--chip-padding-vert)",
    "variable": "var(--spacing--chip-padding-vert)"
  },
  "spacing.Chip.gap.-leading": {
    "value": "var(--spacing--chip-gap-leading)",
    "variable": "var(--spacing--chip-gap-leading)"
  },
  "spacing.Chip.gap.-trailing": {
    "value": "var(--spacing--chip-gap-trailing)",
    "variable": "var(--spacing--chip-gap-trailing)"
  },
  "spacing.Chip.gap.-inputChip-trailing": {
    "value": "var(--spacing--chip-gap-input-chip-trailing)",
    "variable": "var(--spacing--chip-gap-input-chip-trailing)"
  },
  "spacing.Chip.Close.margin.-left": {
    "value": "var(--spacing--chip--close-margin-left)",
    "variable": "var(--spacing--chip--close-margin-left)"
  },
  "spacing.Chip.Close.-padding": {
    "value": "var(--spacing--chip--close-padding)",
    "variable": "var(--spacing--chip--close-padding)"
  },
  "spacing.CloseButton.-padding": {
    "value": "var(--spacing--close-button-padding)",
    "variable": "var(--spacing--close-button-padding)"
  },
  "spacing.CloseButton.-margin": {
    "value": "var(--spacing--close-button-margin)",
    "variable": "var(--spacing--close-button-margin)"
  },
  "spacing.Combobox.ChipsOverflow.trailingTextArea.gap.-limitNumber-toText": {
    "value": "var(--spacing--combobox--chips-overflow-trailing-text-area-gap-limit-number-to-text)",
    "variable": "var(--spacing--combobox--chips-overflow-trailing-text-area-gap-limit-number-to-text)"
  },
  "spacing.Combobox.Clear.margin.-horz": {
    "value": "var(--spacing--combobox--clear-margin-horz)",
    "variable": "var(--spacing--combobox--clear-margin-horz)"
  },
  "spacing.Combobox.Heading.gap.-leading": {
    "value": "var(--spacing--combobox--heading-gap-leading)",
    "variable": "var(--spacing--combobox--heading-gap-leading)"
  },
  "spacing.Combobox.Heading.padding.-horz": {
    "value": "var(--spacing--combobox--heading-padding-horz)",
    "variable": "var(--spacing--combobox--heading-padding-horz)"
  },
  "spacing.Combobox.Heading.padding.-vert": {
    "value": "var(--spacing--combobox--heading-padding-vert)",
    "variable": "var(--spacing--combobox--heading-padding-vert)"
  },
  "spacing.Combobox.Option.gap.-leading": {
    "value": "var(--spacing--combobox--option-gap-leading)",
    "variable": "var(--spacing--combobox--option-gap-leading)"
  },
  "spacing.Combobox.Option.padding.-horz": {
    "value": "var(--spacing--combobox--option-padding-horz)",
    "variable": "var(--spacing--combobox--option-padding-horz)"
  },
  "spacing.Combobox.Option.padding.-vert": {
    "value": "var(--spacing--combobox--option-padding-vert)",
    "variable": "var(--spacing--combobox--option-padding-vert)"
  },
  "spacing.Combobox.Trigger.sm.gap.-close-toSelect": {
    "value": "var(--spacing--combobox--trigger-sm-gap-close-to-select)",
    "variable": "var(--spacing--combobox--trigger-sm-gap-close-to-select)"
  },
  "spacing.Combobox.Trigger.sm.gap.-default": {
    "value": "var(--spacing--combobox--trigger-sm-gap-default)",
    "variable": "var(--spacing--combobox--trigger-sm-gap-default)"
  },
  "spacing.Combobox.Trigger.sm.gap.-trailing": {
    "value": "var(--spacing--combobox--trigger-sm-gap-trailing)",
    "variable": "var(--spacing--combobox--trigger-sm-gap-trailing)"
  },
  "spacing.Combobox.Trigger.sm.padding.-horz": {
    "value": "var(--spacing--combobox--trigger-sm-padding-horz)",
    "variable": "var(--spacing--combobox--trigger-sm-padding-horz)"
  },
  "spacing.Combobox.Trigger.sm.padding.-vert": {
    "value": "var(--spacing--combobox--trigger-sm-padding-vert)",
    "variable": "var(--spacing--combobox--trigger-sm-padding-vert)"
  },
  "spacing.Combobox.Trigger.md.gap.-close-toSelect": {
    "value": "var(--spacing--combobox--trigger-md-gap-close-to-select)",
    "variable": "var(--spacing--combobox--trigger-md-gap-close-to-select)"
  },
  "spacing.Combobox.Trigger.md.gap.-default": {
    "value": "var(--spacing--combobox--trigger-md-gap-default)",
    "variable": "var(--spacing--combobox--trigger-md-gap-default)"
  },
  "spacing.Combobox.Trigger.md.gap.-trailing": {
    "value": "var(--spacing--combobox--trigger-md-gap-trailing)",
    "variable": "var(--spacing--combobox--trigger-md-gap-trailing)"
  },
  "spacing.Combobox.Trigger.md.padding.-horz": {
    "value": "var(--spacing--combobox--trigger-md-padding-horz)",
    "variable": "var(--spacing--combobox--trigger-md-padding-horz)"
  },
  "spacing.Combobox.Trigger.md.padding.-vert": {
    "value": "var(--spacing--combobox--trigger-md-padding-vert)",
    "variable": "var(--spacing--combobox--trigger-md-padding-vert)"
  },
  "spacing.Combobox.Trigger.lg.gap.-close-toSelect": {
    "value": "var(--spacing--combobox--trigger-lg-gap-close-to-select)",
    "variable": "var(--spacing--combobox--trigger-lg-gap-close-to-select)"
  },
  "spacing.Combobox.Trigger.lg.gap.-default": {
    "value": "var(--spacing--combobox--trigger-lg-gap-default)",
    "variable": "var(--spacing--combobox--trigger-lg-gap-default)"
  },
  "spacing.Combobox.Trigger.lg.gap.-trailing": {
    "value": "var(--spacing--combobox--trigger-lg-gap-trailing)",
    "variable": "var(--spacing--combobox--trigger-lg-gap-trailing)"
  },
  "spacing.Combobox.Trigger.lg.padding.-horz": {
    "value": "var(--spacing--combobox--trigger-lg-padding-horz)",
    "variable": "var(--spacing--combobox--trigger-lg-padding-horz)"
  },
  "spacing.Combobox.Trigger.lg.padding.-vert": {
    "value": "var(--spacing--combobox--trigger-lg-padding-vert)",
    "variable": "var(--spacing--combobox--trigger-lg-padding-vert)"
  },
  "spacing.DateInput.sm.gap.-input-toAdornment": {
    "value": "var(--spacing--date-input-sm-gap-input-to-adornment)",
    "variable": "var(--spacing--date-input-sm-gap-input-to-adornment)"
  },
  "spacing.DateInput.sm.gap.-leading": {
    "value": "var(--spacing--date-input-sm-gap-leading)",
    "variable": "var(--spacing--date-input-sm-gap-leading)"
  },
  "spacing.DateInput.sm.gap.-trailing": {
    "value": "var(--spacing--date-input-sm-gap-trailing)",
    "variable": "var(--spacing--date-input-sm-gap-trailing)"
  },
  "spacing.DateInput.sm.padding.-horz": {
    "value": "var(--spacing--date-input-sm-padding-horz)",
    "variable": "var(--spacing--date-input-sm-padding-horz)"
  },
  "spacing.DateInput.sm.padding.-horz-readOnly": {
    "value": "var(--spacing--date-input-sm-padding-horz-read-only)",
    "variable": "var(--spacing--date-input-sm-padding-horz-read-only)"
  },
  "spacing.DateInput.sm.padding.-vert": {
    "value": "var(--spacing--date-input-sm-padding-vert)",
    "variable": "var(--spacing--date-input-sm-padding-vert)"
  },
  "spacing.DateInput.md.gap.-input-toAdornment": {
    "value": "var(--spacing--date-input-md-gap-input-to-adornment)",
    "variable": "var(--spacing--date-input-md-gap-input-to-adornment)"
  },
  "spacing.DateInput.md.gap.-leading": {
    "value": "var(--spacing--date-input-md-gap-leading)",
    "variable": "var(--spacing--date-input-md-gap-leading)"
  },
  "spacing.DateInput.md.gap.-trailing": {
    "value": "var(--spacing--date-input-md-gap-trailing)",
    "variable": "var(--spacing--date-input-md-gap-trailing)"
  },
  "spacing.DateInput.md.padding.-horz": {
    "value": "var(--spacing--date-input-md-padding-horz)",
    "variable": "var(--spacing--date-input-md-padding-horz)"
  },
  "spacing.DateInput.md.padding.-horz-readOnly": {
    "value": "var(--spacing--date-input-md-padding-horz-read-only)",
    "variable": "var(--spacing--date-input-md-padding-horz-read-only)"
  },
  "spacing.DateInput.md.padding.-vert": {
    "value": "var(--spacing--date-input-md-padding-vert)",
    "variable": "var(--spacing--date-input-md-padding-vert)"
  },
  "spacing.DateInput.lg.gap.-input-toAdornment": {
    "value": "var(--spacing--date-input-lg-gap-input-to-adornment)",
    "variable": "var(--spacing--date-input-lg-gap-input-to-adornment)"
  },
  "spacing.DateInput.lg.gap.-leading": {
    "value": "var(--spacing--date-input-lg-gap-leading)",
    "variable": "var(--spacing--date-input-lg-gap-leading)"
  },
  "spacing.DateInput.lg.gap.-trailing": {
    "value": "var(--spacing--date-input-lg-gap-trailing)",
    "variable": "var(--spacing--date-input-lg-gap-trailing)"
  },
  "spacing.DateInput.lg.padding.-horz": {
    "value": "var(--spacing--date-input-lg-padding-horz)",
    "variable": "var(--spacing--date-input-lg-padding-horz)"
  },
  "spacing.DateInput.lg.padding.-horz-readOnly": {
    "value": "var(--spacing--date-input-lg-padding-horz-read-only)",
    "variable": "var(--spacing--date-input-lg-padding-horz-read-only)"
  },
  "spacing.DateInput.lg.padding.-vert": {
    "value": "var(--spacing--date-input-lg-padding-vert)",
    "variable": "var(--spacing--date-input-lg-padding-vert)"
  },
  "spacing.DateInput.HelperArea.gap.-icon-toText": {
    "value": "var(--spacing--date-input--helper-area-gap-icon-to-text)",
    "variable": "var(--spacing--date-input--helper-area-gap-icon-to-text)"
  },
  "spacing.DatePicker.Backdrop.padding.default.-horz": {
    "value": "var(--spacing--date-picker--backdrop-padding-default-horz)",
    "variable": "var(--spacing--date-picker--backdrop-padding-default-horz)"
  },
  "spacing.DatePicker.Backdrop.padding.default.-vert": {
    "value": "var(--spacing--date-picker--backdrop-padding-default-vert)",
    "variable": "var(--spacing--date-picker--backdrop-padding-default-vert)"
  },
  "spacing.DatePicker.Content.padding.-vert": {
    "value": "var(--spacing--date-picker--content-padding-vert)",
    "variable": "var(--spacing--date-picker--content-padding-vert)"
  },
  "spacing.DatePicker.Content.padding.-horz": {
    "value": "var(--spacing--date-picker--content-padding-horz)",
    "variable": "var(--spacing--date-picker--content-padding-horz)"
  },
  "spacing.DatePicker.Footer.padding.-gap-toContent": {
    "value": "var(--spacing--date-picker--footer-padding-gap-to-content)",
    "variable": "var(--spacing--date-picker--footer-padding-gap-to-content)"
  },
  "spacing.DatePicker.Trigger.padding.sm.-horz": {
    "value": "var(--spacing--date-picker--trigger-padding-sm-horz)",
    "variable": "var(--spacing--date-picker--trigger-padding-sm-horz)"
  },
  "spacing.DatePicker.Trigger.padding.md.-horz": {
    "value": "var(--spacing--date-picker--trigger-padding-md-horz)",
    "variable": "var(--spacing--date-picker--trigger-padding-md-horz)"
  },
  "spacing.DatePicker.Trigger.padding.lg.-horz": {
    "value": "var(--spacing--date-picker--trigger-padding-lg-horz)",
    "variable": "var(--spacing--date-picker--trigger-padding-lg-horz)"
  },
  "spacing.DateTimeBlock.Root.gap.-toLabel": {
    "value": "var(--spacing--date-time-block--root-gap-to-label)",
    "variable": "var(--spacing--date-time-block--root-gap-to-label)"
  },
  "spacing.DateTimeBlock.Root.gap.-toTime": {
    "value": "var(--spacing--date-time-block--root-gap-to-time)",
    "variable": "var(--spacing--date-time-block--root-gap-to-time)"
  },
  "spacing.DateTimeBlock.Dates.gap.-toCard": {
    "value": "var(--spacing--date-time-block--dates-gap-to-card)",
    "variable": "var(--spacing--date-time-block--dates-gap-to-card)"
  },
  "spacing.DateTimeBlock.Dates.gap.-toNav": {
    "value": "var(--spacing--date-time-block--dates-gap-to-nav)",
    "variable": "var(--spacing--date-time-block--dates-gap-to-nav)"
  },
  "spacing.DateTimeBlock.Day.padding.-horz": {
    "value": "var(--spacing--date-time-block--day-padding-horz)",
    "variable": "var(--spacing--date-time-block--day-padding-horz)"
  },
  "spacing.DateTimeBlock.Day.padding.-vert": {
    "value": "var(--spacing--date-time-block--day-padding-vert)",
    "variable": "var(--spacing--date-time-block--day-padding-vert)"
  },
  "spacing.DateTimeBlock.Wrap.padding.horz.-outer": {
    "value": "var(--spacing--date-time-block--wrap-padding-horz-outer)",
    "variable": "var(--spacing--date-time-block--wrap-padding-horz-outer)"
  },
  "spacing.DateTimeBlock.Wrap.padding.horz.-inner": {
    "value": "var(--spacing--date-time-block--wrap-padding-horz-inner)",
    "variable": "var(--spacing--date-time-block--wrap-padding-horz-inner)"
  },
  "spacing.Dropdown.Body.padding.-horz": {
    "value": "var(--spacing--dropdown--body-padding-horz)",
    "variable": "var(--spacing--dropdown--body-padding-horz)"
  },
  "spacing.Dropdown.Body.padding.-vert": {
    "value": "var(--spacing--dropdown--body-padding-vert)",
    "variable": "var(--spacing--dropdown--body-padding-vert)"
  },
  "spacing.Dropdown.Footer.padding.-horz": {
    "value": "var(--spacing--dropdown--footer-padding-horz)",
    "variable": "var(--spacing--dropdown--footer-padding-horz)"
  },
  "spacing.Dropdown.Footer.padding.-vert": {
    "value": "var(--spacing--dropdown--footer-padding-vert)",
    "variable": "var(--spacing--dropdown--footer-padding-vert)"
  },
  "spacing.Dropdown.Heading.gap.-leading": {
    "value": "var(--spacing--dropdown--heading-gap-leading)",
    "variable": "var(--spacing--dropdown--heading-gap-leading)"
  },
  "spacing.Dropdown.Heading.padding.-horz": {
    "value": "var(--spacing--dropdown--heading-padding-horz)",
    "variable": "var(--spacing--dropdown--heading-padding-horz)"
  },
  "spacing.Dropdown.Heading.padding.-vert": {
    "value": "var(--spacing--dropdown--heading-padding-vert)",
    "variable": "var(--spacing--dropdown--heading-padding-vert)"
  },
  "spacing.FieldSet.gap.-controls-toHelperArea": {
    "value": "var(--spacing--field-set-gap-controls-to-helper-area)",
    "variable": "var(--spacing--field-set-gap-controls-to-helper-area)"
  },
  "spacing.FieldSet.gap.-controls-toLegendArea": {
    "value": "var(--spacing--field-set-gap-controls-to-legend-area)",
    "variable": "var(--spacing--field-set-gap-controls-to-legend-area)"
  },
  "spacing.FieldSet.helperArea.gap.-text-toIcon": {
    "value": "var(--spacing--field-set-helper-area-gap-text-to-icon)",
    "variable": "var(--spacing--field-set-helper-area-gap-text-to-icon)"
  },
  "spacing.FieldSet.labelArea.gap.-legend-toRequred": {
    "value": "var(--spacing--field-set-label-area-gap-legend-to-requred)",
    "variable": "var(--spacing--field-set-label-area-gap-legend-to-requred)"
  },
  "spacing.FieldSet.labelArea.gap.-legend-toOptional": {
    "value": "var(--spacing--field-set-label-area-gap-legend-to-optional)",
    "variable": "var(--spacing--field-set-label-area-gap-legend-to-optional)"
  },
  "spacing.FieldSet.labeledControlArea.gap.-vert": {
    "value": "var(--spacing--field-set-labeled-control-area-gap-vert)",
    "variable": "var(--spacing--field-set-labeled-control-area-gap-vert)"
  },
  "spacing.FieldSet.labeledControlArea.padding.-left": {
    "value": "var(--spacing--field-set-labeled-control-area-padding-left)",
    "variable": "var(--spacing--field-set-labeled-control-area-padding-left)"
  },
  "spacing.FormField.gap.-field-toHelperArea": {
    "value": "var(--spacing--form-field-gap-field-to-helper-area)",
    "variable": "var(--spacing--form-field-gap-field-to-helper-area)"
  },
  "spacing.FormField.gap.-field-toLabelArea": {
    "value": "var(--spacing--form-field-gap-field-to-label-area)",
    "variable": "var(--spacing--form-field-gap-field-to-label-area)"
  },
  "spacing.FormField.HelperArea.gap.-icon-toText": {
    "value": "var(--spacing--form-field--helper-area-gap-icon-to-text)",
    "variable": "var(--spacing--form-field--helper-area-gap-icon-to-text)"
  },
  "spacing.FormField.labelArea.gap.-label-toRequired": {
    "value": "var(--spacing--form-field-label-area-gap-label-to-required)",
    "variable": "var(--spacing--form-field-label-area-gap-label-to-required)"
  },
  "spacing.FormField.labelArea.gap.-label-toOptional": {
    "value": "var(--spacing--form-field-label-area-gap-label-to-optional)",
    "variable": "var(--spacing--form-field-label-area-gap-label-to-optional)"
  },
  "spacing.Form.FormActions.-marginTop": {
    "value": "var(--spacing--form--form-actions-margin-top)",
    "variable": "var(--spacing--form--form-actions-margin-top)"
  },
  "spacing.Form.FormField.-marginBottom": {
    "value": "var(--spacing--form--form-field-margin-bottom)",
    "variable": "var(--spacing--form--form-field-margin-bottom)"
  },
  "spacing.Form.FieldSet.-marginBottom": {
    "value": "var(--spacing--form--field-set-margin-bottom)",
    "variable": "var(--spacing--form--field-set-margin-bottom)"
  },
  "spacing.Gleam.padding.-horz": {
    "value": "var(--spacing--gleam-padding-horz)",
    "variable": "var(--spacing--gleam-padding-horz)"
  },
  "spacing.IconButton.xs.-padding": {
    "value": "var(--spacing--icon-button-xs-padding)",
    "variable": "var(--spacing--icon-button-xs-padding)"
  },
  "spacing.IconButton.sm.-padding": {
    "value": "var(--spacing--icon-button-sm-padding)",
    "variable": "var(--spacing--icon-button-sm-padding)"
  },
  "spacing.IconButton.md.-padding": {
    "value": "var(--spacing--icon-button-md-padding)",
    "variable": "var(--spacing--icon-button-md-padding)"
  },
  "spacing.IconButton.lg.-padding": {
    "value": "var(--spacing--icon-button-lg-padding)",
    "variable": "var(--spacing--icon-button-lg-padding)"
  },
  "spacing.InlineFeedback.gap.-icon-toText": {
    "value": "var(--spacing--inline-feedback-gap-icon-to-text)",
    "variable": "var(--spacing--inline-feedback-gap-icon-to-text)"
  },
  "spacing.Input.HelperArea.gap.-icon-toText": {
    "value": "var(--spacing--input--helper-area-gap-icon-to-text)",
    "variable": "var(--spacing--input--helper-area-gap-icon-to-text)"
  },
  "spacing.Input.sm.gap.-leading": {
    "value": "var(--spacing--input-sm-gap-leading)",
    "variable": "var(--spacing--input-sm-gap-leading)"
  },
  "spacing.Input.sm.gap.-trailing": {
    "value": "var(--spacing--input-sm-gap-trailing)",
    "variable": "var(--spacing--input-sm-gap-trailing)"
  },
  "spacing.Input.sm.padding.-horz": {
    "value": "var(--spacing--input-sm-padding-horz)",
    "variable": "var(--spacing--input-sm-padding-horz)"
  },
  "spacing.Input.sm.padding.-horz-readOnly": {
    "value": "var(--spacing--input-sm-padding-horz-read-only)",
    "variable": "var(--spacing--input-sm-padding-horz-read-only)"
  },
  "spacing.Input.sm.padding.-vert": {
    "value": "var(--spacing--input-sm-padding-vert)",
    "variable": "var(--spacing--input-sm-padding-vert)"
  },
  "spacing.Input.md.gap.-leading": {
    "value": "var(--spacing--input-md-gap-leading)",
    "variable": "var(--spacing--input-md-gap-leading)"
  },
  "spacing.Input.md.gap.-trailing": {
    "value": "var(--spacing--input-md-gap-trailing)",
    "variable": "var(--spacing--input-md-gap-trailing)"
  },
  "spacing.Input.md.padding.-horz": {
    "value": "var(--spacing--input-md-padding-horz)",
    "variable": "var(--spacing--input-md-padding-horz)"
  },
  "spacing.Input.md.padding.-horz-readOnly": {
    "value": "var(--spacing--input-md-padding-horz-read-only)",
    "variable": "var(--spacing--input-md-padding-horz-read-only)"
  },
  "spacing.Input.md.padding.-vert": {
    "value": "var(--spacing--input-md-padding-vert)",
    "variable": "var(--spacing--input-md-padding-vert)"
  },
  "spacing.Input.lg.gap.-leading": {
    "value": "var(--spacing--input-lg-gap-leading)",
    "variable": "var(--spacing--input-lg-gap-leading)"
  },
  "spacing.Input.lg.gap.-trailing": {
    "value": "var(--spacing--input-lg-gap-trailing)",
    "variable": "var(--spacing--input-lg-gap-trailing)"
  },
  "spacing.Input.lg.padding.-horz": {
    "value": "var(--spacing--input-lg-padding-horz)",
    "variable": "var(--spacing--input-lg-padding-horz)"
  },
  "spacing.Input.lg.padding.-horz-readOnly": {
    "value": "var(--spacing--input-lg-padding-horz-read-only)",
    "variable": "var(--spacing--input-lg-padding-horz-read-only)"
  },
  "spacing.Input.lg.padding.-vert": {
    "value": "var(--spacing--input-lg-padding-vert)",
    "variable": "var(--spacing--input-lg-padding-vert)"
  },
  "spacing.LabeledControl.gap.-control-toLabel": {
    "value": "var(--spacing--labeled-control-gap-control-to-label)",
    "variable": "var(--spacing--labeled-control-gap-control-to-label)"
  },
  "spacing.LabeledControl.padding.vert.-control": {
    "value": "var(--spacing--labeled-control-padding-vert-control)",
    "variable": "var(--spacing--labeled-control-padding-vert-control)"
  },
  "spacing.LabeledControl.padding.vert.-label": {
    "value": "var(--spacing--labeled-control-padding-vert-label)",
    "variable": "var(--spacing--labeled-control-padding-vert-label)"
  },
  "spacing.LabeledControl.padding.vert.switch.-md": {
    "value": "var(--spacing--labeled-control-padding-vert-switch-md)",
    "variable": "var(--spacing--labeled-control-padding-vert-switch-md)"
  },
  "spacing.LabeledControl.padding.vert.switch.-lg": {
    "value": "var(--spacing--labeled-control-padding-vert-switch-lg)",
    "variable": "var(--spacing--labeled-control-padding-vert-switch-lg)"
  },
  "spacing.LabeledInput.LabelArea.padding.top.-default": {
    "value": "var(--spacing--labeled-input--label-area-padding-top-default)",
    "variable": "var(--spacing--labeled-input--label-area-padding-top-default)"
  },
  "spacing.LabeledInput.LabelArea.padding.top.-active": {
    "value": "var(--spacing--labeled-input--label-area-padding-top-active)",
    "variable": "var(--spacing--labeled-input--label-area-padding-top-active)"
  },
  "spacing.LabeledInput.padding.-horz": {
    "value": "var(--spacing--labeled-input-padding-horz)",
    "variable": "var(--spacing--labeled-input-padding-horz)"
  },
  "spacing.LabeledInput.padding.-horz-readOnly": {
    "value": "var(--spacing--labeled-input-padding-horz-read-only)",
    "variable": "var(--spacing--labeled-input-padding-horz-read-only)"
  },
  "spacing.LabeledInput.padding.-top": {
    "value": "var(--spacing--labeled-input-padding-top)",
    "variable": "var(--spacing--labeled-input-padding-top)"
  },
  "spacing.LabeledInput.padding.-bottom": {
    "value": "var(--spacing--labeled-input-padding-bottom)",
    "variable": "var(--spacing--labeled-input-padding-bottom)"
  },
  "spacing.Layout.Content.-padding": {
    "value": "var(--spacing--layout--content-padding)",
    "variable": "var(--spacing--layout--content-padding)"
  },
  "spacing.Layout.Root.-gap": {
    "value": "var(--spacing--layout--root-gap)",
    "variable": "var(--spacing--layout--root-gap)"
  },
  "spacing.List.Item.padding.-horz": {
    "value": "var(--spacing--list--item-padding-horz)",
    "variable": "var(--spacing--list--item-padding-horz)"
  },
  "spacing.List.Item.padding.-vert": {
    "value": "var(--spacing--list--item-padding-vert)",
    "variable": "var(--spacing--list--item-padding-vert)"
  },
  "spacing.List.Item.padding.first.-top": {
    "value": "var(--spacing--list--item-padding-first-top)",
    "variable": "var(--spacing--list--item-padding-first-top)"
  },
  "spacing.List.Item.padding.last.-bottom": {
    "value": "var(--spacing--list--item-padding-last-bottom)",
    "variable": "var(--spacing--list--item-padding-last-bottom)"
  },
  "spacing.List.padding.-nested-horz": {
    "value": "var(--spacing--list-padding-nested-horz)",
    "variable": "var(--spacing--list-padding-nested-horz)"
  },
  "spacing.List.group-gap.-default": {
    "value": "var(--spacing--list-group-gap-default)",
    "variable": "var(--spacing--list-group-gap-default)"
  },
  "spacing.Menu.Heading.gap.-leading": {
    "value": "var(--spacing--menu--heading-gap-leading)",
    "variable": "var(--spacing--menu--heading-gap-leading)"
  },
  "spacing.Menu.Heading.padding.-horz": {
    "value": "var(--spacing--menu--heading-padding-horz)",
    "variable": "var(--spacing--menu--heading-padding-horz)"
  },
  "spacing.Menu.Heading.padding.-vert": {
    "value": "var(--spacing--menu--heading-padding-vert)",
    "variable": "var(--spacing--menu--heading-padding-vert)"
  },
  "spacing.Menu.Item.gap.-leading": {
    "value": "var(--spacing--menu--item-gap-leading)",
    "variable": "var(--spacing--menu--item-gap-leading)"
  },
  "spacing.Menu.Item.padding.-horz": {
    "value": "var(--spacing--menu--item-padding-horz)",
    "variable": "var(--spacing--menu--item-padding-horz)"
  },
  "spacing.Menu.Item.padding.-vert": {
    "value": "var(--spacing--menu--item-padding-vert)",
    "variable": "var(--spacing--menu--item-padding-vert)"
  },
  "spacing.Modal.Backdrop.padding.default.-horz": {
    "value": "var(--spacing--modal--backdrop-padding-default-horz)",
    "variable": "var(--spacing--modal--backdrop-padding-default-horz)"
  },
  "spacing.Modal.Backdrop.padding.default.-vert": {
    "value": "var(--spacing--modal--backdrop-padding-default-vert)",
    "variable": "var(--spacing--modal--backdrop-padding-default-vert)"
  },
  "spacing.Modal.Backdrop.padding.fullScreen.-horz": {
    "value": "var(--spacing--modal--backdrop-padding-full-screen-horz)",
    "variable": "var(--spacing--modal--backdrop-padding-full-screen-horz)"
  },
  "spacing.Modal.Backdrop.padding.fullScreen.-vert": {
    "value": "var(--spacing--modal--backdrop-padding-full-screen-vert)",
    "variable": "var(--spacing--modal--backdrop-padding-full-screen-vert)"
  },
  "spacing.Modal.Body.padding.-horz": {
    "value": "var(--spacing--modal--body-padding-horz)",
    "variable": "var(--spacing--modal--body-padding-horz)"
  },
  "spacing.Modal.Body.padding.-vert": {
    "value": "var(--spacing--modal--body-padding-vert)",
    "variable": "var(--spacing--modal--body-padding-vert)"
  },
  "spacing.Modal.CloseButton.margin.-top": {
    "value": "var(--spacing--modal--close-button-margin-top)",
    "variable": "var(--spacing--modal--close-button-margin-top)"
  },
  "spacing.Modal.CloseButton.margin.-right": {
    "value": "var(--spacing--modal--close-button-margin-right)",
    "variable": "var(--spacing--modal--close-button-margin-right)"
  },
  "spacing.Modal.Content.-offset": {
    "value": "var(--spacing--modal--content-offset)",
    "variable": "var(--spacing--modal--content-offset)"
  },
  "spacing.Modal.Footer.padding.-horz": {
    "value": "var(--spacing--modal--footer-padding-horz)",
    "variable": "var(--spacing--modal--footer-padding-horz)"
  },
  "spacing.Modal.Footer.padding.-vert": {
    "value": "var(--spacing--modal--footer-padding-vert)",
    "variable": "var(--spacing--modal--footer-padding-vert)"
  },
  "spacing.Modal.Header.padding.-left": {
    "value": "var(--spacing--modal--header-padding-left)",
    "variable": "var(--spacing--modal--header-padding-left)"
  },
  "spacing.Modal.Header.padding.-vert": {
    "value": "var(--spacing--modal--header-padding-vert)",
    "variable": "var(--spacing--modal--header-padding-vert)"
  },
  "spacing.Modal.Header.padding.-right": {
    "value": "var(--spacing--modal--header-padding-right)",
    "variable": "var(--spacing--modal--header-padding-right)"
  },
  "spacing.NumberRating.gap.-star-toNumber": {
    "value": "var(--spacing--number-rating-gap-star-to-number)",
    "variable": "var(--spacing--number-rating-gap-star-to-number)"
  },
  "spacing.Page.padding.horz.-desktop": {
    "value": "var(--spacing--page-padding-horz-desktop)",
    "variable": "var(--spacing--page-padding-horz-desktop)"
  },
  "spacing.Page.padding.horz.-tablet": {
    "value": "var(--spacing--page-padding-horz-tablet)",
    "variable": "var(--spacing--page-padding-horz-tablet)"
  },
  "spacing.Page.padding.horz.-mobile": {
    "value": "var(--spacing--page-padding-horz-mobile)",
    "variable": "var(--spacing--page-padding-horz-mobile)"
  },
  "spacing.Page.padding.-bottom": {
    "value": "var(--spacing--page-padding-bottom)",
    "variable": "var(--spacing--page-padding-bottom)"
  },
  "spacing.Page.Breadcrumb.margin.top.-desktop": {
    "value": "var(--spacing--page--breadcrumb-margin-top-desktop)",
    "variable": "var(--spacing--page--breadcrumb-margin-top-desktop)"
  },
  "spacing.Page.Breadcrumb.margin.top.-tablet": {
    "value": "var(--spacing--page--breadcrumb-margin-top-tablet)",
    "variable": "var(--spacing--page--breadcrumb-margin-top-tablet)"
  },
  "spacing.Page.Breadcrumb.margin.top.-mobile": {
    "value": "var(--spacing--page--breadcrumb-margin-top-mobile)",
    "variable": "var(--spacing--page--breadcrumb-margin-top-mobile)"
  },
  "spacing.Page.Breadcrumb.margin.-bottom": {
    "value": "var(--spacing--page--breadcrumb-margin-bottom)",
    "variable": "var(--spacing--page--breadcrumb-margin-bottom)"
  },
  "spacing.Page.Content.margin.vert.-desktop": {
    "value": "var(--spacing--page--content-margin-vert-desktop)",
    "variable": "var(--spacing--page--content-margin-vert-desktop)"
  },
  "spacing.Page.Content.margin.vert.-tablet": {
    "value": "var(--spacing--page--content-margin-vert-tablet)",
    "variable": "var(--spacing--page--content-margin-vert-tablet)"
  },
  "spacing.Page.Content.margin.vert.-mobile": {
    "value": "var(--spacing--page--content-margin-vert-mobile)",
    "variable": "var(--spacing--page--content-margin-vert-mobile)"
  },
  "spacing.Page.Header.margin.bottom.-desktop": {
    "value": "var(--spacing--page--header-margin-bottom-desktop)",
    "variable": "var(--spacing--page--header-margin-bottom-desktop)"
  },
  "spacing.Page.Header.margin.bottom.-tablet": {
    "value": "var(--spacing--page--header-margin-bottom-tablet)",
    "variable": "var(--spacing--page--header-margin-bottom-tablet)"
  },
  "spacing.Page.Header.margin.bottom.-mobile": {
    "value": "var(--spacing--page--header-margin-bottom-mobile)",
    "variable": "var(--spacing--page--header-margin-bottom-mobile)"
  },
  "spacing.Page.Header.margin.top.-desktop": {
    "value": "var(--spacing--page--header-margin-top-desktop)",
    "variable": "var(--spacing--page--header-margin-top-desktop)"
  },
  "spacing.Page.Header.margin.top.-tablet": {
    "value": "var(--spacing--page--header-margin-top-tablet)",
    "variable": "var(--spacing--page--header-margin-top-tablet)"
  },
  "spacing.Page.Header.margin.top.-mobile": {
    "value": "var(--spacing--page--header-margin-top-mobile)",
    "variable": "var(--spacing--page--header-margin-top-mobile)"
  },
  "spacing.Pagination.Item.-between-pages": {
    "value": "var(--spacing--pagination--item-between-pages)",
    "variable": "var(--spacing--pagination--item-between-pages)"
  },
  "spacing.Pagination.JumpItem.-to-controls": {
    "value": "var(--spacing--pagination--jump-item-to-controls)",
    "variable": "var(--spacing--pagination--jump-item-to-controls)"
  },
  "spacing.Pagination.JumpItem.padding.-horz": {
    "value": "var(--spacing--pagination--jump-item-padding-horz)",
    "variable": "var(--spacing--pagination--jump-item-padding-horz)"
  },
  "spacing.Pagination.JumpItem.padding.-vert": {
    "value": "var(--spacing--pagination--jump-item-padding-vert)",
    "variable": "var(--spacing--pagination--jump-item-padding-vert)"
  },
  "spacing.Pagination.Root.-gap-toDivider": {
    "value": "var(--spacing--pagination--root-gap-to-divider)",
    "variable": "var(--spacing--pagination--root-gap-to-divider)"
  },
  "spacing.PhotoCarousel.Dots.-gap-betweenMarkers": {
    "value": "var(--spacing--photo-carousel--dots-gap-between-markers)",
    "variable": "var(--spacing--photo-carousel--dots-gap-between-markers)"
  },
  "spacing.PhotoCarousel.Dots.margin.-bottom": {
    "value": "var(--spacing--photo-carousel--dots-margin-bottom)",
    "variable": "var(--spacing--photo-carousel--dots-margin-bottom)"
  },
  "spacing.PhotoCarousel.Dots.padding.-horz": {
    "value": "var(--spacing--photo-carousel--dots-padding-horz)",
    "variable": "var(--spacing--photo-carousel--dots-padding-horz)"
  },
  "spacing.PhotoCarousel.Dots.padding.-vert": {
    "value": "var(--spacing--photo-carousel--dots-padding-vert)",
    "variable": "var(--spacing--photo-carousel--dots-padding-vert)"
  },
  "spacing.Popover.Backdrop.padding.default.-horz": {
    "value": "var(--spacing--popover--backdrop-padding-default-horz)",
    "variable": "var(--spacing--popover--backdrop-padding-default-horz)"
  },
  "spacing.Popover.Backdrop.padding.default.-vert": {
    "value": "var(--spacing--popover--backdrop-padding-default-vert)",
    "variable": "var(--spacing--popover--backdrop-padding-default-vert)"
  },
  "spacing.Popover.Body.padding.-horz": {
    "value": "var(--spacing--popover--body-padding-horz)",
    "variable": "var(--spacing--popover--body-padding-horz)"
  },
  "spacing.Popover.Body.padding.-vert": {
    "value": "var(--spacing--popover--body-padding-vert)",
    "variable": "var(--spacing--popover--body-padding-vert)"
  },
  "spacing.Popover.CloseButton.margin.-top": {
    "value": "var(--spacing--popover--close-button-margin-top)",
    "variable": "var(--spacing--popover--close-button-margin-top)"
  },
  "spacing.Popover.CloseButton.margin.-right": {
    "value": "var(--spacing--popover--close-button-margin-right)",
    "variable": "var(--spacing--popover--close-button-margin-right)"
  },
  "spacing.Popover.Header.gap.-leading": {
    "value": "var(--spacing--popover--header-gap-leading)",
    "variable": "var(--spacing--popover--header-gap-leading)"
  },
  "spacing.Popover.Header.padding.-left": {
    "value": "var(--spacing--popover--header-padding-left)",
    "variable": "var(--spacing--popover--header-padding-left)"
  },
  "spacing.Popover.Header.padding.-vert": {
    "value": "var(--spacing--popover--header-padding-vert)",
    "variable": "var(--spacing--popover--header-padding-vert)"
  },
  "spacing.Popover.Header.padding.-right": {
    "value": "var(--spacing--popover--header-padding-right)",
    "variable": "var(--spacing--popover--header-padding-right)"
  },
  "spacing.ProgressMeter.gap.-label-toMeta": {
    "value": "var(--spacing--progress-meter-gap-label-to-meta)",
    "variable": "var(--spacing--progress-meter-gap-label-to-meta)"
  },
  "spacing.ProgressMeter.gap.horizontal.-node-toLabel": {
    "value": "var(--spacing--progress-meter-gap-horizontal-node-to-label)",
    "variable": "var(--spacing--progress-meter-gap-horizontal-node-to-label)"
  },
  "spacing.ProgressMeter.gap.vertical.-node-toLabel": {
    "value": "var(--spacing--progress-meter-gap-vertical-node-to-label)",
    "variable": "var(--spacing--progress-meter-gap-vertical-node-to-label)"
  },
  "spacing.ProgressMeter.padding.-tag-top": {
    "value": "var(--spacing--progress-meter-padding-tag-top)",
    "variable": "var(--spacing--progress-meter-padding-tag-top)"
  },
  "spacing.PropertyCard.BadgeArea.-gap": {
    "value": "var(--spacing--property-card--badge-area-gap)",
    "variable": "var(--spacing--property-card--badge-area-gap)"
  },
  "spacing.PropertyCard.Badge.padding.-horz": {
    "value": "var(--spacing--property-card--badge-padding-horz)",
    "variable": "var(--spacing--property-card--badge-padding-horz)"
  },
  "spacing.PropertyCard.Badge.padding.-vert": {
    "value": "var(--spacing--property-card--badge-padding-vert)",
    "variable": "var(--spacing--property-card--badge-padding-vert)"
  },
  "spacing.PropertyCard.DataArea.dataDivider.-gap-toDataItem": {
    "value": "var(--spacing--property-card--data-area-data-divider-gap-to-data-item)",
    "variable": "var(--spacing--property-card--data-area-data-divider-gap-to-data-item)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.between-dataItems.-default": {
    "value": "var(--spacing--property-card--data-wrapper-large-gap-between-data-items-default)",
    "variable": "var(--spacing--property-card--data-wrapper-large-gap-between-data-items-default)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.between-dataItems.-loading": {
    "value": "var(--spacing--property-card--data-wrapper-large-gap-between-data-items-loading)",
    "variable": "var(--spacing--property-card--data-wrapper-large-gap-between-data-items-loading)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.-dataArea1-toIcon": {
    "value": "var(--spacing--property-card--data-wrapper-large-gap-data-area1-to-icon)",
    "variable": "var(--spacing--property-card--data-wrapper-large-gap-data-area1-to-icon)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.-horz": {
    "value": "var(--spacing--property-card--data-wrapper-large-padding-horz)",
    "variable": "var(--spacing--property-card--data-wrapper-large-padding-horz)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.-top": {
    "value": "var(--spacing--property-card--data-wrapper-large-padding-top)",
    "variable": "var(--spacing--property-card--data-wrapper-large-padding-top)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.-bottom": {
    "value": "var(--spacing--property-card--data-wrapper-large-padding-bottom)",
    "variable": "var(--spacing--property-card--data-wrapper-large-padding-bottom)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.between-dataItems.-default": {
    "value": "var(--spacing--property-card--data-wrapper-small-gap-between-data-items-default)",
    "variable": "var(--spacing--property-card--data-wrapper-small-gap-between-data-items-default)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.between-dataItems.-loading": {
    "value": "var(--spacing--property-card--data-wrapper-small-gap-between-data-items-loading)",
    "variable": "var(--spacing--property-card--data-wrapper-small-gap-between-data-items-loading)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.-dataArea1-toIcon": {
    "value": "var(--spacing--property-card--data-wrapper-small-gap-data-area1-to-icon)",
    "variable": "var(--spacing--property-card--data-wrapper-small-gap-data-area1-to-icon)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.-horz": {
    "value": "var(--spacing--property-card--data-wrapper-small-padding-horz)",
    "variable": "var(--spacing--property-card--data-wrapper-small-padding-horz)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.-top": {
    "value": "var(--spacing--property-card--data-wrapper-small-padding-top)",
    "variable": "var(--spacing--property-card--data-wrapper-small-padding-top)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.-bottom": {
    "value": "var(--spacing--property-card--data-wrapper-small-padding-bottom)",
    "variable": "var(--spacing--property-card--data-wrapper-small-padding-bottom)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.between-dataItems.-default": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-gap-between-data-items-default)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-gap-between-data-items-default)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.between-dataItems.-loading": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-gap-between-data-items-loading)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-gap-between-data-items-loading)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.-dataArea1-toIcon": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-gap-data-area1-to-icon)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-gap-data-area1-to-icon)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.-horz": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-padding-horz)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-padding-horz)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.-top": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-padding-top)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-padding-top)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.-bottom": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-padding-bottom)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-padding-bottom)"
  },
  "spacing.PropertyCard.FlexArea.gap.-dataWrapper-toFlexArea": {
    "value": "var(--spacing--property-card--flex-area-gap-data-wrapper-to-flex-area)",
    "variable": "var(--spacing--property-card--flex-area-gap-data-wrapper-to-flex-area)"
  },
  "spacing.PropertyCard.FlexArea.padding.-horz": {
    "value": "var(--spacing--property-card--flex-area-padding-horz)",
    "variable": "var(--spacing--property-card--flex-area-padding-horz)"
  },
  "spacing.PropertyCard.FlexArea.padding.-vert": {
    "value": "var(--spacing--property-card--flex-area-padding-vert)",
    "variable": "var(--spacing--property-card--flex-area-padding-vert)"
  },
  "spacing.PropertyCard.PhotoHeader.margin.-horz": {
    "value": "var(--spacing--property-card--photo-header-margin-horz)",
    "variable": "var(--spacing--property-card--photo-header-margin-horz)"
  },
  "spacing.PropertyCard.PhotoHeader.margin.-vert": {
    "value": "var(--spacing--property-card--photo-header-margin-vert)",
    "variable": "var(--spacing--property-card--photo-header-margin-vert)"
  },
  "spacing.PropertyCard.PhotoFooter.logo.padding.-horz": {
    "value": "var(--spacing--property-card--photo-footer-logo-padding-horz)",
    "variable": "var(--spacing--property-card--photo-footer-logo-padding-horz)"
  },
  "spacing.PropertyCard.PhotoFooter.logo.padding.-vert": {
    "value": "var(--spacing--property-card--photo-footer-logo-padding-vert)",
    "variable": "var(--spacing--property-card--photo-footer-logo-padding-vert)"
  },
  "spacing.PropertyCard.Root.sm.gap.-card-toDataArea5": {
    "value": "var(--spacing--property-card--root-sm-gap-card-to-data-area5)",
    "variable": "var(--spacing--property-card--root-sm-gap-card-to-data-area5)"
  },
  "spacing.PropertyCard.Root.horiz.gap.-card-toDataArea5": {
    "value": "var(--spacing--property-card--root-horiz-gap-card-to-data-area5)",
    "variable": "var(--spacing--property-card--root-horiz-gap-card-to-data-area5)"
  },
  "spacing.PropertyCard.SaveButton.padding.-top": {
    "value": "var(--spacing--property-card--save-button-padding-top)",
    "variable": "var(--spacing--property-card--save-button-padding-top)"
  },
  "spacing.PropertyCard.SaveButton.padding.-right": {
    "value": "var(--spacing--property-card--save-button-padding-right)",
    "variable": "var(--spacing--property-card--save-button-padding-right)"
  },
  "spacing.PropertyCard.SaveButton.padding.-bottom": {
    "value": "var(--spacing--property-card--save-button-padding-bottom)",
    "variable": "var(--spacing--property-card--save-button-padding-bottom)"
  },
  "spacing.PropertyCard.SaveButton.padding.-left": {
    "value": "var(--spacing--property-card--save-button-padding-left)",
    "variable": "var(--spacing--property-card--save-button-padding-left)"
  },
  "spacing.Range.Root.margin.-vert": {
    "value": "var(--spacing--range--root-margin-vert)",
    "variable": "var(--spacing--range--root-margin-vert)"
  },
  "spacing.Range.Handle.margin.-top": {
    "value": "var(--spacing--range--handle-margin-top)",
    "variable": "var(--spacing--range--handle-margin-top)"
  },
  "spacing.RatingStars.gap.-between-stars": {
    "value": "var(--spacing--rating-stars-gap-between-stars)",
    "variable": "var(--spacing--rating-stars-gap-between-stars)"
  },
  "spacing.RatingStars.gap.-stars-toContent": {
    "value": "var(--spacing--rating-stars-gap-stars-to-content)",
    "variable": "var(--spacing--rating-stars-gap-stars-to-content)"
  },
  "spacing.RatingStars.gap.-star-toNumber": {
    "value": "var(--spacing--rating-stars-gap-star-to-number)",
    "variable": "var(--spacing--rating-stars-gap-star-to-number)"
  },
  "spacing.RatingStars.gap.-divider-toContent": {
    "value": "var(--spacing--rating-stars-gap-divider-to-content)",
    "variable": "var(--spacing--rating-stars-gap-divider-to-content)"
  },
  "spacing.ShowHide.gap.-label-toIcon": {
    "value": "var(--spacing--show-hide-gap-label-to-icon)",
    "variable": "var(--spacing--show-hide-gap-label-to-icon)"
  },
  "spacing.ShowHide.gap.-button-toContent": {
    "value": "var(--spacing--show-hide-gap-button-to-content)",
    "variable": "var(--spacing--show-hide-gap-button-to-content)"
  },
  "spacing.Switch.Track.md.padding.-horz": {
    "value": "var(--spacing--switch--track-md-padding-horz)",
    "variable": "var(--spacing--switch--track-md-padding-horz)"
  },
  "spacing.Switch.Track.md.padding.-vert": {
    "value": "var(--spacing--switch--track-md-padding-vert)",
    "variable": "var(--spacing--switch--track-md-padding-vert)"
  },
  "spacing.Switch.Track.lg.padding.-horz": {
    "value": "var(--spacing--switch--track-lg-padding-horz)",
    "variable": "var(--spacing--switch--track-lg-padding-horz)"
  },
  "spacing.Switch.Track.lg.padding.-vert": {
    "value": "var(--spacing--switch--track-lg-padding-vert)",
    "variable": "var(--spacing--switch--track-lg-padding-vert)"
  },
  "spacing.Switch.Handle.md.position.-top": {
    "value": "var(--spacing--switch--handle-md-position-top)",
    "variable": "var(--spacing--switch--handle-md-position-top)"
  },
  "spacing.Switch.Handle.md.position.-left": {
    "value": "var(--spacing--switch--handle-md-position-left)",
    "variable": "var(--spacing--switch--handle-md-position-left)"
  },
  "spacing.Switch.Handle.lg.position.-top": {
    "value": "var(--spacing--switch--handle-lg-position-top)",
    "variable": "var(--spacing--switch--handle-lg-position-top)"
  },
  "spacing.Switch.Handle.lg.position.-left": {
    "value": "var(--spacing--switch--handle-lg-position-left)",
    "variable": "var(--spacing--switch--handle-lg-position-left)"
  },
  "spacing.Table.Cell.gap.-icon-toLabel": {
    "value": "var(--spacing--table--cell-gap-icon-to-label)",
    "variable": "var(--spacing--table--cell-gap-icon-to-label)"
  },
  "spacing.Table.Cell.padding.size.sm.-horz": {
    "value": "var(--spacing--table--cell-padding-size-sm-horz)",
    "variable": "var(--spacing--table--cell-padding-size-sm-horz)"
  },
  "spacing.Table.Cell.padding.size.sm.-vert": {
    "value": "var(--spacing--table--cell-padding-size-sm-vert)",
    "variable": "var(--spacing--table--cell-padding-size-sm-vert)"
  },
  "spacing.Table.Cell.padding.size.md.-horz": {
    "value": "var(--spacing--table--cell-padding-size-md-horz)",
    "variable": "var(--spacing--table--cell-padding-size-md-horz)"
  },
  "spacing.Table.Cell.padding.size.md.-vert": {
    "value": "var(--spacing--table--cell-padding-size-md-vert)",
    "variable": "var(--spacing--table--cell-padding-size-md-vert)"
  },
  "spacing.Table.Cell.padding.size.lg.-horz": {
    "value": "var(--spacing--table--cell-padding-size-lg-horz)",
    "variable": "var(--spacing--table--cell-padding-size-lg-horz)"
  },
  "spacing.Table.Cell.padding.size.lg.-vert": {
    "value": "var(--spacing--table--cell-padding-size-lg-vert)",
    "variable": "var(--spacing--table--cell-padding-size-lg-vert)"
  },
  "spacing.Tabs.gap.-leading": {
    "value": "var(--spacing--tabs-gap-leading)",
    "variable": "var(--spacing--tabs-gap-leading)"
  },
  "spacing.Tabs.gap.-trailing": {
    "value": "var(--spacing--tabs-gap-trailing)",
    "variable": "var(--spacing--tabs-gap-trailing)"
  },
  "spacing.Tabs.-offsetBorder": {
    "value": "var(--spacing--tabs-offset-border)",
    "variable": "var(--spacing--tabs-offset-border)"
  },
  "spacing.Tabs.padding.-panel": {
    "value": "var(--spacing--tabs-padding-panel)",
    "variable": "var(--spacing--tabs-padding-panel)"
  },
  "spacing.Tabs.padding.-horz": {
    "value": "var(--spacing--tabs-padding-horz)",
    "variable": "var(--spacing--tabs-padding-horz)"
  },
  "spacing.Tabs.padding.-vert": {
    "value": "var(--spacing--tabs-padding-vert)",
    "variable": "var(--spacing--tabs-padding-vert)"
  },
  "spacing.Tabs.padding.file.active.-top": {
    "value": "var(--spacing--tabs-padding-file-active-top)",
    "variable": "var(--spacing--tabs-padding-file-active-top)"
  },
  "spacing.Tag.sm.gap.-label-toIcon": {
    "value": "var(--spacing--tag-sm-gap-label-to-icon)",
    "variable": "var(--spacing--tag-sm-gap-label-to-icon)"
  },
  "spacing.Tag.sm.padding.-horz": {
    "value": "var(--spacing--tag-sm-padding-horz)",
    "variable": "var(--spacing--tag-sm-padding-horz)"
  },
  "spacing.Tag.sm.padding.-vert": {
    "value": "var(--spacing--tag-sm-padding-vert)",
    "variable": "var(--spacing--tag-sm-padding-vert)"
  },
  "spacing.Tag.md.gap.-label-toIcon": {
    "value": "var(--spacing--tag-md-gap-label-to-icon)",
    "variable": "var(--spacing--tag-md-gap-label-to-icon)"
  },
  "spacing.Tag.md.padding.-horz": {
    "value": "var(--spacing--tag-md-padding-horz)",
    "variable": "var(--spacing--tag-md-padding-horz)"
  },
  "spacing.Tag.md.padding.-vert": {
    "value": "var(--spacing--tag-md-padding-vert)",
    "variable": "var(--spacing--tag-md-padding-vert)"
  },
  "spacing.TextButton.gap.-label-toIcon": {
    "value": "var(--spacing--text-button-gap-label-to-icon)",
    "variable": "var(--spacing--text-button-gap-label-to-icon)"
  },
  "spacing.TextButton.padding.-horz": {
    "value": "var(--spacing--text-button-padding-horz)",
    "variable": "var(--spacing--text-button-padding-horz)"
  },
  "spacing.TextButton.padding.-vert": {
    "value": "var(--spacing--text-button-padding-vert)",
    "variable": "var(--spacing--text-button-padding-vert)"
  },
  "spacing.Textarea.padding.-horz": {
    "value": "var(--spacing--textarea-padding-horz)",
    "variable": "var(--spacing--textarea-padding-horz)"
  },
  "spacing.Textarea.padding.-horz-readOnly": {
    "value": "var(--spacing--textarea-padding-horz-read-only)",
    "variable": "var(--spacing--textarea-padding-horz-read-only)"
  },
  "spacing.Textarea.padding.-vert": {
    "value": "var(--spacing--textarea-padding-vert)",
    "variable": "var(--spacing--textarea-padding-vert)"
  },
  "spacing.Toast.gap.-content-toAction": {
    "value": "var(--spacing--toast-gap-content-to-action)",
    "variable": "var(--spacing--toast-gap-content-to-action)"
  },
  "spacing.Toast.gap.-leading": {
    "value": "var(--spacing--toast-gap-leading)",
    "variable": "var(--spacing--toast-gap-leading)"
  },
  "spacing.Toast.gap.-trailing": {
    "value": "var(--spacing--toast-gap-trailing)",
    "variable": "var(--spacing--toast-gap-trailing)"
  },
  "spacing.Toast.padding.-horz": {
    "value": "var(--spacing--toast-padding-horz)",
    "variable": "var(--spacing--toast-padding-horz)"
  },
  "spacing.Toast.padding.-vert": {
    "value": "var(--spacing--toast-padding-vert)",
    "variable": "var(--spacing--toast-padding-vert)"
  },
  "spacing.Toast.CloseButton.margin.-top": {
    "value": "var(--spacing--toast--close-button-margin-top)",
    "variable": "var(--spacing--toast--close-button-margin-top)"
  },
  "spacing.Toast.CloseButton.margin.-right": {
    "value": "var(--spacing--toast--close-button-margin-right)",
    "variable": "var(--spacing--toast--close-button-margin-right)"
  },
  "spacing.ToggleButton.sm.gap.-label-toIcon": {
    "value": "var(--spacing--toggle-button-sm-gap-label-to-icon)",
    "variable": "var(--spacing--toggle-button-sm-gap-label-to-icon)"
  },
  "spacing.ToggleButton.sm.padding.bare.-horz": {
    "value": "var(--spacing--toggle-button-sm-padding-bare-horz)",
    "variable": "var(--spacing--toggle-button-sm-padding-bare-horz)"
  },
  "spacing.ToggleButton.sm.padding.bare.-horz-narrow": {
    "value": "var(--spacing--toggle-button-sm-padding-bare-horz-narrow)",
    "variable": "var(--spacing--toggle-button-sm-padding-bare-horz-narrow)"
  },
  "spacing.ToggleButton.sm.padding.bare.-horz-narrowest": {
    "value": "var(--spacing--toggle-button-sm-padding-bare-horz-narrowest)",
    "variable": "var(--spacing--toggle-button-sm-padding-bare-horz-narrowest)"
  },
  "spacing.ToggleButton.sm.padding.-horz": {
    "value": "var(--spacing--toggle-button-sm-padding-horz)",
    "variable": "var(--spacing--toggle-button-sm-padding-horz)"
  },
  "spacing.ToggleButton.sm.padding.-vert": {
    "value": "var(--spacing--toggle-button-sm-padding-vert)",
    "variable": "var(--spacing--toggle-button-sm-padding-vert)"
  },
  "spacing.ToggleButton.md.gap.-label-toIcon": {
    "value": "var(--spacing--toggle-button-md-gap-label-to-icon)",
    "variable": "var(--spacing--toggle-button-md-gap-label-to-icon)"
  },
  "spacing.ToggleButton.md.padding.bare.-horz": {
    "value": "var(--spacing--toggle-button-md-padding-bare-horz)",
    "variable": "var(--spacing--toggle-button-md-padding-bare-horz)"
  },
  "spacing.ToggleButton.md.padding.bare.-horz-narrow": {
    "value": "var(--spacing--toggle-button-md-padding-bare-horz-narrow)",
    "variable": "var(--spacing--toggle-button-md-padding-bare-horz-narrow)"
  },
  "spacing.ToggleButton.md.padding.bare.-horz-narrowest": {
    "value": "var(--spacing--toggle-button-md-padding-bare-horz-narrowest)",
    "variable": "var(--spacing--toggle-button-md-padding-bare-horz-narrowest)"
  },
  "spacing.ToggleButton.md.padding.-horz": {
    "value": "var(--spacing--toggle-button-md-padding-horz)",
    "variable": "var(--spacing--toggle-button-md-padding-horz)"
  },
  "spacing.ToggleButton.md.padding.-vert": {
    "value": "var(--spacing--toggle-button-md-padding-vert)",
    "variable": "var(--spacing--toggle-button-md-padding-vert)"
  },
  "spacing.ToggleButton.lg.gap.-label-toIcon": {
    "value": "var(--spacing--toggle-button-lg-gap-label-to-icon)",
    "variable": "var(--spacing--toggle-button-lg-gap-label-to-icon)"
  },
  "spacing.ToggleButton.lg.padding.bare.-horz": {
    "value": "var(--spacing--toggle-button-lg-padding-bare-horz)",
    "variable": "var(--spacing--toggle-button-lg-padding-bare-horz)"
  },
  "spacing.ToggleButton.lg.padding.bare.-horz-narrow": {
    "value": "var(--spacing--toggle-button-lg-padding-bare-horz-narrow)",
    "variable": "var(--spacing--toggle-button-lg-padding-bare-horz-narrow)"
  },
  "spacing.ToggleButton.lg.padding.bare.-horz-narrowest": {
    "value": "var(--spacing--toggle-button-lg-padding-bare-horz-narrowest)",
    "variable": "var(--spacing--toggle-button-lg-padding-bare-horz-narrowest)"
  },
  "spacing.ToggleButton.lg.padding.-horz": {
    "value": "var(--spacing--toggle-button-lg-padding-horz)",
    "variable": "var(--spacing--toggle-button-lg-padding-horz)"
  },
  "spacing.ToggleButton.lg.padding.-vert": {
    "value": "var(--spacing--toggle-button-lg-padding-vert)",
    "variable": "var(--spacing--toggle-button-lg-padding-vert)"
  },
  "spacing.ToggleCard.Footer.margin.-to-Body": {
    "value": "var(--spacing--toggle-card--footer-margin-to--body)",
    "variable": "var(--spacing--toggle-card--footer-margin-to--body)"
  },
  "spacing.ToggleCard.Footer.padding.-from-Footer": {
    "value": "var(--spacing--toggle-card--footer-padding-from--footer)",
    "variable": "var(--spacing--toggle-card--footer-padding-from--footer)"
  },
  "spacing.ToggleCard.Header.margin.-to-Body": {
    "value": "var(--spacing--toggle-card--header-margin-to--body)",
    "variable": "var(--spacing--toggle-card--header-margin-to--body)"
  },
  "spacing.ToggleCard.Header.padding.-from-Header": {
    "value": "var(--spacing--toggle-card--header-padding-from--header)",
    "variable": "var(--spacing--toggle-card--header-padding-from--header)"
  },
  "spacing.ToggleCard.Root.-padding": {
    "value": "var(--spacing--toggle-card--root-padding)",
    "variable": "var(--spacing--toggle-card--root-padding)"
  },
  "spacing.Tooltip.mWeb.padding.-horz": {
    "value": "var(--spacing--tooltip-m-web-padding-horz)",
    "variable": "var(--spacing--tooltip-m-web-padding-horz)"
  },
  "spacing.Tooltip.mWeb.padding.-vert": {
    "value": "var(--spacing--tooltip-m-web-padding-vert)",
    "variable": "var(--spacing--tooltip-m-web-padding-vert)"
  },
  "spacing.Tooltip.desktop.padding.-horz": {
    "value": "var(--spacing--tooltip-desktop-padding-horz)",
    "variable": "var(--spacing--tooltip-desktop-padding-horz)"
  },
  "spacing.Tooltip.desktop.padding.-vert": {
    "value": "var(--spacing--tooltip-desktop-padding-vert)",
    "variable": "var(--spacing--tooltip-desktop-padding-vert)"
  },
  "spacing.TriggerText.-padding": {
    "value": "var(--spacing--trigger-text-padding)",
    "variable": "var(--spacing--trigger-text-padding)"
  },
  "spacing.UpsellBanner.Action.margin.content-toActions.-horz": {
    "value": "var(--spacing--upsell-banner--action-margin-content-to-actions-horz)",
    "variable": "var(--spacing--upsell-banner--action-margin-content-to-actions-horz)"
  },
  "spacing.UpsellBanner.Action.margin.content-toActions.-vert": {
    "value": "var(--spacing--upsell-banner--action-margin-content-to-actions-vert)",
    "variable": "var(--spacing--upsell-banner--action-margin-content-to-actions-vert)"
  },
  "spacing.UpsellBanner.Body.margin.heading-toMessage.-horz": {
    "value": "var(--spacing--upsell-banner--body-margin-heading-to-message-horz)",
    "variable": "var(--spacing--upsell-banner--body-margin-heading-to-message-horz)"
  },
  "spacing.UpsellBanner.Body.margin.heading-toMessage.-vert": {
    "value": "var(--spacing--upsell-banner--body-margin-heading-to-message-vert)",
    "variable": "var(--spacing--upsell-banner--body-margin-heading-to-message-vert)"
  },
  "spacing.UpsellBanner.Header.margin.-content-toClose": {
    "value": "var(--spacing--upsell-banner--header-margin-content-to-close)",
    "variable": "var(--spacing--upsell-banner--header-margin-content-to-close)"
  },
  "spacing.UpsellBanner.Root.gap.-leading": {
    "value": "var(--spacing--upsell-banner--root-gap-leading)",
    "variable": "var(--spacing--upsell-banner--root-gap-leading)"
  },
  "spacing.UpsellBanner.Root.gap.-trailing": {
    "value": "var(--spacing--upsell-banner--root-gap-trailing)",
    "variable": "var(--spacing--upsell-banner--root-gap-trailing)"
  },
  "spacing.UpsellBanner.Root.padding.-horz": {
    "value": "var(--spacing--upsell-banner--root-padding-horz)",
    "variable": "var(--spacing--upsell-banner--root-padding-horz)"
  },
  "spacing.UpsellBanner.Root.padding.-vert": {
    "value": "var(--spacing--upsell-banner--root-padding-vert)",
    "variable": "var(--spacing--upsell-banner--root-padding-vert)"
  },
  "spacing.UpsellBanner.CloseButton.margin.-top": {
    "value": "var(--spacing--upsell-banner--close-button-margin-top)",
    "variable": "var(--spacing--upsell-banner--close-button-margin-top)"
  },
  "spacing.UpsellBanner.CloseButton.margin.-right": {
    "value": "var(--spacing--upsell-banner--close-button-margin-right)",
    "variable": "var(--spacing--upsell-banner--close-button-margin-right)"
  },
  "spacing.Upsell.Action.margin.-content-toActions": {
    "value": "var(--spacing--upsell--action-margin-content-to-actions)",
    "variable": "var(--spacing--upsell--action-margin-content-to-actions)"
  },
  "spacing.Upsell.Body.margin.-heading-toMessage": {
    "value": "var(--spacing--upsell--body-margin-heading-to-message)",
    "variable": "var(--spacing--upsell--body-margin-heading-to-message)"
  },
  "spacing.Upsell.Header.gap.-content-toClose": {
    "value": "var(--spacing--upsell--header-gap-content-to-close)",
    "variable": "var(--spacing--upsell--header-gap-content-to-close)"
  },
  "spacing.Upsell.Legal.margin.-content-toActions": {
    "value": "var(--spacing--upsell--legal-margin-content-to-actions)",
    "variable": "var(--spacing--upsell--legal-margin-content-to-actions)"
  },
  "spacing.Upsell.Root.gap.-img-toText": {
    "value": "var(--spacing--upsell--root-gap-img-to-text)",
    "variable": "var(--spacing--upsell--root-gap-img-to-text)"
  },
  "spacing.Upsell.Root.gap.-icon-toText": {
    "value": "var(--spacing--upsell--root-gap-icon-to-text)",
    "variable": "var(--spacing--upsell--root-gap-icon-to-text)"
  },
  "spacing.Upsell.Root.padding.-horz": {
    "value": "var(--spacing--upsell--root-padding-horz)",
    "variable": "var(--spacing--upsell--root-padding-horz)"
  },
  "spacing.Upsell.Root.padding.-vert": {
    "value": "var(--spacing--upsell--root-padding-vert)",
    "variable": "var(--spacing--upsell--root-padding-vert)"
  },
  "spacing.Upsell.CloseButton.margin.-top": {
    "value": "var(--spacing--upsell--close-button-margin-top)",
    "variable": "var(--spacing--upsell--close-button-margin-top)"
  },
  "spacing.Upsell.CloseButton.margin.-right": {
    "value": "var(--spacing--upsell--close-button-margin-right)",
    "variable": "var(--spacing--upsell--close-button-margin-right)"
  },
  "spacing.VerticalNav.Divider.padding.-vert": {
    "value": "var(--spacing--vertical-nav--divider-padding-vert)",
    "variable": "var(--spacing--vertical-nav--divider-padding-vert)"
  },
  "spacing.VerticalNav.Divider.gap.-toNavItems": {
    "value": "var(--spacing--vertical-nav--divider-gap-to-nav-items)",
    "variable": "var(--spacing--vertical-nav--divider-gap-to-nav-items)"
  },
  "spacing.VerticalNav.Heading.padding.-horz": {
    "value": "var(--spacing--vertical-nav--heading-padding-horz)",
    "variable": "var(--spacing--vertical-nav--heading-padding-horz)"
  },
  "spacing.VerticalNav.Heading.padding.-vert": {
    "value": "var(--spacing--vertical-nav--heading-padding-vert)",
    "variable": "var(--spacing--vertical-nav--heading-padding-vert)"
  },
  "spacing.VerticalNav.Item.gap.-leading": {
    "value": "var(--spacing--vertical-nav--item-gap-leading)",
    "variable": "var(--spacing--vertical-nav--item-gap-leading)"
  },
  "spacing.VerticalNav.Item.padding.-horz": {
    "value": "var(--spacing--vertical-nav--item-padding-horz)",
    "variable": "var(--spacing--vertical-nav--item-padding-horz)"
  },
  "spacing.VerticalNav.Item.padding.-vert": {
    "value": "var(--spacing--vertical-nav--item-padding-vert)",
    "variable": "var(--spacing--vertical-nav--item-padding-vert)"
  },
  "spacing.VerticalNav.List.gap.-betweenItems": {
    "value": "var(--spacing--vertical-nav--list-gap-between-items)",
    "variable": "var(--spacing--vertical-nav--list-gap-between-items)"
  },
  "spacing.VerticalNav.List.padding.-vert": {
    "value": "var(--spacing--vertical-nav--list-padding-vert)",
    "variable": "var(--spacing--vertical-nav--list-padding-vert)"
  },
  "spacing.VerticalNav.Root.padding.-vert": {
    "value": "var(--spacing--vertical-nav--root-padding-vert)",
    "variable": "var(--spacing--vertical-nav--root-padding-vert)"
  },
  "spacing.VerticalNav.Root.padding.-horz": {
    "value": "var(--spacing--vertical-nav--root-padding-horz)",
    "variable": "var(--spacing--vertical-nav--root-padding-horz)"
  },
  "spacing.device.margin.-mobile": {
    "value": "var(--spacing-device-margin-mobile)",
    "variable": "var(--spacing-device-margin-mobile)"
  },
  "spacing.device.margin.-tablet": {
    "value": "var(--spacing-device-margin-tablet)",
    "variable": "var(--spacing-device-margin-tablet)"
  },
  "spacing.device.margin.-desktop": {
    "value": "var(--spacing-device-margin-desktop)",
    "variable": "var(--spacing-device-margin-desktop)"
  },
  "spacing.-tightest": {
    "value": "var(--spacing-tightest)",
    "variable": "var(--spacing-tightest)"
  },
  "spacing.-tighter": {
    "value": "var(--spacing-tighter)",
    "variable": "var(--spacing-tighter)"
  },
  "spacing.-tight": {
    "value": "var(--spacing-tight)",
    "variable": "var(--spacing-tight)"
  },
  "spacing.-default": {
    "value": "var(--spacing-default)",
    "variable": "var(--spacing-default)"
  },
  "spacing.-loose": {
    "value": "var(--spacing-loose)",
    "variable": "var(--spacing-loose)"
  },
  "spacing.-looser": {
    "value": "var(--spacing-looser)",
    "variable": "var(--spacing-looser)"
  },
  "spacing.-none": {
    "value": "var(--spacing-none)",
    "variable": "var(--spacing-none)"
  },
  "spacing.-conjoined-offsetBorder": {
    "value": "var(--spacing-conjoined-offset-border)",
    "variable": "var(--spacing-conjoined-offset-border)"
  },
  "spacing.layout.-tightest": {
    "value": "var(--spacing-layout-tightest)",
    "variable": "var(--spacing-layout-tightest)"
  },
  "spacing.layout.-tighter": {
    "value": "var(--spacing-layout-tighter)",
    "variable": "var(--spacing-layout-tighter)"
  },
  "spacing.layout.-tight": {
    "value": "var(--spacing-layout-tight)",
    "variable": "var(--spacing-layout-tight)"
  },
  "spacing.layout.-default": {
    "value": "var(--spacing-layout-default)",
    "variable": "var(--spacing-layout-default)"
  },
  "spacing.layout.-loose": {
    "value": "var(--spacing-layout-loose)",
    "variable": "var(--spacing-layout-loose)"
  },
  "spacing.layout.-looser": {
    "value": "var(--spacing-layout-looser)",
    "variable": "var(--spacing-layout-looser)"
  },
  "spacing.layout.-loosest": {
    "value": "var(--spacing-layout-loosest)",
    "variable": "var(--spacing-layout-loosest)"
  },
  "spacing.layout.vast.-default": {
    "value": "var(--spacing-layout-vast-default)",
    "variable": "var(--spacing-layout-vast-default)"
  },
  "spacing.layout.vast.-loose": {
    "value": "var(--spacing-layout-vast-loose)",
    "variable": "var(--spacing-layout-vast-loose)"
  },
  "spacing.layout.vast.-looser": {
    "value": "var(--spacing-layout-vast-looser)",
    "variable": "var(--spacing-layout-vast-looser)"
  },
  "spacing.micro.-tight": {
    "value": "var(--spacing-micro-tight)",
    "variable": "var(--spacing-micro-tight)"
  },
  "spacing.micro.-default": {
    "value": "var(--spacing-micro-default)",
    "variable": "var(--spacing-micro-default)"
  },
  "spacing.-xxs": {
    "value": "var(--spacing-xxs)",
    "variable": "var(--spacing-xxs)"
  },
  "spacing.-xs": {
    "value": "var(--spacing-xs)",
    "variable": "var(--spacing-xs)"
  },
  "spacing.-sm": {
    "value": "var(--spacing-sm)",
    "variable": "var(--spacing-sm)"
  },
  "spacing.-md": {
    "value": "var(--spacing-md)",
    "variable": "var(--spacing-md)"
  },
  "spacing.-lg": {
    "value": "var(--spacing-lg)",
    "variable": "var(--spacing-lg)"
  },
  "spacing.-xl": {
    "value": "var(--spacing-xl)",
    "variable": "var(--spacing-xl)"
  },
  "spacing.Accordion.Header.gap.-between-tags": {
    "value": "var(--spacing--accordion--header-gap-between-tags)",
    "variable": "var(--spacing--accordion--header-gap-between-tags)"
  },
  "spacing.Alert.gap.-message-toFlexArea": {
    "value": "var(--spacing--alert-gap-message-to-flex-area)",
    "variable": "var(--spacing--alert-gap-message-to-flex-area)"
  },
  "spacing.ButtonGroup.textButton.padding.-horz": {
    "value": "var(--spacing--button-group-text-button-padding-horz)",
    "variable": "var(--spacing--button-group-text-button-padding-horz)"
  },
  "spacing.ButtonGroup.textButton.padding.-vert": {
    "value": "var(--spacing--button-group-text-button-padding-vert)",
    "variable": "var(--spacing--button-group-text-button-padding-vert)"
  },
  "spacing.FormField.HelperArea.gap.-text-toCharCount": {
    "value": "var(--spacing--form-field--helper-area-gap-text-to-char-count)",
    "variable": "var(--spacing--form-field--helper-area-gap-text-to-char-count)"
  },
  "spacing.Input.sm.gap.-input-toAdornment": {
    "value": "var(--spacing--input-sm-gap-input-to-adornment)",
    "variable": "var(--spacing--input-sm-gap-input-to-adornment)"
  },
  "spacing.Input.md.gap.-input-toAdornment": {
    "value": "var(--spacing--input-md-gap-input-to-adornment)",
    "variable": "var(--spacing--input-md-gap-input-to-adornment)"
  },
  "spacing.Input.lg.gap.-input-toAdornment": {
    "value": "var(--spacing--input-lg-gap-input-to-adornment)",
    "variable": "var(--spacing--input-lg-gap-input-to-adornment)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.-dataArea1-toSupportRows": {
    "value": "var(--spacing--property-card--data-wrapper-large-gap-data-area1-to-support-rows)",
    "variable": "var(--spacing--property-card--data-wrapper-large-gap-data-area1-to-support-rows)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.-dataArea1-toSupportRows": {
    "value": "var(--spacing--property-card--data-wrapper-small-gap-data-area1-to-support-rows)",
    "variable": "var(--spacing--property-card--data-wrapper-small-gap-data-area1-to-support-rows)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.-dataArea1-toSupportRows": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-gap-data-area1-to-support-rows)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-gap-data-area1-to-support-rows)"
  },
  "colors.aqua.50": {
    "value": "var(--colors-aqua-50)",
    "variable": "var(--colors-aqua-50)"
  },
  "colors.aqua.100": {
    "value": "var(--colors-aqua-100)",
    "variable": "var(--colors-aqua-100)"
  },
  "colors.aqua.200": {
    "value": "var(--colors-aqua-200)",
    "variable": "var(--colors-aqua-200)"
  },
  "colors.aqua.300": {
    "value": "var(--colors-aqua-300)",
    "variable": "var(--colors-aqua-300)"
  },
  "colors.aqua.400": {
    "value": "var(--colors-aqua-400)",
    "variable": "var(--colors-aqua-400)"
  },
  "colors.aqua.500": {
    "value": "var(--colors-aqua-500)",
    "variable": "var(--colors-aqua-500)"
  },
  "colors.aqua.600": {
    "value": "var(--colors-aqua-600)",
    "variable": "var(--colors-aqua-600)"
  },
  "colors.aqua.700": {
    "value": "var(--colors-aqua-700)",
    "variable": "var(--colors-aqua-700)"
  },
  "colors.aqua.800": {
    "value": "var(--colors-aqua-800)",
    "variable": "var(--colors-aqua-800)"
  },
  "colors.aqua.900": {
    "value": "var(--colors-aqua-900)",
    "variable": "var(--colors-aqua-900)"
  },
  "colors.aqua.950": {
    "value": "var(--colors-aqua-950)",
    "variable": "var(--colors-aqua-950)"
  },
  "colors.black": {
    "value": "var(--colors-black)",
    "variable": "var(--colors-black)"
  },
  "colors.blue.50": {
    "value": "var(--colors-blue-50)",
    "variable": "var(--colors-blue-50)"
  },
  "colors.blue.100": {
    "value": "var(--colors-blue-100)",
    "variable": "var(--colors-blue-100)"
  },
  "colors.blue.200": {
    "value": "var(--colors-blue-200)",
    "variable": "var(--colors-blue-200)"
  },
  "colors.blue.300": {
    "value": "var(--colors-blue-300)",
    "variable": "var(--colors-blue-300)"
  },
  "colors.blue.375": {
    "value": "var(--colors-blue-375)",
    "variable": "var(--colors-blue-375)"
  },
  "colors.blue.400": {
    "value": "var(--colors-blue-400)",
    "variable": "var(--colors-blue-400)"
  },
  "colors.blue.500": {
    "value": "var(--colors-blue-500)",
    "variable": "var(--colors-blue-500)"
  },
  "colors.blue.600": {
    "value": "var(--colors-blue-600)",
    "variable": "var(--colors-blue-600)"
  },
  "colors.blue.700": {
    "value": "var(--colors-blue-700)",
    "variable": "var(--colors-blue-700)"
  },
  "colors.blue.800": {
    "value": "var(--colors-blue-800)",
    "variable": "var(--colors-blue-800)"
  },
  "colors.blue.900": {
    "value": "var(--colors-blue-900)",
    "variable": "var(--colors-blue-900)"
  },
  "colors.blue.950": {
    "value": "var(--colors-blue-950)",
    "variable": "var(--colors-blue-950)"
  },
  "colors.legacy.coolGray.100": {
    "value": "var(--colors-legacy-cool-gray-100)",
    "variable": "var(--colors-legacy-cool-gray-100)"
  },
  "colors.legacy.coolGray.200": {
    "value": "var(--colors-legacy-cool-gray-200)",
    "variable": "var(--colors-legacy-cool-gray-200)"
  },
  "colors.legacy.coolGray.300": {
    "value": "var(--colors-legacy-cool-gray-300)",
    "variable": "var(--colors-legacy-cool-gray-300)"
  },
  "colors.legacy.coolGray.400": {
    "value": "var(--colors-legacy-cool-gray-400)",
    "variable": "var(--colors-legacy-cool-gray-400)"
  },
  "colors.legacy.coolGray.500": {
    "value": "var(--colors-legacy-cool-gray-500)",
    "variable": "var(--colors-legacy-cool-gray-500)"
  },
  "colors.legacy.coolGray.600": {
    "value": "var(--colors-legacy-cool-gray-600)",
    "variable": "var(--colors-legacy-cool-gray-600)"
  },
  "colors.legacy.orangeRed.100": {
    "value": "var(--colors-legacy-orange-red-100)",
    "variable": "var(--colors-legacy-orange-red-100)"
  },
  "colors.legacy.orangeRed.200": {
    "value": "var(--colors-legacy-orange-red-200)",
    "variable": "var(--colors-legacy-orange-red-200)"
  },
  "colors.legacy.orangeRed.300": {
    "value": "var(--colors-legacy-orange-red-300)",
    "variable": "var(--colors-legacy-orange-red-300)"
  },
  "colors.legacy.orangeRed.400": {
    "value": "var(--colors-legacy-orange-red-400)",
    "variable": "var(--colors-legacy-orange-red-400)"
  },
  "colors.legacy.orangeRed.500": {
    "value": "var(--colors-legacy-orange-red-500)",
    "variable": "var(--colors-legacy-orange-red-500)"
  },
  "colors.legacy.orangeRed.600": {
    "value": "var(--colors-legacy-orange-red-600)",
    "variable": "var(--colors-legacy-orange-red-600)"
  },
  "colors.gray.50": {
    "value": "var(--colors-gray-50)",
    "variable": "var(--colors-gray-50)"
  },
  "colors.gray.100": {
    "value": "var(--colors-gray-100)",
    "variable": "var(--colors-gray-100)"
  },
  "colors.gray.200": {
    "value": "var(--colors-gray-200)",
    "variable": "var(--colors-gray-200)"
  },
  "colors.gray.300": {
    "value": "var(--colors-gray-300)",
    "variable": "var(--colors-gray-300)"
  },
  "colors.gray.400": {
    "value": "var(--colors-gray-400)",
    "variable": "var(--colors-gray-400)"
  },
  "colors.gray.500": {
    "value": "var(--colors-gray-500)",
    "variable": "var(--colors-gray-500)"
  },
  "colors.gray.600": {
    "value": "var(--colors-gray-600)",
    "variable": "var(--colors-gray-600)"
  },
  "colors.gray.700": {
    "value": "var(--colors-gray-700)",
    "variable": "var(--colors-gray-700)"
  },
  "colors.gray.800": {
    "value": "var(--colors-gray-800)",
    "variable": "var(--colors-gray-800)"
  },
  "colors.gray.900": {
    "value": "var(--colors-gray-900)",
    "variable": "var(--colors-gray-900)"
  },
  "colors.gray.950": {
    "value": "var(--colors-gray-950)",
    "variable": "var(--colors-gray-950)"
  },
  "colors.green.50": {
    "value": "var(--colors-green-50)",
    "variable": "var(--colors-green-50)"
  },
  "colors.green.100": {
    "value": "var(--colors-green-100)",
    "variable": "var(--colors-green-100)"
  },
  "colors.green.200": {
    "value": "var(--colors-green-200)",
    "variable": "var(--colors-green-200)"
  },
  "colors.green.300": {
    "value": "var(--colors-green-300)",
    "variable": "var(--colors-green-300)"
  },
  "colors.green.400": {
    "value": "var(--colors-green-400)",
    "variable": "var(--colors-green-400)"
  },
  "colors.green.500": {
    "value": "var(--colors-green-500)",
    "variable": "var(--colors-green-500)"
  },
  "colors.green.600": {
    "value": "var(--colors-green-600)",
    "variable": "var(--colors-green-600)"
  },
  "colors.green.700": {
    "value": "var(--colors-green-700)",
    "variable": "var(--colors-green-700)"
  },
  "colors.green.800": {
    "value": "var(--colors-green-800)",
    "variable": "var(--colors-green-800)"
  },
  "colors.green.900": {
    "value": "var(--colors-green-900)",
    "variable": "var(--colors-green-900)"
  },
  "colors.green.950": {
    "value": "var(--colors-green-950)",
    "variable": "var(--colors-green-950)"
  },
  "colors.orange.50": {
    "value": "var(--colors-orange-50)",
    "variable": "var(--colors-orange-50)"
  },
  "colors.orange.100": {
    "value": "var(--colors-orange-100)",
    "variable": "var(--colors-orange-100)"
  },
  "colors.orange.200": {
    "value": "var(--colors-orange-200)",
    "variable": "var(--colors-orange-200)"
  },
  "colors.orange.300": {
    "value": "var(--colors-orange-300)",
    "variable": "var(--colors-orange-300)"
  },
  "colors.orange.400": {
    "value": "var(--colors-orange-400)",
    "variable": "var(--colors-orange-400)"
  },
  "colors.orange.500": {
    "value": "var(--colors-orange-500)",
    "variable": "var(--colors-orange-500)"
  },
  "colors.orange.600": {
    "value": "var(--colors-orange-600)",
    "variable": "var(--colors-orange-600)"
  },
  "colors.orange.700": {
    "value": "var(--colors-orange-700)",
    "variable": "var(--colors-orange-700)"
  },
  "colors.orange.800": {
    "value": "var(--colors-orange-800)",
    "variable": "var(--colors-orange-800)"
  },
  "colors.orange.900": {
    "value": "var(--colors-orange-900)",
    "variable": "var(--colors-orange-900)"
  },
  "colors.orange.950": {
    "value": "var(--colors-orange-950)",
    "variable": "var(--colors-orange-950)"
  },
  "colors.purple.50": {
    "value": "var(--colors-purple-50)",
    "variable": "var(--colors-purple-50)"
  },
  "colors.purple.100": {
    "value": "var(--colors-purple-100)",
    "variable": "var(--colors-purple-100)"
  },
  "colors.purple.200": {
    "value": "var(--colors-purple-200)",
    "variable": "var(--colors-purple-200)"
  },
  "colors.purple.300": {
    "value": "var(--colors-purple-300)",
    "variable": "var(--colors-purple-300)"
  },
  "colors.purple.400": {
    "value": "var(--colors-purple-400)",
    "variable": "var(--colors-purple-400)"
  },
  "colors.purple.500": {
    "value": "var(--colors-purple-500)",
    "variable": "var(--colors-purple-500)"
  },
  "colors.purple.600": {
    "value": "var(--colors-purple-600)",
    "variable": "var(--colors-purple-600)"
  },
  "colors.purple.700": {
    "value": "var(--colors-purple-700)",
    "variable": "var(--colors-purple-700)"
  },
  "colors.purple.800": {
    "value": "var(--colors-purple-800)",
    "variable": "var(--colors-purple-800)"
  },
  "colors.purple.900": {
    "value": "var(--colors-purple-900)",
    "variable": "var(--colors-purple-900)"
  },
  "colors.purple.950": {
    "value": "var(--colors-purple-950)",
    "variable": "var(--colors-purple-950)"
  },
  "colors.red.50": {
    "value": "var(--colors-red-50)",
    "variable": "var(--colors-red-50)"
  },
  "colors.red.100": {
    "value": "var(--colors-red-100)",
    "variable": "var(--colors-red-100)"
  },
  "colors.red.200": {
    "value": "var(--colors-red-200)",
    "variable": "var(--colors-red-200)"
  },
  "colors.red.300": {
    "value": "var(--colors-red-300)",
    "variable": "var(--colors-red-300)"
  },
  "colors.red.400": {
    "value": "var(--colors-red-400)",
    "variable": "var(--colors-red-400)"
  },
  "colors.red.500": {
    "value": "var(--colors-red-500)",
    "variable": "var(--colors-red-500)"
  },
  "colors.red.600": {
    "value": "var(--colors-red-600)",
    "variable": "var(--colors-red-600)"
  },
  "colors.red.700": {
    "value": "var(--colors-red-700)",
    "variable": "var(--colors-red-700)"
  },
  "colors.red.800": {
    "value": "var(--colors-red-800)",
    "variable": "var(--colors-red-800)"
  },
  "colors.red.900": {
    "value": "var(--colors-red-900)",
    "variable": "var(--colors-red-900)"
  },
  "colors.red.950": {
    "value": "var(--colors-red-950)",
    "variable": "var(--colors-red-950)"
  },
  "colors.teal.50": {
    "value": "var(--colors-teal-50)",
    "variable": "var(--colors-teal-50)"
  },
  "colors.teal.100": {
    "value": "var(--colors-teal-100)",
    "variable": "var(--colors-teal-100)"
  },
  "colors.teal.200": {
    "value": "var(--colors-teal-200)",
    "variable": "var(--colors-teal-200)"
  },
  "colors.teal.300": {
    "value": "var(--colors-teal-300)",
    "variable": "var(--colors-teal-300)"
  },
  "colors.teal.400": {
    "value": "var(--colors-teal-400)",
    "variable": "var(--colors-teal-400)"
  },
  "colors.teal.500": {
    "value": "var(--colors-teal-500)",
    "variable": "var(--colors-teal-500)"
  },
  "colors.teal.600": {
    "value": "var(--colors-teal-600)",
    "variable": "var(--colors-teal-600)"
  },
  "colors.teal.700": {
    "value": "var(--colors-teal-700)",
    "variable": "var(--colors-teal-700)"
  },
  "colors.teal.800": {
    "value": "var(--colors-teal-800)",
    "variable": "var(--colors-teal-800)"
  },
  "colors.teal.900": {
    "value": "var(--colors-teal-900)",
    "variable": "var(--colors-teal-900)"
  },
  "colors.teal.950": {
    "value": "var(--colors-teal-950)",
    "variable": "var(--colors-teal-950)"
  },
  "colors.transparent.invisible": {
    "value": "var(--colors-transparent-invisible)",
    "variable": "var(--colors-transparent-invisible)"
  },
  "colors.transparent.black-0": {
    "value": "var(--colors-transparent-black-0)",
    "variable": "var(--colors-transparent-black-0)"
  },
  "colors.transparent.black-15": {
    "value": "var(--colors-transparent-black-15)",
    "variable": "var(--colors-transparent-black-15)"
  },
  "colors.transparent.black-20": {
    "value": "var(--colors-transparent-black-20)",
    "variable": "var(--colors-transparent-black-20)"
  },
  "colors.transparent.black-30": {
    "value": "var(--colors-transparent-black-30)",
    "variable": "var(--colors-transparent-black-30)"
  },
  "colors.transparent.black-60": {
    "value": "var(--colors-transparent-black-60)",
    "variable": "var(--colors-transparent-black-60)"
  },
  "colors.transparent.black-75": {
    "value": "var(--colors-transparent-black-75)",
    "variable": "var(--colors-transparent-black-75)"
  },
  "colors.transparent.white-0": {
    "value": "var(--colors-transparent-white-0)",
    "variable": "var(--colors-transparent-white-0)"
  },
  "colors.transparent.white-30": {
    "value": "var(--colors-transparent-white-30)",
    "variable": "var(--colors-transparent-white-30)"
  },
  "colors.transparent.white-40": {
    "value": "var(--colors-transparent-white-40)",
    "variable": "var(--colors-transparent-white-40)"
  },
  "colors.transparent.white-60": {
    "value": "var(--colors-transparent-white-60)",
    "variable": "var(--colors-transparent-white-60)"
  },
  "colors.transparent.white-80": {
    "value": "var(--colors-transparent-white-80)",
    "variable": "var(--colors-transparent-white-80)"
  },
  "colors.transparent.gray.50-0": {
    "value": "var(--colors-transparent-gray-50-0)",
    "variable": "var(--colors-transparent-gray-50-0)"
  },
  "colors.transparent.gray.100-0": {
    "value": "var(--colors-transparent-gray-100-0)",
    "variable": "var(--colors-transparent-gray-100-0)"
  },
  "colors.transparent.gray.200-0": {
    "value": "var(--colors-transparent-gray-200-0)",
    "variable": "var(--colors-transparent-gray-200-0)"
  },
  "colors.transparent.gray.300-0": {
    "value": "var(--colors-transparent-gray-300-0)",
    "variable": "var(--colors-transparent-gray-300-0)"
  },
  "colors.transparent.gray.400-0": {
    "value": "var(--colors-transparent-gray-400-0)",
    "variable": "var(--colors-transparent-gray-400-0)"
  },
  "colors.transparent.gray.400-20": {
    "value": "var(--colors-transparent-gray-400-20)",
    "variable": "var(--colors-transparent-gray-400-20)"
  },
  "colors.transparent.gray.400-30": {
    "value": "var(--colors-transparent-gray-400-30)",
    "variable": "var(--colors-transparent-gray-400-30)"
  },
  "colors.transparent.gray.500-0": {
    "value": "var(--colors-transparent-gray-500-0)",
    "variable": "var(--colors-transparent-gray-500-0)"
  },
  "colors.transparent.gray.500-20": {
    "value": "var(--colors-transparent-gray-500-20)",
    "variable": "var(--colors-transparent-gray-500-20)"
  },
  "colors.transparent.gray.500-30": {
    "value": "var(--colors-transparent-gray-500-30)",
    "variable": "var(--colors-transparent-gray-500-30)"
  },
  "colors.transparent.gray.600-0": {
    "value": "var(--colors-transparent-gray-600-0)",
    "variable": "var(--colors-transparent-gray-600-0)"
  },
  "colors.transparent.gray.600-20": {
    "value": "var(--colors-transparent-gray-600-20)",
    "variable": "var(--colors-transparent-gray-600-20)"
  },
  "colors.transparent.gray.600-30": {
    "value": "var(--colors-transparent-gray-600-30)",
    "variable": "var(--colors-transparent-gray-600-30)"
  },
  "colors.transparent.gray.600-40": {
    "value": "var(--colors-transparent-gray-600-40)",
    "variable": "var(--colors-transparent-gray-600-40)"
  },
  "colors.transparent.gray.600-60": {
    "value": "var(--colors-transparent-gray-600-60)",
    "variable": "var(--colors-transparent-gray-600-60)"
  },
  "colors.transparent.gray.700-0": {
    "value": "var(--colors-transparent-gray-700-0)",
    "variable": "var(--colors-transparent-gray-700-0)"
  },
  "colors.transparent.gray.700-80": {
    "value": "var(--colors-transparent-gray-700-80)",
    "variable": "var(--colors-transparent-gray-700-80)"
  },
  "colors.transparent.gray.800-0": {
    "value": "var(--colors-transparent-gray-800-0)",
    "variable": "var(--colors-transparent-gray-800-0)"
  },
  "colors.transparent.gray.900-0": {
    "value": "var(--colors-transparent-gray-900-0)",
    "variable": "var(--colors-transparent-gray-900-0)"
  },
  "colors.transparent.gray.900-80": {
    "value": "var(--colors-transparent-gray-900-80)",
    "variable": "var(--colors-transparent-gray-900-80)"
  },
  "colors.transparent.gray.950-20": {
    "value": "var(--colors-transparent-gray-950-20)",
    "variable": "var(--colors-transparent-gray-950-20)"
  },
  "colors.transparent.gray.950-30": {
    "value": "var(--colors-transparent-gray-950-30)",
    "variable": "var(--colors-transparent-gray-950-30)"
  },
  "colors.white": {
    "value": "var(--colors-white)",
    "variable": "var(--colors-white)"
  },
  "colors.yellow.50": {
    "value": "var(--colors-yellow-50)",
    "variable": "var(--colors-yellow-50)"
  },
  "colors.yellow.100": {
    "value": "var(--colors-yellow-100)",
    "variable": "var(--colors-yellow-100)"
  },
  "colors.yellow.200": {
    "value": "var(--colors-yellow-200)",
    "variable": "var(--colors-yellow-200)"
  },
  "colors.yellow.300": {
    "value": "var(--colors-yellow-300)",
    "variable": "var(--colors-yellow-300)"
  },
  "colors.yellow.400": {
    "value": "var(--colors-yellow-400)",
    "variable": "var(--colors-yellow-400)"
  },
  "colors.yellow.500": {
    "value": "var(--colors-yellow-500)",
    "variable": "var(--colors-yellow-500)"
  },
  "colors.yellow.600": {
    "value": "var(--colors-yellow-600)",
    "variable": "var(--colors-yellow-600)"
  },
  "colors.yellow.700": {
    "value": "var(--colors-yellow-700)",
    "variable": "var(--colors-yellow-700)"
  },
  "colors.yellow.800": {
    "value": "var(--colors-yellow-800)",
    "variable": "var(--colors-yellow-800)"
  },
  "colors.yellow.900": {
    "value": "var(--colors-yellow-900)",
    "variable": "var(--colors-yellow-900)"
  },
  "colors.yellow.950": {
    "value": "var(--colors-yellow-950)",
    "variable": "var(--colors-yellow-950)"
  },
  "borderWidths.25": {
    "value": "var(--border-widths-25)",
    "variable": "var(--border-widths-25)"
  },
  "borderWidths.50": {
    "value": "var(--border-widths-50)",
    "variable": "var(--border-widths-50)"
  },
  "borderWidths.100": {
    "value": "var(--border-widths-100)",
    "variable": "var(--border-widths-100)"
  },
  "borderWidths.150": {
    "value": "var(--border-widths-150)",
    "variable": "var(--border-widths-150)"
  },
  "borderWidths.zero": {
    "value": "var(--border-widths-zero)",
    "variable": "var(--border-widths-zero)"
  },
  "radii.50": {
    "value": "var(--radii-50)",
    "variable": "var(--radii-50)"
  },
  "radii.100": {
    "value": "var(--radii-100)",
    "variable": "var(--radii-100)"
  },
  "radii.150": {
    "value": "var(--radii-150)",
    "variable": "var(--radii-150)"
  },
  "radii.200": {
    "value": "var(--radii-200)",
    "variable": "var(--radii-200)"
  },
  "radii.300": {
    "value": "var(--radii-300)",
    "variable": "var(--radii-300)"
  },
  "radii.400": {
    "value": "var(--radii-400)",
    "variable": "var(--radii-400)"
  },
  "radii.500": {
    "value": "var(--radii-500)",
    "variable": "var(--radii-500)"
  },
  "radii.600": {
    "value": "var(--radii-600)",
    "variable": "var(--radii-600)"
  },
  "radii.700": {
    "value": "var(--radii-700)",
    "variable": "var(--radii-700)"
  },
  "radii.zero": {
    "value": "var(--radii-zero)",
    "variable": "var(--radii-zero)"
  },
  "radii.capsule": {
    "value": "var(--radii-capsule)",
    "variable": "var(--radii-capsule)"
  },
  "radii.ellipse": {
    "value": "var(--radii-ellipse)",
    "variable": "var(--radii-ellipse)"
  },
  "spacing.25": {
    "value": "var(--spacing-25)",
    "variable": "var(--spacing-25)"
  },
  "spacing.50": {
    "value": "var(--spacing-50)",
    "variable": "var(--spacing-50)"
  },
  "spacing.100": {
    "value": "var(--spacing-100)",
    "variable": "var(--spacing-100)"
  },
  "spacing.150": {
    "value": "var(--spacing-150)",
    "variable": "var(--spacing-150)"
  },
  "spacing.200": {
    "value": "var(--spacing-200)",
    "variable": "var(--spacing-200)"
  },
  "spacing.250": {
    "value": "var(--spacing-250)",
    "variable": "var(--spacing-250)"
  },
  "spacing.300": {
    "value": "var(--spacing-300)",
    "variable": "var(--spacing-300)"
  },
  "spacing.350": {
    "value": "var(--spacing-350)",
    "variable": "var(--spacing-350)"
  },
  "spacing.400": {
    "value": "var(--spacing-400)",
    "variable": "var(--spacing-400)"
  },
  "spacing.500": {
    "value": "var(--spacing-500)",
    "variable": "var(--spacing-500)"
  },
  "spacing.600": {
    "value": "var(--spacing-600)",
    "variable": "var(--spacing-600)"
  },
  "spacing.700": {
    "value": "var(--spacing-700)",
    "variable": "var(--spacing-700)"
  },
  "spacing.800": {
    "value": "var(--spacing-800)",
    "variable": "var(--spacing-800)"
  },
  "spacing.900": {
    "value": "var(--spacing-900)",
    "variable": "var(--spacing-900)"
  },
  "spacing.1000": {
    "value": "var(--spacing-1000)",
    "variable": "var(--spacing-1000)"
  },
  "spacing.1100": {
    "value": "var(--spacing-1100)",
    "variable": "var(--spacing-1100)"
  },
  "spacing.1200": {
    "value": "var(--spacing-1200)",
    "variable": "var(--spacing-1200)"
  },
  "spacing.1300": {
    "value": "var(--spacing-1300)",
    "variable": "var(--spacing-1300)"
  },
  "spacing.1400": {
    "value": "var(--spacing-1400)",
    "variable": "var(--spacing-1400)"
  },
  "spacing.1500": {
    "value": "var(--spacing-1500)",
    "variable": "var(--spacing-1500)"
  },
  "spacing.1600": {
    "value": "var(--spacing-1600)",
    "variable": "var(--spacing-1600)"
  },
  "spacing.1800": {
    "value": "var(--spacing-1800)",
    "variable": "var(--spacing-1800)"
  },
  "spacing.2400": {
    "value": "var(--spacing-2400)",
    "variable": "var(--spacing-2400)"
  },
  "spacing.negative-25": {
    "value": "var(--spacing-negative-25)",
    "variable": "var(--spacing-negative-25)"
  },
  "spacing.zero": {
    "value": "var(--spacing-zero)",
    "variable": "var(--spacing-zero)"
  },
  "sizes.25": {
    "value": "var(--sizes-25)",
    "variable": "var(--sizes-25)"
  },
  "sizes.50": {
    "value": "var(--sizes-50)",
    "variable": "var(--sizes-50)"
  },
  "sizes.75": {
    "value": "var(--sizes-75)",
    "variable": "var(--sizes-75)"
  },
  "sizes.100": {
    "value": "var(--sizes-100)",
    "variable": "var(--sizes-100)"
  },
  "sizes.150": {
    "value": "var(--sizes-150)",
    "variable": "var(--sizes-150)"
  },
  "sizes.200": {
    "value": "var(--sizes-200)",
    "variable": "var(--sizes-200)"
  },
  "sizes.250": {
    "value": "var(--sizes-250)",
    "variable": "var(--sizes-250)"
  },
  "sizes.300": {
    "value": "var(--sizes-300)",
    "variable": "var(--sizes-300)"
  },
  "sizes.350": {
    "value": "var(--sizes-350)",
    "variable": "var(--sizes-350)"
  },
  "sizes.400": {
    "value": "var(--sizes-400)",
    "variable": "var(--sizes-400)"
  },
  "sizes.500": {
    "value": "var(--sizes-500)",
    "variable": "var(--sizes-500)"
  },
  "sizes.600": {
    "value": "var(--sizes-600)",
    "variable": "var(--sizes-600)"
  },
  "sizes.700": {
    "value": "var(--sizes-700)",
    "variable": "var(--sizes-700)"
  },
  "sizes.750": {
    "value": "var(--sizes-750)",
    "variable": "var(--sizes-750)"
  },
  "sizes.800": {
    "value": "var(--sizes-800)",
    "variable": "var(--sizes-800)"
  },
  "sizes.900": {
    "value": "var(--sizes-900)",
    "variable": "var(--sizes-900)"
  },
  "sizes.1000": {
    "value": "var(--sizes-1000)",
    "variable": "var(--sizes-1000)"
  },
  "sizes.1100": {
    "value": "var(--sizes-1100)",
    "variable": "var(--sizes-1100)"
  },
  "sizes.1200": {
    "value": "var(--sizes-1200)",
    "variable": "var(--sizes-1200)"
  },
  "sizes.1300": {
    "value": "var(--sizes-1300)",
    "variable": "var(--sizes-1300)"
  },
  "sizes.1400": {
    "value": "var(--sizes-1400)",
    "variable": "var(--sizes-1400)"
  },
  "sizes.1500": {
    "value": "var(--sizes-1500)",
    "variable": "var(--sizes-1500)"
  },
  "sizes.1600": {
    "value": "var(--sizes-1600)",
    "variable": "var(--sizes-1600)"
  },
  "sizes.1700": {
    "value": "var(--sizes-1700)",
    "variable": "var(--sizes-1700)"
  },
  "sizes.1800": {
    "value": "var(--sizes-1800)",
    "variable": "var(--sizes-1800)"
  },
  "sizes.1900": {
    "value": "var(--sizes-1900)",
    "variable": "var(--sizes-1900)"
  },
  "sizes.2000": {
    "value": "var(--sizes-2000)",
    "variable": "var(--sizes-2000)"
  },
  "sizes.2100": {
    "value": "var(--sizes-2100)",
    "variable": "var(--sizes-2100)"
  },
  "sizes.2200": {
    "value": "var(--sizes-2200)",
    "variable": "var(--sizes-2200)"
  },
  "sizes.2300": {
    "value": "var(--sizes-2300)",
    "variable": "var(--sizes-2300)"
  },
  "sizes.2400": {
    "value": "var(--sizes-2400)",
    "variable": "var(--sizes-2400)"
  },
  "sizes.2500": {
    "value": "var(--sizes-2500)",
    "variable": "var(--sizes-2500)"
  },
  "sizes.2600": {
    "value": "var(--sizes-2600)",
    "variable": "var(--sizes-2600)"
  },
  "sizes.3600": {
    "value": "var(--sizes-3600)",
    "variable": "var(--sizes-3600)"
  },
  "sizes.4000": {
    "value": "var(--sizes-4000)",
    "variable": "var(--sizes-4000)"
  },
  "sizes.5000": {
    "value": "var(--sizes-5000)",
    "variable": "var(--sizes-5000)"
  },
  "sizes.zero": {
    "value": "var(--sizes-zero)",
    "variable": "var(--sizes-zero)"
  },
  "sizes.effect.blur.25": {
    "value": "var(--sizes-effect-blur-25)",
    "variable": "var(--sizes-effect-blur-25)"
  },
  "sizes.effect.blur.50": {
    "value": "var(--sizes-effect-blur-50)",
    "variable": "var(--sizes-effect-blur-50)"
  },
  "sizes.effect.blur.100": {
    "value": "var(--sizes-effect-blur-100)",
    "variable": "var(--sizes-effect-blur-100)"
  },
  "sizes.effect.blur.200": {
    "value": "var(--sizes-effect-blur-200)",
    "variable": "var(--sizes-effect-blur-200)"
  },
  "sizes.effect.blur.300": {
    "value": "var(--sizes-effect-blur-300)",
    "variable": "var(--sizes-effect-blur-300)"
  },
  "sizes.effect.blur.400": {
    "value": "var(--sizes-effect-blur-400)",
    "variable": "var(--sizes-effect-blur-400)"
  },
  "sizes.effect.blur.500": {
    "value": "var(--sizes-effect-blur-500)",
    "variable": "var(--sizes-effect-blur-500)"
  },
  "sizes.effect.blur.750": {
    "value": "var(--sizes-effect-blur-750)",
    "variable": "var(--sizes-effect-blur-750)"
  },
  "sizes.effect.offset.50": {
    "value": "var(--sizes-effect-offset-50)",
    "variable": "var(--sizes-effect-offset-50)"
  },
  "sizes.effect.offset.100": {
    "value": "var(--sizes-effect-offset-100)",
    "variable": "var(--sizes-effect-offset-100)"
  },
  "sizes.effect.offset.150": {
    "value": "var(--sizes-effect-offset-150)",
    "variable": "var(--sizes-effect-offset-150)"
  },
  "sizes.effect.offset.200": {
    "value": "var(--sizes-effect-offset-200)",
    "variable": "var(--sizes-effect-offset-200)"
  },
  "sizes.effect.offset.400": {
    "value": "var(--sizes-effect-offset-400)",
    "variable": "var(--sizes-effect-offset-400)"
  },
  "sizes.effect.offset.none": {
    "value": "var(--sizes-effect-offset-none)",
    "variable": "var(--sizes-effect-offset-none)"
  },
  "sizes.effect.spread.25": {
    "value": "var(--sizes-effect-spread-25)",
    "variable": "var(--sizes-effect-spread-25)"
  },
  "sizes.effect.spread.75": {
    "value": "var(--sizes-effect-spread-75)",
    "variable": "var(--sizes-effect-spread-75)"
  },
  "sizes.effect.spread.100": {
    "value": "var(--sizes-effect-spread-100)",
    "variable": "var(--sizes-effect-spread-100)"
  },
  "sizes.effect.spread.none": {
    "value": "var(--sizes-effect-spread-none)",
    "variable": "var(--sizes-effect-spread-none)"
  },
  "shadows.none": {
    "value": "var(--shadows-none)",
    "variable": "var(--shadows-none)"
  },
  "shadows.focus": {
    "value": "var(--shadows-focus)",
    "variable": "var(--shadows-focus)"
  },
  "shadows.sm": {
    "value": "var(--shadows-sm)",
    "variable": "var(--shadows-sm)"
  },
  "shadows.smHeavy": {
    "value": "var(--shadows-sm-heavy)",
    "variable": "var(--shadows-sm-heavy)"
  },
  "shadows.md": {
    "value": "var(--shadows-md)",
    "variable": "var(--shadows-md)"
  },
  "shadows.lg": {
    "value": "var(--shadows-lg)",
    "variable": "var(--shadows-lg)"
  },
  "opacity.8": {
    "value": "var(--opacity-8)",
    "variable": "var(--opacity-8)"
  },
  "opacity.10": {
    "value": "var(--opacity-10)",
    "variable": "var(--opacity-10)"
  },
  "opacity.12": {
    "value": "var(--opacity-12)",
    "variable": "var(--opacity-12)"
  },
  "opacity.15": {
    "value": "var(--opacity-15)",
    "variable": "var(--opacity-15)"
  },
  "opacity.20": {
    "value": "var(--opacity-20)",
    "variable": "var(--opacity-20)"
  },
  "opacity.30": {
    "value": "var(--opacity-30)",
    "variable": "var(--opacity-30)"
  },
  "opacity.32": {
    "value": "var(--opacity-32)",
    "variable": "var(--opacity-32)"
  },
  "opacity.40": {
    "value": "var(--opacity-40)",
    "variable": "var(--opacity-40)"
  },
  "opacity.50": {
    "value": "var(--opacity-50)",
    "variable": "var(--opacity-50)"
  },
  "opacity.60": {
    "value": "var(--opacity-60)",
    "variable": "var(--opacity-60)"
  },
  "opacity.70": {
    "value": "var(--opacity-70)",
    "variable": "var(--opacity-70)"
  },
  "opacity.75": {
    "value": "var(--opacity-75)",
    "variable": "var(--opacity-75)"
  },
  "opacity.80": {
    "value": "var(--opacity-80)",
    "variable": "var(--opacity-80)"
  },
  "opacity.100": {
    "value": "var(--opacity-100)",
    "variable": "var(--opacity-100)"
  },
  "opacity.zero": {
    "value": "var(--opacity-zero)",
    "variable": "var(--opacity-zero)"
  },
  "fonts.brand": {
    "value": "var(--fonts-brand)",
    "variable": "var(--fonts-brand)"
  },
  "fonts.ui": {
    "value": "var(--fonts-ui)",
    "variable": "var(--fonts-ui)"
  },
  "lineHeights.400": {
    "value": "var(--line-heights-400)",
    "variable": "var(--line-heights-400)"
  },
  "lineHeights.600": {
    "value": "var(--line-heights-600)",
    "variable": "var(--line-heights-600)"
  },
  "lineHeights.800": {
    "value": "var(--line-heights-800)",
    "variable": "var(--line-heights-800)"
  },
  "lineHeights.1000": {
    "value": "var(--line-heights-1000)",
    "variable": "var(--line-heights-1000)"
  },
  "lineHeights.1200": {
    "value": "var(--line-heights-1200)",
    "variable": "var(--line-heights-1200)"
  },
  "lineHeights.1400": {
    "value": "var(--line-heights-1400)",
    "variable": "var(--line-heights-1400)"
  },
  "lineHeights.1600": {
    "value": "var(--line-heights-1600)",
    "variable": "var(--line-heights-1600)"
  },
  "lineHeights.1800": {
    "value": "var(--line-heights-1800)",
    "variable": "var(--line-heights-1800)"
  },
  "fontWeights.regular": {
    "value": "var(--font-weights-regular)",
    "variable": "var(--font-weights-regular)"
  },
  "fontWeights.bold": {
    "value": "var(--font-weights-bold)",
    "variable": "var(--font-weights-bold)"
  },
  "fontWeights.heavy": {
    "value": "var(--font-weights-heavy)",
    "variable": "var(--font-weights-heavy)"
  },
  "fontWeights.heading": {
    "value": "var(--font-weights-heading)",
    "variable": "var(--font-weights-heading)"
  },
  "fontWeights.emphasis": {
    "value": "var(--font-weights-emphasis)",
    "variable": "var(--font-weights-emphasis)"
  },
  "fontWeights.default": {
    "value": "var(--font-weights-default)",
    "variable": "var(--font-weights-default)"
  },
  "fontWeights.responsive.default.mobile": {
    "value": "var(--font-weights-responsive-default-mobile)",
    "variable": "var(--font-weights-responsive-default-mobile)"
  },
  "fontWeights.responsive.default.tablet": {
    "value": "var(--font-weights-responsive-default-tablet)",
    "variable": "var(--font-weights-responsive-default-tablet)"
  },
  "fontWeights.responsive.default.desktop": {
    "value": "var(--font-weights-responsive-default-desktop)",
    "variable": "var(--font-weights-responsive-default-desktop)"
  },
  "fontWeights.responsive.emphasis.mobile": {
    "value": "var(--font-weights-responsive-emphasis-mobile)",
    "variable": "var(--font-weights-responsive-emphasis-mobile)"
  },
  "fontWeights.responsive.emphasis.tablet": {
    "value": "var(--font-weights-responsive-emphasis-tablet)",
    "variable": "var(--font-weights-responsive-emphasis-tablet)"
  },
  "fontWeights.responsive.emphasis.desktop": {
    "value": "var(--font-weights-responsive-emphasis-desktop)",
    "variable": "var(--font-weights-responsive-emphasis-desktop)"
  },
  "fontWeights.responsive.heading.mobile": {
    "value": "var(--font-weights-responsive-heading-mobile)",
    "variable": "var(--font-weights-responsive-heading-mobile)"
  },
  "fontWeights.responsive.heading.tablet": {
    "value": "var(--font-weights-responsive-heading-tablet)",
    "variable": "var(--font-weights-responsive-heading-tablet)"
  },
  "fontWeights.responsive.heading.desktop": {
    "value": "var(--font-weights-responsive-heading-desktop)",
    "variable": "var(--font-weights-responsive-heading-desktop)"
  },
  "fontSizes.250": {
    "value": "var(--font-sizes-250)",
    "variable": "var(--font-sizes-250)"
  },
  "fontSizes.300": {
    "value": "var(--font-sizes-300)",
    "variable": "var(--font-sizes-300)"
  },
  "fontSizes.350": {
    "value": "var(--font-sizes-350)",
    "variable": "var(--font-sizes-350)"
  },
  "fontSizes.400": {
    "value": "var(--font-sizes-400)",
    "variable": "var(--font-sizes-400)"
  },
  "fontSizes.450": {
    "value": "var(--font-sizes-450)",
    "variable": "var(--font-sizes-450)"
  },
  "fontSizes.500": {
    "value": "var(--font-sizes-500)",
    "variable": "var(--font-sizes-500)"
  },
  "fontSizes.600": {
    "value": "var(--font-sizes-600)",
    "variable": "var(--font-sizes-600)"
  },
  "fontSizes.700": {
    "value": "var(--font-sizes-700)",
    "variable": "var(--font-sizes-700)"
  },
  "fontSizes.800": {
    "value": "var(--font-sizes-800)",
    "variable": "var(--font-sizes-800)"
  },
  "fontSizes.900": {
    "value": "var(--font-sizes-900)",
    "variable": "var(--font-sizes-900)"
  },
  "fontSizes.1000": {
    "value": "var(--font-sizes-1000)",
    "variable": "var(--font-sizes-1000)"
  },
  "fontSizes.1100": {
    "value": "var(--font-sizes-1100)",
    "variable": "var(--font-sizes-1100)"
  },
  "fontSizes.1200": {
    "value": "var(--font-sizes-1200)",
    "variable": "var(--font-sizes-1200)"
  },
  "fontSizes.1500": {
    "value": "var(--font-sizes-1500)",
    "variable": "var(--font-sizes-1500)"
  },
  "letterSpacings.none": {
    "value": "var(--letter-spacings-none)",
    "variable": "var(--letter-spacings-none)"
  },
  "letterSpacings.default": {
    "value": "var(--letter-spacings-default)",
    "variable": "var(--letter-spacings-default)"
  },
  "zIndex.loadingMask": {
    "value": "var(--z-index-loading-mask)",
    "variable": "var(--z-index-loading-mask)"
  },
  "zIndex.combobox": {
    "value": "var(--z-index-combobox)",
    "variable": "var(--z-index-combobox)"
  },
  "zIndex.datePicker": {
    "value": "var(--z-index-date-picker)",
    "variable": "var(--z-index-date-picker)"
  },
  "zIndex.dropdown": {
    "value": "var(--z-index-dropdown)",
    "variable": "var(--z-index-dropdown)"
  },
  "zIndex.menu": {
    "value": "var(--z-index-menu)",
    "variable": "var(--z-index-menu)"
  },
  "zIndex.modal": {
    "value": "var(--z-index-modal)",
    "variable": "var(--z-index-modal)"
  },
  "zIndex.popover": {
    "value": "var(--z-index-popover)",
    "variable": "var(--z-index-popover)"
  },
  "zIndex.tooltip": {
    "value": "var(--z-index-tooltip)",
    "variable": "var(--z-index-tooltip)"
  },
  "zIndex.toast": {
    "value": "var(--z-index-toast)",
    "variable": "var(--z-index-toast)"
  },
  "colors.bg.accent.brand.hero": {
    "value": "var(--colors-bg-accent-brand-hero)",
    "variable": "var(--colors-bg-accent-brand-hero)"
  },
  "colors.bg.accent.brand.hero-fixed": {
    "value": "var(--colors-bg-accent-brand-hero-fixed)",
    "variable": "var(--colors-bg-accent-brand-hero-fixed)"
  },
  "colors.bg.accent.aqua.impact": {
    "value": "var(--colors-bg-accent-aqua-impact)",
    "variable": "var(--colors-bg-accent-aqua-impact)"
  },
  "colors.bg.accent.aqua.hero": {
    "value": "var(--colors-bg-accent-aqua-hero)",
    "variable": "var(--colors-bg-accent-aqua-hero)"
  },
  "colors.bg.accent.aqua.soft": {
    "value": "var(--colors-bg-accent-aqua-soft)",
    "variable": "var(--colors-bg-accent-aqua-soft)"
  },
  "colors.bg.accent.blue.impact": {
    "value": "var(--colors-bg-accent-blue-impact)",
    "variable": "var(--colors-bg-accent-blue-impact)"
  },
  "colors.bg.accent.blue.hero": {
    "value": "var(--colors-bg-accent-blue-hero)",
    "variable": "var(--colors-bg-accent-blue-hero)"
  },
  "colors.bg.accent.blue.soft": {
    "value": "var(--colors-bg-accent-blue-soft)",
    "variable": "var(--colors-bg-accent-blue-soft)"
  },
  "colors.bg.accent.gray.impact": {
    "value": "var(--colors-bg-accent-gray-impact)",
    "variable": "var(--colors-bg-accent-gray-impact)"
  },
  "colors.bg.accent.gray.hero": {
    "value": "var(--colors-bg-accent-gray-hero)",
    "variable": "var(--colors-bg-accent-gray-hero)"
  },
  "colors.bg.accent.gray.soft": {
    "value": "var(--colors-bg-accent-gray-soft)",
    "variable": "var(--colors-bg-accent-gray-soft)"
  },
  "colors.bg.accent.green.impact": {
    "value": "var(--colors-bg-accent-green-impact)",
    "variable": "var(--colors-bg-accent-green-impact)"
  },
  "colors.bg.accent.green.hero": {
    "value": "var(--colors-bg-accent-green-hero)",
    "variable": "var(--colors-bg-accent-green-hero)"
  },
  "colors.bg.accent.green.soft": {
    "value": "var(--colors-bg-accent-green-soft)",
    "variable": "var(--colors-bg-accent-green-soft)"
  },
  "colors.bg.accent.orange.impact": {
    "value": "var(--colors-bg-accent-orange-impact)",
    "variable": "var(--colors-bg-accent-orange-impact)"
  },
  "colors.bg.accent.orange.hero": {
    "value": "var(--colors-bg-accent-orange-hero)",
    "variable": "var(--colors-bg-accent-orange-hero)"
  },
  "colors.bg.accent.orange.soft": {
    "value": "var(--colors-bg-accent-orange-soft)",
    "variable": "var(--colors-bg-accent-orange-soft)"
  },
  "colors.bg.accent.purple.impact": {
    "value": "var(--colors-bg-accent-purple-impact)",
    "variable": "var(--colors-bg-accent-purple-impact)"
  },
  "colors.bg.accent.purple.hero": {
    "value": "var(--colors-bg-accent-purple-hero)",
    "variable": "var(--colors-bg-accent-purple-hero)"
  },
  "colors.bg.accent.purple.soft": {
    "value": "var(--colors-bg-accent-purple-soft)",
    "variable": "var(--colors-bg-accent-purple-soft)"
  },
  "colors.bg.accent.red.impact": {
    "value": "var(--colors-bg-accent-red-impact)",
    "variable": "var(--colors-bg-accent-red-impact)"
  },
  "colors.bg.accent.red.hero": {
    "value": "var(--colors-bg-accent-red-hero)",
    "variable": "var(--colors-bg-accent-red-hero)"
  },
  "colors.bg.accent.red.soft": {
    "value": "var(--colors-bg-accent-red-soft)",
    "variable": "var(--colors-bg-accent-red-soft)"
  },
  "colors.bg.accent.teal.impact": {
    "value": "var(--colors-bg-accent-teal-impact)",
    "variable": "var(--colors-bg-accent-teal-impact)"
  },
  "colors.bg.accent.teal.hero": {
    "value": "var(--colors-bg-accent-teal-hero)",
    "variable": "var(--colors-bg-accent-teal-hero)"
  },
  "colors.bg.accent.teal.soft": {
    "value": "var(--colors-bg-accent-teal-soft)",
    "variable": "var(--colors-bg-accent-teal-soft)"
  },
  "colors.bg.accent.yellow.impact": {
    "value": "var(--colors-bg-accent-yellow-impact)",
    "variable": "var(--colors-bg-accent-yellow-impact)"
  },
  "colors.bg.accent.yellow.hero": {
    "value": "var(--colors-bg-accent-yellow-hero)",
    "variable": "var(--colors-bg-accent-yellow-hero)"
  },
  "colors.bg.accent.yellow.soft": {
    "value": "var(--colors-bg-accent-yellow-soft)",
    "variable": "var(--colors-bg-accent-yellow-soft)"
  },
  "colors.bg.accent.yellow.soft-fixed": {
    "value": "var(--colors-bg-accent-yellow-soft-fixed)",
    "variable": "var(--colors-bg-accent-yellow-soft-fixed)"
  },
  "colors.bg.action.neutral.default": {
    "value": "var(--colors-bg-action-neutral-default)",
    "variable": "var(--colors-bg-action-neutral-default)"
  },
  "colors.bg.action.neutral.hover": {
    "value": "var(--colors-bg-action-neutral-hover)",
    "variable": "var(--colors-bg-action-neutral-hover)"
  },
  "colors.bg.action.neutral.pressed": {
    "value": "var(--colors-bg-action-neutral-pressed)",
    "variable": "var(--colors-bg-action-neutral-pressed)"
  },
  "colors.bg.action.neutral.selected.default": {
    "value": "var(--colors-bg-action-neutral-selected-default)",
    "variable": "var(--colors-bg-action-neutral-selected-default)"
  },
  "colors.bg.action.neutral.selected.hover": {
    "value": "var(--colors-bg-action-neutral-selected-hover)",
    "variable": "var(--colors-bg-action-neutral-selected-hover)"
  },
  "colors.bg.action.neutral.selected.pressed": {
    "value": "var(--colors-bg-action-neutral-selected-pressed)",
    "variable": "var(--colors-bg-action-neutral-selected-pressed)"
  },
  "colors.bg.action.neutral.alt.default": {
    "value": "var(--colors-bg-action-neutral-alt-default)",
    "variable": "var(--colors-bg-action-neutral-alt-default)"
  },
  "colors.bg.action.neutral.alt.hover": {
    "value": "var(--colors-bg-action-neutral-alt-hover)",
    "variable": "var(--colors-bg-action-neutral-alt-hover)"
  },
  "colors.bg.action.neutral.alt.pressed": {
    "value": "var(--colors-bg-action-neutral-alt-pressed)",
    "variable": "var(--colors-bg-action-neutral-alt-pressed)"
  },
  "colors.bg.action.soft.default": {
    "value": "var(--colors-bg-action-soft-default)",
    "variable": "var(--colors-bg-action-soft-default)"
  },
  "colors.bg.action.soft.hover": {
    "value": "var(--colors-bg-action-soft-hover)",
    "variable": "var(--colors-bg-action-soft-hover)"
  },
  "colors.bg.action.soft.pressed": {
    "value": "var(--colors-bg-action-soft-pressed)",
    "variable": "var(--colors-bg-action-soft-pressed)"
  },
  "colors.bg.action.soft.selected.default": {
    "value": "var(--colors-bg-action-soft-selected-default)",
    "variable": "var(--colors-bg-action-soft-selected-default)"
  },
  "colors.bg.action.soft.selected.hover": {
    "value": "var(--colors-bg-action-soft-selected-hover)",
    "variable": "var(--colors-bg-action-soft-selected-hover)"
  },
  "colors.bg.action.soft.selected.pressed": {
    "value": "var(--colors-bg-action-soft-selected-pressed)",
    "variable": "var(--colors-bg-action-soft-selected-pressed)"
  },
  "colors.bg.action.hero.default": {
    "value": "var(--colors-bg-action-hero-default)",
    "variable": "var(--colors-bg-action-hero-default)"
  },
  "colors.bg.action.hero.hover": {
    "value": "var(--colors-bg-action-hero-hover)",
    "variable": "var(--colors-bg-action-hero-hover)"
  },
  "colors.bg.action.hero.pressed": {
    "value": "var(--colors-bg-action-hero-pressed)",
    "variable": "var(--colors-bg-action-hero-pressed)"
  },
  "colors.bg.action.hero.selected.default": {
    "value": "var(--colors-bg-action-hero-selected-default)",
    "variable": "var(--colors-bg-action-hero-selected-default)"
  },
  "colors.bg.action.hero.selected.hover": {
    "value": "var(--colors-bg-action-hero-selected-hover)",
    "variable": "var(--colors-bg-action-hero-selected-hover)"
  },
  "colors.bg.action.hero.selected.pressed": {
    "value": "var(--colors-bg-action-hero-selected-pressed)",
    "variable": "var(--colors-bg-action-hero-selected-pressed)"
  },
  "colors.bg.action.bare.neutral.default": {
    "value": "var(--colors-bg-action-bare-neutral-default)",
    "variable": "var(--colors-bg-action-bare-neutral-default)"
  },
  "colors.bg.action.bare.neutral.hover": {
    "value": "var(--colors-bg-action-bare-neutral-hover)",
    "variable": "var(--colors-bg-action-bare-neutral-hover)"
  },
  "colors.bg.action.bare.neutral.pressed": {
    "value": "var(--colors-bg-action-bare-neutral-pressed)",
    "variable": "var(--colors-bg-action-bare-neutral-pressed)"
  },
  "colors.bg.action.impact.neutral.default": {
    "value": "var(--colors-bg-action-impact-neutral-default)",
    "variable": "var(--colors-bg-action-impact-neutral-default)"
  },
  "colors.bg.action.impact.neutral.hover": {
    "value": "var(--colors-bg-action-impact-neutral-hover)",
    "variable": "var(--colors-bg-action-impact-neutral-hover)"
  },
  "colors.bg.action.impact.neutral.pressed": {
    "value": "var(--colors-bg-action-impact-neutral-pressed)",
    "variable": "var(--colors-bg-action-impact-neutral-pressed)"
  },
  "colors.bg.action.impact.soft.default": {
    "value": "var(--colors-bg-action-impact-soft-default)",
    "variable": "var(--colors-bg-action-impact-soft-default)"
  },
  "colors.bg.action.impact.soft.hover": {
    "value": "var(--colors-bg-action-impact-soft-hover)",
    "variable": "var(--colors-bg-action-impact-soft-hover)"
  },
  "colors.bg.action.impact.soft.pressed": {
    "value": "var(--colors-bg-action-impact-soft-pressed)",
    "variable": "var(--colors-bg-action-impact-soft-pressed)"
  },
  "colors.bg.action.impact.bare.default": {
    "value": "var(--colors-bg-action-impact-bare-default)",
    "variable": "var(--colors-bg-action-impact-bare-default)"
  },
  "colors.bg.action.impact.bare.hover": {
    "value": "var(--colors-bg-action-impact-bare-hover)",
    "variable": "var(--colors-bg-action-impact-bare-hover)"
  },
  "colors.bg.action.impact.bare.pressed": {
    "value": "var(--colors-bg-action-impact-bare-pressed)",
    "variable": "var(--colors-bg-action-impact-bare-pressed)"
  },
  "colors.bg.action.impact.bare.fixed.default": {
    "value": "var(--colors-bg-action-impact-bare-fixed-default)",
    "variable": "var(--colors-bg-action-impact-bare-fixed-default)"
  },
  "colors.bg.action.impact.bare.fixed.hover": {
    "value": "var(--colors-bg-action-impact-bare-fixed-hover)",
    "variable": "var(--colors-bg-action-impact-bare-fixed-hover)"
  },
  "colors.bg.action.impact.bare.fixed.pressed": {
    "value": "var(--colors-bg-action-impact-bare-fixed-pressed)",
    "variable": "var(--colors-bg-action-impact-bare-fixed-pressed)"
  },
  "colors.bg.action.critical.neutral.default": {
    "value": "var(--colors-bg-action-critical-neutral-default)",
    "variable": "var(--colors-bg-action-critical-neutral-default)"
  },
  "colors.bg.action.critical.neutral.hover": {
    "value": "var(--colors-bg-action-critical-neutral-hover)",
    "variable": "var(--colors-bg-action-critical-neutral-hover)"
  },
  "colors.bg.action.critical.neutral.pressed": {
    "value": "var(--colors-bg-action-critical-neutral-pressed)",
    "variable": "var(--colors-bg-action-critical-neutral-pressed)"
  },
  "colors.bg.action.critical.hero.default": {
    "value": "var(--colors-bg-action-critical-hero-default)",
    "variable": "var(--colors-bg-action-critical-hero-default)"
  },
  "colors.bg.action.critical.hero.hover": {
    "value": "var(--colors-bg-action-critical-hero-hover)",
    "variable": "var(--colors-bg-action-critical-hero-hover)"
  },
  "colors.bg.action.critical.hero.pressed": {
    "value": "var(--colors-bg-action-critical-hero-pressed)",
    "variable": "var(--colors-bg-action-critical-hero-pressed)"
  },
  "colors.bg.action.success.hero.default": {
    "value": "var(--colors-bg-action-success-hero-default)",
    "variable": "var(--colors-bg-action-success-hero-default)"
  },
  "colors.bg.action.success.hero.hover": {
    "value": "var(--colors-bg-action-success-hero-hover)",
    "variable": "var(--colors-bg-action-success-hero-hover)"
  },
  "colors.bg.action.success.hero.pressed": {
    "value": "var(--colors-bg-action-success-hero-pressed)",
    "variable": "var(--colors-bg-action-success-hero-pressed)"
  },
  "colors.bg.elevated.action.mediumShadow.default": {
    "value": "var(--colors-bg-elevated-action-medium-shadow-default)",
    "variable": "var(--colors-bg-elevated-action-medium-shadow-default)"
  },
  "colors.bg.elevated.action.mediumShadow.hover": {
    "value": "var(--colors-bg-elevated-action-medium-shadow-hover)",
    "variable": "var(--colors-bg-elevated-action-medium-shadow-hover)"
  },
  "colors.bg.elevated.action.mediumShadow.pressed": {
    "value": "var(--colors-bg-elevated-action-medium-shadow-pressed)",
    "variable": "var(--colors-bg-elevated-action-medium-shadow-pressed)"
  },
  "colors.bg.elevated.action.mediumShadow.selected.default": {
    "value": "var(--colors-bg-elevated-action-medium-shadow-selected-default)",
    "variable": "var(--colors-bg-elevated-action-medium-shadow-selected-default)"
  },
  "colors.bg.elevated.action.mediumShadow.selected.hover": {
    "value": "var(--colors-bg-elevated-action-medium-shadow-selected-hover)",
    "variable": "var(--colors-bg-elevated-action-medium-shadow-selected-hover)"
  },
  "colors.bg.elevated.action.mediumShadow.selected.pressed": {
    "value": "var(--colors-bg-elevated-action-medium-shadow-selected-pressed)",
    "variable": "var(--colors-bg-elevated-action-medium-shadow-selected-pressed)"
  },
  "colors.bg.elevated.action.smallShadow.default": {
    "value": "var(--colors-bg-elevated-action-small-shadow-default)",
    "variable": "var(--colors-bg-elevated-action-small-shadow-default)"
  },
  "colors.bg.elevated.action.smallShadow.hover": {
    "value": "var(--colors-bg-elevated-action-small-shadow-hover)",
    "variable": "var(--colors-bg-elevated-action-small-shadow-hover)"
  },
  "colors.bg.elevated.action.smallShadow.pressed": {
    "value": "var(--colors-bg-elevated-action-small-shadow-pressed)",
    "variable": "var(--colors-bg-elevated-action-small-shadow-pressed)"
  },
  "colors.bg.elevated.action.smallShadow.selected.default": {
    "value": "var(--colors-bg-elevated-action-small-shadow-selected-default)",
    "variable": "var(--colors-bg-elevated-action-small-shadow-selected-default)"
  },
  "colors.bg.elevated.action.smallShadow.selected.hover": {
    "value": "var(--colors-bg-elevated-action-small-shadow-selected-hover)",
    "variable": "var(--colors-bg-elevated-action-small-shadow-selected-hover)"
  },
  "colors.bg.elevated.action.smallShadow.selected.pressed": {
    "value": "var(--colors-bg-elevated-action-small-shadow-selected-pressed)",
    "variable": "var(--colors-bg-elevated-action-small-shadow-selected-pressed)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.default": {
    "value": "var(--colors-bg-elevated-action-small-heavy-shadow-default)",
    "variable": "var(--colors-bg-elevated-action-small-heavy-shadow-default)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.hover": {
    "value": "var(--colors-bg-elevated-action-small-heavy-shadow-hover)",
    "variable": "var(--colors-bg-elevated-action-small-heavy-shadow-hover)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.pressed": {
    "value": "var(--colors-bg-elevated-action-small-heavy-shadow-pressed)",
    "variable": "var(--colors-bg-elevated-action-small-heavy-shadow-pressed)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.selected.default": {
    "value": "var(--colors-bg-elevated-action-small-heavy-shadow-selected-default)",
    "variable": "var(--colors-bg-elevated-action-small-heavy-shadow-selected-default)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.selected.hover": {
    "value": "var(--colors-bg-elevated-action-small-heavy-shadow-selected-hover)",
    "variable": "var(--colors-bg-elevated-action-small-heavy-shadow-selected-hover)"
  },
  "colors.bg.elevated.action.smallHeavyShadow.selected.pressed": {
    "value": "var(--colors-bg-elevated-action-small-heavy-shadow-selected-pressed)",
    "variable": "var(--colors-bg-elevated-action-small-heavy-shadow-selected-pressed)"
  },
  "colors.bg.elevated.sheet": {
    "value": "var(--colors-bg-elevated-sheet)",
    "variable": "var(--colors-bg-elevated-sheet)"
  },
  "colors.bg.elevated.mediumShadow": {
    "value": "var(--colors-bg-elevated-medium-shadow)",
    "variable": "var(--colors-bg-elevated-medium-shadow)"
  },
  "colors.bg.elevated.smallShadow": {
    "value": "var(--colors-bg-elevated-small-shadow)",
    "variable": "var(--colors-bg-elevated-small-shadow)"
  },
  "colors.bg.elevated.smallHeavyShadow": {
    "value": "var(--colors-bg-elevated-small-heavy-shadow)",
    "variable": "var(--colors-bg-elevated-small-heavy-shadow)"
  },
  "colors.bg.express.empower.impact": {
    "value": "var(--colors-bg-express-empower-impact)",
    "variable": "var(--colors-bg-express-empower-impact)"
  },
  "colors.bg.express.empower.hero": {
    "value": "var(--colors-bg-express-empower-hero)",
    "variable": "var(--colors-bg-express-empower-hero)"
  },
  "colors.bg.express.empower.soft": {
    "value": "var(--colors-bg-express-empower-soft)",
    "variable": "var(--colors-bg-express-empower-soft)"
  },
  "colors.bg.express.insight.impact": {
    "value": "var(--colors-bg-express-insight-impact)",
    "variable": "var(--colors-bg-express-insight-impact)"
  },
  "colors.bg.express.insight.hero": {
    "value": "var(--colors-bg-express-insight-hero)",
    "variable": "var(--colors-bg-express-insight-hero)"
  },
  "colors.bg.express.insight.soft": {
    "value": "var(--colors-bg-express-insight-soft)",
    "variable": "var(--colors-bg-express-insight-soft)"
  },
  "colors.bg.express.inspire.impact": {
    "value": "var(--colors-bg-express-inspire-impact)",
    "variable": "var(--colors-bg-express-inspire-impact)"
  },
  "colors.bg.express.inspire.hero": {
    "value": "var(--colors-bg-express-inspire-hero)",
    "variable": "var(--colors-bg-express-inspire-hero)"
  },
  "colors.bg.express.inspire.soft": {
    "value": "var(--colors-bg-express-inspire-soft)",
    "variable": "var(--colors-bg-express-inspire-soft)"
  },
  "colors.bg.express.trust.impact": {
    "value": "var(--colors-bg-express-trust-impact)",
    "variable": "var(--colors-bg-express-trust-impact)"
  },
  "colors.bg.express.trust.hero": {
    "value": "var(--colors-bg-express-trust-hero)",
    "variable": "var(--colors-bg-express-trust-hero)"
  },
  "colors.bg.express.trust.soft": {
    "value": "var(--colors-bg-express-trust-soft)",
    "variable": "var(--colors-bg-express-trust-soft)"
  },
  "colors.bg.feedback.critical.soft": {
    "value": "var(--colors-bg-feedback-critical-soft)",
    "variable": "var(--colors-bg-feedback-critical-soft)"
  },
  "colors.bg.feedback.critical.hero": {
    "value": "var(--colors-bg-feedback-critical-hero)",
    "variable": "var(--colors-bg-feedback-critical-hero)"
  },
  "colors.bg.feedback.critical.impact": {
    "value": "var(--colors-bg-feedback-critical-impact)",
    "variable": "var(--colors-bg-feedback-critical-impact)"
  },
  "colors.bg.feedback.info.soft": {
    "value": "var(--colors-bg-feedback-info-soft)",
    "variable": "var(--colors-bg-feedback-info-soft)"
  },
  "colors.bg.feedback.info.hero": {
    "value": "var(--colors-bg-feedback-info-hero)",
    "variable": "var(--colors-bg-feedback-info-hero)"
  },
  "colors.bg.feedback.info.impact": {
    "value": "var(--colors-bg-feedback-info-impact)",
    "variable": "var(--colors-bg-feedback-info-impact)"
  },
  "colors.bg.feedback.notify.impact": {
    "value": "var(--colors-bg-feedback-notify-impact)",
    "variable": "var(--colors-bg-feedback-notify-impact)"
  },
  "colors.bg.feedback.notify.hero": {
    "value": "var(--colors-bg-feedback-notify-hero)",
    "variable": "var(--colors-bg-feedback-notify-hero)"
  },
  "colors.bg.feedback.notify.hero-fixed": {
    "value": "var(--colors-bg-feedback-notify-hero-fixed)",
    "variable": "var(--colors-bg-feedback-notify-hero-fixed)"
  },
  "colors.bg.feedback.notify.soft": {
    "value": "var(--colors-bg-feedback-notify-soft)",
    "variable": "var(--colors-bg-feedback-notify-soft)"
  },
  "colors.bg.feedback.success.impact": {
    "value": "var(--colors-bg-feedback-success-impact)",
    "variable": "var(--colors-bg-feedback-success-impact)"
  },
  "colors.bg.feedback.success.hero": {
    "value": "var(--colors-bg-feedback-success-hero)",
    "variable": "var(--colors-bg-feedback-success-hero)"
  },
  "colors.bg.feedback.success.soft": {
    "value": "var(--colors-bg-feedback-success-soft)",
    "variable": "var(--colors-bg-feedback-success-soft)"
  },
  "colors.bg.feedback.warning.impact": {
    "value": "var(--colors-bg-feedback-warning-impact)",
    "variable": "var(--colors-bg-feedback-warning-impact)"
  },
  "colors.bg.feedback.warning.hero": {
    "value": "var(--colors-bg-feedback-warning-hero)",
    "variable": "var(--colors-bg-feedback-warning-hero)"
  },
  "colors.bg.feedback.warning.soft": {
    "value": "var(--colors-bg-feedback-warning-soft)",
    "variable": "var(--colors-bg-feedback-warning-soft)"
  },
  "colors.bg.invisible": {
    "value": "var(--colors-bg-invisible)",
    "variable": "var(--colors-bg-invisible)"
  },
  "colors.bg.impact": {
    "value": "var(--colors-bg-impact)",
    "variable": "var(--colors-bg-impact)"
  },
  "colors.bg.impact-fixed": {
    "value": "var(--colors-bg-impact-fixed)",
    "variable": "var(--colors-bg-impact-fixed)"
  },
  "colors.bg.impact-soft": {
    "value": "var(--colors-bg-impact-soft)",
    "variable": "var(--colors-bg-impact-soft)"
  },
  "colors.bg.impact-soft-fixed": {
    "value": "var(--colors-bg-impact-soft-fixed)",
    "variable": "var(--colors-bg-impact-soft-fixed)"
  },
  "colors.bg.impact-softer": {
    "value": "var(--colors-bg-impact-softer)",
    "variable": "var(--colors-bg-impact-softer)"
  },
  "colors.bg.impact-softest": {
    "value": "var(--colors-bg-impact-softest)",
    "variable": "var(--colors-bg-impact-softest)"
  },
  "colors.bg.neutral": {
    "value": "var(--colors-bg-neutral)",
    "variable": "var(--colors-bg-neutral)"
  },
  "colors.bg.neutral-fixed": {
    "value": "var(--colors-bg-neutral-fixed)",
    "variable": "var(--colors-bg-neutral-fixed)"
  },
  "colors.bg.soft": {
    "value": "var(--colors-bg-soft)",
    "variable": "var(--colors-bg-soft)"
  },
  "colors.bg.softer": {
    "value": "var(--colors-bg-softer)",
    "variable": "var(--colors-bg-softer)"
  },
  "colors.bg.softer-fixed": {
    "value": "var(--colors-bg-softer-fixed)",
    "variable": "var(--colors-bg-softer-fixed)"
  },
  "colors.bg.softest": {
    "value": "var(--colors-bg-softest)",
    "variable": "var(--colors-bg-softest)"
  },
  "colors.bg.softest-fixed": {
    "value": "var(--colors-bg-softest-fixed)",
    "variable": "var(--colors-bg-softest-fixed)"
  },
  "colors.bg.screen.neutral": {
    "value": "var(--colors-bg-screen-neutral)",
    "variable": "var(--colors-bg-screen-neutral)"
  },
  "colors.bg.screen.softest": {
    "value": "var(--colors-bg-screen-softest)",
    "variable": "var(--colors-bg-screen-softest)"
  },
  "colors.bg.screen.scrim": {
    "value": "var(--colors-bg-screen-scrim)",
    "variable": "var(--colors-bg-screen-scrim)"
  },
  "colors.bg.transparent.impact-fixed": {
    "value": "var(--colors-bg-transparent-impact-fixed)",
    "variable": "var(--colors-bg-transparent-impact-fixed)"
  },
  "colors.bg.transparent.impact-fixed-faint": {
    "value": "var(--colors-bg-transparent-impact-fixed-faint)",
    "variable": "var(--colors-bg-transparent-impact-fixed-faint)"
  },
  "colors.border.accent.brand.hero": {
    "value": "var(--colors-border-accent-brand-hero)",
    "variable": "var(--colors-border-accent-brand-hero)"
  },
  "colors.border.accent.brand.hero-fixed": {
    "value": "var(--colors-border-accent-brand-hero-fixed)",
    "variable": "var(--colors-border-accent-brand-hero-fixed)"
  },
  "colors.border.accent.aqua.strong": {
    "value": "var(--colors-border-accent-aqua-strong)",
    "variable": "var(--colors-border-accent-aqua-strong)"
  },
  "colors.border.accent.aqua.hero": {
    "value": "var(--colors-border-accent-aqua-hero)",
    "variable": "var(--colors-border-accent-aqua-hero)"
  },
  "colors.border.accent.blue.strong": {
    "value": "var(--colors-border-accent-blue-strong)",
    "variable": "var(--colors-border-accent-blue-strong)"
  },
  "colors.border.accent.blue.strong-fixed": {
    "value": "var(--colors-border-accent-blue-strong-fixed)",
    "variable": "var(--colors-border-accent-blue-strong-fixed)"
  },
  "colors.border.accent.blue.hero": {
    "value": "var(--colors-border-accent-blue-hero)",
    "variable": "var(--colors-border-accent-blue-hero)"
  },
  "colors.border.accent.gray.strong": {
    "value": "var(--colors-border-accent-gray-strong)",
    "variable": "var(--colors-border-accent-gray-strong)"
  },
  "colors.border.accent.gray.hero": {
    "value": "var(--colors-border-accent-gray-hero)",
    "variable": "var(--colors-border-accent-gray-hero)"
  },
  "colors.border.accent.green.strong": {
    "value": "var(--colors-border-accent-green-strong)",
    "variable": "var(--colors-border-accent-green-strong)"
  },
  "colors.border.accent.green.hero": {
    "value": "var(--colors-border-accent-green-hero)",
    "variable": "var(--colors-border-accent-green-hero)"
  },
  "colors.border.accent.orange.strong": {
    "value": "var(--colors-border-accent-orange-strong)",
    "variable": "var(--colors-border-accent-orange-strong)"
  },
  "colors.border.accent.orange.hero": {
    "value": "var(--colors-border-accent-orange-hero)",
    "variable": "var(--colors-border-accent-orange-hero)"
  },
  "colors.border.accent.purple.strong": {
    "value": "var(--colors-border-accent-purple-strong)",
    "variable": "var(--colors-border-accent-purple-strong)"
  },
  "colors.border.accent.purple.hero": {
    "value": "var(--colors-border-accent-purple-hero)",
    "variable": "var(--colors-border-accent-purple-hero)"
  },
  "colors.border.accent.red.strong": {
    "value": "var(--colors-border-accent-red-strong)",
    "variable": "var(--colors-border-accent-red-strong)"
  },
  "colors.border.accent.red.hero": {
    "value": "var(--colors-border-accent-red-hero)",
    "variable": "var(--colors-border-accent-red-hero)"
  },
  "colors.border.accent.teal.strong": {
    "value": "var(--colors-border-accent-teal-strong)",
    "variable": "var(--colors-border-accent-teal-strong)"
  },
  "colors.border.accent.teal.hero": {
    "value": "var(--colors-border-accent-teal-hero)",
    "variable": "var(--colors-border-accent-teal-hero)"
  },
  "colors.border.accent.yellow.strong": {
    "value": "var(--colors-border-accent-yellow-strong)",
    "variable": "var(--colors-border-accent-yellow-strong)"
  },
  "colors.border.accent.yellow.hero": {
    "value": "var(--colors-border-accent-yellow-hero)",
    "variable": "var(--colors-border-accent-yellow-hero)"
  },
  "colors.border.action.neutral.default": {
    "value": "var(--colors-border-action-neutral-default)",
    "variable": "var(--colors-border-action-neutral-default)"
  },
  "colors.border.action.neutral.hover": {
    "value": "var(--colors-border-action-neutral-hover)",
    "variable": "var(--colors-border-action-neutral-hover)"
  },
  "colors.border.action.neutral.pressed": {
    "value": "var(--colors-border-action-neutral-pressed)",
    "variable": "var(--colors-border-action-neutral-pressed)"
  },
  "colors.border.action.strong.default": {
    "value": "var(--colors-border-action-strong-default)",
    "variable": "var(--colors-border-action-strong-default)"
  },
  "colors.border.action.strong.hover": {
    "value": "var(--colors-border-action-strong-hover)",
    "variable": "var(--colors-border-action-strong-hover)"
  },
  "colors.border.action.strong.pressed": {
    "value": "var(--colors-border-action-strong-pressed)",
    "variable": "var(--colors-border-action-strong-pressed)"
  },
  "colors.border.action.hero.default": {
    "value": "var(--colors-border-action-hero-default)",
    "variable": "var(--colors-border-action-hero-default)"
  },
  "colors.border.action.hero.hover": {
    "value": "var(--colors-border-action-hero-hover)",
    "variable": "var(--colors-border-action-hero-hover)"
  },
  "colors.border.action.hero.pressed": {
    "value": "var(--colors-border-action-hero-pressed)",
    "variable": "var(--colors-border-action-hero-pressed)"
  },
  "colors.border.action.hero.selected.default": {
    "value": "var(--colors-border-action-hero-selected-default)",
    "variable": "var(--colors-border-action-hero-selected-default)"
  },
  "colors.border.action.hero.selected.hover": {
    "value": "var(--colors-border-action-hero-selected-hover)",
    "variable": "var(--colors-border-action-hero-selected-hover)"
  },
  "colors.border.action.hero.selected.pressed": {
    "value": "var(--colors-border-action-hero-selected-pressed)",
    "variable": "var(--colors-border-action-hero-selected-pressed)"
  },
  "colors.border.action.critical.strong.default": {
    "value": "var(--colors-border-action-critical-strong-default)",
    "variable": "var(--colors-border-action-critical-strong-default)"
  },
  "colors.border.action.critical.strong.hover": {
    "value": "var(--colors-border-action-critical-strong-hover)",
    "variable": "var(--colors-border-action-critical-strong-hover)"
  },
  "colors.border.action.critical.strong.pressed": {
    "value": "var(--colors-border-action-critical-strong-pressed)",
    "variable": "var(--colors-border-action-critical-strong-pressed)"
  },
  "colors.border.action.critical.hero.default": {
    "value": "var(--colors-border-action-critical-hero-default)",
    "variable": "var(--colors-border-action-critical-hero-default)"
  },
  "colors.border.action.critical.hero.hover": {
    "value": "var(--colors-border-action-critical-hero-hover)",
    "variable": "var(--colors-border-action-critical-hero-hover)"
  },
  "colors.border.action.critical.hero.pressed": {
    "value": "var(--colors-border-action-critical-hero-pressed)",
    "variable": "var(--colors-border-action-critical-hero-pressed)"
  },
  "colors.border.express.empower.strong": {
    "value": "var(--colors-border-express-empower-strong)",
    "variable": "var(--colors-border-express-empower-strong)"
  },
  "colors.border.express.empower.hero": {
    "value": "var(--colors-border-express-empower-hero)",
    "variable": "var(--colors-border-express-empower-hero)"
  },
  "colors.border.express.insight.strong": {
    "value": "var(--colors-border-express-insight-strong)",
    "variable": "var(--colors-border-express-insight-strong)"
  },
  "colors.border.express.insight.hero": {
    "value": "var(--colors-border-express-insight-hero)",
    "variable": "var(--colors-border-express-insight-hero)"
  },
  "colors.border.express.inspire.strong": {
    "value": "var(--colors-border-express-inspire-strong)",
    "variable": "var(--colors-border-express-inspire-strong)"
  },
  "colors.border.express.inspire.hero": {
    "value": "var(--colors-border-express-inspire-hero)",
    "variable": "var(--colors-border-express-inspire-hero)"
  },
  "colors.border.express.trust.strong": {
    "value": "var(--colors-border-express-trust-strong)",
    "variable": "var(--colors-border-express-trust-strong)"
  },
  "colors.border.express.trust.hero": {
    "value": "var(--colors-border-express-trust-hero)",
    "variable": "var(--colors-border-express-trust-hero)"
  },
  "colors.border.feedback.critical.strong": {
    "value": "var(--colors-border-feedback-critical-strong)",
    "variable": "var(--colors-border-feedback-critical-strong)"
  },
  "colors.border.feedback.critical.hero": {
    "value": "var(--colors-border-feedback-critical-hero)",
    "variable": "var(--colors-border-feedback-critical-hero)"
  },
  "colors.border.feedback.critical.hero-alt": {
    "value": "var(--colors-border-feedback-critical-hero-alt)",
    "variable": "var(--colors-border-feedback-critical-hero-alt)"
  },
  "colors.border.feedback.info.strong": {
    "value": "var(--colors-border-feedback-info-strong)",
    "variable": "var(--colors-border-feedback-info-strong)"
  },
  "colors.border.feedback.info.hero": {
    "value": "var(--colors-border-feedback-info-hero)",
    "variable": "var(--colors-border-feedback-info-hero)"
  },
  "colors.border.feedback.notify.strong": {
    "value": "var(--colors-border-feedback-notify-strong)",
    "variable": "var(--colors-border-feedback-notify-strong)"
  },
  "colors.border.feedback.notify.hero": {
    "value": "var(--colors-border-feedback-notify-hero)",
    "variable": "var(--colors-border-feedback-notify-hero)"
  },
  "colors.border.feedback.notify.hero-alt": {
    "value": "var(--colors-border-feedback-notify-hero-alt)",
    "variable": "var(--colors-border-feedback-notify-hero-alt)"
  },
  "colors.border.feedback.success.strong": {
    "value": "var(--colors-border-feedback-success-strong)",
    "variable": "var(--colors-border-feedback-success-strong)"
  },
  "colors.border.feedback.success.hero": {
    "value": "var(--colors-border-feedback-success-hero)",
    "variable": "var(--colors-border-feedback-success-hero)"
  },
  "colors.border.feedback.success.hero-alt": {
    "value": "var(--colors-border-feedback-success-hero-alt)",
    "variable": "var(--colors-border-feedback-success-hero-alt)"
  },
  "colors.border.feedback.warning.strong": {
    "value": "var(--colors-border-feedback-warning-strong)",
    "variable": "var(--colors-border-feedback-warning-strong)"
  },
  "colors.border.feedback.warning.hero": {
    "value": "var(--colors-border-feedback-warning-hero)",
    "variable": "var(--colors-border-feedback-warning-hero)"
  },
  "colors.border.invisible": {
    "value": "var(--colors-border-invisible)",
    "variable": "var(--colors-border-invisible)"
  },
  "colors.border.muted": {
    "value": "var(--colors-border-muted)",
    "variable": "var(--colors-border-muted)"
  },
  "colors.border.muted-alt": {
    "value": "var(--colors-border-muted-alt)",
    "variable": "var(--colors-border-muted-alt)"
  },
  "colors.border.neutral": {
    "value": "var(--colors-border-neutral)",
    "variable": "var(--colors-border-neutral)"
  },
  "colors.border.neutral-fixed": {
    "value": "var(--colors-border-neutral-fixed)",
    "variable": "var(--colors-border-neutral-fixed)"
  },
  "colors.border.subtle": {
    "value": "var(--colors-border-subtle)",
    "variable": "var(--colors-border-subtle)"
  },
  "colors.border.onHero.action.neutral.default": {
    "value": "var(--colors-border-on-hero-action-neutral-default)",
    "variable": "var(--colors-border-on-hero-action-neutral-default)"
  },
  "colors.border.onHero.action.neutral.hover": {
    "value": "var(--colors-border-on-hero-action-neutral-hover)",
    "variable": "var(--colors-border-on-hero-action-neutral-hover)"
  },
  "colors.border.onHero.action.neutral.pressed": {
    "value": "var(--colors-border-on-hero-action-neutral-pressed)",
    "variable": "var(--colors-border-on-hero-action-neutral-pressed)"
  },
  "colors.border.onHero.express.empower.hero": {
    "value": "var(--colors-border-on-hero-express-empower-hero)",
    "variable": "var(--colors-border-on-hero-express-empower-hero)"
  },
  "colors.border.onHero.express.insight.hero": {
    "value": "var(--colors-border-on-hero-express-insight-hero)",
    "variable": "var(--colors-border-on-hero-express-insight-hero)"
  },
  "colors.border.onHero.express.inspire.hero": {
    "value": "var(--colors-border-on-hero-express-inspire-hero)",
    "variable": "var(--colors-border-on-hero-express-inspire-hero)"
  },
  "colors.border.onHero.express.trust.hero": {
    "value": "var(--colors-border-on-hero-express-trust-hero)",
    "variable": "var(--colors-border-on-hero-express-trust-hero)"
  },
  "colors.border.onHero.neutral": {
    "value": "var(--colors-border-on-hero-neutral)",
    "variable": "var(--colors-border-on-hero-neutral)"
  },
  "colors.border.onHero.neutral-fixed": {
    "value": "var(--colors-border-on-hero-neutral-fixed)",
    "variable": "var(--colors-border-on-hero-neutral-fixed)"
  },
  "colors.border.onImpact.action.neutral.default": {
    "value": "var(--colors-border-on-impact-action-neutral-default)",
    "variable": "var(--colors-border-on-impact-action-neutral-default)"
  },
  "colors.border.onImpact.action.neutral.hover": {
    "value": "var(--colors-border-on-impact-action-neutral-hover)",
    "variable": "var(--colors-border-on-impact-action-neutral-hover)"
  },
  "colors.border.onImpact.action.neutral.pressed": {
    "value": "var(--colors-border-on-impact-action-neutral-pressed)",
    "variable": "var(--colors-border-on-impact-action-neutral-pressed)"
  },
  "colors.border.onImpact.express.empower.hero": {
    "value": "var(--colors-border-on-impact-express-empower-hero)",
    "variable": "var(--colors-border-on-impact-express-empower-hero)"
  },
  "colors.border.onImpact.express.insight.hero": {
    "value": "var(--colors-border-on-impact-express-insight-hero)",
    "variable": "var(--colors-border-on-impact-express-insight-hero)"
  },
  "colors.border.onImpact.express.inspire.hero": {
    "value": "var(--colors-border-on-impact-express-inspire-hero)",
    "variable": "var(--colors-border-on-impact-express-inspire-hero)"
  },
  "colors.border.onImpact.express.trust.hero": {
    "value": "var(--colors-border-on-impact-express-trust-hero)",
    "variable": "var(--colors-border-on-impact-express-trust-hero)"
  },
  "colors.border.onImpact.feedback.critical.strong": {
    "value": "var(--colors-border-on-impact-feedback-critical-strong)",
    "variable": "var(--colors-border-on-impact-feedback-critical-strong)"
  },
  "colors.border.onImpact.feedback.critical.hero": {
    "value": "var(--colors-border-on-impact-feedback-critical-hero)",
    "variable": "var(--colors-border-on-impact-feedback-critical-hero)"
  },
  "colors.border.onImpact.feedback.critical.hero-alt": {
    "value": "var(--colors-border-on-impact-feedback-critical-hero-alt)",
    "variable": "var(--colors-border-on-impact-feedback-critical-hero-alt)"
  },
  "colors.border.onImpact.feedback.info.strong": {
    "value": "var(--colors-border-on-impact-feedback-info-strong)",
    "variable": "var(--colors-border-on-impact-feedback-info-strong)"
  },
  "colors.border.onImpact.feedback.info.hero": {
    "value": "var(--colors-border-on-impact-feedback-info-hero)",
    "variable": "var(--colors-border-on-impact-feedback-info-hero)"
  },
  "colors.border.onImpact.feedback.notify.strong": {
    "value": "var(--colors-border-on-impact-feedback-notify-strong)",
    "variable": "var(--colors-border-on-impact-feedback-notify-strong)"
  },
  "colors.border.onImpact.feedback.notify.hero": {
    "value": "var(--colors-border-on-impact-feedback-notify-hero)",
    "variable": "var(--colors-border-on-impact-feedback-notify-hero)"
  },
  "colors.border.onImpact.feedback.notify.hero-alt": {
    "value": "var(--colors-border-on-impact-feedback-notify-hero-alt)",
    "variable": "var(--colors-border-on-impact-feedback-notify-hero-alt)"
  },
  "colors.border.onImpact.feedback.success.strong": {
    "value": "var(--colors-border-on-impact-feedback-success-strong)",
    "variable": "var(--colors-border-on-impact-feedback-success-strong)"
  },
  "colors.border.onImpact.feedback.success.hero": {
    "value": "var(--colors-border-on-impact-feedback-success-hero)",
    "variable": "var(--colors-border-on-impact-feedback-success-hero)"
  },
  "colors.border.onImpact.feedback.success.hero-alt": {
    "value": "var(--colors-border-on-impact-feedback-success-hero-alt)",
    "variable": "var(--colors-border-on-impact-feedback-success-hero-alt)"
  },
  "colors.border.onImpact.feedback.warning.strong": {
    "value": "var(--colors-border-on-impact-feedback-warning-strong)",
    "variable": "var(--colors-border-on-impact-feedback-warning-strong)"
  },
  "colors.border.onImpact.feedback.warning.hero": {
    "value": "var(--colors-border-on-impact-feedback-warning-hero)",
    "variable": "var(--colors-border-on-impact-feedback-warning-hero)"
  },
  "colors.border.onImpact.neutral": {
    "value": "var(--colors-border-on-impact-neutral)",
    "variable": "var(--colors-border-on-impact-neutral)"
  },
  "colors.border.onImpact.neutral-fixed": {
    "value": "var(--colors-border-on-impact-neutral-fixed)",
    "variable": "var(--colors-border-on-impact-neutral-fixed)"
  },
  "colors.border.onImpact.subtle": {
    "value": "var(--colors-border-on-impact-subtle)",
    "variable": "var(--colors-border-on-impact-subtle)"
  },
  "colors.effect.elevation.sm": {
    "value": "var(--colors-effect-elevation-sm)",
    "variable": "var(--colors-effect-elevation-sm)"
  },
  "colors.effect.elevation.smHeavy": {
    "value": "var(--colors-effect-elevation-sm-heavy)",
    "variable": "var(--colors-effect-elevation-sm-heavy)"
  },
  "colors.effect.elevation.md": {
    "value": "var(--colors-effect-elevation-md)",
    "variable": "var(--colors-effect-elevation-md)"
  },
  "colors.effect.elevation.lg": {
    "value": "var(--colors-effect-elevation-lg)",
    "variable": "var(--colors-effect-elevation-lg)"
  },
  "colors.effect.elevation.invisible": {
    "value": "var(--colors-effect-elevation-invisible)",
    "variable": "var(--colors-effect-elevation-invisible)"
  },
  "colors.effect.elevation.focus-1": {
    "value": "var(--colors-effect-elevation-focus-1)",
    "variable": "var(--colors-effect-elevation-focus-1)"
  },
  "colors.effect.elevation.focus-2": {
    "value": "var(--colors-effect-elevation-focus-2)",
    "variable": "var(--colors-effect-elevation-focus-2)"
  },
  "colors.effect.elevation.focus-3": {
    "value": "var(--colors-effect-elevation-focus-3)",
    "variable": "var(--colors-effect-elevation-focus-3)"
  },
  "colors.icon.accent.brand.hero": {
    "value": "var(--colors-icon-accent-brand-hero)",
    "variable": "var(--colors-icon-accent-brand-hero)"
  },
  "colors.icon.accent.brand.hero-fixed": {
    "value": "var(--colors-icon-accent-brand-hero-fixed)",
    "variable": "var(--colors-icon-accent-brand-hero-fixed)"
  },
  "colors.icon.accent.aqua.strong": {
    "value": "var(--colors-icon-accent-aqua-strong)",
    "variable": "var(--colors-icon-accent-aqua-strong)"
  },
  "colors.icon.accent.aqua.hero": {
    "value": "var(--colors-icon-accent-aqua-hero)",
    "variable": "var(--colors-icon-accent-aqua-hero)"
  },
  "colors.icon.accent.blue.strong": {
    "value": "var(--colors-icon-accent-blue-strong)",
    "variable": "var(--colors-icon-accent-blue-strong)"
  },
  "colors.icon.accent.blue.strong-fixed": {
    "value": "var(--colors-icon-accent-blue-strong-fixed)",
    "variable": "var(--colors-icon-accent-blue-strong-fixed)"
  },
  "colors.icon.accent.blue.hero": {
    "value": "var(--colors-icon-accent-blue-hero)",
    "variable": "var(--colors-icon-accent-blue-hero)"
  },
  "colors.icon.accent.gray.strong": {
    "value": "var(--colors-icon-accent-gray-strong)",
    "variable": "var(--colors-icon-accent-gray-strong)"
  },
  "colors.icon.accent.gray.hero": {
    "value": "var(--colors-icon-accent-gray-hero)",
    "variable": "var(--colors-icon-accent-gray-hero)"
  },
  "colors.icon.accent.green.strong": {
    "value": "var(--colors-icon-accent-green-strong)",
    "variable": "var(--colors-icon-accent-green-strong)"
  },
  "colors.icon.accent.green.hero": {
    "value": "var(--colors-icon-accent-green-hero)",
    "variable": "var(--colors-icon-accent-green-hero)"
  },
  "colors.icon.accent.orange.strong": {
    "value": "var(--colors-icon-accent-orange-strong)",
    "variable": "var(--colors-icon-accent-orange-strong)"
  },
  "colors.icon.accent.orange.hero": {
    "value": "var(--colors-icon-accent-orange-hero)",
    "variable": "var(--colors-icon-accent-orange-hero)"
  },
  "colors.icon.accent.purple.strong": {
    "value": "var(--colors-icon-accent-purple-strong)",
    "variable": "var(--colors-icon-accent-purple-strong)"
  },
  "colors.icon.accent.purple.hero": {
    "value": "var(--colors-icon-accent-purple-hero)",
    "variable": "var(--colors-icon-accent-purple-hero)"
  },
  "colors.icon.accent.red.strong": {
    "value": "var(--colors-icon-accent-red-strong)",
    "variable": "var(--colors-icon-accent-red-strong)"
  },
  "colors.icon.accent.red.hero": {
    "value": "var(--colors-icon-accent-red-hero)",
    "variable": "var(--colors-icon-accent-red-hero)"
  },
  "colors.icon.accent.teal.strong": {
    "value": "var(--colors-icon-accent-teal-strong)",
    "variable": "var(--colors-icon-accent-teal-strong)"
  },
  "colors.icon.accent.teal.hero": {
    "value": "var(--colors-icon-accent-teal-hero)",
    "variable": "var(--colors-icon-accent-teal-hero)"
  },
  "colors.icon.accent.yellow.strong": {
    "value": "var(--colors-icon-accent-yellow-strong)",
    "variable": "var(--colors-icon-accent-yellow-strong)"
  },
  "colors.icon.accent.yellow.hero": {
    "value": "var(--colors-icon-accent-yellow-hero)",
    "variable": "var(--colors-icon-accent-yellow-hero)"
  },
  "colors.icon.action.neutral.default": {
    "value": "var(--colors-icon-action-neutral-default)",
    "variable": "var(--colors-icon-action-neutral-default)"
  },
  "colors.icon.action.neutral.hover": {
    "value": "var(--colors-icon-action-neutral-hover)",
    "variable": "var(--colors-icon-action-neutral-hover)"
  },
  "colors.icon.action.neutral.pressed": {
    "value": "var(--colors-icon-action-neutral-pressed)",
    "variable": "var(--colors-icon-action-neutral-pressed)"
  },
  "colors.icon.action.hero.default": {
    "value": "var(--colors-icon-action-hero-default)",
    "variable": "var(--colors-icon-action-hero-default)"
  },
  "colors.icon.action.hero.hover": {
    "value": "var(--colors-icon-action-hero-hover)",
    "variable": "var(--colors-icon-action-hero-hover)"
  },
  "colors.icon.action.hero.pressed": {
    "value": "var(--colors-icon-action-hero-pressed)",
    "variable": "var(--colors-icon-action-hero-pressed)"
  },
  "colors.icon.action.hero.selected.default": {
    "value": "var(--colors-icon-action-hero-selected-default)",
    "variable": "var(--colors-icon-action-hero-selected-default)"
  },
  "colors.icon.action.hero.selected.hover": {
    "value": "var(--colors-icon-action-hero-selected-hover)",
    "variable": "var(--colors-icon-action-hero-selected-hover)"
  },
  "colors.icon.action.hero.selected.pressed": {
    "value": "var(--colors-icon-action-hero-selected-pressed)",
    "variable": "var(--colors-icon-action-hero-selected-pressed)"
  },
  "colors.icon.action.strong.default": {
    "value": "var(--colors-icon-action-strong-default)",
    "variable": "var(--colors-icon-action-strong-default)"
  },
  "colors.icon.action.strong.hover": {
    "value": "var(--colors-icon-action-strong-hover)",
    "variable": "var(--colors-icon-action-strong-hover)"
  },
  "colors.icon.action.strong.pressed": {
    "value": "var(--colors-icon-action-strong-pressed)",
    "variable": "var(--colors-icon-action-strong-pressed)"
  },
  "colors.icon.action.critical.strong.default": {
    "value": "var(--colors-icon-action-critical-strong-default)",
    "variable": "var(--colors-icon-action-critical-strong-default)"
  },
  "colors.icon.action.critical.strong.hover": {
    "value": "var(--colors-icon-action-critical-strong-hover)",
    "variable": "var(--colors-icon-action-critical-strong-hover)"
  },
  "colors.icon.action.critical.strong.pressed": {
    "value": "var(--colors-icon-action-critical-strong-pressed)",
    "variable": "var(--colors-icon-action-critical-strong-pressed)"
  },
  "colors.icon.action.critical.hero.default": {
    "value": "var(--colors-icon-action-critical-hero-default)",
    "variable": "var(--colors-icon-action-critical-hero-default)"
  },
  "colors.icon.action.critical.hero.hover": {
    "value": "var(--colors-icon-action-critical-hero-hover)",
    "variable": "var(--colors-icon-action-critical-hero-hover)"
  },
  "colors.icon.action.critical.hero.pressed": {
    "value": "var(--colors-icon-action-critical-hero-pressed)",
    "variable": "var(--colors-icon-action-critical-hero-pressed)"
  },
  "colors.icon.action.success.hero.default": {
    "value": "var(--colors-icon-action-success-hero-default)",
    "variable": "var(--colors-icon-action-success-hero-default)"
  },
  "colors.icon.action.success.hero.hover": {
    "value": "var(--colors-icon-action-success-hero-hover)",
    "variable": "var(--colors-icon-action-success-hero-hover)"
  },
  "colors.icon.action.success.hero.pressed": {
    "value": "var(--colors-icon-action-success-hero-pressed)",
    "variable": "var(--colors-icon-action-success-hero-pressed)"
  },
  "colors.icon.action.disabled": {
    "value": "var(--colors-icon-action-disabled)",
    "variable": "var(--colors-icon-action-disabled)"
  },
  "colors.icon.action.disabled-muted": {
    "value": "var(--colors-icon-action-disabled-muted)",
    "variable": "var(--colors-icon-action-disabled-muted)"
  },
  "colors.icon.action.disabled-alt": {
    "value": "var(--colors-icon-action-disabled-alt)",
    "variable": "var(--colors-icon-action-disabled-alt)"
  },
  "colors.icon.express.empower.strong": {
    "value": "var(--colors-icon-express-empower-strong)",
    "variable": "var(--colors-icon-express-empower-strong)"
  },
  "colors.icon.express.empower.hero": {
    "value": "var(--colors-icon-express-empower-hero)",
    "variable": "var(--colors-icon-express-empower-hero)"
  },
  "colors.icon.express.insight.strong": {
    "value": "var(--colors-icon-express-insight-strong)",
    "variable": "var(--colors-icon-express-insight-strong)"
  },
  "colors.icon.express.insight.hero": {
    "value": "var(--colors-icon-express-insight-hero)",
    "variable": "var(--colors-icon-express-insight-hero)"
  },
  "colors.icon.express.inspire.strong": {
    "value": "var(--colors-icon-express-inspire-strong)",
    "variable": "var(--colors-icon-express-inspire-strong)"
  },
  "colors.icon.express.inspire.hero": {
    "value": "var(--colors-icon-express-inspire-hero)",
    "variable": "var(--colors-icon-express-inspire-hero)"
  },
  "colors.icon.express.trust.strong": {
    "value": "var(--colors-icon-express-trust-strong)",
    "variable": "var(--colors-icon-express-trust-strong)"
  },
  "colors.icon.express.trust.hero": {
    "value": "var(--colors-icon-express-trust-hero)",
    "variable": "var(--colors-icon-express-trust-hero)"
  },
  "colors.icon.feedback.critical.strong": {
    "value": "var(--colors-icon-feedback-critical-strong)",
    "variable": "var(--colors-icon-feedback-critical-strong)"
  },
  "colors.icon.feedback.critical.hero": {
    "value": "var(--colors-icon-feedback-critical-hero)",
    "variable": "var(--colors-icon-feedback-critical-hero)"
  },
  "colors.icon.feedback.critical.hero-alt": {
    "value": "var(--colors-icon-feedback-critical-hero-alt)",
    "variable": "var(--colors-icon-feedback-critical-hero-alt)"
  },
  "colors.icon.feedback.info.strong": {
    "value": "var(--colors-icon-feedback-info-strong)",
    "variable": "var(--colors-icon-feedback-info-strong)"
  },
  "colors.icon.feedback.info.hero": {
    "value": "var(--colors-icon-feedback-info-hero)",
    "variable": "var(--colors-icon-feedback-info-hero)"
  },
  "colors.icon.feedback.notify.strong": {
    "value": "var(--colors-icon-feedback-notify-strong)",
    "variable": "var(--colors-icon-feedback-notify-strong)"
  },
  "colors.icon.feedback.notify.hero": {
    "value": "var(--colors-icon-feedback-notify-hero)",
    "variable": "var(--colors-icon-feedback-notify-hero)"
  },
  "colors.icon.feedback.notify.hero-alt": {
    "value": "var(--colors-icon-feedback-notify-hero-alt)",
    "variable": "var(--colors-icon-feedback-notify-hero-alt)"
  },
  "colors.icon.feedback.success.strong": {
    "value": "var(--colors-icon-feedback-success-strong)",
    "variable": "var(--colors-icon-feedback-success-strong)"
  },
  "colors.icon.feedback.success.hero": {
    "value": "var(--colors-icon-feedback-success-hero)",
    "variable": "var(--colors-icon-feedback-success-hero)"
  },
  "colors.icon.feedback.success.hero-alt": {
    "value": "var(--colors-icon-feedback-success-hero-alt)",
    "variable": "var(--colors-icon-feedback-success-hero-alt)"
  },
  "colors.icon.feedback.warning.strong": {
    "value": "var(--colors-icon-feedback-warning-strong)",
    "variable": "var(--colors-icon-feedback-warning-strong)"
  },
  "colors.icon.feedback.warning.hero": {
    "value": "var(--colors-icon-feedback-warning-hero)",
    "variable": "var(--colors-icon-feedback-warning-hero)"
  },
  "colors.icon.neutral": {
    "value": "var(--colors-icon-neutral)",
    "variable": "var(--colors-icon-neutral)"
  },
  "colors.icon.neutral-fixed": {
    "value": "var(--colors-icon-neutral-fixed)",
    "variable": "var(--colors-icon-neutral-fixed)"
  },
  "colors.icon.muted": {
    "value": "var(--colors-icon-muted)",
    "variable": "var(--colors-icon-muted)"
  },
  "colors.icon.subtle": {
    "value": "var(--colors-icon-subtle)",
    "variable": "var(--colors-icon-subtle)"
  },
  "colors.icon.invisible": {
    "value": "var(--colors-icon-invisible)",
    "variable": "var(--colors-icon-invisible)"
  },
  "colors.icon.link.default": {
    "value": "var(--colors-icon-link-default)",
    "variable": "var(--colors-icon-link-default)"
  },
  "colors.icon.link.hover": {
    "value": "var(--colors-icon-link-hover)",
    "variable": "var(--colors-icon-link-hover)"
  },
  "colors.icon.link.pressed": {
    "value": "var(--colors-icon-link-pressed)",
    "variable": "var(--colors-icon-link-pressed)"
  },
  "colors.icon.link.last-visited": {
    "value": "var(--colors-icon-link-last-visited)",
    "variable": "var(--colors-icon-link-last-visited)"
  },
  "colors.icon.transparent.neutral-fixed": {
    "value": "var(--colors-icon-transparent-neutral-fixed)",
    "variable": "var(--colors-icon-transparent-neutral-fixed)"
  },
  "colors.icon.transparent.neutral-fixed-faint": {
    "value": "var(--colors-icon-transparent-neutral-fixed-faint)",
    "variable": "var(--colors-icon-transparent-neutral-fixed-faint)"
  },
  "colors.icon.transparent.action.neutral-fixed.default": {
    "value": "var(--colors-icon-transparent-action-neutral-fixed-default)",
    "variable": "var(--colors-icon-transparent-action-neutral-fixed-default)"
  },
  "colors.icon.transparent.action.neutral-fixed.hover": {
    "value": "var(--colors-icon-transparent-action-neutral-fixed-hover)",
    "variable": "var(--colors-icon-transparent-action-neutral-fixed-hover)"
  },
  "colors.icon.transparent.action.neutral-fixed.pressed": {
    "value": "var(--colors-icon-transparent-action-neutral-fixed-pressed)",
    "variable": "var(--colors-icon-transparent-action-neutral-fixed-pressed)"
  },
  "colors.icon.transparent.onImpact.neutral-fixed": {
    "value": "var(--colors-icon-transparent-on-impact-neutral-fixed)",
    "variable": "var(--colors-icon-transparent-on-impact-neutral-fixed)"
  },
  "colors.icon.transparent.onInverse.neutral-fixed": {
    "value": "var(--colors-icon-transparent-on-inverse-neutral-fixed)",
    "variable": "var(--colors-icon-transparent-on-inverse-neutral-fixed)"
  },
  "colors.icon.onHero.action.neutral.default": {
    "value": "var(--colors-icon-on-hero-action-neutral-default)",
    "variable": "var(--colors-icon-on-hero-action-neutral-default)"
  },
  "colors.icon.onHero.action.neutral.hover": {
    "value": "var(--colors-icon-on-hero-action-neutral-hover)",
    "variable": "var(--colors-icon-on-hero-action-neutral-hover)"
  },
  "colors.icon.onHero.action.neutral.pressed": {
    "value": "var(--colors-icon-on-hero-action-neutral-pressed)",
    "variable": "var(--colors-icon-on-hero-action-neutral-pressed)"
  },
  "colors.icon.onHero.express.empower.hero": {
    "value": "var(--colors-icon-on-hero-express-empower-hero)",
    "variable": "var(--colors-icon-on-hero-express-empower-hero)"
  },
  "colors.icon.onHero.express.insight.hero": {
    "value": "var(--colors-icon-on-hero-express-insight-hero)",
    "variable": "var(--colors-icon-on-hero-express-insight-hero)"
  },
  "colors.icon.onHero.express.inspire.hero": {
    "value": "var(--colors-icon-on-hero-express-inspire-hero)",
    "variable": "var(--colors-icon-on-hero-express-inspire-hero)"
  },
  "colors.icon.onHero.express.trust.hero": {
    "value": "var(--colors-icon-on-hero-express-trust-hero)",
    "variable": "var(--colors-icon-on-hero-express-trust-hero)"
  },
  "colors.icon.onHero.neutral": {
    "value": "var(--colors-icon-on-hero-neutral)",
    "variable": "var(--colors-icon-on-hero-neutral)"
  },
  "colors.icon.onHero.neutral-fixed": {
    "value": "var(--colors-icon-on-hero-neutral-fixed)",
    "variable": "var(--colors-icon-on-hero-neutral-fixed)"
  },
  "colors.icon.onHero.link.default": {
    "value": "var(--colors-icon-on-hero-link-default)",
    "variable": "var(--colors-icon-on-hero-link-default)"
  },
  "colors.icon.onHero.link.hover": {
    "value": "var(--colors-icon-on-hero-link-hover)",
    "variable": "var(--colors-icon-on-hero-link-hover)"
  },
  "colors.icon.onHero.link.pressed": {
    "value": "var(--colors-icon-on-hero-link-pressed)",
    "variable": "var(--colors-icon-on-hero-link-pressed)"
  },
  "colors.icon.onImpact.action.neutral.default": {
    "value": "var(--colors-icon-on-impact-action-neutral-default)",
    "variable": "var(--colors-icon-on-impact-action-neutral-default)"
  },
  "colors.icon.onImpact.action.neutral.hover": {
    "value": "var(--colors-icon-on-impact-action-neutral-hover)",
    "variable": "var(--colors-icon-on-impact-action-neutral-hover)"
  },
  "colors.icon.onImpact.action.neutral.pressed": {
    "value": "var(--colors-icon-on-impact-action-neutral-pressed)",
    "variable": "var(--colors-icon-on-impact-action-neutral-pressed)"
  },
  "colors.icon.onImpact.action.neutral-fixed.default": {
    "value": "var(--colors-icon-on-impact-action-neutral-fixed-default)",
    "variable": "var(--colors-icon-on-impact-action-neutral-fixed-default)"
  },
  "colors.icon.onImpact.action.neutral-fixed.hover": {
    "value": "var(--colors-icon-on-impact-action-neutral-fixed-hover)",
    "variable": "var(--colors-icon-on-impact-action-neutral-fixed-hover)"
  },
  "colors.icon.onImpact.action.neutral-fixed.pressed": {
    "value": "var(--colors-icon-on-impact-action-neutral-fixed-pressed)",
    "variable": "var(--colors-icon-on-impact-action-neutral-fixed-pressed)"
  },
  "colors.icon.onImpact.action.neutral-fixed.selected.default": {
    "value": "var(--colors-icon-on-impact-action-neutral-fixed-selected-default)",
    "variable": "var(--colors-icon-on-impact-action-neutral-fixed-selected-default)"
  },
  "colors.icon.onImpact.action.neutral-fixed.selected.hover": {
    "value": "var(--colors-icon-on-impact-action-neutral-fixed-selected-hover)",
    "variable": "var(--colors-icon-on-impact-action-neutral-fixed-selected-hover)"
  },
  "colors.icon.onImpact.action.neutral-fixed.selected.pressed": {
    "value": "var(--colors-icon-on-impact-action-neutral-fixed-selected-pressed)",
    "variable": "var(--colors-icon-on-impact-action-neutral-fixed-selected-pressed)"
  },
  "colors.icon.onImpact.express.empower.hero": {
    "value": "var(--colors-icon-on-impact-express-empower-hero)",
    "variable": "var(--colors-icon-on-impact-express-empower-hero)"
  },
  "colors.icon.onImpact.express.insight.hero": {
    "value": "var(--colors-icon-on-impact-express-insight-hero)",
    "variable": "var(--colors-icon-on-impact-express-insight-hero)"
  },
  "colors.icon.onImpact.express.inspire.hero": {
    "value": "var(--colors-icon-on-impact-express-inspire-hero)",
    "variable": "var(--colors-icon-on-impact-express-inspire-hero)"
  },
  "colors.icon.onImpact.express.trust.hero": {
    "value": "var(--colors-icon-on-impact-express-trust-hero)",
    "variable": "var(--colors-icon-on-impact-express-trust-hero)"
  },
  "colors.icon.onImpact.feedback.critical.strong": {
    "value": "var(--colors-icon-on-impact-feedback-critical-strong)",
    "variable": "var(--colors-icon-on-impact-feedback-critical-strong)"
  },
  "colors.icon.onImpact.feedback.critical.hero": {
    "value": "var(--colors-icon-on-impact-feedback-critical-hero)",
    "variable": "var(--colors-icon-on-impact-feedback-critical-hero)"
  },
  "colors.icon.onImpact.feedback.critical.hero-alt": {
    "value": "var(--colors-icon-on-impact-feedback-critical-hero-alt)",
    "variable": "var(--colors-icon-on-impact-feedback-critical-hero-alt)"
  },
  "colors.icon.onImpact.feedback.info.strong": {
    "value": "var(--colors-icon-on-impact-feedback-info-strong)",
    "variable": "var(--colors-icon-on-impact-feedback-info-strong)"
  },
  "colors.icon.onImpact.feedback.info.hero": {
    "value": "var(--colors-icon-on-impact-feedback-info-hero)",
    "variable": "var(--colors-icon-on-impact-feedback-info-hero)"
  },
  "colors.icon.onImpact.feedback.notify.strong": {
    "value": "var(--colors-icon-on-impact-feedback-notify-strong)",
    "variable": "var(--colors-icon-on-impact-feedback-notify-strong)"
  },
  "colors.icon.onImpact.feedback.notify.hero": {
    "value": "var(--colors-icon-on-impact-feedback-notify-hero)",
    "variable": "var(--colors-icon-on-impact-feedback-notify-hero)"
  },
  "colors.icon.onImpact.feedback.notify.hero-alt": {
    "value": "var(--colors-icon-on-impact-feedback-notify-hero-alt)",
    "variable": "var(--colors-icon-on-impact-feedback-notify-hero-alt)"
  },
  "colors.icon.onImpact.feedback.success.strong": {
    "value": "var(--colors-icon-on-impact-feedback-success-strong)",
    "variable": "var(--colors-icon-on-impact-feedback-success-strong)"
  },
  "colors.icon.onImpact.feedback.success.hero": {
    "value": "var(--colors-icon-on-impact-feedback-success-hero)",
    "variable": "var(--colors-icon-on-impact-feedback-success-hero)"
  },
  "colors.icon.onImpact.feedback.success.hero-alt": {
    "value": "var(--colors-icon-on-impact-feedback-success-hero-alt)",
    "variable": "var(--colors-icon-on-impact-feedback-success-hero-alt)"
  },
  "colors.icon.onImpact.feedback.warning.strong": {
    "value": "var(--colors-icon-on-impact-feedback-warning-strong)",
    "variable": "var(--colors-icon-on-impact-feedback-warning-strong)"
  },
  "colors.icon.onImpact.feedback.warning.hero": {
    "value": "var(--colors-icon-on-impact-feedback-warning-hero)",
    "variable": "var(--colors-icon-on-impact-feedback-warning-hero)"
  },
  "colors.icon.onImpact.neutral": {
    "value": "var(--colors-icon-on-impact-neutral)",
    "variable": "var(--colors-icon-on-impact-neutral)"
  },
  "colors.icon.onImpact.neutral-fixed": {
    "value": "var(--colors-icon-on-impact-neutral-fixed)",
    "variable": "var(--colors-icon-on-impact-neutral-fixed)"
  },
  "colors.icon.onImpact.subtle": {
    "value": "var(--colors-icon-on-impact-subtle)",
    "variable": "var(--colors-icon-on-impact-subtle)"
  },
  "colors.icon.onImpact.link.default": {
    "value": "var(--colors-icon-on-impact-link-default)",
    "variable": "var(--colors-icon-on-impact-link-default)"
  },
  "colors.icon.onImpact.link.hover": {
    "value": "var(--colors-icon-on-impact-link-hover)",
    "variable": "var(--colors-icon-on-impact-link-hover)"
  },
  "colors.icon.onImpact.link.pressed": {
    "value": "var(--colors-icon-on-impact-link-pressed)",
    "variable": "var(--colors-icon-on-impact-link-pressed)"
  },
  "colors.icon.onImpact.link.fixed.default": {
    "value": "var(--colors-icon-on-impact-link-fixed-default)",
    "variable": "var(--colors-icon-on-impact-link-fixed-default)"
  },
  "colors.icon.onImpact.link.fixed.hover": {
    "value": "var(--colors-icon-on-impact-link-fixed-hover)",
    "variable": "var(--colors-icon-on-impact-link-fixed-hover)"
  },
  "colors.icon.onImpact.link.fixed.pressed": {
    "value": "var(--colors-icon-on-impact-link-fixed-pressed)",
    "variable": "var(--colors-icon-on-impact-link-fixed-pressed)"
  },
  "colors.icon.onImpact.link.fixed.selected.default": {
    "value": "var(--colors-icon-on-impact-link-fixed-selected-default)",
    "variable": "var(--colors-icon-on-impact-link-fixed-selected-default)"
  },
  "colors.icon.onImpact.link.fixed.selected.hover": {
    "value": "var(--colors-icon-on-impact-link-fixed-selected-hover)",
    "variable": "var(--colors-icon-on-impact-link-fixed-selected-hover)"
  },
  "colors.icon.onImpact.link.fixed.selected.pressed": {
    "value": "var(--colors-icon-on-impact-link-fixed-selected-pressed)",
    "variable": "var(--colors-icon-on-impact-link-fixed-selected-pressed)"
  },
  "colors.text.onHero.action.neutral.default": {
    "value": "var(--colors-text-on-hero-action-neutral-default)",
    "variable": "var(--colors-text-on-hero-action-neutral-default)"
  },
  "colors.text.onHero.action.neutral.hover": {
    "value": "var(--colors-text-on-hero-action-neutral-hover)",
    "variable": "var(--colors-text-on-hero-action-neutral-hover)"
  },
  "colors.text.onHero.action.neutral.pressed": {
    "value": "var(--colors-text-on-hero-action-neutral-pressed)",
    "variable": "var(--colors-text-on-hero-action-neutral-pressed)"
  },
  "colors.text.onHero.express.empower.hero": {
    "value": "var(--colors-text-on-hero-express-empower-hero)",
    "variable": "var(--colors-text-on-hero-express-empower-hero)"
  },
  "colors.text.onHero.express.insight.hero": {
    "value": "var(--colors-text-on-hero-express-insight-hero)",
    "variable": "var(--colors-text-on-hero-express-insight-hero)"
  },
  "colors.text.onHero.express.inspire.hero": {
    "value": "var(--colors-text-on-hero-express-inspire-hero)",
    "variable": "var(--colors-text-on-hero-express-inspire-hero)"
  },
  "colors.text.onHero.express.trust.hero": {
    "value": "var(--colors-text-on-hero-express-trust-hero)",
    "variable": "var(--colors-text-on-hero-express-trust-hero)"
  },
  "colors.text.onHero.neutral": {
    "value": "var(--colors-text-on-hero-neutral)",
    "variable": "var(--colors-text-on-hero-neutral)"
  },
  "colors.text.onHero.neutral-fixed": {
    "value": "var(--colors-text-on-hero-neutral-fixed)",
    "variable": "var(--colors-text-on-hero-neutral-fixed)"
  },
  "colors.text.onHero.link.default": {
    "value": "var(--colors-text-on-hero-link-default)",
    "variable": "var(--colors-text-on-hero-link-default)"
  },
  "colors.text.onHero.link.hover": {
    "value": "var(--colors-text-on-hero-link-hover)",
    "variable": "var(--colors-text-on-hero-link-hover)"
  },
  "colors.text.onHero.link.pressed": {
    "value": "var(--colors-text-on-hero-link-pressed)",
    "variable": "var(--colors-text-on-hero-link-pressed)"
  },
  "colors.text.onHero.link.fixed.default": {
    "value": "var(--colors-text-on-hero-link-fixed-default)",
    "variable": "var(--colors-text-on-hero-link-fixed-default)"
  },
  "colors.text.onHero.link.fixed.hover": {
    "value": "var(--colors-text-on-hero-link-fixed-hover)",
    "variable": "var(--colors-text-on-hero-link-fixed-hover)"
  },
  "colors.text.onHero.link.fixed.pressed": {
    "value": "var(--colors-text-on-hero-link-fixed-pressed)",
    "variable": "var(--colors-text-on-hero-link-fixed-pressed)"
  },
  "colors.text.onImpact.action.neutral.default": {
    "value": "var(--colors-text-on-impact-action-neutral-default)",
    "variable": "var(--colors-text-on-impact-action-neutral-default)"
  },
  "colors.text.onImpact.action.neutral.hover": {
    "value": "var(--colors-text-on-impact-action-neutral-hover)",
    "variable": "var(--colors-text-on-impact-action-neutral-hover)"
  },
  "colors.text.onImpact.action.neutral.pressed": {
    "value": "var(--colors-text-on-impact-action-neutral-pressed)",
    "variable": "var(--colors-text-on-impact-action-neutral-pressed)"
  },
  "colors.text.onImpact.express.energy.hero": {
    "value": "var(--colors-text-on-impact-express-energy-hero)",
    "variable": "var(--colors-text-on-impact-express-energy-hero)"
  },
  "colors.text.onImpact.express.insight.hero": {
    "value": "var(--colors-text-on-impact-express-insight-hero)",
    "variable": "var(--colors-text-on-impact-express-insight-hero)"
  },
  "colors.text.onImpact.express.inspire.hero": {
    "value": "var(--colors-text-on-impact-express-inspire-hero)",
    "variable": "var(--colors-text-on-impact-express-inspire-hero)"
  },
  "colors.text.onImpact.express.trust.hero": {
    "value": "var(--colors-text-on-impact-express-trust-hero)",
    "variable": "var(--colors-text-on-impact-express-trust-hero)"
  },
  "colors.text.onImpact.feedback.critical.strong": {
    "value": "var(--colors-text-on-impact-feedback-critical-strong)",
    "variable": "var(--colors-text-on-impact-feedback-critical-strong)"
  },
  "colors.text.onImpact.feedback.critical.hero": {
    "value": "var(--colors-text-on-impact-feedback-critical-hero)",
    "variable": "var(--colors-text-on-impact-feedback-critical-hero)"
  },
  "colors.text.onImpact.feedback.info.strong": {
    "value": "var(--colors-text-on-impact-feedback-info-strong)",
    "variable": "var(--colors-text-on-impact-feedback-info-strong)"
  },
  "colors.text.onImpact.feedback.info.hero": {
    "value": "var(--colors-text-on-impact-feedback-info-hero)",
    "variable": "var(--colors-text-on-impact-feedback-info-hero)"
  },
  "colors.text.onImpact.feedback.notify.strong": {
    "value": "var(--colors-text-on-impact-feedback-notify-strong)",
    "variable": "var(--colors-text-on-impact-feedback-notify-strong)"
  },
  "colors.text.onImpact.feedback.notify.hero": {
    "value": "var(--colors-text-on-impact-feedback-notify-hero)",
    "variable": "var(--colors-text-on-impact-feedback-notify-hero)"
  },
  "colors.text.onImpact.feedback.success.strong": {
    "value": "var(--colors-text-on-impact-feedback-success-strong)",
    "variable": "var(--colors-text-on-impact-feedback-success-strong)"
  },
  "colors.text.onImpact.feedback.success.hero": {
    "value": "var(--colors-text-on-impact-feedback-success-hero)",
    "variable": "var(--colors-text-on-impact-feedback-success-hero)"
  },
  "colors.text.onImpact.feedback.warning.strong": {
    "value": "var(--colors-text-on-impact-feedback-warning-strong)",
    "variable": "var(--colors-text-on-impact-feedback-warning-strong)"
  },
  "colors.text.onImpact.feedback.warning.hero": {
    "value": "var(--colors-text-on-impact-feedback-warning-hero)",
    "variable": "var(--colors-text-on-impact-feedback-warning-hero)"
  },
  "colors.text.onImpact.neutral": {
    "value": "var(--colors-text-on-impact-neutral)",
    "variable": "var(--colors-text-on-impact-neutral)"
  },
  "colors.text.onImpact.neutral-fixed": {
    "value": "var(--colors-text-on-impact-neutral-fixed)",
    "variable": "var(--colors-text-on-impact-neutral-fixed)"
  },
  "colors.text.onImpact.subtle": {
    "value": "var(--colors-text-on-impact-subtle)",
    "variable": "var(--colors-text-on-impact-subtle)"
  },
  "colors.text.onImpact.link.default": {
    "value": "var(--colors-text-on-impact-link-default)",
    "variable": "var(--colors-text-on-impact-link-default)"
  },
  "colors.text.onImpact.link.hover": {
    "value": "var(--colors-text-on-impact-link-hover)",
    "variable": "var(--colors-text-on-impact-link-hover)"
  },
  "colors.text.onImpact.link.pressed": {
    "value": "var(--colors-text-on-impact-link-pressed)",
    "variable": "var(--colors-text-on-impact-link-pressed)"
  },
  "colors.text.onImpact.link.last-visited": {
    "value": "var(--colors-text-on-impact-link-last-visited)",
    "variable": "var(--colors-text-on-impact-link-last-visited)"
  },
  "colors.text.onImpact.link.fixed.default": {
    "value": "var(--colors-text-on-impact-link-fixed-default)",
    "variable": "var(--colors-text-on-impact-link-fixed-default)"
  },
  "colors.text.onImpact.link.fixed.hover": {
    "value": "var(--colors-text-on-impact-link-fixed-hover)",
    "variable": "var(--colors-text-on-impact-link-fixed-hover)"
  },
  "colors.text.onImpact.link.fixed.pressed": {
    "value": "var(--colors-text-on-impact-link-fixed-pressed)",
    "variable": "var(--colors-text-on-impact-link-fixed-pressed)"
  },
  "colors.text.onImpact.link.fixed.last-visited": {
    "value": "var(--colors-text-on-impact-link-fixed-last-visited)",
    "variable": "var(--colors-text-on-impact-link-fixed-last-visited)"
  },
  "colors.text.accent.brand.hero": {
    "value": "var(--colors-text-accent-brand-hero)",
    "variable": "var(--colors-text-accent-brand-hero)"
  },
  "colors.text.accent.brand.hero-fixed": {
    "value": "var(--colors-text-accent-brand-hero-fixed)",
    "variable": "var(--colors-text-accent-brand-hero-fixed)"
  },
  "colors.text.accent.aqua.strong": {
    "value": "var(--colors-text-accent-aqua-strong)",
    "variable": "var(--colors-text-accent-aqua-strong)"
  },
  "colors.text.accent.aqua.hero": {
    "value": "var(--colors-text-accent-aqua-hero)",
    "variable": "var(--colors-text-accent-aqua-hero)"
  },
  "colors.text.accent.blue.strong": {
    "value": "var(--colors-text-accent-blue-strong)",
    "variable": "var(--colors-text-accent-blue-strong)"
  },
  "colors.text.accent.blue.strong-fixed": {
    "value": "var(--colors-text-accent-blue-strong-fixed)",
    "variable": "var(--colors-text-accent-blue-strong-fixed)"
  },
  "colors.text.accent.blue.hero": {
    "value": "var(--colors-text-accent-blue-hero)",
    "variable": "var(--colors-text-accent-blue-hero)"
  },
  "colors.text.accent.gray.strong": {
    "value": "var(--colors-text-accent-gray-strong)",
    "variable": "var(--colors-text-accent-gray-strong)"
  },
  "colors.text.accent.gray.hero": {
    "value": "var(--colors-text-accent-gray-hero)",
    "variable": "var(--colors-text-accent-gray-hero)"
  },
  "colors.text.accent.green.strong": {
    "value": "var(--colors-text-accent-green-strong)",
    "variable": "var(--colors-text-accent-green-strong)"
  },
  "colors.text.accent.green.hero": {
    "value": "var(--colors-text-accent-green-hero)",
    "variable": "var(--colors-text-accent-green-hero)"
  },
  "colors.text.accent.orange.strong": {
    "value": "var(--colors-text-accent-orange-strong)",
    "variable": "var(--colors-text-accent-orange-strong)"
  },
  "colors.text.accent.orange.hero": {
    "value": "var(--colors-text-accent-orange-hero)",
    "variable": "var(--colors-text-accent-orange-hero)"
  },
  "colors.text.accent.purple.strong": {
    "value": "var(--colors-text-accent-purple-strong)",
    "variable": "var(--colors-text-accent-purple-strong)"
  },
  "colors.text.accent.purple.hero": {
    "value": "var(--colors-text-accent-purple-hero)",
    "variable": "var(--colors-text-accent-purple-hero)"
  },
  "colors.text.accent.red.strong": {
    "value": "var(--colors-text-accent-red-strong)",
    "variable": "var(--colors-text-accent-red-strong)"
  },
  "colors.text.accent.red.hero": {
    "value": "var(--colors-text-accent-red-hero)",
    "variable": "var(--colors-text-accent-red-hero)"
  },
  "colors.text.accent.teal.strong": {
    "value": "var(--colors-text-accent-teal-strong)",
    "variable": "var(--colors-text-accent-teal-strong)"
  },
  "colors.text.accent.teal.hero": {
    "value": "var(--colors-text-accent-teal-hero)",
    "variable": "var(--colors-text-accent-teal-hero)"
  },
  "colors.text.accent.yellow.strong": {
    "value": "var(--colors-text-accent-yellow-strong)",
    "variable": "var(--colors-text-accent-yellow-strong)"
  },
  "colors.text.accent.yellow.hero": {
    "value": "var(--colors-text-accent-yellow-hero)",
    "variable": "var(--colors-text-accent-yellow-hero)"
  },
  "colors.text.action.disabled": {
    "value": "var(--colors-text-action-disabled)",
    "variable": "var(--colors-text-action-disabled)"
  },
  "colors.text.action.disabled-alt": {
    "value": "var(--colors-text-action-disabled-alt)",
    "variable": "var(--colors-text-action-disabled-alt)"
  },
  "colors.text.action.neutral.default": {
    "value": "var(--colors-text-action-neutral-default)",
    "variable": "var(--colors-text-action-neutral-default)"
  },
  "colors.text.action.neutral.hover": {
    "value": "var(--colors-text-action-neutral-hover)",
    "variable": "var(--colors-text-action-neutral-hover)"
  },
  "colors.text.action.neutral.pressed": {
    "value": "var(--colors-text-action-neutral-pressed)",
    "variable": "var(--colors-text-action-neutral-pressed)"
  },
  "colors.text.action.hero.default": {
    "value": "var(--colors-text-action-hero-default)",
    "variable": "var(--colors-text-action-hero-default)"
  },
  "colors.text.action.hero.hover": {
    "value": "var(--colors-text-action-hero-hover)",
    "variable": "var(--colors-text-action-hero-hover)"
  },
  "colors.text.action.hero.pressed": {
    "value": "var(--colors-text-action-hero-pressed)",
    "variable": "var(--colors-text-action-hero-pressed)"
  },
  "colors.text.action.hero.selected.default": {
    "value": "var(--colors-text-action-hero-selected-default)",
    "variable": "var(--colors-text-action-hero-selected-default)"
  },
  "colors.text.action.hero.selected.hover": {
    "value": "var(--colors-text-action-hero-selected-hover)",
    "variable": "var(--colors-text-action-hero-selected-hover)"
  },
  "colors.text.action.hero.selected.pressed": {
    "value": "var(--colors-text-action-hero-selected-pressed)",
    "variable": "var(--colors-text-action-hero-selected-pressed)"
  },
  "colors.text.action.strong.default": {
    "value": "var(--colors-text-action-strong-default)",
    "variable": "var(--colors-text-action-strong-default)"
  },
  "colors.text.action.strong.hover": {
    "value": "var(--colors-text-action-strong-hover)",
    "variable": "var(--colors-text-action-strong-hover)"
  },
  "colors.text.action.strong.pressed": {
    "value": "var(--colors-text-action-strong-pressed)",
    "variable": "var(--colors-text-action-strong-pressed)"
  },
  "colors.text.action.critical.strong.default": {
    "value": "var(--colors-text-action-critical-strong-default)",
    "variable": "var(--colors-text-action-critical-strong-default)"
  },
  "colors.text.action.critical.strong.hover": {
    "value": "var(--colors-text-action-critical-strong-hover)",
    "variable": "var(--colors-text-action-critical-strong-hover)"
  },
  "colors.text.action.critical.strong.pressed": {
    "value": "var(--colors-text-action-critical-strong-pressed)",
    "variable": "var(--colors-text-action-critical-strong-pressed)"
  },
  "colors.text.action.critical.hero.default": {
    "value": "var(--colors-text-action-critical-hero-default)",
    "variable": "var(--colors-text-action-critical-hero-default)"
  },
  "colors.text.action.critical.hero.hover": {
    "value": "var(--colors-text-action-critical-hero-hover)",
    "variable": "var(--colors-text-action-critical-hero-hover)"
  },
  "colors.text.action.critical.hero.pressed": {
    "value": "var(--colors-text-action-critical-hero-pressed)",
    "variable": "var(--colors-text-action-critical-hero-pressed)"
  },
  "colors.text.express.empower.strong": {
    "value": "var(--colors-text-express-empower-strong)",
    "variable": "var(--colors-text-express-empower-strong)"
  },
  "colors.text.express.empower.hero": {
    "value": "var(--colors-text-express-empower-hero)",
    "variable": "var(--colors-text-express-empower-hero)"
  },
  "colors.text.express.insight.strong": {
    "value": "var(--colors-text-express-insight-strong)",
    "variable": "var(--colors-text-express-insight-strong)"
  },
  "colors.text.express.insight.hero": {
    "value": "var(--colors-text-express-insight-hero)",
    "variable": "var(--colors-text-express-insight-hero)"
  },
  "colors.text.express.inspire.strong": {
    "value": "var(--colors-text-express-inspire-strong)",
    "variable": "var(--colors-text-express-inspire-strong)"
  },
  "colors.text.express.inspire.hero": {
    "value": "var(--colors-text-express-inspire-hero)",
    "variable": "var(--colors-text-express-inspire-hero)"
  },
  "colors.text.express.trust.strong": {
    "value": "var(--colors-text-express-trust-strong)",
    "variable": "var(--colors-text-express-trust-strong)"
  },
  "colors.text.express.trust.hero": {
    "value": "var(--colors-text-express-trust-hero)",
    "variable": "var(--colors-text-express-trust-hero)"
  },
  "colors.text.feedback.critical.strong": {
    "value": "var(--colors-text-feedback-critical-strong)",
    "variable": "var(--colors-text-feedback-critical-strong)"
  },
  "colors.text.feedback.critical.hero": {
    "value": "var(--colors-text-feedback-critical-hero)",
    "variable": "var(--colors-text-feedback-critical-hero)"
  },
  "colors.text.feedback.info.strong": {
    "value": "var(--colors-text-feedback-info-strong)",
    "variable": "var(--colors-text-feedback-info-strong)"
  },
  "colors.text.feedback.info.hero": {
    "value": "var(--colors-text-feedback-info-hero)",
    "variable": "var(--colors-text-feedback-info-hero)"
  },
  "colors.text.feedback.notify.strong": {
    "value": "var(--colors-text-feedback-notify-strong)",
    "variable": "var(--colors-text-feedback-notify-strong)"
  },
  "colors.text.feedback.notify.hero": {
    "value": "var(--colors-text-feedback-notify-hero)",
    "variable": "var(--colors-text-feedback-notify-hero)"
  },
  "colors.text.feedback.success.strong": {
    "value": "var(--colors-text-feedback-success-strong)",
    "variable": "var(--colors-text-feedback-success-strong)"
  },
  "colors.text.feedback.success.hero": {
    "value": "var(--colors-text-feedback-success-hero)",
    "variable": "var(--colors-text-feedback-success-hero)"
  },
  "colors.text.feedback.warning.strong": {
    "value": "var(--colors-text-feedback-warning-strong)",
    "variable": "var(--colors-text-feedback-warning-strong)"
  },
  "colors.text.feedback.warning.hero": {
    "value": "var(--colors-text-feedback-warning-hero)",
    "variable": "var(--colors-text-feedback-warning-hero)"
  },
  "colors.text.neutral": {
    "value": "var(--colors-text-neutral)",
    "variable": "var(--colors-text-neutral)"
  },
  "colors.text.neutral-fixed": {
    "value": "var(--colors-text-neutral-fixed)",
    "variable": "var(--colors-text-neutral-fixed)"
  },
  "colors.text.subtle": {
    "value": "var(--colors-text-subtle)",
    "variable": "var(--colors-text-subtle)"
  },
  "colors.text.invisible": {
    "value": "var(--colors-text-invisible)",
    "variable": "var(--colors-text-invisible)"
  },
  "colors.text.link.default": {
    "value": "var(--colors-text-link-default)",
    "variable": "var(--colors-text-link-default)"
  },
  "colors.text.link.hover": {
    "value": "var(--colors-text-link-hover)",
    "variable": "var(--colors-text-link-hover)"
  },
  "colors.text.link.pressed": {
    "value": "var(--colors-text-link-pressed)",
    "variable": "var(--colors-text-link-pressed)"
  },
  "colors.text.link.last-visited": {
    "value": "var(--colors-text-link-last-visited)",
    "variable": "var(--colors-text-link-last-visited)"
  },
  "colors.Accordion.bg.default": {
    "value": "var(--colors--accordion-bg-default)",
    "variable": "var(--colors--accordion-bg-default)"
  },
  "colors.Accordion.bg.hover": {
    "value": "var(--colors--accordion-bg-hover)",
    "variable": "var(--colors--accordion-bg-hover)"
  },
  "colors.Accordion.bg.pressed": {
    "value": "var(--colors--accordion-bg-pressed)",
    "variable": "var(--colors--accordion-bg-pressed)"
  },
  "colors.Accordion.bg.selectedPressed": {
    "value": "var(--colors--accordion-bg-selected-pressed)",
    "variable": "var(--colors--accordion-bg-selected-pressed)"
  },
  "colors.Accordion.border.default": {
    "value": "var(--colors--accordion-border-default)",
    "variable": "var(--colors--accordion-border-default)"
  },
  "colors.Accordion.Header.bg.default": {
    "value": "var(--colors--accordion--header-bg-default)",
    "variable": "var(--colors--accordion--header-bg-default)"
  },
  "colors.Accordion.Header.bg.hover": {
    "value": "var(--colors--accordion--header-bg-hover)",
    "variable": "var(--colors--accordion--header-bg-hover)"
  },
  "colors.Accordion.Header.bg.pressed": {
    "value": "var(--colors--accordion--header-bg-pressed)",
    "variable": "var(--colors--accordion--header-bg-pressed)"
  },
  "colors.Accordion.Header.bg.selected": {
    "value": "var(--colors--accordion--header-bg-selected)",
    "variable": "var(--colors--accordion--header-bg-selected)"
  },
  "colors.Accordion.Header.bg.selectedHover": {
    "value": "var(--colors--accordion--header-bg-selected-hover)",
    "variable": "var(--colors--accordion--header-bg-selected-hover)"
  },
  "colors.Accordion.Header.bg.selectedPressed": {
    "value": "var(--colors--accordion--header-bg-selected-pressed)",
    "variable": "var(--colors--accordion--header-bg-selected-pressed)"
  },
  "colors.Accordion.Header.border.default": {
    "value": "var(--colors--accordion--header-border-default)",
    "variable": "var(--colors--accordion--header-border-default)"
  },
  "colors.Accordion.Header.icon.leading": {
    "value": "var(--colors--accordion--header-icon-leading)",
    "variable": "var(--colors--accordion--header-icon-leading)"
  },
  "colors.Accordion.Header.icon.trailing": {
    "value": "var(--colors--accordion--header-icon-trailing)",
    "variable": "var(--colors--accordion--header-icon-trailing)"
  },
  "colors.Accordion.Header.label.default": {
    "value": "var(--colors--accordion--header-label-default)",
    "variable": "var(--colors--accordion--header-label-default)"
  },
  "colors.Accordion.Header.label.trailing": {
    "value": "var(--colors--accordion--header-label-trailing)",
    "variable": "var(--colors--accordion--header-label-trailing)"
  },
  "colors.Accordion.Panel.bg": {
    "value": "var(--colors--accordion--panel-bg)",
    "variable": "var(--colors--accordion--panel-bg)"
  },
  "colors.Accordion.Panel.border": {
    "value": "var(--colors--accordion--panel-border)",
    "variable": "var(--colors--accordion--panel-border)"
  },
  "colors.AdornedInput.Adornment.default": {
    "value": "var(--colors--adorned-input--adornment-default)",
    "variable": "var(--colors--adorned-input--adornment-default)"
  },
  "colors.AdornedInput.Input.placeholder": {
    "value": "var(--colors--adorned-input--input-placeholder)",
    "variable": "var(--colors--adorned-input--input-placeholder)"
  },
  "colors.AdornedInput.Input.populated": {
    "value": "var(--colors--adorned-input--input-populated)",
    "variable": "var(--colors--adorned-input--input-populated)"
  },
  "colors.AdornedInput.bg.active": {
    "value": "var(--colors--adorned-input-bg-active)",
    "variable": "var(--colors--adorned-input-bg-active)"
  },
  "colors.AdornedInput.bg.activeHover": {
    "value": "var(--colors--adorned-input-bg-active-hover)",
    "variable": "var(--colors--adorned-input-bg-active-hover)"
  },
  "colors.AdornedInput.bg.autofill": {
    "value": "var(--colors--adorned-input-bg-autofill)",
    "variable": "var(--colors--adorned-input-bg-autofill)"
  },
  "colors.AdornedInput.bg.default": {
    "value": "var(--colors--adorned-input-bg-default)",
    "variable": "var(--colors--adorned-input-bg-default)"
  },
  "colors.AdornedInput.bg.error": {
    "value": "var(--colors--adorned-input-bg-error)",
    "variable": "var(--colors--adorned-input-bg-error)"
  },
  "colors.AdornedInput.bg.errorActive": {
    "value": "var(--colors--adorned-input-bg-error-active)",
    "variable": "var(--colors--adorned-input-bg-error-active)"
  },
  "colors.AdornedInput.bg.errorHover": {
    "value": "var(--colors--adorned-input-bg-error-hover)",
    "variable": "var(--colors--adorned-input-bg-error-hover)"
  },
  "colors.AdornedInput.bg.hover": {
    "value": "var(--colors--adorned-input-bg-hover)",
    "variable": "var(--colors--adorned-input-bg-hover)"
  },
  "colors.AdornedInput.bg.readOnly": {
    "value": "var(--colors--adorned-input-bg-read-only)",
    "variable": "var(--colors--adorned-input-bg-read-only)"
  },
  "colors.AdornedInput.border.active": {
    "value": "var(--colors--adorned-input-border-active)",
    "variable": "var(--colors--adorned-input-border-active)"
  },
  "colors.AdornedInput.border.activeHover": {
    "value": "var(--colors--adorned-input-border-active-hover)",
    "variable": "var(--colors--adorned-input-border-active-hover)"
  },
  "colors.AdornedInput.border.default": {
    "value": "var(--colors--adorned-input-border-default)",
    "variable": "var(--colors--adorned-input-border-default)"
  },
  "colors.AdornedInput.border.error": {
    "value": "var(--colors--adorned-input-border-error)",
    "variable": "var(--colors--adorned-input-border-error)"
  },
  "colors.AdornedInput.border.errorActive": {
    "value": "var(--colors--adorned-input-border-error-active)",
    "variable": "var(--colors--adorned-input-border-error-active)"
  },
  "colors.AdornedInput.border.errorHover": {
    "value": "var(--colors--adorned-input-border-error-hover)",
    "variable": "var(--colors--adorned-input-border-error-hover)"
  },
  "colors.AdornedInput.border.hover": {
    "value": "var(--colors--adorned-input-border-hover)",
    "variable": "var(--colors--adorned-input-border-hover)"
  },
  "colors.Alert.critical.bg": {
    "value": "var(--colors--alert-critical-bg)",
    "variable": "var(--colors--alert-critical-bg)"
  },
  "colors.Alert.critical.border": {
    "value": "var(--colors--alert-critical-border)",
    "variable": "var(--colors--alert-critical-border)"
  },
  "colors.Alert.critical.icon": {
    "value": "var(--colors--alert-critical-icon)",
    "variable": "var(--colors--alert-critical-icon)"
  },
  "colors.Alert.critical.text": {
    "value": "var(--colors--alert-critical-text)",
    "variable": "var(--colors--alert-critical-text)"
  },
  "colors.Alert.info.bg": {
    "value": "var(--colors--alert-info-bg)",
    "variable": "var(--colors--alert-info-bg)"
  },
  "colors.Alert.info.border": {
    "value": "var(--colors--alert-info-border)",
    "variable": "var(--colors--alert-info-border)"
  },
  "colors.Alert.info.icon": {
    "value": "var(--colors--alert-info-icon)",
    "variable": "var(--colors--alert-info-icon)"
  },
  "colors.Alert.info.text": {
    "value": "var(--colors--alert-info-text)",
    "variable": "var(--colors--alert-info-text)"
  },
  "colors.Alert.notify.bg": {
    "value": "var(--colors--alert-notify-bg)",
    "variable": "var(--colors--alert-notify-bg)"
  },
  "colors.Alert.notify.border": {
    "value": "var(--colors--alert-notify-border)",
    "variable": "var(--colors--alert-notify-border)"
  },
  "colors.Alert.notify.icon": {
    "value": "var(--colors--alert-notify-icon)",
    "variable": "var(--colors--alert-notify-icon)"
  },
  "colors.Alert.notify.text": {
    "value": "var(--colors--alert-notify-text)",
    "variable": "var(--colors--alert-notify-text)"
  },
  "colors.Alert.success.bg": {
    "value": "var(--colors--alert-success-bg)",
    "variable": "var(--colors--alert-success-bg)"
  },
  "colors.Alert.success.border": {
    "value": "var(--colors--alert-success-border)",
    "variable": "var(--colors--alert-success-border)"
  },
  "colors.Alert.success.icon": {
    "value": "var(--colors--alert-success-icon)",
    "variable": "var(--colors--alert-success-icon)"
  },
  "colors.Alert.success.text": {
    "value": "var(--colors--alert-success-text)",
    "variable": "var(--colors--alert-success-text)"
  },
  "colors.Alert.warning.bg": {
    "value": "var(--colors--alert-warning-bg)",
    "variable": "var(--colors--alert-warning-bg)"
  },
  "colors.Alert.warning.border": {
    "value": "var(--colors--alert-warning-border)",
    "variable": "var(--colors--alert-warning-border)"
  },
  "colors.Alert.warning.icon": {
    "value": "var(--colors--alert-warning-icon)",
    "variable": "var(--colors--alert-warning-icon)"
  },
  "colors.Alert.warning.text": {
    "value": "var(--colors--alert-warning-text)",
    "variable": "var(--colors--alert-warning-text)"
  },
  "colors.Anchor.default": {
    "value": "var(--colors--anchor-default)",
    "variable": "var(--colors--anchor-default)"
  },
  "colors.Anchor.focus": {
    "value": "var(--colors--anchor-focus)",
    "variable": "var(--colors--anchor-focus)"
  },
  "colors.Anchor.visited": {
    "value": "var(--colors--anchor-visited)",
    "variable": "var(--colors--anchor-visited)"
  },
  "colors.Anchor.hover": {
    "value": "var(--colors--anchor-hover)",
    "variable": "var(--colors--anchor-hover)"
  },
  "colors.Anchor.pressed": {
    "value": "var(--colors--anchor-pressed)",
    "variable": "var(--colors--anchor-pressed)"
  },
  "colors.Anchor.onImpact.default": {
    "value": "var(--colors--anchor-on-impact-default)",
    "variable": "var(--colors--anchor-on-impact-default)"
  },
  "colors.Anchor.onImpact.hover": {
    "value": "var(--colors--anchor-on-impact-hover)",
    "variable": "var(--colors--anchor-on-impact-hover)"
  },
  "colors.Anchor.onImpact.focus": {
    "value": "var(--colors--anchor-on-impact-focus)",
    "variable": "var(--colors--anchor-on-impact-focus)"
  },
  "colors.Anchor.onImpact.visited": {
    "value": "var(--colors--anchor-on-impact-visited)",
    "variable": "var(--colors--anchor-on-impact-visited)"
  },
  "colors.Anchor.onImpact.pressed": {
    "value": "var(--colors--anchor-on-impact-pressed)",
    "variable": "var(--colors--anchor-on-impact-pressed)"
  },
  "colors.Avatar.Badge.hero.bg": {
    "value": "var(--colors--avatar--badge-hero-bg)",
    "variable": "var(--colors--avatar--badge-hero-bg)"
  },
  "colors.Avatar.Badge.hero.border": {
    "value": "var(--colors--avatar--badge-hero-border)",
    "variable": "var(--colors--avatar--badge-hero-border)"
  },
  "colors.Avatar.Badge.hero.icon": {
    "value": "var(--colors--avatar--badge-hero-icon)",
    "variable": "var(--colors--avatar--badge-hero-icon)"
  },
  "colors.Avatar.Badge.impact.bg": {
    "value": "var(--colors--avatar--badge-impact-bg)",
    "variable": "var(--colors--avatar--badge-impact-bg)"
  },
  "colors.Avatar.Badge.impact.border": {
    "value": "var(--colors--avatar--badge-impact-border)",
    "variable": "var(--colors--avatar--badge-impact-border)"
  },
  "colors.Avatar.Badge.impact.icon": {
    "value": "var(--colors--avatar--badge-impact-icon)",
    "variable": "var(--colors--avatar--badge-impact-icon)"
  },
  "colors.Avatar.Icon.default": {
    "value": "var(--colors--avatar--icon-default)",
    "variable": "var(--colors--avatar--icon-default)"
  },
  "colors.Avatar.Icon.brand.hero": {
    "value": "var(--colors--avatar--icon-brand-hero)",
    "variable": "var(--colors--avatar--icon-brand-hero)"
  },
  "colors.Avatar.Icon.accent-1": {
    "value": "var(--colors--avatar--icon-accent-1)",
    "variable": "var(--colors--avatar--icon-accent-1)"
  },
  "colors.Avatar.Icon.accent-2": {
    "value": "var(--colors--avatar--icon-accent-2)",
    "variable": "var(--colors--avatar--icon-accent-2)"
  },
  "colors.Avatar.Icon.accent-3": {
    "value": "var(--colors--avatar--icon-accent-3)",
    "variable": "var(--colors--avatar--icon-accent-3)"
  },
  "colors.Avatar.Icon.accent-4": {
    "value": "var(--colors--avatar--icon-accent-4)",
    "variable": "var(--colors--avatar--icon-accent-4)"
  },
  "colors.Avatar.Root.bg": {
    "value": "var(--colors--avatar--root-bg)",
    "variable": "var(--colors--avatar--root-bg)"
  },
  "colors.Avatar.Root.border": {
    "value": "var(--colors--avatar--root-border)",
    "variable": "var(--colors--avatar--root-border)"
  },
  "colors.Avatar.Root.text": {
    "value": "var(--colors--avatar--root-text)",
    "variable": "var(--colors--avatar--root-text)"
  },
  "colors.Avatar.Root.brand.hero.bg": {
    "value": "var(--colors--avatar--root-brand-hero-bg)",
    "variable": "var(--colors--avatar--root-brand-hero-bg)"
  },
  "colors.Avatar.Root.brand.hero.border": {
    "value": "var(--colors--avatar--root-brand-hero-border)",
    "variable": "var(--colors--avatar--root-brand-hero-border)"
  },
  "colors.Avatar.Root.brand.hero.text": {
    "value": "var(--colors--avatar--root-brand-hero-text)",
    "variable": "var(--colors--avatar--root-brand-hero-text)"
  },
  "colors.Avatar.Root.accent.1.bg": {
    "value": "var(--colors--avatar--root-accent-1-bg)",
    "variable": "var(--colors--avatar--root-accent-1-bg)"
  },
  "colors.Avatar.Root.accent.1.border": {
    "value": "var(--colors--avatar--root-accent-1-border)",
    "variable": "var(--colors--avatar--root-accent-1-border)"
  },
  "colors.Avatar.Root.accent.1.text": {
    "value": "var(--colors--avatar--root-accent-1-text)",
    "variable": "var(--colors--avatar--root-accent-1-text)"
  },
  "colors.Avatar.Root.accent.2.bg": {
    "value": "var(--colors--avatar--root-accent-2-bg)",
    "variable": "var(--colors--avatar--root-accent-2-bg)"
  },
  "colors.Avatar.Root.accent.2.border": {
    "value": "var(--colors--avatar--root-accent-2-border)",
    "variable": "var(--colors--avatar--root-accent-2-border)"
  },
  "colors.Avatar.Root.accent.2.text": {
    "value": "var(--colors--avatar--root-accent-2-text)",
    "variable": "var(--colors--avatar--root-accent-2-text)"
  },
  "colors.Avatar.Root.accent.3.bg": {
    "value": "var(--colors--avatar--root-accent-3-bg)",
    "variable": "var(--colors--avatar--root-accent-3-bg)"
  },
  "colors.Avatar.Root.accent.3.border": {
    "value": "var(--colors--avatar--root-accent-3-border)",
    "variable": "var(--colors--avatar--root-accent-3-border)"
  },
  "colors.Avatar.Root.accent.3.text": {
    "value": "var(--colors--avatar--root-accent-3-text)",
    "variable": "var(--colors--avatar--root-accent-3-text)"
  },
  "colors.Avatar.Root.accent.4.bg": {
    "value": "var(--colors--avatar--root-accent-4-bg)",
    "variable": "var(--colors--avatar--root-accent-4-bg)"
  },
  "colors.Avatar.Root.accent.4.border": {
    "value": "var(--colors--avatar--root-accent-4-border)",
    "variable": "var(--colors--avatar--root-accent-4-border)"
  },
  "colors.Avatar.Root.accent.4.text": {
    "value": "var(--colors--avatar--root-accent-4-text)",
    "variable": "var(--colors--avatar--root-accent-4-text)"
  },
  "colors.Banner.critical.bg": {
    "value": "var(--colors--banner-critical-bg)",
    "variable": "var(--colors--banner-critical-bg)"
  },
  "colors.Banner.critical.icon": {
    "value": "var(--colors--banner-critical-icon)",
    "variable": "var(--colors--banner-critical-icon)"
  },
  "colors.Banner.critical.text": {
    "value": "var(--colors--banner-critical-text)",
    "variable": "var(--colors--banner-critical-text)"
  },
  "colors.Banner.info.bg": {
    "value": "var(--colors--banner-info-bg)",
    "variable": "var(--colors--banner-info-bg)"
  },
  "colors.Banner.info.icon": {
    "value": "var(--colors--banner-info-icon)",
    "variable": "var(--colors--banner-info-icon)"
  },
  "colors.Banner.info.text": {
    "value": "var(--colors--banner-info-text)",
    "variable": "var(--colors--banner-info-text)"
  },
  "colors.Banner.success.bg": {
    "value": "var(--colors--banner-success-bg)",
    "variable": "var(--colors--banner-success-bg)"
  },
  "colors.Banner.success.icon": {
    "value": "var(--colors--banner-success-icon)",
    "variable": "var(--colors--banner-success-icon)"
  },
  "colors.Banner.success.text": {
    "value": "var(--colors--banner-success-text)",
    "variable": "var(--colors--banner-success-text)"
  },
  "colors.Banner.warning.bg": {
    "value": "var(--colors--banner-warning-bg)",
    "variable": "var(--colors--banner-warning-bg)"
  },
  "colors.Banner.warning.icon": {
    "value": "var(--colors--banner-warning-icon)",
    "variable": "var(--colors--banner-warning-icon)"
  },
  "colors.Banner.warning.text": {
    "value": "var(--colors--banner-warning-text)",
    "variable": "var(--colors--banner-warning-text)"
  },
  "colors.Button.filled.brand.bg.default": {
    "value": "var(--colors--button-filled-brand-bg-default)",
    "variable": "var(--colors--button-filled-brand-bg-default)"
  },
  "colors.Button.filled.brand.bg.hover": {
    "value": "var(--colors--button-filled-brand-bg-hover)",
    "variable": "var(--colors--button-filled-brand-bg-hover)"
  },
  "colors.Button.filled.brand.bg.pressed": {
    "value": "var(--colors--button-filled-brand-bg-pressed)",
    "variable": "var(--colors--button-filled-brand-bg-pressed)"
  },
  "colors.Button.filled.brand.label.default": {
    "value": "var(--colors--button-filled-brand-label-default)",
    "variable": "var(--colors--button-filled-brand-label-default)"
  },
  "colors.Button.filled.brand.label.hover": {
    "value": "var(--colors--button-filled-brand-label-hover)",
    "variable": "var(--colors--button-filled-brand-label-hover)"
  },
  "colors.Button.filled.brand.label.pressed": {
    "value": "var(--colors--button-filled-brand-label-pressed)",
    "variable": "var(--colors--button-filled-brand-label-pressed)"
  },
  "colors.Button.filled.brand.border.default": {
    "value": "var(--colors--button-filled-brand-border-default)",
    "variable": "var(--colors--button-filled-brand-border-default)"
  },
  "colors.Button.filled.brand.border.hover": {
    "value": "var(--colors--button-filled-brand-border-hover)",
    "variable": "var(--colors--button-filled-brand-border-hover)"
  },
  "colors.Button.filled.brand.border.pressed": {
    "value": "var(--colors--button-filled-brand-border-pressed)",
    "variable": "var(--colors--button-filled-brand-border-pressed)"
  },
  "colors.Button.filled.brand.icon.default": {
    "value": "var(--colors--button-filled-brand-icon-default)",
    "variable": "var(--colors--button-filled-brand-icon-default)"
  },
  "colors.Button.filled.brand.icon.hover": {
    "value": "var(--colors--button-filled-brand-icon-hover)",
    "variable": "var(--colors--button-filled-brand-icon-hover)"
  },
  "colors.Button.filled.brand.icon.pressed": {
    "value": "var(--colors--button-filled-brand-icon-pressed)",
    "variable": "var(--colors--button-filled-brand-icon-pressed)"
  },
  "colors.Button.filled.critical.bg.default": {
    "value": "var(--colors--button-filled-critical-bg-default)",
    "variable": "var(--colors--button-filled-critical-bg-default)"
  },
  "colors.Button.filled.critical.bg.hover": {
    "value": "var(--colors--button-filled-critical-bg-hover)",
    "variable": "var(--colors--button-filled-critical-bg-hover)"
  },
  "colors.Button.filled.critical.bg.pressed": {
    "value": "var(--colors--button-filled-critical-bg-pressed)",
    "variable": "var(--colors--button-filled-critical-bg-pressed)"
  },
  "colors.Button.filled.critical.label.default": {
    "value": "var(--colors--button-filled-critical-label-default)",
    "variable": "var(--colors--button-filled-critical-label-default)"
  },
  "colors.Button.filled.critical.label.hover": {
    "value": "var(--colors--button-filled-critical-label-hover)",
    "variable": "var(--colors--button-filled-critical-label-hover)"
  },
  "colors.Button.filled.critical.label.pressed": {
    "value": "var(--colors--button-filled-critical-label-pressed)",
    "variable": "var(--colors--button-filled-critical-label-pressed)"
  },
  "colors.Button.filled.critical.icon.default": {
    "value": "var(--colors--button-filled-critical-icon-default)",
    "variable": "var(--colors--button-filled-critical-icon-default)"
  },
  "colors.Button.filled.critical.icon.hover": {
    "value": "var(--colors--button-filled-critical-icon-hover)",
    "variable": "var(--colors--button-filled-critical-icon-hover)"
  },
  "colors.Button.filled.critical.icon.pressed": {
    "value": "var(--colors--button-filled-critical-icon-pressed)",
    "variable": "var(--colors--button-filled-critical-icon-pressed)"
  },
  "colors.Button.filled.critical.border.default": {
    "value": "var(--colors--button-filled-critical-border-default)",
    "variable": "var(--colors--button-filled-critical-border-default)"
  },
  "colors.Button.filled.critical.border.hover": {
    "value": "var(--colors--button-filled-critical-border-hover)",
    "variable": "var(--colors--button-filled-critical-border-hover)"
  },
  "colors.Button.filled.critical.border.pressed": {
    "value": "var(--colors--button-filled-critical-border-pressed)",
    "variable": "var(--colors--button-filled-critical-border-pressed)"
  },
  "colors.Button.outlined.brand.bg.default": {
    "value": "var(--colors--button-outlined-brand-bg-default)",
    "variable": "var(--colors--button-outlined-brand-bg-default)"
  },
  "colors.Button.outlined.brand.bg.hover": {
    "value": "var(--colors--button-outlined-brand-bg-hover)",
    "variable": "var(--colors--button-outlined-brand-bg-hover)"
  },
  "colors.Button.outlined.brand.bg.pressed": {
    "value": "var(--colors--button-outlined-brand-bg-pressed)",
    "variable": "var(--colors--button-outlined-brand-bg-pressed)"
  },
  "colors.Button.outlined.brand.label.default": {
    "value": "var(--colors--button-outlined-brand-label-default)",
    "variable": "var(--colors--button-outlined-brand-label-default)"
  },
  "colors.Button.outlined.brand.label.hover": {
    "value": "var(--colors--button-outlined-brand-label-hover)",
    "variable": "var(--colors--button-outlined-brand-label-hover)"
  },
  "colors.Button.outlined.brand.label.pressed": {
    "value": "var(--colors--button-outlined-brand-label-pressed)",
    "variable": "var(--colors--button-outlined-brand-label-pressed)"
  },
  "colors.Button.outlined.brand.icon.default": {
    "value": "var(--colors--button-outlined-brand-icon-default)",
    "variable": "var(--colors--button-outlined-brand-icon-default)"
  },
  "colors.Button.outlined.brand.icon.hover": {
    "value": "var(--colors--button-outlined-brand-icon-hover)",
    "variable": "var(--colors--button-outlined-brand-icon-hover)"
  },
  "colors.Button.outlined.brand.icon.pressed": {
    "value": "var(--colors--button-outlined-brand-icon-pressed)",
    "variable": "var(--colors--button-outlined-brand-icon-pressed)"
  },
  "colors.Button.outlined.brand.border.default": {
    "value": "var(--colors--button-outlined-brand-border-default)",
    "variable": "var(--colors--button-outlined-brand-border-default)"
  },
  "colors.Button.outlined.brand.border.hover": {
    "value": "var(--colors--button-outlined-brand-border-hover)",
    "variable": "var(--colors--button-outlined-brand-border-hover)"
  },
  "colors.Button.outlined.brand.border.pressed": {
    "value": "var(--colors--button-outlined-brand-border-pressed)",
    "variable": "var(--colors--button-outlined-brand-border-pressed)"
  },
  "colors.Button.outlined.neutral.bg.default": {
    "value": "var(--colors--button-outlined-neutral-bg-default)",
    "variable": "var(--colors--button-outlined-neutral-bg-default)"
  },
  "colors.Button.outlined.neutral.bg.hover": {
    "value": "var(--colors--button-outlined-neutral-bg-hover)",
    "variable": "var(--colors--button-outlined-neutral-bg-hover)"
  },
  "colors.Button.outlined.neutral.bg.pressed": {
    "value": "var(--colors--button-outlined-neutral-bg-pressed)",
    "variable": "var(--colors--button-outlined-neutral-bg-pressed)"
  },
  "colors.Button.outlined.neutral.bg.selected": {
    "value": "var(--colors--button-outlined-neutral-bg-selected)",
    "variable": "var(--colors--button-outlined-neutral-bg-selected)"
  },
  "colors.Button.outlined.neutral.bg.selectedHover": {
    "value": "var(--colors--button-outlined-neutral-bg-selected-hover)",
    "variable": "var(--colors--button-outlined-neutral-bg-selected-hover)"
  },
  "colors.Button.outlined.neutral.bg.selectedPressed": {
    "value": "var(--colors--button-outlined-neutral-bg-selected-pressed)",
    "variable": "var(--colors--button-outlined-neutral-bg-selected-pressed)"
  },
  "colors.Button.outlined.neutral.label.default": {
    "value": "var(--colors--button-outlined-neutral-label-default)",
    "variable": "var(--colors--button-outlined-neutral-label-default)"
  },
  "colors.Button.outlined.neutral.label.hover": {
    "value": "var(--colors--button-outlined-neutral-label-hover)",
    "variable": "var(--colors--button-outlined-neutral-label-hover)"
  },
  "colors.Button.outlined.neutral.label.pressed": {
    "value": "var(--colors--button-outlined-neutral-label-pressed)",
    "variable": "var(--colors--button-outlined-neutral-label-pressed)"
  },
  "colors.Button.outlined.neutral.label.selected": {
    "value": "var(--colors--button-outlined-neutral-label-selected)",
    "variable": "var(--colors--button-outlined-neutral-label-selected)"
  },
  "colors.Button.outlined.neutral.label.selectedHover": {
    "value": "var(--colors--button-outlined-neutral-label-selected-hover)",
    "variable": "var(--colors--button-outlined-neutral-label-selected-hover)"
  },
  "colors.Button.outlined.neutral.label.selectedPressed": {
    "value": "var(--colors--button-outlined-neutral-label-selected-pressed)",
    "variable": "var(--colors--button-outlined-neutral-label-selected-pressed)"
  },
  "colors.Button.outlined.neutral.icon.default": {
    "value": "var(--colors--button-outlined-neutral-icon-default)",
    "variable": "var(--colors--button-outlined-neutral-icon-default)"
  },
  "colors.Button.outlined.neutral.icon.hover": {
    "value": "var(--colors--button-outlined-neutral-icon-hover)",
    "variable": "var(--colors--button-outlined-neutral-icon-hover)"
  },
  "colors.Button.outlined.neutral.icon.pressed": {
    "value": "var(--colors--button-outlined-neutral-icon-pressed)",
    "variable": "var(--colors--button-outlined-neutral-icon-pressed)"
  },
  "colors.Button.outlined.neutral.icon.selected": {
    "value": "var(--colors--button-outlined-neutral-icon-selected)",
    "variable": "var(--colors--button-outlined-neutral-icon-selected)"
  },
  "colors.Button.outlined.neutral.icon.selectedHover": {
    "value": "var(--colors--button-outlined-neutral-icon-selected-hover)",
    "variable": "var(--colors--button-outlined-neutral-icon-selected-hover)"
  },
  "colors.Button.outlined.neutral.icon.selectedPressed": {
    "value": "var(--colors--button-outlined-neutral-icon-selected-pressed)",
    "variable": "var(--colors--button-outlined-neutral-icon-selected-pressed)"
  },
  "colors.Button.outlined.neutral.border.default": {
    "value": "var(--colors--button-outlined-neutral-border-default)",
    "variable": "var(--colors--button-outlined-neutral-border-default)"
  },
  "colors.Button.outlined.neutral.border.hover": {
    "value": "var(--colors--button-outlined-neutral-border-hover)",
    "variable": "var(--colors--button-outlined-neutral-border-hover)"
  },
  "colors.Button.outlined.neutral.border.pressed": {
    "value": "var(--colors--button-outlined-neutral-border-pressed)",
    "variable": "var(--colors--button-outlined-neutral-border-pressed)"
  },
  "colors.Button.outlined.neutral.border.selected": {
    "value": "var(--colors--button-outlined-neutral-border-selected)",
    "variable": "var(--colors--button-outlined-neutral-border-selected)"
  },
  "colors.Button.outlined.neutral.border.selectedHover": {
    "value": "var(--colors--button-outlined-neutral-border-selected-hover)",
    "variable": "var(--colors--button-outlined-neutral-border-selected-hover)"
  },
  "colors.Button.outlined.neutral.border.selectedPressed": {
    "value": "var(--colors--button-outlined-neutral-border-selected-pressed)",
    "variable": "var(--colors--button-outlined-neutral-border-selected-pressed)"
  },
  "colors.Button.bare.brand.bg.default": {
    "value": "var(--colors--button-bare-brand-bg-default)",
    "variable": "var(--colors--button-bare-brand-bg-default)"
  },
  "colors.Button.bare.brand.bg.hover": {
    "value": "var(--colors--button-bare-brand-bg-hover)",
    "variable": "var(--colors--button-bare-brand-bg-hover)"
  },
  "colors.Button.bare.brand.bg.pressed": {
    "value": "var(--colors--button-bare-brand-bg-pressed)",
    "variable": "var(--colors--button-bare-brand-bg-pressed)"
  },
  "colors.Button.bare.brand.label.default": {
    "value": "var(--colors--button-bare-brand-label-default)",
    "variable": "var(--colors--button-bare-brand-label-default)"
  },
  "colors.Button.bare.brand.label.hover": {
    "value": "var(--colors--button-bare-brand-label-hover)",
    "variable": "var(--colors--button-bare-brand-label-hover)"
  },
  "colors.Button.bare.brand.label.pressed": {
    "value": "var(--colors--button-bare-brand-label-pressed)",
    "variable": "var(--colors--button-bare-brand-label-pressed)"
  },
  "colors.Button.bare.brand.icon.default": {
    "value": "var(--colors--button-bare-brand-icon-default)",
    "variable": "var(--colors--button-bare-brand-icon-default)"
  },
  "colors.Button.bare.brand.icon.hover": {
    "value": "var(--colors--button-bare-brand-icon-hover)",
    "variable": "var(--colors--button-bare-brand-icon-hover)"
  },
  "colors.Button.bare.brand.icon.pressed": {
    "value": "var(--colors--button-bare-brand-icon-pressed)",
    "variable": "var(--colors--button-bare-brand-icon-pressed)"
  },
  "colors.Button.bare.neutral.bg.default": {
    "value": "var(--colors--button-bare-neutral-bg-default)",
    "variable": "var(--colors--button-bare-neutral-bg-default)"
  },
  "colors.Button.bare.neutral.bg.hover": {
    "value": "var(--colors--button-bare-neutral-bg-hover)",
    "variable": "var(--colors--button-bare-neutral-bg-hover)"
  },
  "colors.Button.bare.neutral.bg.pressed": {
    "value": "var(--colors--button-bare-neutral-bg-pressed)",
    "variable": "var(--colors--button-bare-neutral-bg-pressed)"
  },
  "colors.Button.bare.neutral.label.default": {
    "value": "var(--colors--button-bare-neutral-label-default)",
    "variable": "var(--colors--button-bare-neutral-label-default)"
  },
  "colors.Button.bare.neutral.label.hover": {
    "value": "var(--colors--button-bare-neutral-label-hover)",
    "variable": "var(--colors--button-bare-neutral-label-hover)"
  },
  "colors.Button.bare.neutral.label.pressed": {
    "value": "var(--colors--button-bare-neutral-label-pressed)",
    "variable": "var(--colors--button-bare-neutral-label-pressed)"
  },
  "colors.Button.bare.neutral.icon.default": {
    "value": "var(--colors--button-bare-neutral-icon-default)",
    "variable": "var(--colors--button-bare-neutral-icon-default)"
  },
  "colors.Button.bare.neutral.icon.hover": {
    "value": "var(--colors--button-bare-neutral-icon-hover)",
    "variable": "var(--colors--button-bare-neutral-icon-hover)"
  },
  "colors.Button.bare.neutral.icon.pressed": {
    "value": "var(--colors--button-bare-neutral-icon-pressed)",
    "variable": "var(--colors--button-bare-neutral-icon-pressed)"
  },
  "colors.Button.onImpact.filled.brand.bg.default": {
    "value": "var(--colors--button-on-impact-filled-brand-bg-default)",
    "variable": "var(--colors--button-on-impact-filled-brand-bg-default)"
  },
  "colors.Button.onImpact.filled.brand.bg.hover": {
    "value": "var(--colors--button-on-impact-filled-brand-bg-hover)",
    "variable": "var(--colors--button-on-impact-filled-brand-bg-hover)"
  },
  "colors.Button.onImpact.filled.brand.bg.pressed": {
    "value": "var(--colors--button-on-impact-filled-brand-bg-pressed)",
    "variable": "var(--colors--button-on-impact-filled-brand-bg-pressed)"
  },
  "colors.Button.onImpact.filled.brand.label.default": {
    "value": "var(--colors--button-on-impact-filled-brand-label-default)",
    "variable": "var(--colors--button-on-impact-filled-brand-label-default)"
  },
  "colors.Button.onImpact.filled.brand.label.hover": {
    "value": "var(--colors--button-on-impact-filled-brand-label-hover)",
    "variable": "var(--colors--button-on-impact-filled-brand-label-hover)"
  },
  "colors.Button.onImpact.filled.brand.label.pressed": {
    "value": "var(--colors--button-on-impact-filled-brand-label-pressed)",
    "variable": "var(--colors--button-on-impact-filled-brand-label-pressed)"
  },
  "colors.Button.onImpact.filled.brand.icon.default": {
    "value": "var(--colors--button-on-impact-filled-brand-icon-default)",
    "variable": "var(--colors--button-on-impact-filled-brand-icon-default)"
  },
  "colors.Button.onImpact.filled.brand.icon.hover": {
    "value": "var(--colors--button-on-impact-filled-brand-icon-hover)",
    "variable": "var(--colors--button-on-impact-filled-brand-icon-hover)"
  },
  "colors.Button.onImpact.filled.brand.icon.pressed": {
    "value": "var(--colors--button-on-impact-filled-brand-icon-pressed)",
    "variable": "var(--colors--button-on-impact-filled-brand-icon-pressed)"
  },
  "colors.Button.onImpact.filled.brand.border.default": {
    "value": "var(--colors--button-on-impact-filled-brand-border-default)",
    "variable": "var(--colors--button-on-impact-filled-brand-border-default)"
  },
  "colors.Button.onImpact.filled.brand.border.hover": {
    "value": "var(--colors--button-on-impact-filled-brand-border-hover)",
    "variable": "var(--colors--button-on-impact-filled-brand-border-hover)"
  },
  "colors.Button.onImpact.filled.brand.border.pressed": {
    "value": "var(--colors--button-on-impact-filled-brand-border-pressed)",
    "variable": "var(--colors--button-on-impact-filled-brand-border-pressed)"
  },
  "colors.Button.onImpact.filled.critical.bg.default": {
    "value": "var(--colors--button-on-impact-filled-critical-bg-default)",
    "variable": "var(--colors--button-on-impact-filled-critical-bg-default)"
  },
  "colors.Button.onImpact.filled.critical.bg.hover": {
    "value": "var(--colors--button-on-impact-filled-critical-bg-hover)",
    "variable": "var(--colors--button-on-impact-filled-critical-bg-hover)"
  },
  "colors.Button.onImpact.filled.critical.bg.pressed": {
    "value": "var(--colors--button-on-impact-filled-critical-bg-pressed)",
    "variable": "var(--colors--button-on-impact-filled-critical-bg-pressed)"
  },
  "colors.Button.onImpact.filled.critical.label.default": {
    "value": "var(--colors--button-on-impact-filled-critical-label-default)",
    "variable": "var(--colors--button-on-impact-filled-critical-label-default)"
  },
  "colors.Button.onImpact.filled.critical.label.hover": {
    "value": "var(--colors--button-on-impact-filled-critical-label-hover)",
    "variable": "var(--colors--button-on-impact-filled-critical-label-hover)"
  },
  "colors.Button.onImpact.filled.critical.label.pressed": {
    "value": "var(--colors--button-on-impact-filled-critical-label-pressed)",
    "variable": "var(--colors--button-on-impact-filled-critical-label-pressed)"
  },
  "colors.Button.onImpact.filled.critical.icon.default": {
    "value": "var(--colors--button-on-impact-filled-critical-icon-default)",
    "variable": "var(--colors--button-on-impact-filled-critical-icon-default)"
  },
  "colors.Button.onImpact.filled.critical.icon.hover": {
    "value": "var(--colors--button-on-impact-filled-critical-icon-hover)",
    "variable": "var(--colors--button-on-impact-filled-critical-icon-hover)"
  },
  "colors.Button.onImpact.filled.critical.icon.pressed": {
    "value": "var(--colors--button-on-impact-filled-critical-icon-pressed)",
    "variable": "var(--colors--button-on-impact-filled-critical-icon-pressed)"
  },
  "colors.Button.onImpact.filled.critical.border.pressed": {
    "value": "var(--colors--button-on-impact-filled-critical-border-pressed)",
    "variable": "var(--colors--button-on-impact-filled-critical-border-pressed)"
  },
  "colors.Button.onImpact.outlined.brand.bg.default": {
    "value": "var(--colors--button-on-impact-outlined-brand-bg-default)",
    "variable": "var(--colors--button-on-impact-outlined-brand-bg-default)"
  },
  "colors.Button.onImpact.outlined.brand.bg.hover": {
    "value": "var(--colors--button-on-impact-outlined-brand-bg-hover)",
    "variable": "var(--colors--button-on-impact-outlined-brand-bg-hover)"
  },
  "colors.Button.onImpact.outlined.brand.bg.pressed": {
    "value": "var(--colors--button-on-impact-outlined-brand-bg-pressed)",
    "variable": "var(--colors--button-on-impact-outlined-brand-bg-pressed)"
  },
  "colors.Button.onImpact.outlined.brand.label.default": {
    "value": "var(--colors--button-on-impact-outlined-brand-label-default)",
    "variable": "var(--colors--button-on-impact-outlined-brand-label-default)"
  },
  "colors.Button.onImpact.outlined.brand.label.hover": {
    "value": "var(--colors--button-on-impact-outlined-brand-label-hover)",
    "variable": "var(--colors--button-on-impact-outlined-brand-label-hover)"
  },
  "colors.Button.onImpact.outlined.brand.label.pressed": {
    "value": "var(--colors--button-on-impact-outlined-brand-label-pressed)",
    "variable": "var(--colors--button-on-impact-outlined-brand-label-pressed)"
  },
  "colors.Button.onImpact.outlined.brand.icon.default": {
    "value": "var(--colors--button-on-impact-outlined-brand-icon-default)",
    "variable": "var(--colors--button-on-impact-outlined-brand-icon-default)"
  },
  "colors.Button.onImpact.outlined.brand.icon.hover": {
    "value": "var(--colors--button-on-impact-outlined-brand-icon-hover)",
    "variable": "var(--colors--button-on-impact-outlined-brand-icon-hover)"
  },
  "colors.Button.onImpact.outlined.brand.icon.pressed": {
    "value": "var(--colors--button-on-impact-outlined-brand-icon-pressed)",
    "variable": "var(--colors--button-on-impact-outlined-brand-icon-pressed)"
  },
  "colors.Button.onImpact.outlined.brand.border.default": {
    "value": "var(--colors--button-on-impact-outlined-brand-border-default)",
    "variable": "var(--colors--button-on-impact-outlined-brand-border-default)"
  },
  "colors.Button.onImpact.outlined.brand.border.hover": {
    "value": "var(--colors--button-on-impact-outlined-brand-border-hover)",
    "variable": "var(--colors--button-on-impact-outlined-brand-border-hover)"
  },
  "colors.Button.onImpact.outlined.brand.border.pressed": {
    "value": "var(--colors--button-on-impact-outlined-brand-border-pressed)",
    "variable": "var(--colors--button-on-impact-outlined-brand-border-pressed)"
  },
  "colors.Button.onImpact.outlined.neutral.bg.default": {
    "value": "var(--colors--button-on-impact-outlined-neutral-bg-default)",
    "variable": "var(--colors--button-on-impact-outlined-neutral-bg-default)"
  },
  "colors.Button.onImpact.outlined.neutral.bg.hover": {
    "value": "var(--colors--button-on-impact-outlined-neutral-bg-hover)",
    "variable": "var(--colors--button-on-impact-outlined-neutral-bg-hover)"
  },
  "colors.Button.onImpact.outlined.neutral.bg.pressed": {
    "value": "var(--colors--button-on-impact-outlined-neutral-bg-pressed)",
    "variable": "var(--colors--button-on-impact-outlined-neutral-bg-pressed)"
  },
  "colors.Button.onImpact.outlined.neutral.label.default": {
    "value": "var(--colors--button-on-impact-outlined-neutral-label-default)",
    "variable": "var(--colors--button-on-impact-outlined-neutral-label-default)"
  },
  "colors.Button.onImpact.outlined.neutral.label.hover": {
    "value": "var(--colors--button-on-impact-outlined-neutral-label-hover)",
    "variable": "var(--colors--button-on-impact-outlined-neutral-label-hover)"
  },
  "colors.Button.onImpact.outlined.neutral.label.pressed": {
    "value": "var(--colors--button-on-impact-outlined-neutral-label-pressed)",
    "variable": "var(--colors--button-on-impact-outlined-neutral-label-pressed)"
  },
  "colors.Button.onImpact.outlined.neutral.icon.default": {
    "value": "var(--colors--button-on-impact-outlined-neutral-icon-default)",
    "variable": "var(--colors--button-on-impact-outlined-neutral-icon-default)"
  },
  "colors.Button.onImpact.outlined.neutral.icon.hover": {
    "value": "var(--colors--button-on-impact-outlined-neutral-icon-hover)",
    "variable": "var(--colors--button-on-impact-outlined-neutral-icon-hover)"
  },
  "colors.Button.onImpact.outlined.neutral.icon.pressed": {
    "value": "var(--colors--button-on-impact-outlined-neutral-icon-pressed)",
    "variable": "var(--colors--button-on-impact-outlined-neutral-icon-pressed)"
  },
  "colors.Button.onImpact.outlined.neutral.border.default": {
    "value": "var(--colors--button-on-impact-outlined-neutral-border-default)",
    "variable": "var(--colors--button-on-impact-outlined-neutral-border-default)"
  },
  "colors.Button.onImpact.outlined.neutral.border.hover": {
    "value": "var(--colors--button-on-impact-outlined-neutral-border-hover)",
    "variable": "var(--colors--button-on-impact-outlined-neutral-border-hover)"
  },
  "colors.Button.onImpact.outlined.neutral.border.pressed": {
    "value": "var(--colors--button-on-impact-outlined-neutral-border-pressed)",
    "variable": "var(--colors--button-on-impact-outlined-neutral-border-pressed)"
  },
  "colors.Button.onImpact.bare.brand.bg.default": {
    "value": "var(--colors--button-on-impact-bare-brand-bg-default)",
    "variable": "var(--colors--button-on-impact-bare-brand-bg-default)"
  },
  "colors.Button.onImpact.bare.brand.label.default": {
    "value": "var(--colors--button-on-impact-bare-brand-label-default)",
    "variable": "var(--colors--button-on-impact-bare-brand-label-default)"
  },
  "colors.Button.onImpact.bare.brand.label.hover": {
    "value": "var(--colors--button-on-impact-bare-brand-label-hover)",
    "variable": "var(--colors--button-on-impact-bare-brand-label-hover)"
  },
  "colors.Button.onImpact.bare.brand.label.pressed": {
    "value": "var(--colors--button-on-impact-bare-brand-label-pressed)",
    "variable": "var(--colors--button-on-impact-bare-brand-label-pressed)"
  },
  "colors.Button.onImpact.bare.brand.icon.default": {
    "value": "var(--colors--button-on-impact-bare-brand-icon-default)",
    "variable": "var(--colors--button-on-impact-bare-brand-icon-default)"
  },
  "colors.Button.onImpact.bare.brand.icon.hover": {
    "value": "var(--colors--button-on-impact-bare-brand-icon-hover)",
    "variable": "var(--colors--button-on-impact-bare-brand-icon-hover)"
  },
  "colors.Button.onImpact.bare.brand.icon.pressed": {
    "value": "var(--colors--button-on-impact-bare-brand-icon-pressed)",
    "variable": "var(--colors--button-on-impact-bare-brand-icon-pressed)"
  },
  "colors.Button.onImpact.bare.neutral.bg.default": {
    "value": "var(--colors--button-on-impact-bare-neutral-bg-default)",
    "variable": "var(--colors--button-on-impact-bare-neutral-bg-default)"
  },
  "colors.Button.onImpact.bare.neutral.bg.hover": {
    "value": "var(--colors--button-on-impact-bare-neutral-bg-hover)",
    "variable": "var(--colors--button-on-impact-bare-neutral-bg-hover)"
  },
  "colors.Button.onImpact.bare.neutral.bg.pressed": {
    "value": "var(--colors--button-on-impact-bare-neutral-bg-pressed)",
    "variable": "var(--colors--button-on-impact-bare-neutral-bg-pressed)"
  },
  "colors.Button.onImpact.bare.neutral.label.default": {
    "value": "var(--colors--button-on-impact-bare-neutral-label-default)",
    "variable": "var(--colors--button-on-impact-bare-neutral-label-default)"
  },
  "colors.Button.onImpact.bare.neutral.label.hover": {
    "value": "var(--colors--button-on-impact-bare-neutral-label-hover)",
    "variable": "var(--colors--button-on-impact-bare-neutral-label-hover)"
  },
  "colors.Button.onImpact.bare.neutral.label.pressed": {
    "value": "var(--colors--button-on-impact-bare-neutral-label-pressed)",
    "variable": "var(--colors--button-on-impact-bare-neutral-label-pressed)"
  },
  "colors.Button.onImpact.bare.neutral.icon.default": {
    "value": "var(--colors--button-on-impact-bare-neutral-icon-default)",
    "variable": "var(--colors--button-on-impact-bare-neutral-icon-default)"
  },
  "colors.Button.onImpact.bare.neutral.icon.hover": {
    "value": "var(--colors--button-on-impact-bare-neutral-icon-hover)",
    "variable": "var(--colors--button-on-impact-bare-neutral-icon-hover)"
  },
  "colors.Button.onImpact.bare.neutral.icon.pressed": {
    "value": "var(--colors--button-on-impact-bare-neutral-icon-pressed)",
    "variable": "var(--colors--button-on-impact-bare-neutral-icon-pressed)"
  },
  "colors.Calendar.ControlButton.bg.default": {
    "value": "var(--colors--calendar--control-button-bg-default)",
    "variable": "var(--colors--calendar--control-button-bg-default)"
  },
  "colors.Calendar.ControlButton.bg.hover": {
    "value": "var(--colors--calendar--control-button-bg-hover)",
    "variable": "var(--colors--calendar--control-button-bg-hover)"
  },
  "colors.Calendar.ControlButton.bg.pressed": {
    "value": "var(--colors--calendar--control-button-bg-pressed)",
    "variable": "var(--colors--calendar--control-button-bg-pressed)"
  },
  "colors.Calendar.ControlButton.icon.default": {
    "value": "var(--colors--calendar--control-button-icon-default)",
    "variable": "var(--colors--calendar--control-button-icon-default)"
  },
  "colors.Calendar.DayOfWeek.border.default": {
    "value": "var(--colors--calendar--day-of-week-border-default)",
    "variable": "var(--colors--calendar--day-of-week-border-default)"
  },
  "colors.Calendar.Day.bg.default": {
    "value": "var(--colors--calendar--day-bg-default)",
    "variable": "var(--colors--calendar--day-bg-default)"
  },
  "colors.Calendar.Day.bg.hover": {
    "value": "var(--colors--calendar--day-bg-hover)",
    "variable": "var(--colors--calendar--day-bg-hover)"
  },
  "colors.Calendar.Day.bg.pressed": {
    "value": "var(--colors--calendar--day-bg-pressed)",
    "variable": "var(--colors--calendar--day-bg-pressed)"
  },
  "colors.Calendar.Day.bg.selected": {
    "value": "var(--colors--calendar--day-bg-selected)",
    "variable": "var(--colors--calendar--day-bg-selected)"
  },
  "colors.Calendar.Day.bg.selectedHover": {
    "value": "var(--colors--calendar--day-bg-selected-hover)",
    "variable": "var(--colors--calendar--day-bg-selected-hover)"
  },
  "colors.Calendar.Day.bg.selectedPressed": {
    "value": "var(--colors--calendar--day-bg-selected-pressed)",
    "variable": "var(--colors--calendar--day-bg-selected-pressed)"
  },
  "colors.Calendar.Day.border.default": {
    "value": "var(--colors--calendar--day-border-default)",
    "variable": "var(--colors--calendar--day-border-default)"
  },
  "colors.Calendar.Day.border.hover": {
    "value": "var(--colors--calendar--day-border-hover)",
    "variable": "var(--colors--calendar--day-border-hover)"
  },
  "colors.Calendar.Day.border.pressed": {
    "value": "var(--colors--calendar--day-border-pressed)",
    "variable": "var(--colors--calendar--day-border-pressed)"
  },
  "colors.Calendar.Day.border.selected": {
    "value": "var(--colors--calendar--day-border-selected)",
    "variable": "var(--colors--calendar--day-border-selected)"
  },
  "colors.Calendar.Day.border.selectedHover": {
    "value": "var(--colors--calendar--day-border-selected-hover)",
    "variable": "var(--colors--calendar--day-border-selected-hover)"
  },
  "colors.Calendar.Day.border.selectedPressed": {
    "value": "var(--colors--calendar--day-border-selected-pressed)",
    "variable": "var(--colors--calendar--day-border-selected-pressed)"
  },
  "colors.Calendar.Day.border.today.default": {
    "value": "var(--colors--calendar--day-border-today-default)",
    "variable": "var(--colors--calendar--day-border-today-default)"
  },
  "colors.Calendar.Day.border.today.hover": {
    "value": "var(--colors--calendar--day-border-today-hover)",
    "variable": "var(--colors--calendar--day-border-today-hover)"
  },
  "colors.Calendar.Day.border.today.pressed": {
    "value": "var(--colors--calendar--day-border-today-pressed)",
    "variable": "var(--colors--calendar--day-border-today-pressed)"
  },
  "colors.Calendar.Day.border.today.selected": {
    "value": "var(--colors--calendar--day-border-today-selected)",
    "variable": "var(--colors--calendar--day-border-today-selected)"
  },
  "colors.Calendar.Day.border.today.selectedHover": {
    "value": "var(--colors--calendar--day-border-today-selected-hover)",
    "variable": "var(--colors--calendar--day-border-today-selected-hover)"
  },
  "colors.Calendar.Day.border.today.selectedPressed": {
    "value": "var(--colors--calendar--day-border-today-selected-pressed)",
    "variable": "var(--colors--calendar--day-border-today-selected-pressed)"
  },
  "colors.Calendar.Day.label.default": {
    "value": "var(--colors--calendar--day-label-default)",
    "variable": "var(--colors--calendar--day-label-default)"
  },
  "colors.Calendar.Day.label.hover": {
    "value": "var(--colors--calendar--day-label-hover)",
    "variable": "var(--colors--calendar--day-label-hover)"
  },
  "colors.Calendar.Day.label.pressed": {
    "value": "var(--colors--calendar--day-label-pressed)",
    "variable": "var(--colors--calendar--day-label-pressed)"
  },
  "colors.Calendar.Day.label.selected": {
    "value": "var(--colors--calendar--day-label-selected)",
    "variable": "var(--colors--calendar--day-label-selected)"
  },
  "colors.Calendar.Day.label.selectedHover": {
    "value": "var(--colors--calendar--day-label-selected-hover)",
    "variable": "var(--colors--calendar--day-label-selected-hover)"
  },
  "colors.Calendar.Day.label.selectedPressed": {
    "value": "var(--colors--calendar--day-label-selected-pressed)",
    "variable": "var(--colors--calendar--day-label-selected-pressed)"
  },
  "colors.Calendar.Root.bg.default": {
    "value": "var(--colors--calendar--root-bg-default)",
    "variable": "var(--colors--calendar--root-bg-default)"
  },
  "colors.Calendar.YearSelect.bg.default": {
    "value": "var(--colors--calendar--year-select-bg-default)",
    "variable": "var(--colors--calendar--year-select-bg-default)"
  },
  "colors.Calendar.YearSelect.bg.hover": {
    "value": "var(--colors--calendar--year-select-bg-hover)",
    "variable": "var(--colors--calendar--year-select-bg-hover)"
  },
  "colors.Calendar.YearSelect.bg.pressed": {
    "value": "var(--colors--calendar--year-select-bg-pressed)",
    "variable": "var(--colors--calendar--year-select-bg-pressed)"
  },
  "colors.Calendar.YearSelect.icon.default": {
    "value": "var(--colors--calendar--year-select-icon-default)",
    "variable": "var(--colors--calendar--year-select-icon-default)"
  },
  "colors.Calendar.YearSelect.icon.hover": {
    "value": "var(--colors--calendar--year-select-icon-hover)",
    "variable": "var(--colors--calendar--year-select-icon-hover)"
  },
  "colors.Calendar.YearSelect.icon.pressed": {
    "value": "var(--colors--calendar--year-select-icon-pressed)",
    "variable": "var(--colors--calendar--year-select-icon-pressed)"
  },
  "colors.Card.Footer.border": {
    "value": "var(--colors--card--footer-border)",
    "variable": "var(--colors--card--footer-border)"
  },
  "colors.Card.Header.border": {
    "value": "var(--colors--card--header-border)",
    "variable": "var(--colors--card--header-border)"
  },
  "colors.Card.Root.neutral.bg": {
    "value": "var(--colors--card--root-neutral-bg)",
    "variable": "var(--colors--card--root-neutral-bg)"
  },
  "colors.Card.Root.neutral.border": {
    "value": "var(--colors--card--root-neutral-border)",
    "variable": "var(--colors--card--root-neutral-border)"
  },
  "colors.Card.Root.neutral.elevated.bg": {
    "value": "var(--colors--card--root-neutral-elevated-bg)",
    "variable": "var(--colors--card--root-neutral-elevated-bg)"
  },
  "colors.Card.Root.soft.bg": {
    "value": "var(--colors--card--root-soft-bg)",
    "variable": "var(--colors--card--root-soft-bg)"
  },
  "colors.Card.Root.soft.border": {
    "value": "var(--colors--card--root-soft-border)",
    "variable": "var(--colors--card--root-soft-border)"
  },
  "colors.Card.Root.interactive.neutral.bg.default": {
    "value": "var(--colors--card--root-interactive-neutral-bg-default)",
    "variable": "var(--colors--card--root-interactive-neutral-bg-default)"
  },
  "colors.Card.Root.interactive.neutral.bg.hover": {
    "value": "var(--colors--card--root-interactive-neutral-bg-hover)",
    "variable": "var(--colors--card--root-interactive-neutral-bg-hover)"
  },
  "colors.Card.Root.interactive.neutral.bg.pressed": {
    "value": "var(--colors--card--root-interactive-neutral-bg-pressed)",
    "variable": "var(--colors--card--root-interactive-neutral-bg-pressed)"
  },
  "colors.Card.Root.interactive.neutral.border.default": {
    "value": "var(--colors--card--root-interactive-neutral-border-default)",
    "variable": "var(--colors--card--root-interactive-neutral-border-default)"
  },
  "colors.Card.Root.interactive.neutral.border.hover": {
    "value": "var(--colors--card--root-interactive-neutral-border-hover)",
    "variable": "var(--colors--card--root-interactive-neutral-border-hover)"
  },
  "colors.Card.Root.interactive.neutral.border.pressed": {
    "value": "var(--colors--card--root-interactive-neutral-border-pressed)",
    "variable": "var(--colors--card--root-interactive-neutral-border-pressed)"
  },
  "colors.Card.Root.interactive.neutral.elevated.bg.default": {
    "value": "var(--colors--card--root-interactive-neutral-elevated-bg-default)",
    "variable": "var(--colors--card--root-interactive-neutral-elevated-bg-default)"
  },
  "colors.Card.Root.interactive.neutral.elevated.bg.hover": {
    "value": "var(--colors--card--root-interactive-neutral-elevated-bg-hover)",
    "variable": "var(--colors--card--root-interactive-neutral-elevated-bg-hover)"
  },
  "colors.Card.Root.interactive.neutral.elevated.bg.pressed": {
    "value": "var(--colors--card--root-interactive-neutral-elevated-bg-pressed)",
    "variable": "var(--colors--card--root-interactive-neutral-elevated-bg-pressed)"
  },
  "colors.Card.Root.interactive.soft.bg.default": {
    "value": "var(--colors--card--root-interactive-soft-bg-default)",
    "variable": "var(--colors--card--root-interactive-soft-bg-default)"
  },
  "colors.Card.Root.interactive.soft.bg.hover": {
    "value": "var(--colors--card--root-interactive-soft-bg-hover)",
    "variable": "var(--colors--card--root-interactive-soft-bg-hover)"
  },
  "colors.Card.Root.interactive.soft.bg.pressed": {
    "value": "var(--colors--card--root-interactive-soft-bg-pressed)",
    "variable": "var(--colors--card--root-interactive-soft-bg-pressed)"
  },
  "colors.Card.Root.interactive.soft.border.default": {
    "value": "var(--colors--card--root-interactive-soft-border-default)",
    "variable": "var(--colors--card--root-interactive-soft-border-default)"
  },
  "colors.Card.Root.interactive.soft.border.hover": {
    "value": "var(--colors--card--root-interactive-soft-border-hover)",
    "variable": "var(--colors--card--root-interactive-soft-border-hover)"
  },
  "colors.Card.Root.interactive.soft.border.pressed": {
    "value": "var(--colors--card--root-interactive-soft-border-pressed)",
    "variable": "var(--colors--card--root-interactive-soft-border-pressed)"
  },
  "colors.Card.Root.interactive.soft.elevated.bg.default": {
    "value": "var(--colors--card--root-interactive-soft-elevated-bg-default)",
    "variable": "var(--colors--card--root-interactive-soft-elevated-bg-default)"
  },
  "colors.Card.Root.interactive.soft.elevated.bg.hover": {
    "value": "var(--colors--card--root-interactive-soft-elevated-bg-hover)",
    "variable": "var(--colors--card--root-interactive-soft-elevated-bg-hover)"
  },
  "colors.Card.Root.interactive.soft.elevated.bg.pressed": {
    "value": "var(--colors--card--root-interactive-soft-elevated-bg-pressed)",
    "variable": "var(--colors--card--root-interactive-soft-elevated-bg-pressed)"
  },
  "colors.Card.text.heading": {
    "value": "var(--colors--card-text-heading)",
    "variable": "var(--colors--card-text-heading)"
  },
  "colors.Card.text.description": {
    "value": "var(--colors--card-text-description)",
    "variable": "var(--colors--card-text-description)"
  },
  "colors.Carousel.SkipLink.bg": {
    "value": "var(--colors--carousel--skip-link-bg)",
    "variable": "var(--colors--carousel--skip-link-bg)"
  },
  "colors.Checkbox.bg.default": {
    "value": "var(--colors--checkbox-bg-default)",
    "variable": "var(--colors--checkbox-bg-default)"
  },
  "colors.Checkbox.bg.hover": {
    "value": "var(--colors--checkbox-bg-hover)",
    "variable": "var(--colors--checkbox-bg-hover)"
  },
  "colors.Checkbox.bg.pressed": {
    "value": "var(--colors--checkbox-bg-pressed)",
    "variable": "var(--colors--checkbox-bg-pressed)"
  },
  "colors.Checkbox.bg.indeterminate": {
    "value": "var(--colors--checkbox-bg-indeterminate)",
    "variable": "var(--colors--checkbox-bg-indeterminate)"
  },
  "colors.Checkbox.bg.indeterminateHover": {
    "value": "var(--colors--checkbox-bg-indeterminate-hover)",
    "variable": "var(--colors--checkbox-bg-indeterminate-hover)"
  },
  "colors.Checkbox.bg.indeterminatePressed": {
    "value": "var(--colors--checkbox-bg-indeterminate-pressed)",
    "variable": "var(--colors--checkbox-bg-indeterminate-pressed)"
  },
  "colors.Checkbox.bg.selected": {
    "value": "var(--colors--checkbox-bg-selected)",
    "variable": "var(--colors--checkbox-bg-selected)"
  },
  "colors.Checkbox.bg.selectedHover": {
    "value": "var(--colors--checkbox-bg-selected-hover)",
    "variable": "var(--colors--checkbox-bg-selected-hover)"
  },
  "colors.Checkbox.bg.selectedPressed": {
    "value": "var(--colors--checkbox-bg-selected-pressed)",
    "variable": "var(--colors--checkbox-bg-selected-pressed)"
  },
  "colors.Checkbox.border.default": {
    "value": "var(--colors--checkbox-border-default)",
    "variable": "var(--colors--checkbox-border-default)"
  },
  "colors.Checkbox.border.hover": {
    "value": "var(--colors--checkbox-border-hover)",
    "variable": "var(--colors--checkbox-border-hover)"
  },
  "colors.Checkbox.border.pressed": {
    "value": "var(--colors--checkbox-border-pressed)",
    "variable": "var(--colors--checkbox-border-pressed)"
  },
  "colors.Checkbox.border.indeterminate": {
    "value": "var(--colors--checkbox-border-indeterminate)",
    "variable": "var(--colors--checkbox-border-indeterminate)"
  },
  "colors.Checkbox.border.indeterminateHover": {
    "value": "var(--colors--checkbox-border-indeterminate-hover)",
    "variable": "var(--colors--checkbox-border-indeterminate-hover)"
  },
  "colors.Checkbox.border.indeterminatePressed": {
    "value": "var(--colors--checkbox-border-indeterminate-pressed)",
    "variable": "var(--colors--checkbox-border-indeterminate-pressed)"
  },
  "colors.Checkbox.border.selected": {
    "value": "var(--colors--checkbox-border-selected)",
    "variable": "var(--colors--checkbox-border-selected)"
  },
  "colors.Checkbox.border.selectedHover": {
    "value": "var(--colors--checkbox-border-selected-hover)",
    "variable": "var(--colors--checkbox-border-selected-hover)"
  },
  "colors.Checkbox.border.selectedPressed": {
    "value": "var(--colors--checkbox-border-selected-pressed)",
    "variable": "var(--colors--checkbox-border-selected-pressed)"
  },
  "colors.Checkbox.icon.default": {
    "value": "var(--colors--checkbox-icon-default)",
    "variable": "var(--colors--checkbox-icon-default)"
  },
  "colors.Checkbox.icon.indeterminate": {
    "value": "var(--colors--checkbox-icon-indeterminate)",
    "variable": "var(--colors--checkbox-icon-indeterminate)"
  },
  "colors.Checkbox.icon.indeterminateHover": {
    "value": "var(--colors--checkbox-icon-indeterminate-hover)",
    "variable": "var(--colors--checkbox-icon-indeterminate-hover)"
  },
  "colors.Checkbox.icon.indeterminatePressed": {
    "value": "var(--colors--checkbox-icon-indeterminate-pressed)",
    "variable": "var(--colors--checkbox-icon-indeterminate-pressed)"
  },
  "colors.Checkbox.icon.selected": {
    "value": "var(--colors--checkbox-icon-selected)",
    "variable": "var(--colors--checkbox-icon-selected)"
  },
  "colors.Checkbox.icon.selectedHover": {
    "value": "var(--colors--checkbox-icon-selected-hover)",
    "variable": "var(--colors--checkbox-icon-selected-hover)"
  },
  "colors.Checkbox.icon.selectedPressed": {
    "value": "var(--colors--checkbox-icon-selected-pressed)",
    "variable": "var(--colors--checkbox-icon-selected-pressed)"
  },
  "colors.Chip.bg.default": {
    "value": "var(--colors--chip-bg-default)",
    "variable": "var(--colors--chip-bg-default)"
  },
  "colors.Chip.bg.hover": {
    "value": "var(--colors--chip-bg-hover)",
    "variable": "var(--colors--chip-bg-hover)"
  },
  "colors.Chip.bg.pressed": {
    "value": "var(--colors--chip-bg-pressed)",
    "variable": "var(--colors--chip-bg-pressed)"
  },
  "colors.Chip.bg.selected": {
    "value": "var(--colors--chip-bg-selected)",
    "variable": "var(--colors--chip-bg-selected)"
  },
  "colors.Chip.bg.selectedHover": {
    "value": "var(--colors--chip-bg-selected-hover)",
    "variable": "var(--colors--chip-bg-selected-hover)"
  },
  "colors.Chip.bg.selectedPressed": {
    "value": "var(--colors--chip-bg-selected-pressed)",
    "variable": "var(--colors--chip-bg-selected-pressed)"
  },
  "colors.Chip.bg.elevated.default": {
    "value": "var(--colors--chip-bg-elevated-default)",
    "variable": "var(--colors--chip-bg-elevated-default)"
  },
  "colors.Chip.bg.elevated.hover": {
    "value": "var(--colors--chip-bg-elevated-hover)",
    "variable": "var(--colors--chip-bg-elevated-hover)"
  },
  "colors.Chip.bg.elevated.pressed": {
    "value": "var(--colors--chip-bg-elevated-pressed)",
    "variable": "var(--colors--chip-bg-elevated-pressed)"
  },
  "colors.Chip.bg.elevated.selected": {
    "value": "var(--colors--chip-bg-elevated-selected)",
    "variable": "var(--colors--chip-bg-elevated-selected)"
  },
  "colors.Chip.bg.elevated.selectedHover": {
    "value": "var(--colors--chip-bg-elevated-selected-hover)",
    "variable": "var(--colors--chip-bg-elevated-selected-hover)"
  },
  "colors.Chip.bg.elevated.selectedPressed": {
    "value": "var(--colors--chip-bg-elevated-selected-pressed)",
    "variable": "var(--colors--chip-bg-elevated-selected-pressed)"
  },
  "colors.Chip.label.default": {
    "value": "var(--colors--chip-label-default)",
    "variable": "var(--colors--chip-label-default)"
  },
  "colors.Chip.label.hover": {
    "value": "var(--colors--chip-label-hover)",
    "variable": "var(--colors--chip-label-hover)"
  },
  "colors.Chip.label.pressed": {
    "value": "var(--colors--chip-label-pressed)",
    "variable": "var(--colors--chip-label-pressed)"
  },
  "colors.Chip.label.selected": {
    "value": "var(--colors--chip-label-selected)",
    "variable": "var(--colors--chip-label-selected)"
  },
  "colors.Chip.label.selectedHover": {
    "value": "var(--colors--chip-label-selected-hover)",
    "variable": "var(--colors--chip-label-selected-hover)"
  },
  "colors.Chip.label.selectedPressed": {
    "value": "var(--colors--chip-label-selected-pressed)",
    "variable": "var(--colors--chip-label-selected-pressed)"
  },
  "colors.Chip.icon.default": {
    "value": "var(--colors--chip-icon-default)",
    "variable": "var(--colors--chip-icon-default)"
  },
  "colors.Chip.icon.hover": {
    "value": "var(--colors--chip-icon-hover)",
    "variable": "var(--colors--chip-icon-hover)"
  },
  "colors.Chip.icon.pressed": {
    "value": "var(--colors--chip-icon-pressed)",
    "variable": "var(--colors--chip-icon-pressed)"
  },
  "colors.Chip.icon.selected": {
    "value": "var(--colors--chip-icon-selected)",
    "variable": "var(--colors--chip-icon-selected)"
  },
  "colors.Chip.icon.selectedHover": {
    "value": "var(--colors--chip-icon-selected-hover)",
    "variable": "var(--colors--chip-icon-selected-hover)"
  },
  "colors.Chip.icon.selectedPressed": {
    "value": "var(--colors--chip-icon-selected-pressed)",
    "variable": "var(--colors--chip-icon-selected-pressed)"
  },
  "colors.Chip.border.default": {
    "value": "var(--colors--chip-border-default)",
    "variable": "var(--colors--chip-border-default)"
  },
  "colors.Chip.border.hover": {
    "value": "var(--colors--chip-border-hover)",
    "variable": "var(--colors--chip-border-hover)"
  },
  "colors.Chip.border.pressed": {
    "value": "var(--colors--chip-border-pressed)",
    "variable": "var(--colors--chip-border-pressed)"
  },
  "colors.Chip.border.selected": {
    "value": "var(--colors--chip-border-selected)",
    "variable": "var(--colors--chip-border-selected)"
  },
  "colors.Chip.border.selectedHover": {
    "value": "var(--colors--chip-border-selected-hover)",
    "variable": "var(--colors--chip-border-selected-hover)"
  },
  "colors.Chip.border.selectedPressed": {
    "value": "var(--colors--chip-border-selected-pressed)",
    "variable": "var(--colors--chip-border-selected-pressed)"
  },
  "colors.CloseButton.bg.default": {
    "value": "var(--colors--close-button-bg-default)",
    "variable": "var(--colors--close-button-bg-default)"
  },
  "colors.CloseButton.bg.hover": {
    "value": "var(--colors--close-button-bg-hover)",
    "variable": "var(--colors--close-button-bg-hover)"
  },
  "colors.CloseButton.bg.pressed": {
    "value": "var(--colors--close-button-bg-pressed)",
    "variable": "var(--colors--close-button-bg-pressed)"
  },
  "colors.CloseButton.bg.onImpact.default": {
    "value": "var(--colors--close-button-bg-on-impact-default)",
    "variable": "var(--colors--close-button-bg-on-impact-default)"
  },
  "colors.CloseButton.bg.onImpact.hover": {
    "value": "var(--colors--close-button-bg-on-impact-hover)",
    "variable": "var(--colors--close-button-bg-on-impact-hover)"
  },
  "colors.CloseButton.bg.onImpact.pressed": {
    "value": "var(--colors--close-button-bg-on-impact-pressed)",
    "variable": "var(--colors--close-button-bg-on-impact-pressed)"
  },
  "colors.CloseButton.border.default": {
    "value": "var(--colors--close-button-border-default)",
    "variable": "var(--colors--close-button-border-default)"
  },
  "colors.CloseButton.border.hover": {
    "value": "var(--colors--close-button-border-hover)",
    "variable": "var(--colors--close-button-border-hover)"
  },
  "colors.CloseButton.border.pressed": {
    "value": "var(--colors--close-button-border-pressed)",
    "variable": "var(--colors--close-button-border-pressed)"
  },
  "colors.CloseButton.border.onImpact.default": {
    "value": "var(--colors--close-button-border-on-impact-default)",
    "variable": "var(--colors--close-button-border-on-impact-default)"
  },
  "colors.CloseButton.border.onImpact.hover": {
    "value": "var(--colors--close-button-border-on-impact-hover)",
    "variable": "var(--colors--close-button-border-on-impact-hover)"
  },
  "colors.CloseButton.border.onImpact.pressed": {
    "value": "var(--colors--close-button-border-on-impact-pressed)",
    "variable": "var(--colors--close-button-border-on-impact-pressed)"
  },
  "colors.CloseButton.icon.default": {
    "value": "var(--colors--close-button-icon-default)",
    "variable": "var(--colors--close-button-icon-default)"
  },
  "colors.CloseButton.icon.hover": {
    "value": "var(--colors--close-button-icon-hover)",
    "variable": "var(--colors--close-button-icon-hover)"
  },
  "colors.CloseButton.icon.pressed": {
    "value": "var(--colors--close-button-icon-pressed)",
    "variable": "var(--colors--close-button-icon-pressed)"
  },
  "colors.CloseButton.icon.onImpact.default": {
    "value": "var(--colors--close-button-icon-on-impact-default)",
    "variable": "var(--colors--close-button-icon-on-impact-default)"
  },
  "colors.CloseButton.icon.onImpact.hover": {
    "value": "var(--colors--close-button-icon-on-impact-hover)",
    "variable": "var(--colors--close-button-icon-on-impact-hover)"
  },
  "colors.CloseButton.icon.onImpact.pressed": {
    "value": "var(--colors--close-button-icon-on-impact-pressed)",
    "variable": "var(--colors--close-button-icon-on-impact-pressed)"
  },
  "colors.Combobox.Heading.bg": {
    "value": "var(--colors--combobox--heading-bg)",
    "variable": "var(--colors--combobox--heading-bg)"
  },
  "colors.Combobox.Heading.icon": {
    "value": "var(--colors--combobox--heading-icon)",
    "variable": "var(--colors--combobox--heading-icon)"
  },
  "colors.Combobox.Heading.label": {
    "value": "var(--colors--combobox--heading-label)",
    "variable": "var(--colors--combobox--heading-label)"
  },
  "colors.Combobox.Adornment.icon.trailing.default": {
    "value": "var(--colors--combobox--adornment-icon-trailing-default)",
    "variable": "var(--colors--combobox--adornment-icon-trailing-default)"
  },
  "colors.Combobox.ChipsOverflow.text.default": {
    "value": "var(--colors--combobox--chips-overflow-text-default)",
    "variable": "var(--colors--combobox--chips-overflow-text-default)"
  },
  "colors.Combobox.bg.default": {
    "value": "var(--colors--combobox-bg-default)",
    "variable": "var(--colors--combobox-bg-default)"
  },
  "colors.Combobox.bg.hover": {
    "value": "var(--colors--combobox-bg-hover)",
    "variable": "var(--colors--combobox-bg-hover)"
  },
  "colors.Combobox.bg.active": {
    "value": "var(--colors--combobox-bg-active)",
    "variable": "var(--colors--combobox-bg-active)"
  },
  "colors.Combobox.bg.activeHover": {
    "value": "var(--colors--combobox-bg-active-hover)",
    "variable": "var(--colors--combobox-bg-active-hover)"
  },
  "colors.Combobox.bg.error": {
    "value": "var(--colors--combobox-bg-error)",
    "variable": "var(--colors--combobox-bg-error)"
  },
  "colors.Combobox.bg.errorHover": {
    "value": "var(--colors--combobox-bg-error-hover)",
    "variable": "var(--colors--combobox-bg-error-hover)"
  },
  "colors.Combobox.bg.errorActive": {
    "value": "var(--colors--combobox-bg-error-active)",
    "variable": "var(--colors--combobox-bg-error-active)"
  },
  "colors.Combobox.bg.readOnly": {
    "value": "var(--colors--combobox-bg-read-only)",
    "variable": "var(--colors--combobox-bg-read-only)"
  },
  "colors.Combobox.border.default": {
    "value": "var(--colors--combobox-border-default)",
    "variable": "var(--colors--combobox-border-default)"
  },
  "colors.Combobox.border.hover": {
    "value": "var(--colors--combobox-border-hover)",
    "variable": "var(--colors--combobox-border-hover)"
  },
  "colors.Combobox.border.active": {
    "value": "var(--colors--combobox-border-active)",
    "variable": "var(--colors--combobox-border-active)"
  },
  "colors.Combobox.border.activeHover": {
    "value": "var(--colors--combobox-border-active-hover)",
    "variable": "var(--colors--combobox-border-active-hover)"
  },
  "colors.Combobox.border.error": {
    "value": "var(--colors--combobox-border-error)",
    "variable": "var(--colors--combobox-border-error)"
  },
  "colors.Combobox.border.errorHover": {
    "value": "var(--colors--combobox-border-error-hover)",
    "variable": "var(--colors--combobox-border-error-hover)"
  },
  "colors.Combobox.border.errorActive": {
    "value": "var(--colors--combobox-border-error-active)",
    "variable": "var(--colors--combobox-border-error-active)"
  },
  "colors.Combobox.icon.clearButton.default": {
    "value": "var(--colors--combobox-icon-clear-button-default)",
    "variable": "var(--colors--combobox-icon-clear-button-default)"
  },
  "colors.Combobox.icon.clearButton.hover": {
    "value": "var(--colors--combobox-icon-clear-button-hover)",
    "variable": "var(--colors--combobox-icon-clear-button-hover)"
  },
  "colors.Combobox.icon.clearButton.pressed": {
    "value": "var(--colors--combobox-icon-clear-button-pressed)",
    "variable": "var(--colors--combobox-icon-clear-button-pressed)"
  },
  "colors.Combobox.icon.trailing.default": {
    "value": "var(--colors--combobox-icon-trailing-default)",
    "variable": "var(--colors--combobox-icon-trailing-default)"
  },
  "colors.Combobox.icon.trailing.readOnly": {
    "value": "var(--colors--combobox-icon-trailing-read-only)",
    "variable": "var(--colors--combobox-icon-trailing-read-only)"
  },
  "colors.Combobox.text.populated": {
    "value": "var(--colors--combobox-text-populated)",
    "variable": "var(--colors--combobox-text-populated)"
  },
  "colors.Combobox.text.placeholder": {
    "value": "var(--colors--combobox-text-placeholder)",
    "variable": "var(--colors--combobox-text-placeholder)"
  },
  "colors.Combobox.text.readOnly": {
    "value": "var(--colors--combobox-text-read-only)",
    "variable": "var(--colors--combobox-text-read-only)"
  },
  "colors.Combobox.Content.bg": {
    "value": "var(--colors--combobox--content-bg)",
    "variable": "var(--colors--combobox--content-bg)"
  },
  "colors.Combobox.Group.border": {
    "value": "var(--colors--combobox--group-border)",
    "variable": "var(--colors--combobox--group-border)"
  },
  "colors.Combobox.Input.text.populated": {
    "value": "var(--colors--combobox--input-text-populated)",
    "variable": "var(--colors--combobox--input-text-populated)"
  },
  "colors.Combobox.Input.text.placeholder": {
    "value": "var(--colors--combobox--input-text-placeholder)",
    "variable": "var(--colors--combobox--input-text-placeholder)"
  },
  "colors.Combobox.OptionLabel.text.label.default": {
    "value": "var(--colors--combobox--option-label-text-label-default)",
    "variable": "var(--colors--combobox--option-label-text-label-default)"
  },
  "colors.Combobox.OptionLabel.text.label.hover": {
    "value": "var(--colors--combobox--option-label-text-label-hover)",
    "variable": "var(--colors--combobox--option-label-text-label-hover)"
  },
  "colors.Combobox.OptionLabel.text.label.pressed": {
    "value": "var(--colors--combobox--option-label-text-label-pressed)",
    "variable": "var(--colors--combobox--option-label-text-label-pressed)"
  },
  "colors.Combobox.OptionLabel.text.label.selected": {
    "value": "var(--colors--combobox--option-label-text-label-selected)",
    "variable": "var(--colors--combobox--option-label-text-label-selected)"
  },
  "colors.Combobox.OptionMedia.icon.default": {
    "value": "var(--colors--combobox--option-media-icon-default)",
    "variable": "var(--colors--combobox--option-media-icon-default)"
  },
  "colors.Combobox.OptionMedia.icon.hover": {
    "value": "var(--colors--combobox--option-media-icon-hover)",
    "variable": "var(--colors--combobox--option-media-icon-hover)"
  },
  "colors.Combobox.OptionMedia.icon.pressed": {
    "value": "var(--colors--combobox--option-media-icon-pressed)",
    "variable": "var(--colors--combobox--option-media-icon-pressed)"
  },
  "colors.Combobox.OptionMedia.icon.selected": {
    "value": "var(--colors--combobox--option-media-icon-selected)",
    "variable": "var(--colors--combobox--option-media-icon-selected)"
  },
  "colors.Combobox.OptionMeta.text.meta.default": {
    "value": "var(--colors--combobox--option-meta-text-meta-default)",
    "variable": "var(--colors--combobox--option-meta-text-meta-default)"
  },
  "colors.Combobox.OptionMeta.text.meta.hover": {
    "value": "var(--colors--combobox--option-meta-text-meta-hover)",
    "variable": "var(--colors--combobox--option-meta-text-meta-hover)"
  },
  "colors.Combobox.OptionMeta.text.meta.pressed": {
    "value": "var(--colors--combobox--option-meta-text-meta-pressed)",
    "variable": "var(--colors--combobox--option-meta-text-meta-pressed)"
  },
  "colors.Combobox.OptionMeta.text.meta.selected": {
    "value": "var(--colors--combobox--option-meta-text-meta-selected)",
    "variable": "var(--colors--combobox--option-meta-text-meta-selected)"
  },
  "colors.Combobox.Option.bg.default": {
    "value": "var(--colors--combobox--option-bg-default)",
    "variable": "var(--colors--combobox--option-bg-default)"
  },
  "colors.Combobox.Option.bg.hover": {
    "value": "var(--colors--combobox--option-bg-hover)",
    "variable": "var(--colors--combobox--option-bg-hover)"
  },
  "colors.Combobox.Option.bg.pressed": {
    "value": "var(--colors--combobox--option-bg-pressed)",
    "variable": "var(--colors--combobox--option-bg-pressed)"
  },
  "colors.Combobox.Option.bg.selected": {
    "value": "var(--colors--combobox--option-bg-selected)",
    "variable": "var(--colors--combobox--option-bg-selected)"
  },
  "colors.Combobox.Trigger.bg.default": {
    "value": "var(--colors--combobox--trigger-bg-default)",
    "variable": "var(--colors--combobox--trigger-bg-default)"
  },
  "colors.Combobox.Trigger.bg.hover": {
    "value": "var(--colors--combobox--trigger-bg-hover)",
    "variable": "var(--colors--combobox--trigger-bg-hover)"
  },
  "colors.Combobox.Trigger.bg.active": {
    "value": "var(--colors--combobox--trigger-bg-active)",
    "variable": "var(--colors--combobox--trigger-bg-active)"
  },
  "colors.Combobox.Trigger.bg.activeHover": {
    "value": "var(--colors--combobox--trigger-bg-active-hover)",
    "variable": "var(--colors--combobox--trigger-bg-active-hover)"
  },
  "colors.Combobox.Trigger.bg.error": {
    "value": "var(--colors--combobox--trigger-bg-error)",
    "variable": "var(--colors--combobox--trigger-bg-error)"
  },
  "colors.Combobox.Trigger.bg.errorHover": {
    "value": "var(--colors--combobox--trigger-bg-error-hover)",
    "variable": "var(--colors--combobox--trigger-bg-error-hover)"
  },
  "colors.Combobox.Trigger.bg.errorActive": {
    "value": "var(--colors--combobox--trigger-bg-error-active)",
    "variable": "var(--colors--combobox--trigger-bg-error-active)"
  },
  "colors.Combobox.Trigger.border.default": {
    "value": "var(--colors--combobox--trigger-border-default)",
    "variable": "var(--colors--combobox--trigger-border-default)"
  },
  "colors.Combobox.Trigger.border.hover": {
    "value": "var(--colors--combobox--trigger-border-hover)",
    "variable": "var(--colors--combobox--trigger-border-hover)"
  },
  "colors.Combobox.Trigger.border.active": {
    "value": "var(--colors--combobox--trigger-border-active)",
    "variable": "var(--colors--combobox--trigger-border-active)"
  },
  "colors.Combobox.Trigger.border.activeHover": {
    "value": "var(--colors--combobox--trigger-border-active-hover)",
    "variable": "var(--colors--combobox--trigger-border-active-hover)"
  },
  "colors.Combobox.Trigger.border.error": {
    "value": "var(--colors--combobox--trigger-border-error)",
    "variable": "var(--colors--combobox--trigger-border-error)"
  },
  "colors.Combobox.Trigger.border.errorHover": {
    "value": "var(--colors--combobox--trigger-border-error-hover)",
    "variable": "var(--colors--combobox--trigger-border-error-hover)"
  },
  "colors.Combobox.Trigger.border.errorActive": {
    "value": "var(--colors--combobox--trigger-border-error-active)",
    "variable": "var(--colors--combobox--trigger-border-error-active)"
  },
  "colors.DateInput.bg.active": {
    "value": "var(--colors--date-input-bg-active)",
    "variable": "var(--colors--date-input-bg-active)"
  },
  "colors.DateInput.bg.activeHover": {
    "value": "var(--colors--date-input-bg-active-hover)",
    "variable": "var(--colors--date-input-bg-active-hover)"
  },
  "colors.DateInput.bg.autofill": {
    "value": "var(--colors--date-input-bg-autofill)",
    "variable": "var(--colors--date-input-bg-autofill)"
  },
  "colors.DateInput.bg.default": {
    "value": "var(--colors--date-input-bg-default)",
    "variable": "var(--colors--date-input-bg-default)"
  },
  "colors.DateInput.bg.error": {
    "value": "var(--colors--date-input-bg-error)",
    "variable": "var(--colors--date-input-bg-error)"
  },
  "colors.DateInput.bg.errorActive": {
    "value": "var(--colors--date-input-bg-error-active)",
    "variable": "var(--colors--date-input-bg-error-active)"
  },
  "colors.DateInput.bg.errorHover": {
    "value": "var(--colors--date-input-bg-error-hover)",
    "variable": "var(--colors--date-input-bg-error-hover)"
  },
  "colors.DateInput.bg.hover": {
    "value": "var(--colors--date-input-bg-hover)",
    "variable": "var(--colors--date-input-bg-hover)"
  },
  "colors.DateInput.bg.readOnly": {
    "value": "var(--colors--date-input-bg-read-only)",
    "variable": "var(--colors--date-input-bg-read-only)"
  },
  "colors.DateInput.border.active": {
    "value": "var(--colors--date-input-border-active)",
    "variable": "var(--colors--date-input-border-active)"
  },
  "colors.DateInput.border.activeHover": {
    "value": "var(--colors--date-input-border-active-hover)",
    "variable": "var(--colors--date-input-border-active-hover)"
  },
  "colors.DateInput.border.default": {
    "value": "var(--colors--date-input-border-default)",
    "variable": "var(--colors--date-input-border-default)"
  },
  "colors.DateInput.border.error": {
    "value": "var(--colors--date-input-border-error)",
    "variable": "var(--colors--date-input-border-error)"
  },
  "colors.DateInput.border.errorActive": {
    "value": "var(--colors--date-input-border-error-active)",
    "variable": "var(--colors--date-input-border-error-active)"
  },
  "colors.DateInput.border.errorHover": {
    "value": "var(--colors--date-input-border-error-hover)",
    "variable": "var(--colors--date-input-border-error-hover)"
  },
  "colors.DateInput.border.hover": {
    "value": "var(--colors--date-input-border-hover)",
    "variable": "var(--colors--date-input-border-hover)"
  },
  "colors.DateInput.border.readOnly": {
    "value": "var(--colors--date-input-border-read-only)",
    "variable": "var(--colors--date-input-border-read-only)"
  },
  "colors.DateInput.icon.leading.default": {
    "value": "var(--colors--date-input-icon-leading-default)",
    "variable": "var(--colors--date-input-icon-leading-default)"
  },
  "colors.DateInput.icon.leading.readOnly": {
    "value": "var(--colors--date-input-icon-leading-read-only)",
    "variable": "var(--colors--date-input-icon-leading-read-only)"
  },
  "colors.DateInput.icon.trailing.default": {
    "value": "var(--colors--date-input-icon-trailing-default)",
    "variable": "var(--colors--date-input-icon-trailing-default)"
  },
  "colors.DateInput.icon.trailing.readOnly": {
    "value": "var(--colors--date-input-icon-trailing-read-only)",
    "variable": "var(--colors--date-input-icon-trailing-read-only)"
  },
  "colors.DateInput.text.adornment.default": {
    "value": "var(--colors--date-input-text-adornment-default)",
    "variable": "var(--colors--date-input-text-adornment-default)"
  },
  "colors.DateInput.text.adornment.readOnly": {
    "value": "var(--colors--date-input-text-adornment-read-only)",
    "variable": "var(--colors--date-input-text-adornment-read-only)"
  },
  "colors.DateInput.text.placeholder": {
    "value": "var(--colors--date-input-text-placeholder)",
    "variable": "var(--colors--date-input-text-placeholder)"
  },
  "colors.DateInput.text.populated": {
    "value": "var(--colors--date-input-text-populated)",
    "variable": "var(--colors--date-input-text-populated)"
  },
  "colors.DateInput.text.readOnly": {
    "value": "var(--colors--date-input-text-read-only)",
    "variable": "var(--colors--date-input-text-read-only)"
  },
  "colors.DateInput.HelperArea.icon.default": {
    "value": "var(--colors--date-input--helper-area-icon-default)",
    "variable": "var(--colors--date-input--helper-area-icon-default)"
  },
  "colors.DateInput.HelperArea.icon.error": {
    "value": "var(--colors--date-input--helper-area-icon-error)",
    "variable": "var(--colors--date-input--helper-area-icon-error)"
  },
  "colors.DateInput.HelperArea.icon.readOnly": {
    "value": "var(--colors--date-input--helper-area-icon-read-only)",
    "variable": "var(--colors--date-input--helper-area-icon-read-only)"
  },
  "colors.DateInput.HelperArea.text.default": {
    "value": "var(--colors--date-input--helper-area-text-default)",
    "variable": "var(--colors--date-input--helper-area-text-default)"
  },
  "colors.DateInput.HelperArea.text.error": {
    "value": "var(--colors--date-input--helper-area-text-error)",
    "variable": "var(--colors--date-input--helper-area-text-error)"
  },
  "colors.DateInput.HelperArea.text.readOnly": {
    "value": "var(--colors--date-input--helper-area-text-read-only)",
    "variable": "var(--colors--date-input--helper-area-text-read-only)"
  },
  "colors.DateInput.LabelArea.indicator.optional": {
    "value": "var(--colors--date-input--label-area-indicator-optional)",
    "variable": "var(--colors--date-input--label-area-indicator-optional)"
  },
  "colors.DateInput.LabelArea.indicator.readOnly": {
    "value": "var(--colors--date-input--label-area-indicator-read-only)",
    "variable": "var(--colors--date-input--label-area-indicator-read-only)"
  },
  "colors.DateInput.LabelArea.indicator.required": {
    "value": "var(--colors--date-input--label-area-indicator-required)",
    "variable": "var(--colors--date-input--label-area-indicator-required)"
  },
  "colors.DateInput.LabelArea.label.default": {
    "value": "var(--colors--date-input--label-area-label-default)",
    "variable": "var(--colors--date-input--label-area-label-default)"
  },
  "colors.DateInput.LabelArea.label.readOnly": {
    "value": "var(--colors--date-input--label-area-label-read-only)",
    "variable": "var(--colors--date-input--label-area-label-read-only)"
  },
  "colors.DatePicker.Backdrop.bg": {
    "value": "var(--colors--date-picker--backdrop-bg)",
    "variable": "var(--colors--date-picker--backdrop-bg)"
  },
  "colors.DatePicker.Content.bg": {
    "value": "var(--colors--date-picker--content-bg)",
    "variable": "var(--colors--date-picker--content-bg)"
  },
  "colors.DatePicker.InputGroup.bg.default": {
    "value": "var(--colors--date-picker--input-group-bg-default)",
    "variable": "var(--colors--date-picker--input-group-bg-default)"
  },
  "colors.DatePicker.InputGroup.bg.hover": {
    "value": "var(--colors--date-picker--input-group-bg-hover)",
    "variable": "var(--colors--date-picker--input-group-bg-hover)"
  },
  "colors.DatePicker.InputGroup.bg.active": {
    "value": "var(--colors--date-picker--input-group-bg-active)",
    "variable": "var(--colors--date-picker--input-group-bg-active)"
  },
  "colors.DatePicker.InputGroup.bg.activeHover": {
    "value": "var(--colors--date-picker--input-group-bg-active-hover)",
    "variable": "var(--colors--date-picker--input-group-bg-active-hover)"
  },
  "colors.DatePicker.InputGroup.bg.error": {
    "value": "var(--colors--date-picker--input-group-bg-error)",
    "variable": "var(--colors--date-picker--input-group-bg-error)"
  },
  "colors.DatePicker.InputGroup.bg.errorActive": {
    "value": "var(--colors--date-picker--input-group-bg-error-active)",
    "variable": "var(--colors--date-picker--input-group-bg-error-active)"
  },
  "colors.DatePicker.InputGroup.bg.errorHover": {
    "value": "var(--colors--date-picker--input-group-bg-error-hover)",
    "variable": "var(--colors--date-picker--input-group-bg-error-hover)"
  },
  "colors.DatePicker.InputGroup.bg.readOnly": {
    "value": "var(--colors--date-picker--input-group-bg-read-only)",
    "variable": "var(--colors--date-picker--input-group-bg-read-only)"
  },
  "colors.DatePicker.InputGroup.border.default": {
    "value": "var(--colors--date-picker--input-group-border-default)",
    "variable": "var(--colors--date-picker--input-group-border-default)"
  },
  "colors.DatePicker.InputGroup.border.hover": {
    "value": "var(--colors--date-picker--input-group-border-hover)",
    "variable": "var(--colors--date-picker--input-group-border-hover)"
  },
  "colors.DatePicker.InputGroup.border.active": {
    "value": "var(--colors--date-picker--input-group-border-active)",
    "variable": "var(--colors--date-picker--input-group-border-active)"
  },
  "colors.DatePicker.InputGroup.border.activeHover": {
    "value": "var(--colors--date-picker--input-group-border-active-hover)",
    "variable": "var(--colors--date-picker--input-group-border-active-hover)"
  },
  "colors.DatePicker.InputGroup.border.error": {
    "value": "var(--colors--date-picker--input-group-border-error)",
    "variable": "var(--colors--date-picker--input-group-border-error)"
  },
  "colors.DatePicker.InputGroup.border.errorActive": {
    "value": "var(--colors--date-picker--input-group-border-error-active)",
    "variable": "var(--colors--date-picker--input-group-border-error-active)"
  },
  "colors.DatePicker.InputGroup.border.errorHover": {
    "value": "var(--colors--date-picker--input-group-border-error-hover)",
    "variable": "var(--colors--date-picker--input-group-border-error-hover)"
  },
  "colors.DatePicker.InputGroup.border.readOnly": {
    "value": "var(--colors--date-picker--input-group-border-read-only)",
    "variable": "var(--colors--date-picker--input-group-border-read-only)"
  },
  "colors.DatePicker.InputGroup.text.placeholder": {
    "value": "var(--colors--date-picker--input-group-text-placeholder)",
    "variable": "var(--colors--date-picker--input-group-text-placeholder)"
  },
  "colors.DatePicker.InputGroup.text.populated": {
    "value": "var(--colors--date-picker--input-group-text-populated)",
    "variable": "var(--colors--date-picker--input-group-text-populated)"
  },
  "colors.DatePicker.InputGroup.text.readOnly": {
    "value": "var(--colors--date-picker--input-group-text-read-only)",
    "variable": "var(--colors--date-picker--input-group-text-read-only)"
  },
  "colors.DatePicker.Trigger.border.default": {
    "value": "var(--colors--date-picker--trigger-border-default)",
    "variable": "var(--colors--date-picker--trigger-border-default)"
  },
  "colors.DatePicker.Trigger.border.active": {
    "value": "var(--colors--date-picker--trigger-border-active)",
    "variable": "var(--colors--date-picker--trigger-border-active)"
  },
  "colors.DatePicker.Trigger.border.error": {
    "value": "var(--colors--date-picker--trigger-border-error)",
    "variable": "var(--colors--date-picker--trigger-border-error)"
  },
  "colors.Divider.muted.bg": {
    "value": "var(--colors--divider-muted-bg)",
    "variable": "var(--colors--divider-muted-bg)"
  },
  "colors.Divider.muted-alt.bg": {
    "value": "var(--colors--divider-muted-alt-bg)",
    "variable": "var(--colors--divider-muted-alt-bg)"
  },
  "colors.Divider.emphasized.bg": {
    "value": "var(--colors--divider-emphasized-bg)",
    "variable": "var(--colors--divider-emphasized-bg)"
  },
  "colors.Dropdown.Content.bg": {
    "value": "var(--colors--dropdown--content-bg)",
    "variable": "var(--colors--dropdown--content-bg)"
  },
  "colors.Dropdown.Heading.bg": {
    "value": "var(--colors--dropdown--heading-bg)",
    "variable": "var(--colors--dropdown--heading-bg)"
  },
  "colors.Dropdown.Heading.icon": {
    "value": "var(--colors--dropdown--heading-icon)",
    "variable": "var(--colors--dropdown--heading-icon)"
  },
  "colors.Dropdown.Heading.text": {
    "value": "var(--colors--dropdown--heading-text)",
    "variable": "var(--colors--dropdown--heading-text)"
  },
  "colors.DuoColorIcon.trust.default.bg": {
    "value": "var(--colors--duo-color-icon-trust-default-bg)",
    "variable": "var(--colors--duo-color-icon-trust-default-bg)"
  },
  "colors.DuoColorIcon.trust.default.icon": {
    "value": "var(--colors--duo-color-icon-trust-default-icon)",
    "variable": "var(--colors--duo-color-icon-trust-default-icon)"
  },
  "colors.DuoColorIcon.trust.onHero.bg": {
    "value": "var(--colors--duo-color-icon-trust-on-hero-bg)",
    "variable": "var(--colors--duo-color-icon-trust-on-hero-bg)"
  },
  "colors.DuoColorIcon.trust.onHero.icon": {
    "value": "var(--colors--duo-color-icon-trust-on-hero-icon)",
    "variable": "var(--colors--duo-color-icon-trust-on-hero-icon)"
  },
  "colors.DuoColorIcon.trust.onImpact.bg": {
    "value": "var(--colors--duo-color-icon-trust-on-impact-bg)",
    "variable": "var(--colors--duo-color-icon-trust-on-impact-bg)"
  },
  "colors.DuoColorIcon.trust.onImpact.icon": {
    "value": "var(--colors--duo-color-icon-trust-on-impact-icon)",
    "variable": "var(--colors--duo-color-icon-trust-on-impact-icon)"
  },
  "colors.DuoColorIcon.insight.default.bg": {
    "value": "var(--colors--duo-color-icon-insight-default-bg)",
    "variable": "var(--colors--duo-color-icon-insight-default-bg)"
  },
  "colors.DuoColorIcon.insight.default.icon": {
    "value": "var(--colors--duo-color-icon-insight-default-icon)",
    "variable": "var(--colors--duo-color-icon-insight-default-icon)"
  },
  "colors.DuoColorIcon.insight.onHero.bg": {
    "value": "var(--colors--duo-color-icon-insight-on-hero-bg)",
    "variable": "var(--colors--duo-color-icon-insight-on-hero-bg)"
  },
  "colors.DuoColorIcon.insight.onHero.icon": {
    "value": "var(--colors--duo-color-icon-insight-on-hero-icon)",
    "variable": "var(--colors--duo-color-icon-insight-on-hero-icon)"
  },
  "colors.DuoColorIcon.insight.onImpact.bg": {
    "value": "var(--colors--duo-color-icon-insight-on-impact-bg)",
    "variable": "var(--colors--duo-color-icon-insight-on-impact-bg)"
  },
  "colors.DuoColorIcon.insight.onImpact.icon": {
    "value": "var(--colors--duo-color-icon-insight-on-impact-icon)",
    "variable": "var(--colors--duo-color-icon-insight-on-impact-icon)"
  },
  "colors.DuoColorIcon.inspire.default.bg": {
    "value": "var(--colors--duo-color-icon-inspire-default-bg)",
    "variable": "var(--colors--duo-color-icon-inspire-default-bg)"
  },
  "colors.DuoColorIcon.inspire.default.icon": {
    "value": "var(--colors--duo-color-icon-inspire-default-icon)",
    "variable": "var(--colors--duo-color-icon-inspire-default-icon)"
  },
  "colors.DuoColorIcon.inspire.onHero.bg": {
    "value": "var(--colors--duo-color-icon-inspire-on-hero-bg)",
    "variable": "var(--colors--duo-color-icon-inspire-on-hero-bg)"
  },
  "colors.DuoColorIcon.inspire.onHero.icon": {
    "value": "var(--colors--duo-color-icon-inspire-on-hero-icon)",
    "variable": "var(--colors--duo-color-icon-inspire-on-hero-icon)"
  },
  "colors.DuoColorIcon.inspire.onImpact.bg": {
    "value": "var(--colors--duo-color-icon-inspire-on-impact-bg)",
    "variable": "var(--colors--duo-color-icon-inspire-on-impact-bg)"
  },
  "colors.DuoColorIcon.inspire.onImpact.icon": {
    "value": "var(--colors--duo-color-icon-inspire-on-impact-icon)",
    "variable": "var(--colors--duo-color-icon-inspire-on-impact-icon)"
  },
  "colors.DuoColorIcon.empower.default.bg": {
    "value": "var(--colors--duo-color-icon-empower-default-bg)",
    "variable": "var(--colors--duo-color-icon-empower-default-bg)"
  },
  "colors.DuoColorIcon.empower.default.icon": {
    "value": "var(--colors--duo-color-icon-empower-default-icon)",
    "variable": "var(--colors--duo-color-icon-empower-default-icon)"
  },
  "colors.DuoColorIcon.empower.onHero.bg": {
    "value": "var(--colors--duo-color-icon-empower-on-hero-bg)",
    "variable": "var(--colors--duo-color-icon-empower-on-hero-bg)"
  },
  "colors.DuoColorIcon.empower.onHero.icon": {
    "value": "var(--colors--duo-color-icon-empower-on-hero-icon)",
    "variable": "var(--colors--duo-color-icon-empower-on-hero-icon)"
  },
  "colors.DuoColorIcon.empower.onImpact.bg": {
    "value": "var(--colors--duo-color-icon-empower-on-impact-bg)",
    "variable": "var(--colors--duo-color-icon-empower-on-impact-bg)"
  },
  "colors.DuoColorIcon.empower.onImpact.icon": {
    "value": "var(--colors--duo-color-icon-empower-on-impact-icon)",
    "variable": "var(--colors--duo-color-icon-empower-on-impact-icon)"
  },
  "colors.DuoColorIcon.info.default.bg": {
    "value": "var(--colors--duo-color-icon-info-default-bg)",
    "variable": "var(--colors--duo-color-icon-info-default-bg)"
  },
  "colors.DuoColorIcon.info.default.icon": {
    "value": "var(--colors--duo-color-icon-info-default-icon)",
    "variable": "var(--colors--duo-color-icon-info-default-icon)"
  },
  "colors.DuoColorIcon.info.onHero.bg": {
    "value": "var(--colors--duo-color-icon-info-on-hero-bg)",
    "variable": "var(--colors--duo-color-icon-info-on-hero-bg)"
  },
  "colors.DuoColorIcon.info.onHero.icon": {
    "value": "var(--colors--duo-color-icon-info-on-hero-icon)",
    "variable": "var(--colors--duo-color-icon-info-on-hero-icon)"
  },
  "colors.DuoColorIcon.info.onImpact.bg": {
    "value": "var(--colors--duo-color-icon-info-on-impact-bg)",
    "variable": "var(--colors--duo-color-icon-info-on-impact-bg)"
  },
  "colors.DuoColorIcon.info.onImpact.icon": {
    "value": "var(--colors--duo-color-icon-info-on-impact-icon)",
    "variable": "var(--colors--duo-color-icon-info-on-impact-icon)"
  },
  "colors.DuoColorIcon.success.default.bg": {
    "value": "var(--colors--duo-color-icon-success-default-bg)",
    "variable": "var(--colors--duo-color-icon-success-default-bg)"
  },
  "colors.DuoColorIcon.success.default.icon": {
    "value": "var(--colors--duo-color-icon-success-default-icon)",
    "variable": "var(--colors--duo-color-icon-success-default-icon)"
  },
  "colors.DuoColorIcon.success.onHero.bg": {
    "value": "var(--colors--duo-color-icon-success-on-hero-bg)",
    "variable": "var(--colors--duo-color-icon-success-on-hero-bg)"
  },
  "colors.DuoColorIcon.success.onHero.icon": {
    "value": "var(--colors--duo-color-icon-success-on-hero-icon)",
    "variable": "var(--colors--duo-color-icon-success-on-hero-icon)"
  },
  "colors.DuoColorIcon.success.onImpact.bg": {
    "value": "var(--colors--duo-color-icon-success-on-impact-bg)",
    "variable": "var(--colors--duo-color-icon-success-on-impact-bg)"
  },
  "colors.DuoColorIcon.success.onImpact.icon": {
    "value": "var(--colors--duo-color-icon-success-on-impact-icon)",
    "variable": "var(--colors--duo-color-icon-success-on-impact-icon)"
  },
  "colors.DuoColorIcon.critical.default.bg": {
    "value": "var(--colors--duo-color-icon-critical-default-bg)",
    "variable": "var(--colors--duo-color-icon-critical-default-bg)"
  },
  "colors.DuoColorIcon.critical.default.icon": {
    "value": "var(--colors--duo-color-icon-critical-default-icon)",
    "variable": "var(--colors--duo-color-icon-critical-default-icon)"
  },
  "colors.DuoColorIcon.critical.onHero.bg": {
    "value": "var(--colors--duo-color-icon-critical-on-hero-bg)",
    "variable": "var(--colors--duo-color-icon-critical-on-hero-bg)"
  },
  "colors.DuoColorIcon.critical.onHero.icon": {
    "value": "var(--colors--duo-color-icon-critical-on-hero-icon)",
    "variable": "var(--colors--duo-color-icon-critical-on-hero-icon)"
  },
  "colors.DuoColorIcon.critical.onImpact.bg": {
    "value": "var(--colors--duo-color-icon-critical-on-impact-bg)",
    "variable": "var(--colors--duo-color-icon-critical-on-impact-bg)"
  },
  "colors.DuoColorIcon.critical.onImpact.icon": {
    "value": "var(--colors--duo-color-icon-critical-on-impact-icon)",
    "variable": "var(--colors--duo-color-icon-critical-on-impact-icon)"
  },
  "colors.DuoColorIcon.warning.default.bg": {
    "value": "var(--colors--duo-color-icon-warning-default-bg)",
    "variable": "var(--colors--duo-color-icon-warning-default-bg)"
  },
  "colors.DuoColorIcon.warning.default.icon": {
    "value": "var(--colors--duo-color-icon-warning-default-icon)",
    "variable": "var(--colors--duo-color-icon-warning-default-icon)"
  },
  "colors.DuoColorIcon.warning.onHero.bg": {
    "value": "var(--colors--duo-color-icon-warning-on-hero-bg)",
    "variable": "var(--colors--duo-color-icon-warning-on-hero-bg)"
  },
  "colors.DuoColorIcon.warning.onHero.icon": {
    "value": "var(--colors--duo-color-icon-warning-on-hero-icon)",
    "variable": "var(--colors--duo-color-icon-warning-on-hero-icon)"
  },
  "colors.DuoColorIcon.warning.onImpact.bg": {
    "value": "var(--colors--duo-color-icon-warning-on-impact-bg)",
    "variable": "var(--colors--duo-color-icon-warning-on-impact-bg)"
  },
  "colors.DuoColorIcon.warning.onImpact.icon": {
    "value": "var(--colors--duo-color-icon-warning-on-impact-icon)",
    "variable": "var(--colors--duo-color-icon-warning-on-impact-icon)"
  },
  "colors.DuoColorIcon.notify.default.bg": {
    "value": "var(--colors--duo-color-icon-notify-default-bg)",
    "variable": "var(--colors--duo-color-icon-notify-default-bg)"
  },
  "colors.DuoColorIcon.notify.default.icon": {
    "value": "var(--colors--duo-color-icon-notify-default-icon)",
    "variable": "var(--colors--duo-color-icon-notify-default-icon)"
  },
  "colors.DuoColorIcon.notify.onHero.bg": {
    "value": "var(--colors--duo-color-icon-notify-on-hero-bg)",
    "variable": "var(--colors--duo-color-icon-notify-on-hero-bg)"
  },
  "colors.DuoColorIcon.notify.onHero.icon": {
    "value": "var(--colors--duo-color-icon-notify-on-hero-icon)",
    "variable": "var(--colors--duo-color-icon-notify-on-hero-icon)"
  },
  "colors.DuoColorIcon.notify.onImpact.bg": {
    "value": "var(--colors--duo-color-icon-notify-on-impact-bg)",
    "variable": "var(--colors--duo-color-icon-notify-on-impact-bg)"
  },
  "colors.DuoColorIcon.notify.onImpact.icon": {
    "value": "var(--colors--duo-color-icon-notify-on-impact-icon)",
    "variable": "var(--colors--duo-color-icon-notify-on-impact-icon)"
  },
  "colors.FieldSet.HelperArea.icon.default": {
    "value": "var(--colors--field-set--helper-area-icon-default)",
    "variable": "var(--colors--field-set--helper-area-icon-default)"
  },
  "colors.FieldSet.HelperArea.icon.error": {
    "value": "var(--colors--field-set--helper-area-icon-error)",
    "variable": "var(--colors--field-set--helper-area-icon-error)"
  },
  "colors.FieldSet.HelperArea.text.default": {
    "value": "var(--colors--field-set--helper-area-text-default)",
    "variable": "var(--colors--field-set--helper-area-text-default)"
  },
  "colors.FieldSet.HelperArea.text.error": {
    "value": "var(--colors--field-set--helper-area-text-error)",
    "variable": "var(--colors--field-set--helper-area-text-error)"
  },
  "colors.FieldSet.LabelArea.indicator.optional": {
    "value": "var(--colors--field-set--label-area-indicator-optional)",
    "variable": "var(--colors--field-set--label-area-indicator-optional)"
  },
  "colors.FieldSet.LabelArea.indicator.required": {
    "value": "var(--colors--field-set--label-area-indicator-required)",
    "variable": "var(--colors--field-set--label-area-indicator-required)"
  },
  "colors.FieldSet.LabelArea.label.default": {
    "value": "var(--colors--field-set--label-area-label-default)",
    "variable": "var(--colors--field-set--label-area-label-default)"
  },
  "colors.FormField.HelperArea.icon.default": {
    "value": "var(--colors--form-field--helper-area-icon-default)",
    "variable": "var(--colors--form-field--helper-area-icon-default)"
  },
  "colors.FormField.HelperArea.icon.error": {
    "value": "var(--colors--form-field--helper-area-icon-error)",
    "variable": "var(--colors--form-field--helper-area-icon-error)"
  },
  "colors.FormField.HelperArea.icon.readOnly": {
    "value": "var(--colors--form-field--helper-area-icon-read-only)",
    "variable": "var(--colors--form-field--helper-area-icon-read-only)"
  },
  "colors.FormField.HelperArea.text.default": {
    "value": "var(--colors--form-field--helper-area-text-default)",
    "variable": "var(--colors--form-field--helper-area-text-default)"
  },
  "colors.FormField.HelperArea.text.error": {
    "value": "var(--colors--form-field--helper-area-text-error)",
    "variable": "var(--colors--form-field--helper-area-text-error)"
  },
  "colors.FormField.HelperArea.text.readOnly": {
    "value": "var(--colors--form-field--helper-area-text-read-only)",
    "variable": "var(--colors--form-field--helper-area-text-read-only)"
  },
  "colors.FormField.LabelArea.indicator.optional": {
    "value": "var(--colors--form-field--label-area-indicator-optional)",
    "variable": "var(--colors--form-field--label-area-indicator-optional)"
  },
  "colors.FormField.LabelArea.indicator.readOnly": {
    "value": "var(--colors--form-field--label-area-indicator-read-only)",
    "variable": "var(--colors--form-field--label-area-indicator-read-only)"
  },
  "colors.FormField.LabelArea.indicator.required": {
    "value": "var(--colors--form-field--label-area-indicator-required)",
    "variable": "var(--colors--form-field--label-area-indicator-required)"
  },
  "colors.FormField.LabelArea.label.default": {
    "value": "var(--colors--form-field--label-area-label-default)",
    "variable": "var(--colors--form-field--label-area-label-default)"
  },
  "colors.FormField.LabelArea.label.readOnly": {
    "value": "var(--colors--form-field--label-area-label-read-only)",
    "variable": "var(--colors--form-field--label-area-label-read-only)"
  },
  "colors.Gleam.bg": {
    "value": "var(--colors--gleam-bg)",
    "variable": "var(--colors--gleam-bg)"
  },
  "colors.Gleam.text": {
    "value": "var(--colors--gleam-text)",
    "variable": "var(--colors--gleam-text)"
  },
  "colors.Gleam.info.bg": {
    "value": "var(--colors--gleam-info-bg)",
    "variable": "var(--colors--gleam-info-bg)"
  },
  "colors.Gleam.info.text": {
    "value": "var(--colors--gleam-info-text)",
    "variable": "var(--colors--gleam-info-text)"
  },
  "colors.Gleam.new.bg": {
    "value": "var(--colors--gleam-new-bg)",
    "variable": "var(--colors--gleam-new-bg)"
  },
  "colors.Gleam.new.text": {
    "value": "var(--colors--gleam-new-text)",
    "variable": "var(--colors--gleam-new-text)"
  },
  "colors.Gleam.onImpact.info.bg": {
    "value": "var(--colors--gleam-on-impact-info-bg)",
    "variable": "var(--colors--gleam-on-impact-info-bg)"
  },
  "colors.Gleam.onImpact.info.text": {
    "value": "var(--colors--gleam-on-impact-info-text)",
    "variable": "var(--colors--gleam-on-impact-info-text)"
  },
  "colors.Gleam.onImpact.new.bg": {
    "value": "var(--colors--gleam-on-impact-new-bg)",
    "variable": "var(--colors--gleam-on-impact-new-bg)"
  },
  "colors.Gleam.onImpact.new.text": {
    "value": "var(--colors--gleam-on-impact-new-text)",
    "variable": "var(--colors--gleam-on-impact-new-text)"
  },
  "colors.IconButton.filled.brand.bg.default": {
    "value": "var(--colors--icon-button-filled-brand-bg-default)",
    "variable": "var(--colors--icon-button-filled-brand-bg-default)"
  },
  "colors.IconButton.filled.brand.bg.hover": {
    "value": "var(--colors--icon-button-filled-brand-bg-hover)",
    "variable": "var(--colors--icon-button-filled-brand-bg-hover)"
  },
  "colors.IconButton.filled.brand.bg.pressed": {
    "value": "var(--colors--icon-button-filled-brand-bg-pressed)",
    "variable": "var(--colors--icon-button-filled-brand-bg-pressed)"
  },
  "colors.IconButton.filled.brand.label.default": {
    "value": "var(--colors--icon-button-filled-brand-label-default)",
    "variable": "var(--colors--icon-button-filled-brand-label-default)"
  },
  "colors.IconButton.filled.brand.label.hover": {
    "value": "var(--colors--icon-button-filled-brand-label-hover)",
    "variable": "var(--colors--icon-button-filled-brand-label-hover)"
  },
  "colors.IconButton.filled.brand.label.pressed": {
    "value": "var(--colors--icon-button-filled-brand-label-pressed)",
    "variable": "var(--colors--icon-button-filled-brand-label-pressed)"
  },
  "colors.IconButton.filled.brand.border.default": {
    "value": "var(--colors--icon-button-filled-brand-border-default)",
    "variable": "var(--colors--icon-button-filled-brand-border-default)"
  },
  "colors.IconButton.filled.brand.border.hover": {
    "value": "var(--colors--icon-button-filled-brand-border-hover)",
    "variable": "var(--colors--icon-button-filled-brand-border-hover)"
  },
  "colors.IconButton.filled.brand.border.pressed": {
    "value": "var(--colors--icon-button-filled-brand-border-pressed)",
    "variable": "var(--colors--icon-button-filled-brand-border-pressed)"
  },
  "colors.IconButton.filled.brand.icon.default": {
    "value": "var(--colors--icon-button-filled-brand-icon-default)",
    "variable": "var(--colors--icon-button-filled-brand-icon-default)"
  },
  "colors.IconButton.filled.brand.icon.hover": {
    "value": "var(--colors--icon-button-filled-brand-icon-hover)",
    "variable": "var(--colors--icon-button-filled-brand-icon-hover)"
  },
  "colors.IconButton.filled.brand.icon.pressed": {
    "value": "var(--colors--icon-button-filled-brand-icon-pressed)",
    "variable": "var(--colors--icon-button-filled-brand-icon-pressed)"
  },
  "colors.IconButton.filled.critical.bg.default": {
    "value": "var(--colors--icon-button-filled-critical-bg-default)",
    "variable": "var(--colors--icon-button-filled-critical-bg-default)"
  },
  "colors.IconButton.filled.critical.bg.hover": {
    "value": "var(--colors--icon-button-filled-critical-bg-hover)",
    "variable": "var(--colors--icon-button-filled-critical-bg-hover)"
  },
  "colors.IconButton.filled.critical.bg.pressed": {
    "value": "var(--colors--icon-button-filled-critical-bg-pressed)",
    "variable": "var(--colors--icon-button-filled-critical-bg-pressed)"
  },
  "colors.IconButton.filled.critical.label.default": {
    "value": "var(--colors--icon-button-filled-critical-label-default)",
    "variable": "var(--colors--icon-button-filled-critical-label-default)"
  },
  "colors.IconButton.filled.critical.label.hover": {
    "value": "var(--colors--icon-button-filled-critical-label-hover)",
    "variable": "var(--colors--icon-button-filled-critical-label-hover)"
  },
  "colors.IconButton.filled.critical.label.pressed": {
    "value": "var(--colors--icon-button-filled-critical-label-pressed)",
    "variable": "var(--colors--icon-button-filled-critical-label-pressed)"
  },
  "colors.IconButton.filled.critical.icon.default": {
    "value": "var(--colors--icon-button-filled-critical-icon-default)",
    "variable": "var(--colors--icon-button-filled-critical-icon-default)"
  },
  "colors.IconButton.filled.critical.icon.hover": {
    "value": "var(--colors--icon-button-filled-critical-icon-hover)",
    "variable": "var(--colors--icon-button-filled-critical-icon-hover)"
  },
  "colors.IconButton.filled.critical.icon.pressed": {
    "value": "var(--colors--icon-button-filled-critical-icon-pressed)",
    "variable": "var(--colors--icon-button-filled-critical-icon-pressed)"
  },
  "colors.IconButton.filled.critical.border.default": {
    "value": "var(--colors--icon-button-filled-critical-border-default)",
    "variable": "var(--colors--icon-button-filled-critical-border-default)"
  },
  "colors.IconButton.filled.critical.border.hover": {
    "value": "var(--colors--icon-button-filled-critical-border-hover)",
    "variable": "var(--colors--icon-button-filled-critical-border-hover)"
  },
  "colors.IconButton.filled.critical.border.pressed": {
    "value": "var(--colors--icon-button-filled-critical-border-pressed)",
    "variable": "var(--colors--icon-button-filled-critical-border-pressed)"
  },
  "colors.IconButton.outlined.brand.bg.default": {
    "value": "var(--colors--icon-button-outlined-brand-bg-default)",
    "variable": "var(--colors--icon-button-outlined-brand-bg-default)"
  },
  "colors.IconButton.outlined.brand.bg.hover": {
    "value": "var(--colors--icon-button-outlined-brand-bg-hover)",
    "variable": "var(--colors--icon-button-outlined-brand-bg-hover)"
  },
  "colors.IconButton.outlined.brand.bg.pressed": {
    "value": "var(--colors--icon-button-outlined-brand-bg-pressed)",
    "variable": "var(--colors--icon-button-outlined-brand-bg-pressed)"
  },
  "colors.IconButton.outlined.brand.label.default": {
    "value": "var(--colors--icon-button-outlined-brand-label-default)",
    "variable": "var(--colors--icon-button-outlined-brand-label-default)"
  },
  "colors.IconButton.outlined.brand.label.hover": {
    "value": "var(--colors--icon-button-outlined-brand-label-hover)",
    "variable": "var(--colors--icon-button-outlined-brand-label-hover)"
  },
  "colors.IconButton.outlined.brand.label.pressed": {
    "value": "var(--colors--icon-button-outlined-brand-label-pressed)",
    "variable": "var(--colors--icon-button-outlined-brand-label-pressed)"
  },
  "colors.IconButton.outlined.brand.icon.default": {
    "value": "var(--colors--icon-button-outlined-brand-icon-default)",
    "variable": "var(--colors--icon-button-outlined-brand-icon-default)"
  },
  "colors.IconButton.outlined.brand.icon.hover": {
    "value": "var(--colors--icon-button-outlined-brand-icon-hover)",
    "variable": "var(--colors--icon-button-outlined-brand-icon-hover)"
  },
  "colors.IconButton.outlined.brand.icon.pressed": {
    "value": "var(--colors--icon-button-outlined-brand-icon-pressed)",
    "variable": "var(--colors--icon-button-outlined-brand-icon-pressed)"
  },
  "colors.IconButton.outlined.brand.border.default": {
    "value": "var(--colors--icon-button-outlined-brand-border-default)",
    "variable": "var(--colors--icon-button-outlined-brand-border-default)"
  },
  "colors.IconButton.outlined.brand.border.hover": {
    "value": "var(--colors--icon-button-outlined-brand-border-hover)",
    "variable": "var(--colors--icon-button-outlined-brand-border-hover)"
  },
  "colors.IconButton.outlined.brand.border.pressed": {
    "value": "var(--colors--icon-button-outlined-brand-border-pressed)",
    "variable": "var(--colors--icon-button-outlined-brand-border-pressed)"
  },
  "colors.IconButton.outlined.neutral.bg.default": {
    "value": "var(--colors--icon-button-outlined-neutral-bg-default)",
    "variable": "var(--colors--icon-button-outlined-neutral-bg-default)"
  },
  "colors.IconButton.outlined.neutral.bg.hover": {
    "value": "var(--colors--icon-button-outlined-neutral-bg-hover)",
    "variable": "var(--colors--icon-button-outlined-neutral-bg-hover)"
  },
  "colors.IconButton.outlined.neutral.bg.pressed": {
    "value": "var(--colors--icon-button-outlined-neutral-bg-pressed)",
    "variable": "var(--colors--icon-button-outlined-neutral-bg-pressed)"
  },
  "colors.IconButton.outlined.neutral.bg.selected": {
    "value": "var(--colors--icon-button-outlined-neutral-bg-selected)",
    "variable": "var(--colors--icon-button-outlined-neutral-bg-selected)"
  },
  "colors.IconButton.outlined.neutral.bg.selectedHover": {
    "value": "var(--colors--icon-button-outlined-neutral-bg-selected-hover)",
    "variable": "var(--colors--icon-button-outlined-neutral-bg-selected-hover)"
  },
  "colors.IconButton.outlined.neutral.bg.selectedPressed": {
    "value": "var(--colors--icon-button-outlined-neutral-bg-selected-pressed)",
    "variable": "var(--colors--icon-button-outlined-neutral-bg-selected-pressed)"
  },
  "colors.IconButton.outlined.neutral.label.default": {
    "value": "var(--colors--icon-button-outlined-neutral-label-default)",
    "variable": "var(--colors--icon-button-outlined-neutral-label-default)"
  },
  "colors.IconButton.outlined.neutral.label.hover": {
    "value": "var(--colors--icon-button-outlined-neutral-label-hover)",
    "variable": "var(--colors--icon-button-outlined-neutral-label-hover)"
  },
  "colors.IconButton.outlined.neutral.label.pressed": {
    "value": "var(--colors--icon-button-outlined-neutral-label-pressed)",
    "variable": "var(--colors--icon-button-outlined-neutral-label-pressed)"
  },
  "colors.IconButton.outlined.neutral.label.selected": {
    "value": "var(--colors--icon-button-outlined-neutral-label-selected)",
    "variable": "var(--colors--icon-button-outlined-neutral-label-selected)"
  },
  "colors.IconButton.outlined.neutral.label.selectedHover": {
    "value": "var(--colors--icon-button-outlined-neutral-label-selected-hover)",
    "variable": "var(--colors--icon-button-outlined-neutral-label-selected-hover)"
  },
  "colors.IconButton.outlined.neutral.label.selectedPressed": {
    "value": "var(--colors--icon-button-outlined-neutral-label-selected-pressed)",
    "variable": "var(--colors--icon-button-outlined-neutral-label-selected-pressed)"
  },
  "colors.IconButton.outlined.neutral.icon.default": {
    "value": "var(--colors--icon-button-outlined-neutral-icon-default)",
    "variable": "var(--colors--icon-button-outlined-neutral-icon-default)"
  },
  "colors.IconButton.outlined.neutral.icon.hover": {
    "value": "var(--colors--icon-button-outlined-neutral-icon-hover)",
    "variable": "var(--colors--icon-button-outlined-neutral-icon-hover)"
  },
  "colors.IconButton.outlined.neutral.icon.pressed": {
    "value": "var(--colors--icon-button-outlined-neutral-icon-pressed)",
    "variable": "var(--colors--icon-button-outlined-neutral-icon-pressed)"
  },
  "colors.IconButton.outlined.neutral.icon.selected": {
    "value": "var(--colors--icon-button-outlined-neutral-icon-selected)",
    "variable": "var(--colors--icon-button-outlined-neutral-icon-selected)"
  },
  "colors.IconButton.outlined.neutral.icon.selectedHover": {
    "value": "var(--colors--icon-button-outlined-neutral-icon-selected-hover)",
    "variable": "var(--colors--icon-button-outlined-neutral-icon-selected-hover)"
  },
  "colors.IconButton.outlined.neutral.icon.selectedPressed": {
    "value": "var(--colors--icon-button-outlined-neutral-icon-selected-pressed)",
    "variable": "var(--colors--icon-button-outlined-neutral-icon-selected-pressed)"
  },
  "colors.IconButton.outlined.neutral.border.default": {
    "value": "var(--colors--icon-button-outlined-neutral-border-default)",
    "variable": "var(--colors--icon-button-outlined-neutral-border-default)"
  },
  "colors.IconButton.outlined.neutral.border.hover": {
    "value": "var(--colors--icon-button-outlined-neutral-border-hover)",
    "variable": "var(--colors--icon-button-outlined-neutral-border-hover)"
  },
  "colors.IconButton.outlined.neutral.border.pressed": {
    "value": "var(--colors--icon-button-outlined-neutral-border-pressed)",
    "variable": "var(--colors--icon-button-outlined-neutral-border-pressed)"
  },
  "colors.IconButton.outlined.neutral.border.selected": {
    "value": "var(--colors--icon-button-outlined-neutral-border-selected)",
    "variable": "var(--colors--icon-button-outlined-neutral-border-selected)"
  },
  "colors.IconButton.outlined.neutral.border.selectedHover": {
    "value": "var(--colors--icon-button-outlined-neutral-border-selected-hover)",
    "variable": "var(--colors--icon-button-outlined-neutral-border-selected-hover)"
  },
  "colors.IconButton.outlined.neutral.border.selectedPressed": {
    "value": "var(--colors--icon-button-outlined-neutral-border-selected-pressed)",
    "variable": "var(--colors--icon-button-outlined-neutral-border-selected-pressed)"
  },
  "colors.IconButton.bare.brand.bg.default": {
    "value": "var(--colors--icon-button-bare-brand-bg-default)",
    "variable": "var(--colors--icon-button-bare-brand-bg-default)"
  },
  "colors.IconButton.bare.brand.bg.hover": {
    "value": "var(--colors--icon-button-bare-brand-bg-hover)",
    "variable": "var(--colors--icon-button-bare-brand-bg-hover)"
  },
  "colors.IconButton.bare.brand.bg.pressed": {
    "value": "var(--colors--icon-button-bare-brand-bg-pressed)",
    "variable": "var(--colors--icon-button-bare-brand-bg-pressed)"
  },
  "colors.IconButton.bare.brand.label.default": {
    "value": "var(--colors--icon-button-bare-brand-label-default)",
    "variable": "var(--colors--icon-button-bare-brand-label-default)"
  },
  "colors.IconButton.bare.brand.label.hover": {
    "value": "var(--colors--icon-button-bare-brand-label-hover)",
    "variable": "var(--colors--icon-button-bare-brand-label-hover)"
  },
  "colors.IconButton.bare.brand.label.pressed": {
    "value": "var(--colors--icon-button-bare-brand-label-pressed)",
    "variable": "var(--colors--icon-button-bare-brand-label-pressed)"
  },
  "colors.IconButton.bare.brand.icon.default": {
    "value": "var(--colors--icon-button-bare-brand-icon-default)",
    "variable": "var(--colors--icon-button-bare-brand-icon-default)"
  },
  "colors.IconButton.bare.brand.icon.hover": {
    "value": "var(--colors--icon-button-bare-brand-icon-hover)",
    "variable": "var(--colors--icon-button-bare-brand-icon-hover)"
  },
  "colors.IconButton.bare.brand.icon.pressed": {
    "value": "var(--colors--icon-button-bare-brand-icon-pressed)",
    "variable": "var(--colors--icon-button-bare-brand-icon-pressed)"
  },
  "colors.IconButton.bare.neutral.bg.default": {
    "value": "var(--colors--icon-button-bare-neutral-bg-default)",
    "variable": "var(--colors--icon-button-bare-neutral-bg-default)"
  },
  "colors.IconButton.bare.neutral.bg.hover": {
    "value": "var(--colors--icon-button-bare-neutral-bg-hover)",
    "variable": "var(--colors--icon-button-bare-neutral-bg-hover)"
  },
  "colors.IconButton.bare.neutral.bg.pressed": {
    "value": "var(--colors--icon-button-bare-neutral-bg-pressed)",
    "variable": "var(--colors--icon-button-bare-neutral-bg-pressed)"
  },
  "colors.IconButton.bare.neutral.label.default": {
    "value": "var(--colors--icon-button-bare-neutral-label-default)",
    "variable": "var(--colors--icon-button-bare-neutral-label-default)"
  },
  "colors.IconButton.bare.neutral.label.hover": {
    "value": "var(--colors--icon-button-bare-neutral-label-hover)",
    "variable": "var(--colors--icon-button-bare-neutral-label-hover)"
  },
  "colors.IconButton.bare.neutral.label.pressed": {
    "value": "var(--colors--icon-button-bare-neutral-label-pressed)",
    "variable": "var(--colors--icon-button-bare-neutral-label-pressed)"
  },
  "colors.IconButton.bare.neutral.icon.default": {
    "value": "var(--colors--icon-button-bare-neutral-icon-default)",
    "variable": "var(--colors--icon-button-bare-neutral-icon-default)"
  },
  "colors.IconButton.bare.neutral.icon.hover": {
    "value": "var(--colors--icon-button-bare-neutral-icon-hover)",
    "variable": "var(--colors--icon-button-bare-neutral-icon-hover)"
  },
  "colors.IconButton.bare.neutral.icon.pressed": {
    "value": "var(--colors--icon-button-bare-neutral-icon-pressed)",
    "variable": "var(--colors--icon-button-bare-neutral-icon-pressed)"
  },
  "colors.IconButton.onImpact.filled.brand.bg.default": {
    "value": "var(--colors--icon-button-on-impact-filled-brand-bg-default)",
    "variable": "var(--colors--icon-button-on-impact-filled-brand-bg-default)"
  },
  "colors.IconButton.onImpact.filled.brand.bg.hover": {
    "value": "var(--colors--icon-button-on-impact-filled-brand-bg-hover)",
    "variable": "var(--colors--icon-button-on-impact-filled-brand-bg-hover)"
  },
  "colors.IconButton.onImpact.filled.brand.bg.pressed": {
    "value": "var(--colors--icon-button-on-impact-filled-brand-bg-pressed)",
    "variable": "var(--colors--icon-button-on-impact-filled-brand-bg-pressed)"
  },
  "colors.IconButton.onImpact.filled.brand.label.default": {
    "value": "var(--colors--icon-button-on-impact-filled-brand-label-default)",
    "variable": "var(--colors--icon-button-on-impact-filled-brand-label-default)"
  },
  "colors.IconButton.onImpact.filled.brand.label.hover": {
    "value": "var(--colors--icon-button-on-impact-filled-brand-label-hover)",
    "variable": "var(--colors--icon-button-on-impact-filled-brand-label-hover)"
  },
  "colors.IconButton.onImpact.filled.brand.label.pressed": {
    "value": "var(--colors--icon-button-on-impact-filled-brand-label-pressed)",
    "variable": "var(--colors--icon-button-on-impact-filled-brand-label-pressed)"
  },
  "colors.IconButton.onImpact.filled.brand.icon.default": {
    "value": "var(--colors--icon-button-on-impact-filled-brand-icon-default)",
    "variable": "var(--colors--icon-button-on-impact-filled-brand-icon-default)"
  },
  "colors.IconButton.onImpact.filled.brand.icon.hover": {
    "value": "var(--colors--icon-button-on-impact-filled-brand-icon-hover)",
    "variable": "var(--colors--icon-button-on-impact-filled-brand-icon-hover)"
  },
  "colors.IconButton.onImpact.filled.brand.icon.pressed": {
    "value": "var(--colors--icon-button-on-impact-filled-brand-icon-pressed)",
    "variable": "var(--colors--icon-button-on-impact-filled-brand-icon-pressed)"
  },
  "colors.IconButton.onImpact.filled.brand.border.default": {
    "value": "var(--colors--icon-button-on-impact-filled-brand-border-default)",
    "variable": "var(--colors--icon-button-on-impact-filled-brand-border-default)"
  },
  "colors.IconButton.onImpact.filled.brand.border.hover": {
    "value": "var(--colors--icon-button-on-impact-filled-brand-border-hover)",
    "variable": "var(--colors--icon-button-on-impact-filled-brand-border-hover)"
  },
  "colors.IconButton.onImpact.filled.brand.border.pressed": {
    "value": "var(--colors--icon-button-on-impact-filled-brand-border-pressed)",
    "variable": "var(--colors--icon-button-on-impact-filled-brand-border-pressed)"
  },
  "colors.IconButton.onImpact.filled.critical.bg.default": {
    "value": "var(--colors--icon-button-on-impact-filled-critical-bg-default)",
    "variable": "var(--colors--icon-button-on-impact-filled-critical-bg-default)"
  },
  "colors.IconButton.onImpact.filled.critical.bg.hover": {
    "value": "var(--colors--icon-button-on-impact-filled-critical-bg-hover)",
    "variable": "var(--colors--icon-button-on-impact-filled-critical-bg-hover)"
  },
  "colors.IconButton.onImpact.filled.critical.bg.pressed": {
    "value": "var(--colors--icon-button-on-impact-filled-critical-bg-pressed)",
    "variable": "var(--colors--icon-button-on-impact-filled-critical-bg-pressed)"
  },
  "colors.IconButton.onImpact.filled.critical.label.default": {
    "value": "var(--colors--icon-button-on-impact-filled-critical-label-default)",
    "variable": "var(--colors--icon-button-on-impact-filled-critical-label-default)"
  },
  "colors.IconButton.onImpact.filled.critical.label.hover": {
    "value": "var(--colors--icon-button-on-impact-filled-critical-label-hover)",
    "variable": "var(--colors--icon-button-on-impact-filled-critical-label-hover)"
  },
  "colors.IconButton.onImpact.filled.critical.label.pressed": {
    "value": "var(--colors--icon-button-on-impact-filled-critical-label-pressed)",
    "variable": "var(--colors--icon-button-on-impact-filled-critical-label-pressed)"
  },
  "colors.IconButton.onImpact.filled.critical.icon.default": {
    "value": "var(--colors--icon-button-on-impact-filled-critical-icon-default)",
    "variable": "var(--colors--icon-button-on-impact-filled-critical-icon-default)"
  },
  "colors.IconButton.onImpact.filled.critical.icon.hover": {
    "value": "var(--colors--icon-button-on-impact-filled-critical-icon-hover)",
    "variable": "var(--colors--icon-button-on-impact-filled-critical-icon-hover)"
  },
  "colors.IconButton.onImpact.filled.critical.icon.pressed": {
    "value": "var(--colors--icon-button-on-impact-filled-critical-icon-pressed)",
    "variable": "var(--colors--icon-button-on-impact-filled-critical-icon-pressed)"
  },
  "colors.IconButton.onImpact.filled.critical.border.pressed": {
    "value": "var(--colors--icon-button-on-impact-filled-critical-border-pressed)",
    "variable": "var(--colors--icon-button-on-impact-filled-critical-border-pressed)"
  },
  "colors.IconButton.onImpact.outlined.brand.bg.default": {
    "value": "var(--colors--icon-button-on-impact-outlined-brand-bg-default)",
    "variable": "var(--colors--icon-button-on-impact-outlined-brand-bg-default)"
  },
  "colors.IconButton.onImpact.outlined.brand.bg.hover": {
    "value": "var(--colors--icon-button-on-impact-outlined-brand-bg-hover)",
    "variable": "var(--colors--icon-button-on-impact-outlined-brand-bg-hover)"
  },
  "colors.IconButton.onImpact.outlined.brand.bg.pressed": {
    "value": "var(--colors--icon-button-on-impact-outlined-brand-bg-pressed)",
    "variable": "var(--colors--icon-button-on-impact-outlined-brand-bg-pressed)"
  },
  "colors.IconButton.onImpact.outlined.brand.label.default": {
    "value": "var(--colors--icon-button-on-impact-outlined-brand-label-default)",
    "variable": "var(--colors--icon-button-on-impact-outlined-brand-label-default)"
  },
  "colors.IconButton.onImpact.outlined.brand.label.hover": {
    "value": "var(--colors--icon-button-on-impact-outlined-brand-label-hover)",
    "variable": "var(--colors--icon-button-on-impact-outlined-brand-label-hover)"
  },
  "colors.IconButton.onImpact.outlined.brand.label.pressed": {
    "value": "var(--colors--icon-button-on-impact-outlined-brand-label-pressed)",
    "variable": "var(--colors--icon-button-on-impact-outlined-brand-label-pressed)"
  },
  "colors.IconButton.onImpact.outlined.brand.icon.default": {
    "value": "var(--colors--icon-button-on-impact-outlined-brand-icon-default)",
    "variable": "var(--colors--icon-button-on-impact-outlined-brand-icon-default)"
  },
  "colors.IconButton.onImpact.outlined.brand.icon.hover": {
    "value": "var(--colors--icon-button-on-impact-outlined-brand-icon-hover)",
    "variable": "var(--colors--icon-button-on-impact-outlined-brand-icon-hover)"
  },
  "colors.IconButton.onImpact.outlined.brand.icon.pressed": {
    "value": "var(--colors--icon-button-on-impact-outlined-brand-icon-pressed)",
    "variable": "var(--colors--icon-button-on-impact-outlined-brand-icon-pressed)"
  },
  "colors.IconButton.onImpact.outlined.brand.border.default": {
    "value": "var(--colors--icon-button-on-impact-outlined-brand-border-default)",
    "variable": "var(--colors--icon-button-on-impact-outlined-brand-border-default)"
  },
  "colors.IconButton.onImpact.outlined.brand.border.hover": {
    "value": "var(--colors--icon-button-on-impact-outlined-brand-border-hover)",
    "variable": "var(--colors--icon-button-on-impact-outlined-brand-border-hover)"
  },
  "colors.IconButton.onImpact.outlined.brand.border.pressed": {
    "value": "var(--colors--icon-button-on-impact-outlined-brand-border-pressed)",
    "variable": "var(--colors--icon-button-on-impact-outlined-brand-border-pressed)"
  },
  "colors.IconButton.onImpact.outlined.neutral.bg.default": {
    "value": "var(--colors--icon-button-on-impact-outlined-neutral-bg-default)",
    "variable": "var(--colors--icon-button-on-impact-outlined-neutral-bg-default)"
  },
  "colors.IconButton.onImpact.outlined.neutral.bg.hover": {
    "value": "var(--colors--icon-button-on-impact-outlined-neutral-bg-hover)",
    "variable": "var(--colors--icon-button-on-impact-outlined-neutral-bg-hover)"
  },
  "colors.IconButton.onImpact.outlined.neutral.bg.pressed": {
    "value": "var(--colors--icon-button-on-impact-outlined-neutral-bg-pressed)",
    "variable": "var(--colors--icon-button-on-impact-outlined-neutral-bg-pressed)"
  },
  "colors.IconButton.onImpact.outlined.neutral.label.default": {
    "value": "var(--colors--icon-button-on-impact-outlined-neutral-label-default)",
    "variable": "var(--colors--icon-button-on-impact-outlined-neutral-label-default)"
  },
  "colors.IconButton.onImpact.outlined.neutral.label.hover": {
    "value": "var(--colors--icon-button-on-impact-outlined-neutral-label-hover)",
    "variable": "var(--colors--icon-button-on-impact-outlined-neutral-label-hover)"
  },
  "colors.IconButton.onImpact.outlined.neutral.label.pressed": {
    "value": "var(--colors--icon-button-on-impact-outlined-neutral-label-pressed)",
    "variable": "var(--colors--icon-button-on-impact-outlined-neutral-label-pressed)"
  },
  "colors.IconButton.onImpact.outlined.neutral.icon.default": {
    "value": "var(--colors--icon-button-on-impact-outlined-neutral-icon-default)",
    "variable": "var(--colors--icon-button-on-impact-outlined-neutral-icon-default)"
  },
  "colors.IconButton.onImpact.outlined.neutral.icon.hover": {
    "value": "var(--colors--icon-button-on-impact-outlined-neutral-icon-hover)",
    "variable": "var(--colors--icon-button-on-impact-outlined-neutral-icon-hover)"
  },
  "colors.IconButton.onImpact.outlined.neutral.icon.pressed": {
    "value": "var(--colors--icon-button-on-impact-outlined-neutral-icon-pressed)",
    "variable": "var(--colors--icon-button-on-impact-outlined-neutral-icon-pressed)"
  },
  "colors.IconButton.onImpact.outlined.neutral.border.default": {
    "value": "var(--colors--icon-button-on-impact-outlined-neutral-border-default)",
    "variable": "var(--colors--icon-button-on-impact-outlined-neutral-border-default)"
  },
  "colors.IconButton.onImpact.outlined.neutral.border.hover": {
    "value": "var(--colors--icon-button-on-impact-outlined-neutral-border-hover)",
    "variable": "var(--colors--icon-button-on-impact-outlined-neutral-border-hover)"
  },
  "colors.IconButton.onImpact.outlined.neutral.border.pressed": {
    "value": "var(--colors--icon-button-on-impact-outlined-neutral-border-pressed)",
    "variable": "var(--colors--icon-button-on-impact-outlined-neutral-border-pressed)"
  },
  "colors.IconButton.onImpact.bare.brand.bg.default": {
    "value": "var(--colors--icon-button-on-impact-bare-brand-bg-default)",
    "variable": "var(--colors--icon-button-on-impact-bare-brand-bg-default)"
  },
  "colors.IconButton.onImpact.bare.brand.label.default": {
    "value": "var(--colors--icon-button-on-impact-bare-brand-label-default)",
    "variable": "var(--colors--icon-button-on-impact-bare-brand-label-default)"
  },
  "colors.IconButton.onImpact.bare.brand.label.hover": {
    "value": "var(--colors--icon-button-on-impact-bare-brand-label-hover)",
    "variable": "var(--colors--icon-button-on-impact-bare-brand-label-hover)"
  },
  "colors.IconButton.onImpact.bare.brand.label.pressed": {
    "value": "var(--colors--icon-button-on-impact-bare-brand-label-pressed)",
    "variable": "var(--colors--icon-button-on-impact-bare-brand-label-pressed)"
  },
  "colors.IconButton.onImpact.bare.brand.icon.default": {
    "value": "var(--colors--icon-button-on-impact-bare-brand-icon-default)",
    "variable": "var(--colors--icon-button-on-impact-bare-brand-icon-default)"
  },
  "colors.IconButton.onImpact.bare.brand.icon.hover": {
    "value": "var(--colors--icon-button-on-impact-bare-brand-icon-hover)",
    "variable": "var(--colors--icon-button-on-impact-bare-brand-icon-hover)"
  },
  "colors.IconButton.onImpact.bare.brand.icon.pressed": {
    "value": "var(--colors--icon-button-on-impact-bare-brand-icon-pressed)",
    "variable": "var(--colors--icon-button-on-impact-bare-brand-icon-pressed)"
  },
  "colors.IconButton.onImpact.bare.neutral.bg.default": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-bg-default)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-bg-default)"
  },
  "colors.IconButton.onImpact.bare.neutral.bg.hover": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-bg-hover)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-bg-hover)"
  },
  "colors.IconButton.onImpact.bare.neutral.bg.pressed": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-bg-pressed)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-bg-pressed)"
  },
  "colors.IconButton.onImpact.bare.neutral.label.default": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-label-default)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-label-default)"
  },
  "colors.IconButton.onImpact.bare.neutral.label.hover": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-label-hover)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-label-hover)"
  },
  "colors.IconButton.onImpact.bare.neutral.label.pressed": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-label-pressed)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-label-pressed)"
  },
  "colors.IconButton.onImpact.bare.neutral.icon.default": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-icon-default)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-icon-default)"
  },
  "colors.IconButton.onImpact.bare.neutral.icon.hover": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-icon-hover)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-icon-hover)"
  },
  "colors.IconButton.onImpact.bare.neutral.icon.pressed": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-icon-pressed)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-icon-pressed)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.bg.default": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-fixed-bg-default)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-fixed-bg-default)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.bg.hover": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-fixed-bg-hover)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-fixed-bg-hover)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.bg.pressed": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-fixed-bg-pressed)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-fixed-bg-pressed)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.label.default": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-fixed-label-default)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-fixed-label-default)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.label.hover": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-fixed-label-hover)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-fixed-label-hover)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.label.pressed": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-fixed-label-pressed)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-fixed-label-pressed)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.icon.default": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-fixed-icon-default)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-fixed-icon-default)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.icon.hover": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-fixed-icon-hover)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-fixed-icon-hover)"
  },
  "colors.IconButton.onImpact.bare.neutral-fixed.icon.pressed": {
    "value": "var(--colors--icon-button-on-impact-bare-neutral-fixed-icon-pressed)",
    "variable": "var(--colors--icon-button-on-impact-bare-neutral-fixed-icon-pressed)"
  },
  "colors.InlineFeedback.critical.icon": {
    "value": "var(--colors--inline-feedback-critical-icon)",
    "variable": "var(--colors--inline-feedback-critical-icon)"
  },
  "colors.InlineFeedback.critical.text": {
    "value": "var(--colors--inline-feedback-critical-text)",
    "variable": "var(--colors--inline-feedback-critical-text)"
  },
  "colors.InlineFeedback.info.icon": {
    "value": "var(--colors--inline-feedback-info-icon)",
    "variable": "var(--colors--inline-feedback-info-icon)"
  },
  "colors.InlineFeedback.info.text": {
    "value": "var(--colors--inline-feedback-info-text)",
    "variable": "var(--colors--inline-feedback-info-text)"
  },
  "colors.InlineFeedback.success.icon": {
    "value": "var(--colors--inline-feedback-success-icon)",
    "variable": "var(--colors--inline-feedback-success-icon)"
  },
  "colors.InlineFeedback.success.text": {
    "value": "var(--colors--inline-feedback-success-text)",
    "variable": "var(--colors--inline-feedback-success-text)"
  },
  "colors.InlineFeedback.transient.icon": {
    "value": "var(--colors--inline-feedback-transient-icon)",
    "variable": "var(--colors--inline-feedback-transient-icon)"
  },
  "colors.InlineFeedback.transient.text": {
    "value": "var(--colors--inline-feedback-transient-text)",
    "variable": "var(--colors--inline-feedback-transient-text)"
  },
  "colors.InlineFeedback.warning.icon": {
    "value": "var(--colors--inline-feedback-warning-icon)",
    "variable": "var(--colors--inline-feedback-warning-icon)"
  },
  "colors.InlineFeedback.warning.text": {
    "value": "var(--colors--inline-feedback-warning-text)",
    "variable": "var(--colors--inline-feedback-warning-text)"
  },
  "colors.Input.HelperArea.icon.default": {
    "value": "var(--colors--input--helper-area-icon-default)",
    "variable": "var(--colors--input--helper-area-icon-default)"
  },
  "colors.Input.HelperArea.icon.error": {
    "value": "var(--colors--input--helper-area-icon-error)",
    "variable": "var(--colors--input--helper-area-icon-error)"
  },
  "colors.Input.HelperArea.icon.readOnly": {
    "value": "var(--colors--input--helper-area-icon-read-only)",
    "variable": "var(--colors--input--helper-area-icon-read-only)"
  },
  "colors.Input.HelperArea.text.default": {
    "value": "var(--colors--input--helper-area-text-default)",
    "variable": "var(--colors--input--helper-area-text-default)"
  },
  "colors.Input.HelperArea.text.error": {
    "value": "var(--colors--input--helper-area-text-error)",
    "variable": "var(--colors--input--helper-area-text-error)"
  },
  "colors.Input.HelperArea.text.readOnly": {
    "value": "var(--colors--input--helper-area-text-read-only)",
    "variable": "var(--colors--input--helper-area-text-read-only)"
  },
  "colors.Input.bg.active": {
    "value": "var(--colors--input-bg-active)",
    "variable": "var(--colors--input-bg-active)"
  },
  "colors.Input.bg.activeHover": {
    "value": "var(--colors--input-bg-active-hover)",
    "variable": "var(--colors--input-bg-active-hover)"
  },
  "colors.Input.bg.autofill": {
    "value": "var(--colors--input-bg-autofill)",
    "variable": "var(--colors--input-bg-autofill)"
  },
  "colors.Input.bg.default": {
    "value": "var(--colors--input-bg-default)",
    "variable": "var(--colors--input-bg-default)"
  },
  "colors.Input.bg.error": {
    "value": "var(--colors--input-bg-error)",
    "variable": "var(--colors--input-bg-error)"
  },
  "colors.Input.bg.errorActive": {
    "value": "var(--colors--input-bg-error-active)",
    "variable": "var(--colors--input-bg-error-active)"
  },
  "colors.Input.bg.errorHover": {
    "value": "var(--colors--input-bg-error-hover)",
    "variable": "var(--colors--input-bg-error-hover)"
  },
  "colors.Input.bg.hover": {
    "value": "var(--colors--input-bg-hover)",
    "variable": "var(--colors--input-bg-hover)"
  },
  "colors.Input.bg.readOnly": {
    "value": "var(--colors--input-bg-read-only)",
    "variable": "var(--colors--input-bg-read-only)"
  },
  "colors.Input.border.active": {
    "value": "var(--colors--input-border-active)",
    "variable": "var(--colors--input-border-active)"
  },
  "colors.Input.border.activeHover": {
    "value": "var(--colors--input-border-active-hover)",
    "variable": "var(--colors--input-border-active-hover)"
  },
  "colors.Input.border.default": {
    "value": "var(--colors--input-border-default)",
    "variable": "var(--colors--input-border-default)"
  },
  "colors.Input.border.error": {
    "value": "var(--colors--input-border-error)",
    "variable": "var(--colors--input-border-error)"
  },
  "colors.Input.border.errorActive": {
    "value": "var(--colors--input-border-error-active)",
    "variable": "var(--colors--input-border-error-active)"
  },
  "colors.Input.border.errorHover": {
    "value": "var(--colors--input-border-error-hover)",
    "variable": "var(--colors--input-border-error-hover)"
  },
  "colors.Input.border.hover": {
    "value": "var(--colors--input-border-hover)",
    "variable": "var(--colors--input-border-hover)"
  },
  "colors.Input.icon.leading.default": {
    "value": "var(--colors--input-icon-leading-default)",
    "variable": "var(--colors--input-icon-leading-default)"
  },
  "colors.Input.icon.leading.readOnly": {
    "value": "var(--colors--input-icon-leading-read-only)",
    "variable": "var(--colors--input-icon-leading-read-only)"
  },
  "colors.Input.icon.trailing.default": {
    "value": "var(--colors--input-icon-trailing-default)",
    "variable": "var(--colors--input-icon-trailing-default)"
  },
  "colors.Input.icon.trailing.readOnly": {
    "value": "var(--colors--input-icon-trailing-read-only)",
    "variable": "var(--colors--input-icon-trailing-read-only)"
  },
  "colors.Input.text.adornment.default": {
    "value": "var(--colors--input-text-adornment-default)",
    "variable": "var(--colors--input-text-adornment-default)"
  },
  "colors.Input.text.adornment.readOnly": {
    "value": "var(--colors--input-text-adornment-read-only)",
    "variable": "var(--colors--input-text-adornment-read-only)"
  },
  "colors.Input.text.placeholder": {
    "value": "var(--colors--input-text-placeholder)",
    "variable": "var(--colors--input-text-placeholder)"
  },
  "colors.Input.text.populated": {
    "value": "var(--colors--input-text-populated)",
    "variable": "var(--colors--input-text-populated)"
  },
  "colors.Input.text.readOnly": {
    "value": "var(--colors--input-text-read-only)",
    "variable": "var(--colors--input-text-read-only)"
  },
  "colors.Input.LabelArea.indicator.optional": {
    "value": "var(--colors--input--label-area-indicator-optional)",
    "variable": "var(--colors--input--label-area-indicator-optional)"
  },
  "colors.Input.LabelArea.indicator.readOnly": {
    "value": "var(--colors--input--label-area-indicator-read-only)",
    "variable": "var(--colors--input--label-area-indicator-read-only)"
  },
  "colors.Input.LabelArea.indicator.required": {
    "value": "var(--colors--input--label-area-indicator-required)",
    "variable": "var(--colors--input--label-area-indicator-required)"
  },
  "colors.Input.LabelArea.label.default": {
    "value": "var(--colors--input--label-area-label-default)",
    "variable": "var(--colors--input--label-area-label-default)"
  },
  "colors.Input.LabelArea.label.readOnly": {
    "value": "var(--colors--input--label-area-label-read-only)",
    "variable": "var(--colors--input--label-area-label-read-only)"
  },
  "colors.Label.text.default": {
    "value": "var(--colors--label-text-default)",
    "variable": "var(--colors--label-text-default)"
  },
  "colors.Label.text.hover": {
    "value": "var(--colors--label-text-hover)",
    "variable": "var(--colors--label-text-hover)"
  },
  "colors.Label.text.pressed": {
    "value": "var(--colors--label-text-pressed)",
    "variable": "var(--colors--label-text-pressed)"
  },
  "colors.Label.text.selected": {
    "value": "var(--colors--label-text-selected)",
    "variable": "var(--colors--label-text-selected)"
  },
  "colors.Label.text.selectedHover": {
    "value": "var(--colors--label-text-selected-hover)",
    "variable": "var(--colors--label-text-selected-hover)"
  },
  "colors.Label.text.selectedPressed": {
    "value": "var(--colors--label-text-selected-pressed)",
    "variable": "var(--colors--label-text-selected-pressed)"
  },
  "colors.Label.indicator.required": {
    "value": "var(--colors--label-indicator-required)",
    "variable": "var(--colors--label-indicator-required)"
  },
  "colors.Label.indicator.optional": {
    "value": "var(--colors--label-indicator-optional)",
    "variable": "var(--colors--label-indicator-optional)"
  },
  "colors.Label.indicator.readOnly": {
    "value": "var(--colors--label-indicator-read-only)",
    "variable": "var(--colors--label-indicator-read-only)"
  },
  "colors.LabeledControl.label.default": {
    "value": "var(--colors--labeled-control-label-default)",
    "variable": "var(--colors--labeled-control-label-default)"
  },
  "colors.LabeledControl.label.hover": {
    "value": "var(--colors--labeled-control-label-hover)",
    "variable": "var(--colors--labeled-control-label-hover)"
  },
  "colors.LabeledControl.label.pressed": {
    "value": "var(--colors--labeled-control-label-pressed)",
    "variable": "var(--colors--labeled-control-label-pressed)"
  },
  "colors.LabeledControl.label.selected": {
    "value": "var(--colors--labeled-control-label-selected)",
    "variable": "var(--colors--labeled-control-label-selected)"
  },
  "colors.LabeledControl.label.selectedHover": {
    "value": "var(--colors--labeled-control-label-selected-hover)",
    "variable": "var(--colors--labeled-control-label-selected-hover)"
  },
  "colors.LabeledControl.label.selectedPressed": {
    "value": "var(--colors--labeled-control-label-selected-pressed)",
    "variable": "var(--colors--labeled-control-label-selected-pressed)"
  },
  "colors.Layout.Content.bg": {
    "value": "var(--colors--layout--content-bg)",
    "variable": "var(--colors--layout--content-bg)"
  },
  "colors.Legend.text.default": {
    "value": "var(--colors--legend-text-default)",
    "variable": "var(--colors--legend-text-default)"
  },
  "colors.Legend.indicator.required": {
    "value": "var(--colors--legend-indicator-required)",
    "variable": "var(--colors--legend-indicator-required)"
  },
  "colors.Legend.indicator.optional": {
    "value": "var(--colors--legend-indicator-optional)",
    "variable": "var(--colors--legend-indicator-optional)"
  },
  "colors.List.label": {
    "value": "var(--colors--list-label)",
    "variable": "var(--colors--list-label)"
  },
  "colors.List.ol-decorator": {
    "value": "var(--colors--list-ol-decorator)",
    "variable": "var(--colors--list-ol-decorator)"
  },
  "colors.List.ul-decorator": {
    "value": "var(--colors--list-ul-decorator)",
    "variable": "var(--colors--list-ul-decorator)"
  },
  "colors.LoadingMask.bg.default": {
    "value": "var(--colors--loading-mask-bg-default)",
    "variable": "var(--colors--loading-mask-bg-default)"
  },
  "colors.LoadingMask.bg.onImpact": {
    "value": "var(--colors--loading-mask-bg-on-impact)",
    "variable": "var(--colors--loading-mask-bg-on-impact)"
  },
  "colors.Menu.Heading.bg": {
    "value": "var(--colors--menu--heading-bg)",
    "variable": "var(--colors--menu--heading-bg)"
  },
  "colors.Menu.Heading.icon": {
    "value": "var(--colors--menu--heading-icon)",
    "variable": "var(--colors--menu--heading-icon)"
  },
  "colors.Menu.Heading.label": {
    "value": "var(--colors--menu--heading-label)",
    "variable": "var(--colors--menu--heading-label)"
  },
  "colors.Menu.Content.bg": {
    "value": "var(--colors--menu--content-bg)",
    "variable": "var(--colors--menu--content-bg)"
  },
  "colors.Menu.Group.border": {
    "value": "var(--colors--menu--group-border)",
    "variable": "var(--colors--menu--group-border)"
  },
  "colors.Menu.ItemIcon.icon.default": {
    "value": "var(--colors--menu--item-icon-icon-default)",
    "variable": "var(--colors--menu--item-icon-icon-default)"
  },
  "colors.Menu.ItemIcon.icon.hover": {
    "value": "var(--colors--menu--item-icon-icon-hover)",
    "variable": "var(--colors--menu--item-icon-icon-hover)"
  },
  "colors.Menu.ItemIcon.icon.pressed": {
    "value": "var(--colors--menu--item-icon-icon-pressed)",
    "variable": "var(--colors--menu--item-icon-icon-pressed)"
  },
  "colors.Menu.ItemIcon.anchor.icon.default": {
    "value": "var(--colors--menu--item-icon-anchor-icon-default)",
    "variable": "var(--colors--menu--item-icon-anchor-icon-default)"
  },
  "colors.Menu.ItemIcon.anchor.icon.hover": {
    "value": "var(--colors--menu--item-icon-anchor-icon-hover)",
    "variable": "var(--colors--menu--item-icon-anchor-icon-hover)"
  },
  "colors.Menu.ItemIcon.anchor.icon.pressed": {
    "value": "var(--colors--menu--item-icon-anchor-icon-pressed)",
    "variable": "var(--colors--menu--item-icon-anchor-icon-pressed)"
  },
  "colors.Menu.ItemLabel.text.label.default": {
    "value": "var(--colors--menu--item-label-text-label-default)",
    "variable": "var(--colors--menu--item-label-text-label-default)"
  },
  "colors.Menu.ItemLabel.text.label.hover": {
    "value": "var(--colors--menu--item-label-text-label-hover)",
    "variable": "var(--colors--menu--item-label-text-label-hover)"
  },
  "colors.Menu.ItemLabel.text.label.pressed": {
    "value": "var(--colors--menu--item-label-text-label-pressed)",
    "variable": "var(--colors--menu--item-label-text-label-pressed)"
  },
  "colors.Menu.ItemLabel.text.anchor.label.default": {
    "value": "var(--colors--menu--item-label-text-anchor-label-default)",
    "variable": "var(--colors--menu--item-label-text-anchor-label-default)"
  },
  "colors.Menu.ItemLabel.text.anchor.label.hover": {
    "value": "var(--colors--menu--item-label-text-anchor-label-hover)",
    "variable": "var(--colors--menu--item-label-text-anchor-label-hover)"
  },
  "colors.Menu.ItemLabel.text.anchor.label.pressed": {
    "value": "var(--colors--menu--item-label-text-anchor-label-pressed)",
    "variable": "var(--colors--menu--item-label-text-anchor-label-pressed)"
  },
  "colors.Menu.ItemMeta.text.meta.default": {
    "value": "var(--colors--menu--item-meta-text-meta-default)",
    "variable": "var(--colors--menu--item-meta-text-meta-default)"
  },
  "colors.Menu.ItemMeta.text.meta.hover": {
    "value": "var(--colors--menu--item-meta-text-meta-hover)",
    "variable": "var(--colors--menu--item-meta-text-meta-hover)"
  },
  "colors.Menu.ItemMeta.text.meta.pressed": {
    "value": "var(--colors--menu--item-meta-text-meta-pressed)",
    "variable": "var(--colors--menu--item-meta-text-meta-pressed)"
  },
  "colors.Menu.Item.bg.default": {
    "value": "var(--colors--menu--item-bg-default)",
    "variable": "var(--colors--menu--item-bg-default)"
  },
  "colors.Menu.Item.bg.hover": {
    "value": "var(--colors--menu--item-bg-hover)",
    "variable": "var(--colors--menu--item-bg-hover)"
  },
  "colors.Menu.Item.bg.pressed": {
    "value": "var(--colors--menu--item-bg-pressed)",
    "variable": "var(--colors--menu--item-bg-pressed)"
  },
  "colors.Modal.Backdrop.bg": {
    "value": "var(--colors--modal--backdrop-bg)",
    "variable": "var(--colors--modal--backdrop-bg)"
  },
  "colors.Modal.Content.bg": {
    "value": "var(--colors--modal--content-bg)",
    "variable": "var(--colors--modal--content-bg)"
  },
  "colors.Modal.Header.text": {
    "value": "var(--colors--modal--header-text)",
    "variable": "var(--colors--modal--header-text)"
  },
  "colors.NumberRating.icon": {
    "value": "var(--colors--number-rating-icon)",
    "variable": "var(--colors--number-rating-icon)"
  },
  "colors.NumberRating.text": {
    "value": "var(--colors--number-rating-text)",
    "variable": "var(--colors--number-rating-text)"
  },
  "colors.Page.bg": {
    "value": "var(--colors--page-bg)",
    "variable": "var(--colors--page-bg)"
  },
  "colors.Pagination.PageButton.bg.default": {
    "value": "var(--colors--pagination--page-button-bg-default)",
    "variable": "var(--colors--pagination--page-button-bg-default)"
  },
  "colors.Pagination.PageButton.bg.hover": {
    "value": "var(--colors--pagination--page-button-bg-hover)",
    "variable": "var(--colors--pagination--page-button-bg-hover)"
  },
  "colors.Pagination.PageButton.bg.pressed": {
    "value": "var(--colors--pagination--page-button-bg-pressed)",
    "variable": "var(--colors--pagination--page-button-bg-pressed)"
  },
  "colors.Pagination.PageButton.bg.active": {
    "value": "var(--colors--pagination--page-button-bg-active)",
    "variable": "var(--colors--pagination--page-button-bg-active)"
  },
  "colors.Pagination.PageButton.border.active": {
    "value": "var(--colors--pagination--page-button-border-active)",
    "variable": "var(--colors--pagination--page-button-border-active)"
  },
  "colors.Pagination.PageButton.label.default": {
    "value": "var(--colors--pagination--page-button-label-default)",
    "variable": "var(--colors--pagination--page-button-label-default)"
  },
  "colors.Pagination.PageButton.label.hover": {
    "value": "var(--colors--pagination--page-button-label-hover)",
    "variable": "var(--colors--pagination--page-button-label-hover)"
  },
  "colors.Pagination.PageButton.label.pressed": {
    "value": "var(--colors--pagination--page-button-label-pressed)",
    "variable": "var(--colors--pagination--page-button-label-pressed)"
  },
  "colors.Pagination.PageButton.label.active": {
    "value": "var(--colors--pagination--page-button-label-active)",
    "variable": "var(--colors--pagination--page-button-label-active)"
  },
  "colors.Pagination.Readout.colors": {
    "value": "var(--colors--pagination--readout-colors)",
    "variable": "var(--colors--pagination--readout-colors)"
  },
  "colors.PhotoCarousel.Dot.active": {
    "value": "var(--colors--photo-carousel--dot-active)",
    "variable": "var(--colors--photo-carousel--dot-active)"
  },
  "colors.PhotoCarousel.Dot.inactive": {
    "value": "var(--colors--photo-carousel--dot-inactive)",
    "variable": "var(--colors--photo-carousel--dot-inactive)"
  },
  "colors.PhotoCarousel.Dots.bg.default": {
    "value": "var(--colors--photo-carousel--dots-bg-default)",
    "variable": "var(--colors--photo-carousel--dots-bg-default)"
  },
  "colors.PhotoCarousel.Dots.bg.focus": {
    "value": "var(--colors--photo-carousel--dots-bg-focus)",
    "variable": "var(--colors--photo-carousel--dots-bg-focus)"
  },
  "colors.PhotoCarousel.NavControls.icon.default": {
    "value": "var(--colors--photo-carousel--nav-controls-icon-default)",
    "variable": "var(--colors--photo-carousel--nav-controls-icon-default)"
  },
  "colors.Popover.Backdrop.bg": {
    "value": "var(--colors--popover--backdrop-bg)",
    "variable": "var(--colors--popover--backdrop-bg)"
  },
  "colors.Popover.Content.bg": {
    "value": "var(--colors--popover--content-bg)",
    "variable": "var(--colors--popover--content-bg)"
  },
  "colors.Popover.Divider.bg.default": {
    "value": "var(--colors--popover--divider-bg-default)",
    "variable": "var(--colors--popover--divider-bg-default)"
  },
  "colors.Popover.Divider.bg.critical": {
    "value": "var(--colors--popover--divider-bg-critical)",
    "variable": "var(--colors--popover--divider-bg-critical)"
  },
  "colors.Popover.Divider.bg.success": {
    "value": "var(--colors--popover--divider-bg-success)",
    "variable": "var(--colors--popover--divider-bg-success)"
  },
  "colors.Popover.Divider.bg.info": {
    "value": "var(--colors--popover--divider-bg-info)",
    "variable": "var(--colors--popover--divider-bg-info)"
  },
  "colors.Popover.Divider.bg.warning": {
    "value": "var(--colors--popover--divider-bg-warning)",
    "variable": "var(--colors--popover--divider-bg-warning)"
  },
  "colors.Popover.Header.bg.default": {
    "value": "var(--colors--popover--header-bg-default)",
    "variable": "var(--colors--popover--header-bg-default)"
  },
  "colors.Popover.Header.bg.critical": {
    "value": "var(--colors--popover--header-bg-critical)",
    "variable": "var(--colors--popover--header-bg-critical)"
  },
  "colors.Popover.Header.bg.success": {
    "value": "var(--colors--popover--header-bg-success)",
    "variable": "var(--colors--popover--header-bg-success)"
  },
  "colors.Popover.Header.bg.info": {
    "value": "var(--colors--popover--header-bg-info)",
    "variable": "var(--colors--popover--header-bg-info)"
  },
  "colors.Popover.Header.bg.warning": {
    "value": "var(--colors--popover--header-bg-warning)",
    "variable": "var(--colors--popover--header-bg-warning)"
  },
  "colors.Popover.Header.text": {
    "value": "var(--colors--popover--header-text)",
    "variable": "var(--colors--popover--header-text)"
  },
  "colors.Popover.Header.icon.critical": {
    "value": "var(--colors--popover--header-icon-critical)",
    "variable": "var(--colors--popover--header-icon-critical)"
  },
  "colors.Popover.Header.icon.success": {
    "value": "var(--colors--popover--header-icon-success)",
    "variable": "var(--colors--popover--header-icon-success)"
  },
  "colors.Popover.Header.icon.info": {
    "value": "var(--colors--popover--header-icon-info)",
    "variable": "var(--colors--popover--header-icon-info)"
  },
  "colors.Popover.Header.icon.warning": {
    "value": "var(--colors--popover--header-icon-warning)",
    "variable": "var(--colors--popover--header-icon-warning)"
  },
  "colors.ProgressIndicator.spinner.icon.default": {
    "value": "var(--colors--progress-indicator-spinner-icon-default)",
    "variable": "var(--colors--progress-indicator-spinner-icon-default)"
  },
  "colors.ProgressIndicator.spinner.icon.onImpact": {
    "value": "var(--colors--progress-indicator-spinner-icon-on-impact)",
    "variable": "var(--colors--progress-indicator-spinner-icon-on-impact)"
  },
  "colors.ProgressIndicator.bar.track.bg.default": {
    "value": "var(--colors--progress-indicator-bar-track-bg-default)",
    "variable": "var(--colors--progress-indicator-bar-track-bg-default)"
  },
  "colors.ProgressIndicator.bar.track.bg.active": {
    "value": "var(--colors--progress-indicator-bar-track-bg-active)",
    "variable": "var(--colors--progress-indicator-bar-track-bg-active)"
  },
  "colors.ProgressIndicator.bar.track.bg.complete": {
    "value": "var(--colors--progress-indicator-bar-track-bg-complete)",
    "variable": "var(--colors--progress-indicator-bar-track-bg-complete)"
  },
  "colors.ProgressIndicator.bar.text.helper": {
    "value": "var(--colors--progress-indicator-bar-text-helper)",
    "variable": "var(--colors--progress-indicator-bar-text-helper)"
  },
  "colors.ProgressIndicator.bar.text.label": {
    "value": "var(--colors--progress-indicator-bar-text-label)",
    "variable": "var(--colors--progress-indicator-bar-text-label)"
  },
  "colors.ProgressMeter.Label.metaText": {
    "value": "var(--colors--progress-meter--label-meta-text)",
    "variable": "var(--colors--progress-meter--label-meta-text)"
  },
  "colors.ProgressMeter.Label.interactive.default": {
    "value": "var(--colors--progress-meter--label-interactive-default)",
    "variable": "var(--colors--progress-meter--label-interactive-default)"
  },
  "colors.ProgressMeter.Label.interactive.hover": {
    "value": "var(--colors--progress-meter--label-interactive-hover)",
    "variable": "var(--colors--progress-meter--label-interactive-hover)"
  },
  "colors.ProgressMeter.Label.interactive.pressed": {
    "value": "var(--colors--progress-meter--label-interactive-pressed)",
    "variable": "var(--colors--progress-meter--label-interactive-pressed)"
  },
  "colors.ProgressMeter.Label.interactive.activeDefault": {
    "value": "var(--colors--progress-meter--label-interactive-active-default)",
    "variable": "var(--colors--progress-meter--label-interactive-active-default)"
  },
  "colors.ProgressMeter.Label.interactive.activeHover": {
    "value": "var(--colors--progress-meter--label-interactive-active-hover)",
    "variable": "var(--colors--progress-meter--label-interactive-active-hover)"
  },
  "colors.ProgressMeter.Label.interactive.activePressed": {
    "value": "var(--colors--progress-meter--label-interactive-active-pressed)",
    "variable": "var(--colors--progress-meter--label-interactive-active-pressed)"
  },
  "colors.ProgressMeter.Label.static.active": {
    "value": "var(--colors--progress-meter--label-static-active)",
    "variable": "var(--colors--progress-meter--label-static-active)"
  },
  "colors.ProgressMeter.Label.static.complete": {
    "value": "var(--colors--progress-meter--label-static-complete)",
    "variable": "var(--colors--progress-meter--label-static-complete)"
  },
  "colors.ProgressMeter.Label.static.error": {
    "value": "var(--colors--progress-meter--label-static-error)",
    "variable": "var(--colors--progress-meter--label-static-error)"
  },
  "colors.ProgressMeter.Label.static.incomplete": {
    "value": "var(--colors--progress-meter--label-static-incomplete)",
    "variable": "var(--colors--progress-meter--label-static-incomplete)"
  },
  "colors.ProgressMeter.Label.static.notStarted": {
    "value": "var(--colors--progress-meter--label-static-not-started)",
    "variable": "var(--colors--progress-meter--label-static-not-started)"
  },
  "colors.ProgressMeter.Label.static.success": {
    "value": "var(--colors--progress-meter--label-static-success)",
    "variable": "var(--colors--progress-meter--label-static-success)"
  },
  "colors.ProgressMeter.Label.static.warning": {
    "value": "var(--colors--progress-meter--label-static-warning)",
    "variable": "var(--colors--progress-meter--label-static-warning)"
  },
  "colors.ProgressMeter.Node.active.bg": {
    "value": "var(--colors--progress-meter--node-active-bg)",
    "variable": "var(--colors--progress-meter--node-active-bg)"
  },
  "colors.ProgressMeter.Node.active.border": {
    "value": "var(--colors--progress-meter--node-active-border)",
    "variable": "var(--colors--progress-meter--node-active-border)"
  },
  "colors.ProgressMeter.Node.active.icon": {
    "value": "var(--colors--progress-meter--node-active-icon)",
    "variable": "var(--colors--progress-meter--node-active-icon)"
  },
  "colors.ProgressMeter.Node.complete.bg": {
    "value": "var(--colors--progress-meter--node-complete-bg)",
    "variable": "var(--colors--progress-meter--node-complete-bg)"
  },
  "colors.ProgressMeter.Node.complete.icon": {
    "value": "var(--colors--progress-meter--node-complete-icon)",
    "variable": "var(--colors--progress-meter--node-complete-icon)"
  },
  "colors.ProgressMeter.Node.error.bg": {
    "value": "var(--colors--progress-meter--node-error-bg)",
    "variable": "var(--colors--progress-meter--node-error-bg)"
  },
  "colors.ProgressMeter.Node.error.icon": {
    "value": "var(--colors--progress-meter--node-error-icon)",
    "variable": "var(--colors--progress-meter--node-error-icon)"
  },
  "colors.ProgressMeter.Node.focusRing.bg": {
    "value": "var(--colors--progress-meter--node-focus-ring-bg)",
    "variable": "var(--colors--progress-meter--node-focus-ring-bg)"
  },
  "colors.ProgressMeter.Node.inactive.icon": {
    "value": "var(--colors--progress-meter--node-inactive-icon)",
    "variable": "var(--colors--progress-meter--node-inactive-icon)"
  },
  "colors.ProgressMeter.Node.incomplete.bg": {
    "value": "var(--colors--progress-meter--node-incomplete-bg)",
    "variable": "var(--colors--progress-meter--node-incomplete-bg)"
  },
  "colors.ProgressMeter.Node.incomplete.icon": {
    "value": "var(--colors--progress-meter--node-incomplete-icon)",
    "variable": "var(--colors--progress-meter--node-incomplete-icon)"
  },
  "colors.ProgressMeter.Node.success.bg": {
    "value": "var(--colors--progress-meter--node-success-bg)",
    "variable": "var(--colors--progress-meter--node-success-bg)"
  },
  "colors.ProgressMeter.Node.success.icon": {
    "value": "var(--colors--progress-meter--node-success-icon)",
    "variable": "var(--colors--progress-meter--node-success-icon)"
  },
  "colors.ProgressMeter.Node.warning.bg": {
    "value": "var(--colors--progress-meter--node-warning-bg)",
    "variable": "var(--colors--progress-meter--node-warning-bg)"
  },
  "colors.ProgressMeter.Node.warning.icon": {
    "value": "var(--colors--progress-meter--node-warning-icon)",
    "variable": "var(--colors--progress-meter--node-warning-icon)"
  },
  "colors.ProgressMeter.Track.active": {
    "value": "var(--colors--progress-meter--track-active)",
    "variable": "var(--colors--progress-meter--track-active)"
  },
  "colors.ProgressMeter.Track.default": {
    "value": "var(--colors--progress-meter--track-default)",
    "variable": "var(--colors--progress-meter--track-default)"
  },
  "colors.PropertyCard.PhotoFallback.bg": {
    "value": "var(--colors--property-card--photo-fallback-bg)",
    "variable": "var(--colors--property-card--photo-fallback-bg)"
  },
  "colors.PropertyCard.PhotoFallback.icon": {
    "value": "var(--colors--property-card--photo-fallback-icon)",
    "variable": "var(--colors--property-card--photo-fallback-icon)"
  },
  "colors.PropertyCard.Badge.brand.bg": {
    "value": "var(--colors--property-card--badge-brand-bg)",
    "variable": "var(--colors--property-card--badge-brand-bg)"
  },
  "colors.PropertyCard.Badge.brand.icon": {
    "value": "var(--colors--property-card--badge-brand-icon)",
    "variable": "var(--colors--property-card--badge-brand-icon)"
  },
  "colors.PropertyCard.Badge.brand.label": {
    "value": "var(--colors--property-card--badge-brand-label)",
    "variable": "var(--colors--property-card--badge-brand-label)"
  },
  "colors.PropertyCard.Badge.flex.bg": {
    "value": "var(--colors--property-card--badge-flex-bg)",
    "variable": "var(--colors--property-card--badge-flex-bg)"
  },
  "colors.PropertyCard.Badge.flex.icon": {
    "value": "var(--colors--property-card--badge-flex-icon)",
    "variable": "var(--colors--property-card--badge-flex-icon)"
  },
  "colors.PropertyCard.Badge.flex.label": {
    "value": "var(--colors--property-card--badge-flex-label)",
    "variable": "var(--colors--property-card--badge-flex-label)"
  },
  "colors.PropertyCard.Badge.neutral.bg": {
    "value": "var(--colors--property-card--badge-neutral-bg)",
    "variable": "var(--colors--property-card--badge-neutral-bg)"
  },
  "colors.PropertyCard.Badge.neutral.icon": {
    "value": "var(--colors--property-card--badge-neutral-icon)",
    "variable": "var(--colors--property-card--badge-neutral-icon)"
  },
  "colors.PropertyCard.Badge.neutral.label": {
    "value": "var(--colors--property-card--badge-neutral-label)",
    "variable": "var(--colors--property-card--badge-neutral-label)"
  },
  "colors.PropertyCard.Badge.notify.bg": {
    "value": "var(--colors--property-card--badge-notify-bg)",
    "variable": "var(--colors--property-card--badge-notify-bg)"
  },
  "colors.PropertyCard.Badge.notify.icon": {
    "value": "var(--colors--property-card--badge-notify-icon)",
    "variable": "var(--colors--property-card--badge-notify-icon)"
  },
  "colors.PropertyCard.Badge.notify.label": {
    "value": "var(--colors--property-card--badge-notify-label)",
    "variable": "var(--colors--property-card--badge-notify-label)"
  },
  "colors.PropertyCard.Badge.buyAbility.bg": {
    "value": "var(--colors--property-card--badge-buy-ability-bg)",
    "variable": "var(--colors--property-card--badge-buy-ability-bg)"
  },
  "colors.PropertyCard.Badge.buyAbility.icon": {
    "value": "var(--colors--property-card--badge-buy-ability-icon)",
    "variable": "var(--colors--property-card--badge-buy-ability-icon)"
  },
  "colors.PropertyCard.Badge.buyAbility.label": {
    "value": "var(--colors--property-card--badge-buy-ability-label)",
    "variable": "var(--colors--property-card--badge-buy-ability-label)"
  },
  "colors.PropertyCard.Body.bg.default": {
    "value": "var(--colors--property-card--body-bg-default)",
    "variable": "var(--colors--property-card--body-bg-default)"
  },
  "colors.PropertyCard.Body.bg.hover": {
    "value": "var(--colors--property-card--body-bg-hover)",
    "variable": "var(--colors--property-card--body-bg-hover)"
  },
  "colors.PropertyCard.Body.bg.pressed": {
    "value": "var(--colors--property-card--body-bg-pressed)",
    "variable": "var(--colors--property-card--body-bg-pressed)"
  },
  "colors.PropertyCard.DataArea.text.info": {
    "value": "var(--colors--property-card--data-area-text-info)",
    "variable": "var(--colors--property-card--data-area-text-info)"
  },
  "colors.PropertyCard.DataArea.text.fineprint": {
    "value": "var(--colors--property-card--data-area-text-fineprint)",
    "variable": "var(--colors--property-card--data-area-text-fineprint)"
  },
  "colors.PropertyCard.DataArea.text.dataDivider": {
    "value": "var(--colors--property-card--data-area-text-data-divider)",
    "variable": "var(--colors--property-card--data-area-text-data-divider)"
  },
  "colors.PropertyCard.Root.loading.bg": {
    "value": "var(--colors--property-card--root-loading-bg)",
    "variable": "var(--colors--property-card--root-loading-bg)"
  },
  "colors.PropertyCard.Root.loading.shimmer": {
    "value": "var(--colors--property-card--root-loading-shimmer)",
    "variable": "var(--colors--property-card--root-loading-shimmer)"
  },
  "colors.PropertyCard.SaveButton.bg.default": {
    "value": "var(--colors--property-card--save-button-bg-default)",
    "variable": "var(--colors--property-card--save-button-bg-default)"
  },
  "colors.PropertyCard.SaveButton.bg.hover": {
    "value": "var(--colors--property-card--save-button-bg-hover)",
    "variable": "var(--colors--property-card--save-button-bg-hover)"
  },
  "colors.PropertyCard.SaveButton.bg.pressed": {
    "value": "var(--colors--property-card--save-button-bg-pressed)",
    "variable": "var(--colors--property-card--save-button-bg-pressed)"
  },
  "colors.PropertyCard.SaveButton.bg.selected": {
    "value": "var(--colors--property-card--save-button-bg-selected)",
    "variable": "var(--colors--property-card--save-button-bg-selected)"
  },
  "colors.PropertyCard.SaveButton.bg.selectedHover": {
    "value": "var(--colors--property-card--save-button-bg-selected-hover)",
    "variable": "var(--colors--property-card--save-button-bg-selected-hover)"
  },
  "colors.PropertyCard.SaveButton.bg.selectedPressed": {
    "value": "var(--colors--property-card--save-button-bg-selected-pressed)",
    "variable": "var(--colors--property-card--save-button-bg-selected-pressed)"
  },
  "colors.PropertyCard.SaveButton.border.default": {
    "value": "var(--colors--property-card--save-button-border-default)",
    "variable": "var(--colors--property-card--save-button-border-default)"
  },
  "colors.PropertyCard.SaveButton.border.hover": {
    "value": "var(--colors--property-card--save-button-border-hover)",
    "variable": "var(--colors--property-card--save-button-border-hover)"
  },
  "colors.PropertyCard.SaveButton.border.pressed": {
    "value": "var(--colors--property-card--save-button-border-pressed)",
    "variable": "var(--colors--property-card--save-button-border-pressed)"
  },
  "colors.PropertyCard.SaveButton.border.selected": {
    "value": "var(--colors--property-card--save-button-border-selected)",
    "variable": "var(--colors--property-card--save-button-border-selected)"
  },
  "colors.PropertyCard.SaveButton.border.selectedHover": {
    "value": "var(--colors--property-card--save-button-border-selected-hover)",
    "variable": "var(--colors--property-card--save-button-border-selected-hover)"
  },
  "colors.PropertyCard.SaveButton.border.selectedPressed": {
    "value": "var(--colors--property-card--save-button-border-selected-pressed)",
    "variable": "var(--colors--property-card--save-button-border-selected-pressed)"
  },
  "colors.Radio.bg.default": {
    "value": "var(--colors--radio-bg-default)",
    "variable": "var(--colors--radio-bg-default)"
  },
  "colors.Radio.bg.hover": {
    "value": "var(--colors--radio-bg-hover)",
    "variable": "var(--colors--radio-bg-hover)"
  },
  "colors.Radio.bg.pressed": {
    "value": "var(--colors--radio-bg-pressed)",
    "variable": "var(--colors--radio-bg-pressed)"
  },
  "colors.Radio.bg.selected": {
    "value": "var(--colors--radio-bg-selected)",
    "variable": "var(--colors--radio-bg-selected)"
  },
  "colors.Radio.bg.selectedHover": {
    "value": "var(--colors--radio-bg-selected-hover)",
    "variable": "var(--colors--radio-bg-selected-hover)"
  },
  "colors.Radio.bg.selectedPressed": {
    "value": "var(--colors--radio-bg-selected-pressed)",
    "variable": "var(--colors--radio-bg-selected-pressed)"
  },
  "colors.Radio.border.default": {
    "value": "var(--colors--radio-border-default)",
    "variable": "var(--colors--radio-border-default)"
  },
  "colors.Radio.border.hover": {
    "value": "var(--colors--radio-border-hover)",
    "variable": "var(--colors--radio-border-hover)"
  },
  "colors.Radio.border.pressed": {
    "value": "var(--colors--radio-border-pressed)",
    "variable": "var(--colors--radio-border-pressed)"
  },
  "colors.Radio.border.selected": {
    "value": "var(--colors--radio-border-selected)",
    "variable": "var(--colors--radio-border-selected)"
  },
  "colors.Radio.border.selectedHover": {
    "value": "var(--colors--radio-border-selected-hover)",
    "variable": "var(--colors--radio-border-selected-hover)"
  },
  "colors.Radio.border.selectedPressed": {
    "value": "var(--colors--radio-border-selected-pressed)",
    "variable": "var(--colors--radio-border-selected-pressed)"
  },
  "colors.Range.Track.bg.default": {
    "value": "var(--colors--range--track-bg-default)",
    "variable": "var(--colors--range--track-bg-default)"
  },
  "colors.Range.Handle.bg.default": {
    "value": "var(--colors--range--handle-bg-default)",
    "variable": "var(--colors--range--handle-bg-default)"
  },
  "colors.Range.Handle.bg.hover": {
    "value": "var(--colors--range--handle-bg-hover)",
    "variable": "var(--colors--range--handle-bg-hover)"
  },
  "colors.Range.Handle.bg.pressed": {
    "value": "var(--colors--range--handle-bg-pressed)",
    "variable": "var(--colors--range--handle-bg-pressed)"
  },
  "colors.Range.Handle.bg.active": {
    "value": "var(--colors--range--handle-bg-active)",
    "variable": "var(--colors--range--handle-bg-active)"
  },
  "colors.Range.Handle.bg.activeHover": {
    "value": "var(--colors--range--handle-bg-active-hover)",
    "variable": "var(--colors--range--handle-bg-active-hover)"
  },
  "colors.Range.Handle.border.default": {
    "value": "var(--colors--range--handle-border-default)",
    "variable": "var(--colors--range--handle-border-default)"
  },
  "colors.Range.Handle.border.hover": {
    "value": "var(--colors--range--handle-border-hover)",
    "variable": "var(--colors--range--handle-border-hover)"
  },
  "colors.Range.Handle.border.active": {
    "value": "var(--colors--range--handle-border-active)",
    "variable": "var(--colors--range--handle-border-active)"
  },
  "colors.Range.Handle.border.pressed": {
    "value": "var(--colors--range--handle-border-pressed)",
    "variable": "var(--colors--range--handle-border-pressed)"
  },
  "colors.Range.Handle.border.activeHover": {
    "value": "var(--colors--range--handle-border-active-hover)",
    "variable": "var(--colors--range--handle-border-active-hover)"
  },
  "colors.RatingStars.icon.empty": {
    "value": "var(--colors--rating-stars-icon-empty)",
    "variable": "var(--colors--rating-stars-icon-empty)"
  },
  "colors.RatingStars.icon.filled": {
    "value": "var(--colors--rating-stars-icon-filled)",
    "variable": "var(--colors--rating-stars-icon-filled)"
  },
  "colors.RatingStars.text.empty": {
    "value": "var(--colors--rating-stars-text-empty)",
    "variable": "var(--colors--rating-stars-text-empty)"
  },
  "colors.RatingStars.text.filled": {
    "value": "var(--colors--rating-stars-text-filled)",
    "variable": "var(--colors--rating-stars-text-filled)"
  },
  "colors.ShowHide.icon.default": {
    "value": "var(--colors--show-hide-icon-default)",
    "variable": "var(--colors--show-hide-icon-default)"
  },
  "colors.ShowHide.icon.hover": {
    "value": "var(--colors--show-hide-icon-hover)",
    "variable": "var(--colors--show-hide-icon-hover)"
  },
  "colors.ShowHide.icon.pressed": {
    "value": "var(--colors--show-hide-icon-pressed)",
    "variable": "var(--colors--show-hide-icon-pressed)"
  },
  "colors.ShowHide.label.default": {
    "value": "var(--colors--show-hide-label-default)",
    "variable": "var(--colors--show-hide-label-default)"
  },
  "colors.ShowHide.label.hover": {
    "value": "var(--colors--show-hide-label-hover)",
    "variable": "var(--colors--show-hide-label-hover)"
  },
  "colors.ShowHide.label.pressed": {
    "value": "var(--colors--show-hide-label-pressed)",
    "variable": "var(--colors--show-hide-label-pressed)"
  },
  "colors.Slider.Track.bg.default": {
    "value": "var(--colors--slider--track-bg-default)",
    "variable": "var(--colors--slider--track-bg-default)"
  },
  "colors.Slider.Track.bg.active": {
    "value": "var(--colors--slider--track-bg-active)",
    "variable": "var(--colors--slider--track-bg-active)"
  },
  "colors.Slider.Handle.bg.default": {
    "value": "var(--colors--slider--handle-bg-default)",
    "variable": "var(--colors--slider--handle-bg-default)"
  },
  "colors.Slider.Handle.bg.hover": {
    "value": "var(--colors--slider--handle-bg-hover)",
    "variable": "var(--colors--slider--handle-bg-hover)"
  },
  "colors.Slider.Handle.bg.pressed": {
    "value": "var(--colors--slider--handle-bg-pressed)",
    "variable": "var(--colors--slider--handle-bg-pressed)"
  },
  "colors.Slider.Handle.bg.active": {
    "value": "var(--colors--slider--handle-bg-active)",
    "variable": "var(--colors--slider--handle-bg-active)"
  },
  "colors.Slider.Handle.bg.activeHover": {
    "value": "var(--colors--slider--handle-bg-active-hover)",
    "variable": "var(--colors--slider--handle-bg-active-hover)"
  },
  "colors.Slider.Handle.bg.activePressed": {
    "value": "var(--colors--slider--handle-bg-active-pressed)",
    "variable": "var(--colors--slider--handle-bg-active-pressed)"
  },
  "colors.Slider.Handle.border.default": {
    "value": "var(--colors--slider--handle-border-default)",
    "variable": "var(--colors--slider--handle-border-default)"
  },
  "colors.Slider.Handle.border.hover": {
    "value": "var(--colors--slider--handle-border-hover)",
    "variable": "var(--colors--slider--handle-border-hover)"
  },
  "colors.Slider.Handle.border.active": {
    "value": "var(--colors--slider--handle-border-active)",
    "variable": "var(--colors--slider--handle-border-active)"
  },
  "colors.Slider.Handle.border.pressed": {
    "value": "var(--colors--slider--handle-border-pressed)",
    "variable": "var(--colors--slider--handle-border-pressed)"
  },
  "colors.Slider.Handle.border.activeHover": {
    "value": "var(--colors--slider--handle-border-active-hover)",
    "variable": "var(--colors--slider--handle-border-active-hover)"
  },
  "colors.Slider.Handle.border.activePressed": {
    "value": "var(--colors--slider--handle-border-active-pressed)",
    "variable": "var(--colors--slider--handle-border-active-pressed)"
  },
  "colors.Switch.Track.bg.default": {
    "value": "var(--colors--switch--track-bg-default)",
    "variable": "var(--colors--switch--track-bg-default)"
  },
  "colors.Switch.Track.bg.hover": {
    "value": "var(--colors--switch--track-bg-hover)",
    "variable": "var(--colors--switch--track-bg-hover)"
  },
  "colors.Switch.Track.bg.pressed": {
    "value": "var(--colors--switch--track-bg-pressed)",
    "variable": "var(--colors--switch--track-bg-pressed)"
  },
  "colors.Switch.Track.bg.selected": {
    "value": "var(--colors--switch--track-bg-selected)",
    "variable": "var(--colors--switch--track-bg-selected)"
  },
  "colors.Switch.Track.bg.selectedHover": {
    "value": "var(--colors--switch--track-bg-selected-hover)",
    "variable": "var(--colors--switch--track-bg-selected-hover)"
  },
  "colors.Switch.Track.bg.selectedPressed": {
    "value": "var(--colors--switch--track-bg-selected-pressed)",
    "variable": "var(--colors--switch--track-bg-selected-pressed)"
  },
  "colors.Switch.Handle.default": {
    "value": "var(--colors--switch--handle-default)",
    "variable": "var(--colors--switch--handle-default)"
  },
  "colors.Switch.Handle.hover": {
    "value": "var(--colors--switch--handle-hover)",
    "variable": "var(--colors--switch--handle-hover)"
  },
  "colors.Switch.Handle.pressed": {
    "value": "var(--colors--switch--handle-pressed)",
    "variable": "var(--colors--switch--handle-pressed)"
  },
  "colors.Switch.Handle.selected": {
    "value": "var(--colors--switch--handle-selected)",
    "variable": "var(--colors--switch--handle-selected)"
  },
  "colors.Switch.Handle.selectedHover": {
    "value": "var(--colors--switch--handle-selected-hover)",
    "variable": "var(--colors--switch--handle-selected-hover)"
  },
  "colors.Switch.Handle.selectedPressed": {
    "value": "var(--colors--switch--handle-selected-pressed)",
    "variable": "var(--colors--switch--handle-selected-pressed)"
  },
  "colors.Table.Cell.border": {
    "value": "var(--colors--table--cell-border)",
    "variable": "var(--colors--table--cell-border)"
  },
  "colors.Table.Cell.bg.default": {
    "value": "var(--colors--table--cell-bg-default)",
    "variable": "var(--colors--table--cell-bg-default)"
  },
  "colors.Table.Cell.bg.hover": {
    "value": "var(--colors--table--cell-bg-hover)",
    "variable": "var(--colors--table--cell-bg-hover)"
  },
  "colors.Table.Cell.bg.pressed": {
    "value": "var(--colors--table--cell-bg-pressed)",
    "variable": "var(--colors--table--cell-bg-pressed)"
  },
  "colors.Table.Cell.bg.selected": {
    "value": "var(--colors--table--cell-bg-selected)",
    "variable": "var(--colors--table--cell-bg-selected)"
  },
  "colors.Table.Cell.bg.zebra": {
    "value": "var(--colors--table--cell-bg-zebra)",
    "variable": "var(--colors--table--cell-bg-zebra)"
  },
  "colors.Table.Cell.text.default": {
    "value": "var(--colors--table--cell-text-default)",
    "variable": "var(--colors--table--cell-text-default)"
  },
  "colors.Table.Cell.text.hover": {
    "value": "var(--colors--table--cell-text-hover)",
    "variable": "var(--colors--table--cell-text-hover)"
  },
  "colors.Table.Cell.text.pressed": {
    "value": "var(--colors--table--cell-text-pressed)",
    "variable": "var(--colors--table--cell-text-pressed)"
  },
  "colors.Table.Cell.text.selected": {
    "value": "var(--colors--table--cell-text-selected)",
    "variable": "var(--colors--table--cell-text-selected)"
  },
  "colors.Table.SortIcon.icon.default": {
    "value": "var(--colors--table--sort-icon-icon-default)",
    "variable": "var(--colors--table--sort-icon-icon-default)"
  },
  "colors.Table.SortIcon.icon.hover": {
    "value": "var(--colors--table--sort-icon-icon-hover)",
    "variable": "var(--colors--table--sort-icon-icon-hover)"
  },
  "colors.Table.SortIcon.icon.pressed": {
    "value": "var(--colors--table--sort-icon-icon-pressed)",
    "variable": "var(--colors--table--sort-icon-icon-pressed)"
  },
  "colors.Table.SortIcon.icon.selected": {
    "value": "var(--colors--table--sort-icon-icon-selected)",
    "variable": "var(--colors--table--sort-icon-icon-selected)"
  },
  "colors.Tabs.default.bg.tab.default": {
    "value": "var(--colors--tabs-default-bg-tab-default)",
    "variable": "var(--colors--tabs-default-bg-tab-default)"
  },
  "colors.Tabs.default.bg.tab.hover": {
    "value": "var(--colors--tabs-default-bg-tab-hover)",
    "variable": "var(--colors--tabs-default-bg-tab-hover)"
  },
  "colors.Tabs.default.bg.tab.pressed": {
    "value": "var(--colors--tabs-default-bg-tab-pressed)",
    "variable": "var(--colors--tabs-default-bg-tab-pressed)"
  },
  "colors.Tabs.default.bg.tab.active": {
    "value": "var(--colors--tabs-default-bg-tab-active)",
    "variable": "var(--colors--tabs-default-bg-tab-active)"
  },
  "colors.Tabs.default.bg.indicator.default": {
    "value": "var(--colors--tabs-default-bg-indicator-default)",
    "variable": "var(--colors--tabs-default-bg-indicator-default)"
  },
  "colors.Tabs.default.bg.indicator.hover": {
    "value": "var(--colors--tabs-default-bg-indicator-hover)",
    "variable": "var(--colors--tabs-default-bg-indicator-hover)"
  },
  "colors.Tabs.default.bg.indicator.pressed": {
    "value": "var(--colors--tabs-default-bg-indicator-pressed)",
    "variable": "var(--colors--tabs-default-bg-indicator-pressed)"
  },
  "colors.Tabs.default.bg.indicator.active": {
    "value": "var(--colors--tabs-default-bg-indicator-active)",
    "variable": "var(--colors--tabs-default-bg-indicator-active)"
  },
  "colors.Tabs.default.bg.panel": {
    "value": "var(--colors--tabs-default-bg-panel)",
    "variable": "var(--colors--tabs-default-bg-panel)"
  },
  "colors.Tabs.default.label.default": {
    "value": "var(--colors--tabs-default-label-default)",
    "variable": "var(--colors--tabs-default-label-default)"
  },
  "colors.Tabs.default.label.hover": {
    "value": "var(--colors--tabs-default-label-hover)",
    "variable": "var(--colors--tabs-default-label-hover)"
  },
  "colors.Tabs.default.label.pressed": {
    "value": "var(--colors--tabs-default-label-pressed)",
    "variable": "var(--colors--tabs-default-label-pressed)"
  },
  "colors.Tabs.default.label.active": {
    "value": "var(--colors--tabs-default-label-active)",
    "variable": "var(--colors--tabs-default-label-active)"
  },
  "colors.Tabs.default.label.selected.default": {
    "value": "var(--colors--tabs-default-label-selected-default)",
    "variable": "var(--colors--tabs-default-label-selected-default)"
  },
  "colors.Tabs.default.label.selected.pressed": {
    "value": "var(--colors--tabs-default-label-selected-pressed)",
    "variable": "var(--colors--tabs-default-label-selected-pressed)"
  },
  "colors.Tabs.default.border.track": {
    "value": "var(--colors--tabs-default-border-track)",
    "variable": "var(--colors--tabs-default-border-track)"
  },
  "colors.Tabs.default.border.tab.default": {
    "value": "var(--colors--tabs-default-border-tab-default)",
    "variable": "var(--colors--tabs-default-border-tab-default)"
  },
  "colors.Tabs.default.border.tab.hover": {
    "value": "var(--colors--tabs-default-border-tab-hover)",
    "variable": "var(--colors--tabs-default-border-tab-hover)"
  },
  "colors.Tabs.default.border.tab.pressed": {
    "value": "var(--colors--tabs-default-border-tab-pressed)",
    "variable": "var(--colors--tabs-default-border-tab-pressed)"
  },
  "colors.Tabs.default.border.tab.active": {
    "value": "var(--colors--tabs-default-border-tab-active)",
    "variable": "var(--colors--tabs-default-border-tab-active)"
  },
  "colors.Tabs.default.icon.default": {
    "value": "var(--colors--tabs-default-icon-default)",
    "variable": "var(--colors--tabs-default-icon-default)"
  },
  "colors.Tabs.default.icon.hover": {
    "value": "var(--colors--tabs-default-icon-hover)",
    "variable": "var(--colors--tabs-default-icon-hover)"
  },
  "colors.Tabs.default.icon.pressed": {
    "value": "var(--colors--tabs-default-icon-pressed)",
    "variable": "var(--colors--tabs-default-icon-pressed)"
  },
  "colors.Tabs.default.icon.active": {
    "value": "var(--colors--tabs-default-icon-active)",
    "variable": "var(--colors--tabs-default-icon-active)"
  },
  "colors.Tabs.file.bg.tab.default": {
    "value": "var(--colors--tabs-file-bg-tab-default)",
    "variable": "var(--colors--tabs-file-bg-tab-default)"
  },
  "colors.Tabs.file.bg.tab.hover": {
    "value": "var(--colors--tabs-file-bg-tab-hover)",
    "variable": "var(--colors--tabs-file-bg-tab-hover)"
  },
  "colors.Tabs.file.bg.tab.pressed": {
    "value": "var(--colors--tabs-file-bg-tab-pressed)",
    "variable": "var(--colors--tabs-file-bg-tab-pressed)"
  },
  "colors.Tabs.file.bg.tab.active": {
    "value": "var(--colors--tabs-file-bg-tab-active)",
    "variable": "var(--colors--tabs-file-bg-tab-active)"
  },
  "colors.Tabs.file.bg.indicator.default": {
    "value": "var(--colors--tabs-file-bg-indicator-default)",
    "variable": "var(--colors--tabs-file-bg-indicator-default)"
  },
  "colors.Tabs.file.bg.indicator.hover": {
    "value": "var(--colors--tabs-file-bg-indicator-hover)",
    "variable": "var(--colors--tabs-file-bg-indicator-hover)"
  },
  "colors.Tabs.file.bg.indicator.pressed": {
    "value": "var(--colors--tabs-file-bg-indicator-pressed)",
    "variable": "var(--colors--tabs-file-bg-indicator-pressed)"
  },
  "colors.Tabs.file.bg.indicator.active": {
    "value": "var(--colors--tabs-file-bg-indicator-active)",
    "variable": "var(--colors--tabs-file-bg-indicator-active)"
  },
  "colors.Tabs.file.bg.panel": {
    "value": "var(--colors--tabs-file-bg-panel)",
    "variable": "var(--colors--tabs-file-bg-panel)"
  },
  "colors.Tabs.file.border.default": {
    "value": "var(--colors--tabs-file-border-default)",
    "variable": "var(--colors--tabs-file-border-default)"
  },
  "colors.Tabs.file.border.hover": {
    "value": "var(--colors--tabs-file-border-hover)",
    "variable": "var(--colors--tabs-file-border-hover)"
  },
  "colors.Tabs.file.border.pressed": {
    "value": "var(--colors--tabs-file-border-pressed)",
    "variable": "var(--colors--tabs-file-border-pressed)"
  },
  "colors.Tabs.file.border.active": {
    "value": "var(--colors--tabs-file-border-active)",
    "variable": "var(--colors--tabs-file-border-active)"
  },
  "colors.Tabs.file.label.default": {
    "value": "var(--colors--tabs-file-label-default)",
    "variable": "var(--colors--tabs-file-label-default)"
  },
  "colors.Tag.aqua.bg": {
    "value": "var(--colors--tag-aqua-bg)",
    "variable": "var(--colors--tag-aqua-bg)"
  },
  "colors.Tag.aqua.icon": {
    "value": "var(--colors--tag-aqua-icon)",
    "variable": "var(--colors--tag-aqua-icon)"
  },
  "colors.Tag.aqua.text": {
    "value": "var(--colors--tag-aqua-text)",
    "variable": "var(--colors--tag-aqua-text)"
  },
  "colors.Tag.blue.bg": {
    "value": "var(--colors--tag-blue-bg)",
    "variable": "var(--colors--tag-blue-bg)"
  },
  "colors.Tag.blue.icon": {
    "value": "var(--colors--tag-blue-icon)",
    "variable": "var(--colors--tag-blue-icon)"
  },
  "colors.Tag.blue.text": {
    "value": "var(--colors--tag-blue-text)",
    "variable": "var(--colors--tag-blue-text)"
  },
  "colors.Tag.critical.bg": {
    "value": "var(--colors--tag-critical-bg)",
    "variable": "var(--colors--tag-critical-bg)"
  },
  "colors.Tag.critical.icon": {
    "value": "var(--colors--tag-critical-icon)",
    "variable": "var(--colors--tag-critical-icon)"
  },
  "colors.Tag.critical.text": {
    "value": "var(--colors--tag-critical-text)",
    "variable": "var(--colors--tag-critical-text)"
  },
  "colors.Tag.gray.bg": {
    "value": "var(--colors--tag-gray-bg)",
    "variable": "var(--colors--tag-gray-bg)"
  },
  "colors.Tag.gray.icon": {
    "value": "var(--colors--tag-gray-icon)",
    "variable": "var(--colors--tag-gray-icon)"
  },
  "colors.Tag.gray.text": {
    "value": "var(--colors--tag-gray-text)",
    "variable": "var(--colors--tag-gray-text)"
  },
  "colors.Tag.green.bg": {
    "value": "var(--colors--tag-green-bg)",
    "variable": "var(--colors--tag-green-bg)"
  },
  "colors.Tag.green.icon": {
    "value": "var(--colors--tag-green-icon)",
    "variable": "var(--colors--tag-green-icon)"
  },
  "colors.Tag.green.text": {
    "value": "var(--colors--tag-green-text)",
    "variable": "var(--colors--tag-green-text)"
  },
  "colors.Tag.info.bg": {
    "value": "var(--colors--tag-info-bg)",
    "variable": "var(--colors--tag-info-bg)"
  },
  "colors.Tag.info.icon": {
    "value": "var(--colors--tag-info-icon)",
    "variable": "var(--colors--tag-info-icon)"
  },
  "colors.Tag.info.text": {
    "value": "var(--colors--tag-info-text)",
    "variable": "var(--colors--tag-info-text)"
  },
  "colors.Tag.orange.bg": {
    "value": "var(--colors--tag-orange-bg)",
    "variable": "var(--colors--tag-orange-bg)"
  },
  "colors.Tag.orange.icon": {
    "value": "var(--colors--tag-orange-icon)",
    "variable": "var(--colors--tag-orange-icon)"
  },
  "colors.Tag.orange.text": {
    "value": "var(--colors--tag-orange-text)",
    "variable": "var(--colors--tag-orange-text)"
  },
  "colors.Tag.purple.bg": {
    "value": "var(--colors--tag-purple-bg)",
    "variable": "var(--colors--tag-purple-bg)"
  },
  "colors.Tag.purple.icon": {
    "value": "var(--colors--tag-purple-icon)",
    "variable": "var(--colors--tag-purple-icon)"
  },
  "colors.Tag.purple.text": {
    "value": "var(--colors--tag-purple-text)",
    "variable": "var(--colors--tag-purple-text)"
  },
  "colors.Tag.red.bg": {
    "value": "var(--colors--tag-red-bg)",
    "variable": "var(--colors--tag-red-bg)"
  },
  "colors.Tag.red.icon": {
    "value": "var(--colors--tag-red-icon)",
    "variable": "var(--colors--tag-red-icon)"
  },
  "colors.Tag.red.text": {
    "value": "var(--colors--tag-red-text)",
    "variable": "var(--colors--tag-red-text)"
  },
  "colors.Tag.success.bg": {
    "value": "var(--colors--tag-success-bg)",
    "variable": "var(--colors--tag-success-bg)"
  },
  "colors.Tag.success.icon": {
    "value": "var(--colors--tag-success-icon)",
    "variable": "var(--colors--tag-success-icon)"
  },
  "colors.Tag.success.text": {
    "value": "var(--colors--tag-success-text)",
    "variable": "var(--colors--tag-success-text)"
  },
  "colors.Tag.teal.bg": {
    "value": "var(--colors--tag-teal-bg)",
    "variable": "var(--colors--tag-teal-bg)"
  },
  "colors.Tag.teal.icon": {
    "value": "var(--colors--tag-teal-icon)",
    "variable": "var(--colors--tag-teal-icon)"
  },
  "colors.Tag.teal.text": {
    "value": "var(--colors--tag-teal-text)",
    "variable": "var(--colors--tag-teal-text)"
  },
  "colors.Tag.warning.bg": {
    "value": "var(--colors--tag-warning-bg)",
    "variable": "var(--colors--tag-warning-bg)"
  },
  "colors.Tag.warning.icon": {
    "value": "var(--colors--tag-warning-icon)",
    "variable": "var(--colors--tag-warning-icon)"
  },
  "colors.Tag.warning.text": {
    "value": "var(--colors--tag-warning-text)",
    "variable": "var(--colors--tag-warning-text)"
  },
  "colors.Tag.yellow.bg": {
    "value": "var(--colors--tag-yellow-bg)",
    "variable": "var(--colors--tag-yellow-bg)"
  },
  "colors.Tag.yellow.icon": {
    "value": "var(--colors--tag-yellow-icon)",
    "variable": "var(--colors--tag-yellow-icon)"
  },
  "colors.Tag.yellow.text": {
    "value": "var(--colors--tag-yellow-text)",
    "variable": "var(--colors--tag-yellow-text)"
  },
  "colors.Tag.transparent.bg": {
    "value": "var(--colors--tag-transparent-bg)",
    "variable": "var(--colors--tag-transparent-bg)"
  },
  "colors.Tag.transparent.icon": {
    "value": "var(--colors--tag-transparent-icon)",
    "variable": "var(--colors--tag-transparent-icon)"
  },
  "colors.Tag.transparent.text": {
    "value": "var(--colors--tag-transparent-text)",
    "variable": "var(--colors--tag-transparent-text)"
  },
  "colors.TextButton.onImpact.neutral.icon.default": {
    "value": "var(--colors--text-button-on-impact-neutral-icon-default)",
    "variable": "var(--colors--text-button-on-impact-neutral-icon-default)"
  },
  "colors.TextButton.onImpact.neutral.icon.hover": {
    "value": "var(--colors--text-button-on-impact-neutral-icon-hover)",
    "variable": "var(--colors--text-button-on-impact-neutral-icon-hover)"
  },
  "colors.TextButton.onImpact.neutral.icon.pressed": {
    "value": "var(--colors--text-button-on-impact-neutral-icon-pressed)",
    "variable": "var(--colors--text-button-on-impact-neutral-icon-pressed)"
  },
  "colors.TextButton.onImpact.neutral.label.default": {
    "value": "var(--colors--text-button-on-impact-neutral-label-default)",
    "variable": "var(--colors--text-button-on-impact-neutral-label-default)"
  },
  "colors.TextButton.onImpact.neutral.label.hover": {
    "value": "var(--colors--text-button-on-impact-neutral-label-hover)",
    "variable": "var(--colors--text-button-on-impact-neutral-label-hover)"
  },
  "colors.TextButton.onImpact.neutral.label.pressed": {
    "value": "var(--colors--text-button-on-impact-neutral-label-pressed)",
    "variable": "var(--colors--text-button-on-impact-neutral-label-pressed)"
  },
  "colors.TextButton.brand.icon.default": {
    "value": "var(--colors--text-button-brand-icon-default)",
    "variable": "var(--colors--text-button-brand-icon-default)"
  },
  "colors.TextButton.brand.icon.hover": {
    "value": "var(--colors--text-button-brand-icon-hover)",
    "variable": "var(--colors--text-button-brand-icon-hover)"
  },
  "colors.TextButton.brand.icon.pressed": {
    "value": "var(--colors--text-button-brand-icon-pressed)",
    "variable": "var(--colors--text-button-brand-icon-pressed)"
  },
  "colors.TextButton.brand.label.default": {
    "value": "var(--colors--text-button-brand-label-default)",
    "variable": "var(--colors--text-button-brand-label-default)"
  },
  "colors.TextButton.brand.label.hover": {
    "value": "var(--colors--text-button-brand-label-hover)",
    "variable": "var(--colors--text-button-brand-label-hover)"
  },
  "colors.TextButton.brand.label.pressed": {
    "value": "var(--colors--text-button-brand-label-pressed)",
    "variable": "var(--colors--text-button-brand-label-pressed)"
  },
  "colors.TextButton.neutral.icon.default": {
    "value": "var(--colors--text-button-neutral-icon-default)",
    "variable": "var(--colors--text-button-neutral-icon-default)"
  },
  "colors.TextButton.neutral.icon.hover": {
    "value": "var(--colors--text-button-neutral-icon-hover)",
    "variable": "var(--colors--text-button-neutral-icon-hover)"
  },
  "colors.TextButton.neutral.icon.pressed": {
    "value": "var(--colors--text-button-neutral-icon-pressed)",
    "variable": "var(--colors--text-button-neutral-icon-pressed)"
  },
  "colors.TextButton.neutral.label.default": {
    "value": "var(--colors--text-button-neutral-label-default)",
    "variable": "var(--colors--text-button-neutral-label-default)"
  },
  "colors.TextButton.neutral.label.hover": {
    "value": "var(--colors--text-button-neutral-label-hover)",
    "variable": "var(--colors--text-button-neutral-label-hover)"
  },
  "colors.TextButton.neutral.label.pressed": {
    "value": "var(--colors--text-button-neutral-label-pressed)",
    "variable": "var(--colors--text-button-neutral-label-pressed)"
  },
  "colors.TextButton.subtle.icon.default": {
    "value": "var(--colors--text-button-subtle-icon-default)",
    "variable": "var(--colors--text-button-subtle-icon-default)"
  },
  "colors.TextButton.subtle.icon.hover": {
    "value": "var(--colors--text-button-subtle-icon-hover)",
    "variable": "var(--colors--text-button-subtle-icon-hover)"
  },
  "colors.TextButton.subtle.icon.pressed": {
    "value": "var(--colors--text-button-subtle-icon-pressed)",
    "variable": "var(--colors--text-button-subtle-icon-pressed)"
  },
  "colors.TextButton.subtle.label.default": {
    "value": "var(--colors--text-button-subtle-label-default)",
    "variable": "var(--colors--text-button-subtle-label-default)"
  },
  "colors.TextButton.subtle.label.hover": {
    "value": "var(--colors--text-button-subtle-label-hover)",
    "variable": "var(--colors--text-button-subtle-label-hover)"
  },
  "colors.TextButton.subtle.label.pressed": {
    "value": "var(--colors--text-button-subtle-label-pressed)",
    "variable": "var(--colors--text-button-subtle-label-pressed)"
  },
  "colors.Toast.critical.bg": {
    "value": "var(--colors--toast-critical-bg)",
    "variable": "var(--colors--toast-critical-bg)"
  },
  "colors.Toast.critical.icon-leading": {
    "value": "var(--colors--toast-critical-icon-leading)",
    "variable": "var(--colors--toast-critical-icon-leading)"
  },
  "colors.Toast.critical.icon-trailing": {
    "value": "var(--colors--toast-critical-icon-trailing)",
    "variable": "var(--colors--toast-critical-icon-trailing)"
  },
  "colors.Toast.critical.text": {
    "value": "var(--colors--toast-critical-text)",
    "variable": "var(--colors--toast-critical-text)"
  },
  "colors.Toast.info.bg": {
    "value": "var(--colors--toast-info-bg)",
    "variable": "var(--colors--toast-info-bg)"
  },
  "colors.Toast.info.icon-leading": {
    "value": "var(--colors--toast-info-icon-leading)",
    "variable": "var(--colors--toast-info-icon-leading)"
  },
  "colors.Toast.info.icon-trailing": {
    "value": "var(--colors--toast-info-icon-trailing)",
    "variable": "var(--colors--toast-info-icon-trailing)"
  },
  "colors.Toast.info.text": {
    "value": "var(--colors--toast-info-text)",
    "variable": "var(--colors--toast-info-text)"
  },
  "colors.Toast.notify.bg": {
    "value": "var(--colors--toast-notify-bg)",
    "variable": "var(--colors--toast-notify-bg)"
  },
  "colors.Toast.notify.icon-leading": {
    "value": "var(--colors--toast-notify-icon-leading)",
    "variable": "var(--colors--toast-notify-icon-leading)"
  },
  "colors.Toast.notify.icon-trailing": {
    "value": "var(--colors--toast-notify-icon-trailing)",
    "variable": "var(--colors--toast-notify-icon-trailing)"
  },
  "colors.Toast.notify.text": {
    "value": "var(--colors--toast-notify-text)",
    "variable": "var(--colors--toast-notify-text)"
  },
  "colors.Toast.success.bg": {
    "value": "var(--colors--toast-success-bg)",
    "variable": "var(--colors--toast-success-bg)"
  },
  "colors.Toast.success.icon-leading": {
    "value": "var(--colors--toast-success-icon-leading)",
    "variable": "var(--colors--toast-success-icon-leading)"
  },
  "colors.Toast.success.icon-trailing": {
    "value": "var(--colors--toast-success-icon-trailing)",
    "variable": "var(--colors--toast-success-icon-trailing)"
  },
  "colors.Toast.success.text": {
    "value": "var(--colors--toast-success-text)",
    "variable": "var(--colors--toast-success-text)"
  },
  "colors.Toast.warning.bg": {
    "value": "var(--colors--toast-warning-bg)",
    "variable": "var(--colors--toast-warning-bg)"
  },
  "colors.Toast.warning.icon-leading": {
    "value": "var(--colors--toast-warning-icon-leading)",
    "variable": "var(--colors--toast-warning-icon-leading)"
  },
  "colors.Toast.warning.icon-trailing": {
    "value": "var(--colors--toast-warning-icon-trailing)",
    "variable": "var(--colors--toast-warning-icon-trailing)"
  },
  "colors.Toast.warning.text": {
    "value": "var(--colors--toast-warning-text)",
    "variable": "var(--colors--toast-warning-text)"
  },
  "colors.ToggleButton.bg.default": {
    "value": "var(--colors--toggle-button-bg-default)",
    "variable": "var(--colors--toggle-button-bg-default)"
  },
  "colors.ToggleButton.bg.hover": {
    "value": "var(--colors--toggle-button-bg-hover)",
    "variable": "var(--colors--toggle-button-bg-hover)"
  },
  "colors.ToggleButton.bg.pressed": {
    "value": "var(--colors--toggle-button-bg-pressed)",
    "variable": "var(--colors--toggle-button-bg-pressed)"
  },
  "colors.ToggleButton.bg.selected": {
    "value": "var(--colors--toggle-button-bg-selected)",
    "variable": "var(--colors--toggle-button-bg-selected)"
  },
  "colors.ToggleButton.bg.selectedHover": {
    "value": "var(--colors--toggle-button-bg-selected-hover)",
    "variable": "var(--colors--toggle-button-bg-selected-hover)"
  },
  "colors.ToggleButton.bg.selectedPressed": {
    "value": "var(--colors--toggle-button-bg-selected-pressed)",
    "variable": "var(--colors--toggle-button-bg-selected-pressed)"
  },
  "colors.ToggleButton.label.default": {
    "value": "var(--colors--toggle-button-label-default)",
    "variable": "var(--colors--toggle-button-label-default)"
  },
  "colors.ToggleButton.label.hover": {
    "value": "var(--colors--toggle-button-label-hover)",
    "variable": "var(--colors--toggle-button-label-hover)"
  },
  "colors.ToggleButton.label.pressed": {
    "value": "var(--colors--toggle-button-label-pressed)",
    "variable": "var(--colors--toggle-button-label-pressed)"
  },
  "colors.ToggleButton.label.selected": {
    "value": "var(--colors--toggle-button-label-selected)",
    "variable": "var(--colors--toggle-button-label-selected)"
  },
  "colors.ToggleButton.label.selectedHover": {
    "value": "var(--colors--toggle-button-label-selected-hover)",
    "variable": "var(--colors--toggle-button-label-selected-hover)"
  },
  "colors.ToggleButton.label.selectedPressed": {
    "value": "var(--colors--toggle-button-label-selected-pressed)",
    "variable": "var(--colors--toggle-button-label-selected-pressed)"
  },
  "colors.ToggleButton.icon.default": {
    "value": "var(--colors--toggle-button-icon-default)",
    "variable": "var(--colors--toggle-button-icon-default)"
  },
  "colors.ToggleButton.icon.hover": {
    "value": "var(--colors--toggle-button-icon-hover)",
    "variable": "var(--colors--toggle-button-icon-hover)"
  },
  "colors.ToggleButton.icon.pressed": {
    "value": "var(--colors--toggle-button-icon-pressed)",
    "variable": "var(--colors--toggle-button-icon-pressed)"
  },
  "colors.ToggleButton.icon.selected": {
    "value": "var(--colors--toggle-button-icon-selected)",
    "variable": "var(--colors--toggle-button-icon-selected)"
  },
  "colors.ToggleButton.icon.selectedHover": {
    "value": "var(--colors--toggle-button-icon-selected-hover)",
    "variable": "var(--colors--toggle-button-icon-selected-hover)"
  },
  "colors.ToggleButton.icon.selectedPressed": {
    "value": "var(--colors--toggle-button-icon-selected-pressed)",
    "variable": "var(--colors--toggle-button-icon-selected-pressed)"
  },
  "colors.ToggleButton.border.default": {
    "value": "var(--colors--toggle-button-border-default)",
    "variable": "var(--colors--toggle-button-border-default)"
  },
  "colors.ToggleButton.border.hover": {
    "value": "var(--colors--toggle-button-border-hover)",
    "variable": "var(--colors--toggle-button-border-hover)"
  },
  "colors.ToggleButton.border.pressed": {
    "value": "var(--colors--toggle-button-border-pressed)",
    "variable": "var(--colors--toggle-button-border-pressed)"
  },
  "colors.ToggleButton.border.selected": {
    "value": "var(--colors--toggle-button-border-selected)",
    "variable": "var(--colors--toggle-button-border-selected)"
  },
  "colors.ToggleButton.border.selectedHover": {
    "value": "var(--colors--toggle-button-border-selected-hover)",
    "variable": "var(--colors--toggle-button-border-selected-hover)"
  },
  "colors.ToggleButton.border.selectedPressed": {
    "value": "var(--colors--toggle-button-border-selected-pressed)",
    "variable": "var(--colors--toggle-button-border-selected-pressed)"
  },
  "colors.ToggleCard.Footer.border": {
    "value": "var(--colors--toggle-card--footer-border)",
    "variable": "var(--colors--toggle-card--footer-border)"
  },
  "colors.ToggleCard.Header.border": {
    "value": "var(--colors--toggle-card--header-border)",
    "variable": "var(--colors--toggle-card--header-border)"
  },
  "colors.ToggleCard.Root.neutral.bg.default": {
    "value": "var(--colors--toggle-card--root-neutral-bg-default)",
    "variable": "var(--colors--toggle-card--root-neutral-bg-default)"
  },
  "colors.ToggleCard.Root.neutral.bg.hover": {
    "value": "var(--colors--toggle-card--root-neutral-bg-hover)",
    "variable": "var(--colors--toggle-card--root-neutral-bg-hover)"
  },
  "colors.ToggleCard.Root.neutral.bg.pressed": {
    "value": "var(--colors--toggle-card--root-neutral-bg-pressed)",
    "variable": "var(--colors--toggle-card--root-neutral-bg-pressed)"
  },
  "colors.ToggleCard.Root.neutral.bg.selected.default": {
    "value": "var(--colors--toggle-card--root-neutral-bg-selected-default)",
    "variable": "var(--colors--toggle-card--root-neutral-bg-selected-default)"
  },
  "colors.ToggleCard.Root.neutral.bg.selected.hover": {
    "value": "var(--colors--toggle-card--root-neutral-bg-selected-hover)",
    "variable": "var(--colors--toggle-card--root-neutral-bg-selected-hover)"
  },
  "colors.ToggleCard.Root.neutral.bg.selected.pressed": {
    "value": "var(--colors--toggle-card--root-neutral-bg-selected-pressed)",
    "variable": "var(--colors--toggle-card--root-neutral-bg-selected-pressed)"
  },
  "colors.ToggleCard.Root.neutral.border.default": {
    "value": "var(--colors--toggle-card--root-neutral-border-default)",
    "variable": "var(--colors--toggle-card--root-neutral-border-default)"
  },
  "colors.ToggleCard.Root.neutral.border.hover": {
    "value": "var(--colors--toggle-card--root-neutral-border-hover)",
    "variable": "var(--colors--toggle-card--root-neutral-border-hover)"
  },
  "colors.ToggleCard.Root.neutral.border.pressed": {
    "value": "var(--colors--toggle-card--root-neutral-border-pressed)",
    "variable": "var(--colors--toggle-card--root-neutral-border-pressed)"
  },
  "colors.ToggleCard.Root.neutral.border.selected.default": {
    "value": "var(--colors--toggle-card--root-neutral-border-selected-default)",
    "variable": "var(--colors--toggle-card--root-neutral-border-selected-default)"
  },
  "colors.ToggleCard.Root.neutral.border.selected.hover": {
    "value": "var(--colors--toggle-card--root-neutral-border-selected-hover)",
    "variable": "var(--colors--toggle-card--root-neutral-border-selected-hover)"
  },
  "colors.ToggleCard.Root.neutral.border.selected.pressed": {
    "value": "var(--colors--toggle-card--root-neutral-border-selected-pressed)",
    "variable": "var(--colors--toggle-card--root-neutral-border-selected-pressed)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.default": {
    "value": "var(--colors--toggle-card--root-neutral-elevated-bg-default)",
    "variable": "var(--colors--toggle-card--root-neutral-elevated-bg-default)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.hover": {
    "value": "var(--colors--toggle-card--root-neutral-elevated-bg-hover)",
    "variable": "var(--colors--toggle-card--root-neutral-elevated-bg-hover)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.pressed": {
    "value": "var(--colors--toggle-card--root-neutral-elevated-bg-pressed)",
    "variable": "var(--colors--toggle-card--root-neutral-elevated-bg-pressed)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.selected.default": {
    "value": "var(--colors--toggle-card--root-neutral-elevated-bg-selected-default)",
    "variable": "var(--colors--toggle-card--root-neutral-elevated-bg-selected-default)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.selected.hover": {
    "value": "var(--colors--toggle-card--root-neutral-elevated-bg-selected-hover)",
    "variable": "var(--colors--toggle-card--root-neutral-elevated-bg-selected-hover)"
  },
  "colors.ToggleCard.Root.neutral.elevated.bg.selected.pressed": {
    "value": "var(--colors--toggle-card--root-neutral-elevated-bg-selected-pressed)",
    "variable": "var(--colors--toggle-card--root-neutral-elevated-bg-selected-pressed)"
  },
  "colors.ToggleCard.Root.soft.bg.default": {
    "value": "var(--colors--toggle-card--root-soft-bg-default)",
    "variable": "var(--colors--toggle-card--root-soft-bg-default)"
  },
  "colors.ToggleCard.Root.soft.bg.hover": {
    "value": "var(--colors--toggle-card--root-soft-bg-hover)",
    "variable": "var(--colors--toggle-card--root-soft-bg-hover)"
  },
  "colors.ToggleCard.Root.soft.bg.pressed": {
    "value": "var(--colors--toggle-card--root-soft-bg-pressed)",
    "variable": "var(--colors--toggle-card--root-soft-bg-pressed)"
  },
  "colors.ToggleCard.Root.soft.bg.selected.default": {
    "value": "var(--colors--toggle-card--root-soft-bg-selected-default)",
    "variable": "var(--colors--toggle-card--root-soft-bg-selected-default)"
  },
  "colors.ToggleCard.Root.soft.bg.selected.hover": {
    "value": "var(--colors--toggle-card--root-soft-bg-selected-hover)",
    "variable": "var(--colors--toggle-card--root-soft-bg-selected-hover)"
  },
  "colors.ToggleCard.Root.soft.bg.selected.pressed": {
    "value": "var(--colors--toggle-card--root-soft-bg-selected-pressed)",
    "variable": "var(--colors--toggle-card--root-soft-bg-selected-pressed)"
  },
  "colors.ToggleCard.Root.soft.border.default": {
    "value": "var(--colors--toggle-card--root-soft-border-default)",
    "variable": "var(--colors--toggle-card--root-soft-border-default)"
  },
  "colors.ToggleCard.Root.soft.border.hover": {
    "value": "var(--colors--toggle-card--root-soft-border-hover)",
    "variable": "var(--colors--toggle-card--root-soft-border-hover)"
  },
  "colors.ToggleCard.Root.soft.border.pressed": {
    "value": "var(--colors--toggle-card--root-soft-border-pressed)",
    "variable": "var(--colors--toggle-card--root-soft-border-pressed)"
  },
  "colors.ToggleCard.Root.soft.border.selected.default": {
    "value": "var(--colors--toggle-card--root-soft-border-selected-default)",
    "variable": "var(--colors--toggle-card--root-soft-border-selected-default)"
  },
  "colors.ToggleCard.Root.soft.border.selected.hover": {
    "value": "var(--colors--toggle-card--root-soft-border-selected-hover)",
    "variable": "var(--colors--toggle-card--root-soft-border-selected-hover)"
  },
  "colors.ToggleCard.Root.soft.border.selected.pressed": {
    "value": "var(--colors--toggle-card--root-soft-border-selected-pressed)",
    "variable": "var(--colors--toggle-card--root-soft-border-selected-pressed)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.default": {
    "value": "var(--colors--toggle-card--root-soft-elevated-bg-default)",
    "variable": "var(--colors--toggle-card--root-soft-elevated-bg-default)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.hover": {
    "value": "var(--colors--toggle-card--root-soft-elevated-bg-hover)",
    "variable": "var(--colors--toggle-card--root-soft-elevated-bg-hover)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.pressed": {
    "value": "var(--colors--toggle-card--root-soft-elevated-bg-pressed)",
    "variable": "var(--colors--toggle-card--root-soft-elevated-bg-pressed)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.selected.default": {
    "value": "var(--colors--toggle-card--root-soft-elevated-bg-selected-default)",
    "variable": "var(--colors--toggle-card--root-soft-elevated-bg-selected-default)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.selected.hover": {
    "value": "var(--colors--toggle-card--root-soft-elevated-bg-selected-hover)",
    "variable": "var(--colors--toggle-card--root-soft-elevated-bg-selected-hover)"
  },
  "colors.ToggleCard.Root.soft.elevated.bg.selected.pressed": {
    "value": "var(--colors--toggle-card--root-soft-elevated-bg-selected-pressed)",
    "variable": "var(--colors--toggle-card--root-soft-elevated-bg-selected-pressed)"
  },
  "colors.Tooltip.neutral.bg": {
    "value": "var(--colors--tooltip-neutral-bg)",
    "variable": "var(--colors--tooltip-neutral-bg)"
  },
  "colors.Tooltip.neutral.text": {
    "value": "var(--colors--tooltip-neutral-text)",
    "variable": "var(--colors--tooltip-neutral-text)"
  },
  "colors.Tooltip.impact.bg": {
    "value": "var(--colors--tooltip-impact-bg)",
    "variable": "var(--colors--tooltip-impact-bg)"
  },
  "colors.Tooltip.impact.text": {
    "value": "var(--colors--tooltip-impact-text)",
    "variable": "var(--colors--tooltip-impact-text)"
  },
  "colors.TriggerButton.bg.default": {
    "value": "var(--colors--trigger-button-bg-default)",
    "variable": "var(--colors--trigger-button-bg-default)"
  },
  "colors.TriggerButton.bg.hover": {
    "value": "var(--colors--trigger-button-bg-hover)",
    "variable": "var(--colors--trigger-button-bg-hover)"
  },
  "colors.TriggerButton.bg.pressed": {
    "value": "var(--colors--trigger-button-bg-pressed)",
    "variable": "var(--colors--trigger-button-bg-pressed)"
  },
  "colors.TriggerButton.border.default": {
    "value": "var(--colors--trigger-button-border-default)",
    "variable": "var(--colors--trigger-button-border-default)"
  },
  "colors.TriggerButton.border.pressed": {
    "value": "var(--colors--trigger-button-border-pressed)",
    "variable": "var(--colors--trigger-button-border-pressed)"
  },
  "colors.TriggerButton.text": {
    "value": "var(--colors--trigger-button-text)",
    "variable": "var(--colors--trigger-button-text)"
  },
  "colors.TriggerText.border.default": {
    "value": "var(--colors--trigger-text-border-default)",
    "variable": "var(--colors--trigger-text-border-default)"
  },
  "colors.TriggerText.border.hover": {
    "value": "var(--colors--trigger-text-border-hover)",
    "variable": "var(--colors--trigger-text-border-hover)"
  },
  "colors.TriggerText.border.pressed": {
    "value": "var(--colors--trigger-text-border-pressed)",
    "variable": "var(--colors--trigger-text-border-pressed)"
  },
  "colors.UpsellBanner.Body.hero.text": {
    "value": "var(--colors--upsell-banner--body-hero-text)",
    "variable": "var(--colors--upsell-banner--body-hero-text)"
  },
  "colors.UpsellBanner.Body.impact.text": {
    "value": "var(--colors--upsell-banner--body-impact-text)",
    "variable": "var(--colors--upsell-banner--body-impact-text)"
  },
  "colors.UpsellBanner.Body.neutral.text": {
    "value": "var(--colors--upsell-banner--body-neutral-text)",
    "variable": "var(--colors--upsell-banner--body-neutral-text)"
  },
  "colors.UpsellBanner.Body.soft.text": {
    "value": "var(--colors--upsell-banner--body-soft-text)",
    "variable": "var(--colors--upsell-banner--body-soft-text)"
  },
  "colors.UpsellBanner.Header.hero.text": {
    "value": "var(--colors--upsell-banner--header-hero-text)",
    "variable": "var(--colors--upsell-banner--header-hero-text)"
  },
  "colors.UpsellBanner.Header.impact.text": {
    "value": "var(--colors--upsell-banner--header-impact-text)",
    "variable": "var(--colors--upsell-banner--header-impact-text)"
  },
  "colors.UpsellBanner.Header.neutral.text": {
    "value": "var(--colors--upsell-banner--header-neutral-text)",
    "variable": "var(--colors--upsell-banner--header-neutral-text)"
  },
  "colors.UpsellBanner.Header.soft.text": {
    "value": "var(--colors--upsell-banner--header-soft-text)",
    "variable": "var(--colors--upsell-banner--header-soft-text)"
  },
  "colors.UpsellBanner.Media.hero.icon": {
    "value": "var(--colors--upsell-banner--media-hero-icon)",
    "variable": "var(--colors--upsell-banner--media-hero-icon)"
  },
  "colors.UpsellBanner.Media.impact.icon": {
    "value": "var(--colors--upsell-banner--media-impact-icon)",
    "variable": "var(--colors--upsell-banner--media-impact-icon)"
  },
  "colors.UpsellBanner.Media.neutral.icon": {
    "value": "var(--colors--upsell-banner--media-neutral-icon)",
    "variable": "var(--colors--upsell-banner--media-neutral-icon)"
  },
  "colors.UpsellBanner.Media.soft.icon": {
    "value": "var(--colors--upsell-banner--media-soft-icon)",
    "variable": "var(--colors--upsell-banner--media-soft-icon)"
  },
  "colors.UpsellBanner.Root.hero.bg": {
    "value": "var(--colors--upsell-banner--root-hero-bg)",
    "variable": "var(--colors--upsell-banner--root-hero-bg)"
  },
  "colors.UpsellBanner.Root.impact.bg": {
    "value": "var(--colors--upsell-banner--root-impact-bg)",
    "variable": "var(--colors--upsell-banner--root-impact-bg)"
  },
  "colors.UpsellBanner.Root.neutral.bg.default": {
    "value": "var(--colors--upsell-banner--root-neutral-bg-default)",
    "variable": "var(--colors--upsell-banner--root-neutral-bg-default)"
  },
  "colors.UpsellBanner.Root.soft.bg": {
    "value": "var(--colors--upsell-banner--root-soft-bg)",
    "variable": "var(--colors--upsell-banner--root-soft-bg)"
  },
  "colors.Upsell.Body.hero.text": {
    "value": "var(--colors--upsell--body-hero-text)",
    "variable": "var(--colors--upsell--body-hero-text)"
  },
  "colors.Upsell.Body.impact.text": {
    "value": "var(--colors--upsell--body-impact-text)",
    "variable": "var(--colors--upsell--body-impact-text)"
  },
  "colors.Upsell.Body.neutral.text": {
    "value": "var(--colors--upsell--body-neutral-text)",
    "variable": "var(--colors--upsell--body-neutral-text)"
  },
  "colors.Upsell.Body.soft.text": {
    "value": "var(--colors--upsell--body-soft-text)",
    "variable": "var(--colors--upsell--body-soft-text)"
  },
  "colors.Upsell.Header.hero.text": {
    "value": "var(--colors--upsell--header-hero-text)",
    "variable": "var(--colors--upsell--header-hero-text)"
  },
  "colors.Upsell.Header.impact.text": {
    "value": "var(--colors--upsell--header-impact-text)",
    "variable": "var(--colors--upsell--header-impact-text)"
  },
  "colors.Upsell.Header.neutral.text": {
    "value": "var(--colors--upsell--header-neutral-text)",
    "variable": "var(--colors--upsell--header-neutral-text)"
  },
  "colors.Upsell.Header.soft.text": {
    "value": "var(--colors--upsell--header-soft-text)",
    "variable": "var(--colors--upsell--header-soft-text)"
  },
  "colors.Upsell.Legal.hero.text-legal": {
    "value": "var(--colors--upsell--legal-hero-text-legal)",
    "variable": "var(--colors--upsell--legal-hero-text-legal)"
  },
  "colors.Upsell.Legal.impact.text-legal": {
    "value": "var(--colors--upsell--legal-impact-text-legal)",
    "variable": "var(--colors--upsell--legal-impact-text-legal)"
  },
  "colors.Upsell.Legal.neutral.text-legal": {
    "value": "var(--colors--upsell--legal-neutral-text-legal)",
    "variable": "var(--colors--upsell--legal-neutral-text-legal)"
  },
  "colors.Upsell.Legal.soft.text-legal": {
    "value": "var(--colors--upsell--legal-soft-text-legal)",
    "variable": "var(--colors--upsell--legal-soft-text-legal)"
  },
  "colors.Upsell.Media.hero.icon": {
    "value": "var(--colors--upsell--media-hero-icon)",
    "variable": "var(--colors--upsell--media-hero-icon)"
  },
  "colors.Upsell.Media.impact.icon": {
    "value": "var(--colors--upsell--media-impact-icon)",
    "variable": "var(--colors--upsell--media-impact-icon)"
  },
  "colors.Upsell.Media.neutral.icon": {
    "value": "var(--colors--upsell--media-neutral-icon)",
    "variable": "var(--colors--upsell--media-neutral-icon)"
  },
  "colors.Upsell.Media.soft.icon": {
    "value": "var(--colors--upsell--media-soft-icon)",
    "variable": "var(--colors--upsell--media-soft-icon)"
  },
  "colors.Upsell.Root.hero.bg": {
    "value": "var(--colors--upsell--root-hero-bg)",
    "variable": "var(--colors--upsell--root-hero-bg)"
  },
  "colors.Upsell.Root.hero.border": {
    "value": "var(--colors--upsell--root-hero-border)",
    "variable": "var(--colors--upsell--root-hero-border)"
  },
  "colors.Upsell.Root.impact.bg": {
    "value": "var(--colors--upsell--root-impact-bg)",
    "variable": "var(--colors--upsell--root-impact-bg)"
  },
  "colors.Upsell.Root.impact.border": {
    "value": "var(--colors--upsell--root-impact-border)",
    "variable": "var(--colors--upsell--root-impact-border)"
  },
  "colors.Upsell.Root.neutral.bg": {
    "value": "var(--colors--upsell--root-neutral-bg)",
    "variable": "var(--colors--upsell--root-neutral-bg)"
  },
  "colors.Upsell.Root.neutral.border": {
    "value": "var(--colors--upsell--root-neutral-border)",
    "variable": "var(--colors--upsell--root-neutral-border)"
  },
  "colors.Upsell.Root.neutral.elevated.bg": {
    "value": "var(--colors--upsell--root-neutral-elevated-bg)",
    "variable": "var(--colors--upsell--root-neutral-elevated-bg)"
  },
  "colors.Upsell.Root.neutral.elevated.border": {
    "value": "var(--colors--upsell--root-neutral-elevated-border)",
    "variable": "var(--colors--upsell--root-neutral-elevated-border)"
  },
  "colors.Upsell.Root.soft.bg": {
    "value": "var(--colors--upsell--root-soft-bg)",
    "variable": "var(--colors--upsell--root-soft-bg)"
  },
  "colors.Upsell.Root.soft.border": {
    "value": "var(--colors--upsell--root-soft-border)",
    "variable": "var(--colors--upsell--root-soft-border)"
  },
  "colors.VerticalNav.Heading": {
    "value": "var(--colors--vertical-nav--heading)",
    "variable": "var(--colors--vertical-nav--heading)"
  },
  "colors.VerticalNav.Item.brand.bg.default": {
    "value": "var(--colors--vertical-nav--item-brand-bg-default)",
    "variable": "var(--colors--vertical-nav--item-brand-bg-default)"
  },
  "colors.VerticalNav.Item.brand.bg.hover": {
    "value": "var(--colors--vertical-nav--item-brand-bg-hover)",
    "variable": "var(--colors--vertical-nav--item-brand-bg-hover)"
  },
  "colors.VerticalNav.Item.brand.bg.active": {
    "value": "var(--colors--vertical-nav--item-brand-bg-active)",
    "variable": "var(--colors--vertical-nav--item-brand-bg-active)"
  },
  "colors.VerticalNav.Item.brand.bg.pressed": {
    "value": "var(--colors--vertical-nav--item-brand-bg-pressed)",
    "variable": "var(--colors--vertical-nav--item-brand-bg-pressed)"
  },
  "colors.VerticalNav.Item.brand.icon.default": {
    "value": "var(--colors--vertical-nav--item-brand-icon-default)",
    "variable": "var(--colors--vertical-nav--item-brand-icon-default)"
  },
  "colors.VerticalNav.Item.brand.icon.hover": {
    "value": "var(--colors--vertical-nav--item-brand-icon-hover)",
    "variable": "var(--colors--vertical-nav--item-brand-icon-hover)"
  },
  "colors.VerticalNav.Item.brand.icon.active": {
    "value": "var(--colors--vertical-nav--item-brand-icon-active)",
    "variable": "var(--colors--vertical-nav--item-brand-icon-active)"
  },
  "colors.VerticalNav.Item.brand.icon.pressed": {
    "value": "var(--colors--vertical-nav--item-brand-icon-pressed)",
    "variable": "var(--colors--vertical-nav--item-brand-icon-pressed)"
  },
  "colors.VerticalNav.Item.brand.label.default": {
    "value": "var(--colors--vertical-nav--item-brand-label-default)",
    "variable": "var(--colors--vertical-nav--item-brand-label-default)"
  },
  "colors.VerticalNav.Item.brand.label.hover": {
    "value": "var(--colors--vertical-nav--item-brand-label-hover)",
    "variable": "var(--colors--vertical-nav--item-brand-label-hover)"
  },
  "colors.VerticalNav.Item.brand.label.active": {
    "value": "var(--colors--vertical-nav--item-brand-label-active)",
    "variable": "var(--colors--vertical-nav--item-brand-label-active)"
  },
  "colors.VerticalNav.Item.brand.label.pressed": {
    "value": "var(--colors--vertical-nav--item-brand-label-pressed)",
    "variable": "var(--colors--vertical-nav--item-brand-label-pressed)"
  },
  "colors.VerticalNav.Item.neutral.bg.default": {
    "value": "var(--colors--vertical-nav--item-neutral-bg-default)",
    "variable": "var(--colors--vertical-nav--item-neutral-bg-default)"
  },
  "colors.VerticalNav.Item.neutral.bg.hover": {
    "value": "var(--colors--vertical-nav--item-neutral-bg-hover)",
    "variable": "var(--colors--vertical-nav--item-neutral-bg-hover)"
  },
  "colors.VerticalNav.Item.neutral.bg.active": {
    "value": "var(--colors--vertical-nav--item-neutral-bg-active)",
    "variable": "var(--colors--vertical-nav--item-neutral-bg-active)"
  },
  "colors.VerticalNav.Item.neutral.bg.pressed": {
    "value": "var(--colors--vertical-nav--item-neutral-bg-pressed)",
    "variable": "var(--colors--vertical-nav--item-neutral-bg-pressed)"
  },
  "colors.VerticalNav.Item.neutral.icon.default": {
    "value": "var(--colors--vertical-nav--item-neutral-icon-default)",
    "variable": "var(--colors--vertical-nav--item-neutral-icon-default)"
  },
  "colors.VerticalNav.Item.neutral.icon.hover": {
    "value": "var(--colors--vertical-nav--item-neutral-icon-hover)",
    "variable": "var(--colors--vertical-nav--item-neutral-icon-hover)"
  },
  "colors.VerticalNav.Item.neutral.icon.active": {
    "value": "var(--colors--vertical-nav--item-neutral-icon-active)",
    "variable": "var(--colors--vertical-nav--item-neutral-icon-active)"
  },
  "colors.VerticalNav.Item.neutral.icon.pressed": {
    "value": "var(--colors--vertical-nav--item-neutral-icon-pressed)",
    "variable": "var(--colors--vertical-nav--item-neutral-icon-pressed)"
  },
  "colors.VerticalNav.Item.neutral.label.default": {
    "value": "var(--colors--vertical-nav--item-neutral-label-default)",
    "variable": "var(--colors--vertical-nav--item-neutral-label-default)"
  },
  "colors.VerticalNav.Item.neutral.label.hover": {
    "value": "var(--colors--vertical-nav--item-neutral-label-hover)",
    "variable": "var(--colors--vertical-nav--item-neutral-label-hover)"
  },
  "colors.VerticalNav.Item.neutral.label.active": {
    "value": "var(--colors--vertical-nav--item-neutral-label-active)",
    "variable": "var(--colors--vertical-nav--item-neutral-label-active)"
  },
  "colors.VerticalNav.Item.neutral.label.pressed": {
    "value": "var(--colors--vertical-nav--item-neutral-label-pressed)",
    "variable": "var(--colors--vertical-nav--item-neutral-label-pressed)"
  },
  "colors.VerticalNav.Root.bg": {
    "value": "var(--colors--vertical-nav--root-bg)",
    "variable": "var(--colors--vertical-nav--root-bg)"
  },
  "colors.VerticalNav.Root.bg-elevated": {
    "value": "var(--colors--vertical-nav--root-bg-elevated)",
    "variable": "var(--colors--vertical-nav--root-bg-elevated)"
  },
  "colors.VerticalNav.Root.border": {
    "value": "var(--colors--vertical-nav--root-border)",
    "variable": "var(--colors--vertical-nav--root-border)"
  },
  "colors.ZillowLogo.brand-mark": {
    "value": "var(--colors--zillow-logo-brand-mark)",
    "variable": "var(--colors--zillow-logo-brand-mark)"
  },
  "colors.ZillowLogo.brand-text": {
    "value": "var(--colors--zillow-logo-brand-text)",
    "variable": "var(--colors--zillow-logo-brand-text)"
  },
  "colors.ZillowLogo.onImpact.brand-mark": {
    "value": "var(--colors--zillow-logo-on-impact-brand-mark)",
    "variable": "var(--colors--zillow-logo-on-impact-brand-mark)"
  },
  "colors.ZillowLogo.onImpact.brand-text": {
    "value": "var(--colors--zillow-logo-on-impact-brand-text)",
    "variable": "var(--colors--zillow-logo-on-impact-brand-text)"
  },
  "colors.ZillowLogo.legacy.brand-mark": {
    "value": "var(--colors--zillow-logo-legacy-brand-mark)",
    "variable": "var(--colors--zillow-logo-legacy-brand-mark)"
  },
  "colors.ZillowLogo.legacy.brand-text": {
    "value": "var(--colors--zillow-logo-legacy-brand-text)",
    "variable": "var(--colors--zillow-logo-legacy-brand-text)"
  },
  "colors.ZillowLogo.legacy.onImpact.brand-mark": {
    "value": "var(--colors--zillow-logo-legacy-on-impact-brand-mark)",
    "variable": "var(--colors--zillow-logo-legacy-on-impact-brand-mark)"
  },
  "colors.ZillowLogo.legacy.onImpact.brand-text": {
    "value": "var(--colors--zillow-logo-legacy-on-impact-brand-text)",
    "variable": "var(--colors--zillow-logo-legacy-on-impact-brand-text)"
  },
  "colors.transparent": {
    "value": "var(--colors-transparent)",
    "variable": "var(--colors-transparent)"
  },
  "colors.brand": {
    "value": "var(--colors-brand)",
    "variable": "var(--colors-brand)"
  },
  "colors.brandSecondary": {
    "value": "var(--colors-brand-secondary)",
    "variable": "var(--colors-brand-secondary)"
  },
  "colors.backgroundBrand": {
    "value": "var(--colors-background-brand)",
    "variable": "var(--colors-background-brand)"
  },
  "colors.textWhite": {
    "value": "var(--colors-text-white)",
    "variable": "var(--colors-text-white)"
  },
  "colors.textLight": {
    "value": "var(--colors-text-light)",
    "variable": "var(--colors-text-light)"
  },
  "colors.textMedium": {
    "value": "var(--colors-text-medium)",
    "variable": "var(--colors-text-medium)"
  },
  "colors.textDark": {
    "value": "var(--colors-text-dark)",
    "variable": "var(--colors-text-dark)"
  },
  "colors.link": {
    "value": "var(--colors-link)",
    "variable": "var(--colors-link)"
  },
  "colors.linkFocus": {
    "value": "var(--colors-link-focus)",
    "variable": "var(--colors-link-focus)"
  },
  "colors.linkInverse": {
    "value": "var(--colors-link-inverse)",
    "variable": "var(--colors-link-inverse)"
  },
  "colors.linkVisited": {
    "value": "var(--colors-link-visited)",
    "variable": "var(--colors-link-visited)"
  },
  "colors.linkHover": {
    "value": "var(--colors-link-hover)",
    "variable": "var(--colors-link-hover)"
  },
  "colors.linkActive": {
    "value": "var(--colors-link-active)",
    "variable": "var(--colors-link-active)"
  },
  "colors.backgroundAqua": {
    "value": "var(--colors-background-aqua)",
    "variable": "var(--colors-background-aqua)"
  },
  "colors.backgroundBlue": {
    "value": "var(--colors-background-blue)",
    "variable": "var(--colors-background-blue)"
  },
  "colors.backgroundGreen": {
    "value": "var(--colors-background-green)",
    "variable": "var(--colors-background-green)"
  },
  "colors.backgroundOrange": {
    "value": "var(--colors-background-orange)",
    "variable": "var(--colors-background-orange)"
  },
  "colors.backgroundOrangeRed": {
    "value": "var(--colors-background-orange-red)",
    "variable": "var(--colors-background-orange-red)"
  },
  "colors.backgroundPurple": {
    "value": "var(--colors-background-purple)",
    "variable": "var(--colors-background-purple)"
  },
  "colors.backgroundRed": {
    "value": "var(--colors-background-red)",
    "variable": "var(--colors-background-red)"
  },
  "colors.backgroundYellow": {
    "value": "var(--colors-background-yellow)",
    "variable": "var(--colors-background-yellow)"
  },
  "colors.backgroundDarkAqua": {
    "value": "var(--colors-background-dark-aqua)",
    "variable": "var(--colors-background-dark-aqua)"
  },
  "colors.backgroundDarkBlue": {
    "value": "var(--colors-background-dark-blue)",
    "variable": "var(--colors-background-dark-blue)"
  },
  "colors.backgroundDarkGreen": {
    "value": "var(--colors-background-dark-green)",
    "variable": "var(--colors-background-dark-green)"
  },
  "colors.backgroundDarkOrange": {
    "value": "var(--colors-background-dark-orange)",
    "variable": "var(--colors-background-dark-orange)"
  },
  "colors.backgroundDarkOrangeRed": {
    "value": "var(--colors-background-dark-orange-red)",
    "variable": "var(--colors-background-dark-orange-red)"
  },
  "colors.backgroundDarkPurple": {
    "value": "var(--colors-background-dark-purple)",
    "variable": "var(--colors-background-dark-purple)"
  },
  "colors.backgroundDarkRed": {
    "value": "var(--colors-background-dark-red)",
    "variable": "var(--colors-background-dark-red)"
  },
  "colors.backgroundDarkYellow": {
    "value": "var(--colors-background-dark-yellow)",
    "variable": "var(--colors-background-dark-yellow)"
  },
  "colors.backgroundWhite": {
    "value": "var(--colors-background-white)",
    "variable": "var(--colors-background-white)"
  },
  "colors.backgroundLight": {
    "value": "var(--colors-background-light)",
    "variable": "var(--colors-background-light)"
  },
  "colors.backgroundDark": {
    "value": "var(--colors-background-dark)",
    "variable": "var(--colors-background-dark)"
  },
  "colors.borderAqua": {
    "value": "var(--colors-border-aqua)",
    "variable": "var(--colors-border-aqua)"
  },
  "colors.borderBlue": {
    "value": "var(--colors-border-blue)",
    "variable": "var(--colors-border-blue)"
  },
  "colors.borderGreen": {
    "value": "var(--colors-border-green)",
    "variable": "var(--colors-border-green)"
  },
  "colors.borderOrange": {
    "value": "var(--colors-border-orange)",
    "variable": "var(--colors-border-orange)"
  },
  "colors.borderOrangeRed": {
    "value": "var(--colors-border-orange-red)",
    "variable": "var(--colors-border-orange-red)"
  },
  "colors.borderPurple": {
    "value": "var(--colors-border-purple)",
    "variable": "var(--colors-border-purple)"
  },
  "colors.borderRed": {
    "value": "var(--colors-border-red)",
    "variable": "var(--colors-border-red)"
  },
  "colors.borderYellow": {
    "value": "var(--colors-border-yellow)",
    "variable": "var(--colors-border-yellow)"
  },
  "colors.borderLight": {
    "value": "var(--colors-border-light)",
    "variable": "var(--colors-border-light)"
  },
  "colors.borderDark": {
    "value": "var(--colors-border-dark)",
    "variable": "var(--colors-border-dark)"
  },
  "colors.error.background": {
    "value": "var(--colors-error-background)",
    "variable": "var(--colors-error-background)"
  },
  "colors.error.border": {
    "value": "var(--colors-error-border)",
    "variable": "var(--colors-error-border)"
  },
  "colors.error.foreground": {
    "value": "var(--colors-error-foreground)",
    "variable": "var(--colors-error-foreground)"
  },
  "colors.error.fontColor": {
    "value": "var(--colors-error-font-color)",
    "variable": "var(--colors-error-font-color)"
  },
  "colors.error.darkBackground": {
    "value": "var(--colors-error-dark-background)",
    "variable": "var(--colors-error-dark-background)"
  },
  "colors.info.background": {
    "value": "var(--colors-info-background)",
    "variable": "var(--colors-info-background)"
  },
  "colors.info.border": {
    "value": "var(--colors-info-border)",
    "variable": "var(--colors-info-border)"
  },
  "colors.info.foreground": {
    "value": "var(--colors-info-foreground)",
    "variable": "var(--colors-info-foreground)"
  },
  "colors.info.fontColor": {
    "value": "var(--colors-info-font-color)",
    "variable": "var(--colors-info-font-color)"
  },
  "colors.info.darkBackground": {
    "value": "var(--colors-info-dark-background)",
    "variable": "var(--colors-info-dark-background)"
  },
  "colors.success.background": {
    "value": "var(--colors-success-background)",
    "variable": "var(--colors-success-background)"
  },
  "colors.success.border": {
    "value": "var(--colors-success-border)",
    "variable": "var(--colors-success-border)"
  },
  "colors.success.foreground": {
    "value": "var(--colors-success-foreground)",
    "variable": "var(--colors-success-foreground)"
  },
  "colors.success.fontColor": {
    "value": "var(--colors-success-font-color)",
    "variable": "var(--colors-success-font-color)"
  },
  "colors.success.darkBackground": {
    "value": "var(--colors-success-dark-background)",
    "variable": "var(--colors-success-dark-background)"
  },
  "colors.warning.background": {
    "value": "var(--colors-warning-background)",
    "variable": "var(--colors-warning-background)"
  },
  "colors.warning.border": {
    "value": "var(--colors-warning-border)",
    "variable": "var(--colors-warning-border)"
  },
  "colors.warning.foreground": {
    "value": "var(--colors-warning-foreground)",
    "variable": "var(--colors-warning-foreground)"
  },
  "colors.warning.fontColor": {
    "value": "var(--colors-warning-font-color)",
    "variable": "var(--colors-warning-font-color)"
  },
  "colors.warning.darkBackground": {
    "value": "var(--colors-warning-dark-background)",
    "variable": "var(--colors-warning-dark-background)"
  },
  "colors.transient.foreground": {
    "value": "var(--colors-transient-foreground)",
    "variable": "var(--colors-transient-foreground)"
  },
  "borderWidths.Accordion.default": {
    "value": "var(--border-widths--accordion-default)",
    "variable": "var(--border-widths--accordion-default)"
  },
  "borderWidths.AdornedInput.active": {
    "value": "var(--border-widths--adorned-input-active)",
    "variable": "var(--border-widths--adorned-input-active)"
  },
  "borderWidths.AdornedInput.default": {
    "value": "var(--border-widths--adorned-input-default)",
    "variable": "var(--border-widths--adorned-input-default)"
  },
  "borderWidths.Alert": {
    "value": "var(--border-widths--alert)",
    "variable": "var(--border-widths--alert)"
  },
  "borderWidths.Avatar.Badge.sm": {
    "value": "var(--border-widths--avatar--badge-sm)",
    "variable": "var(--border-widths--avatar--badge-sm)"
  },
  "borderWidths.Avatar.Badge.md": {
    "value": "var(--border-widths--avatar--badge-md)",
    "variable": "var(--border-widths--avatar--badge-md)"
  },
  "borderWidths.Avatar.Badge.lg": {
    "value": "var(--border-widths--avatar--badge-lg)",
    "variable": "var(--border-widths--avatar--badge-lg)"
  },
  "borderWidths.Avatar.Image.default": {
    "value": "var(--border-widths--avatar--image-default)",
    "variable": "var(--border-widths--avatar--image-default)"
  },
  "borderWidths.Avatar.Root.default": {
    "value": "var(--border-widths--avatar--root-default)",
    "variable": "var(--border-widths--avatar--root-default)"
  },
  "borderWidths.Button.default": {
    "value": "var(--border-widths--button-default)",
    "variable": "var(--border-widths--button-default)"
  },
  "borderWidths.Button.selected": {
    "value": "var(--border-widths--button-selected)",
    "variable": "var(--border-widths--button-selected)"
  },
  "borderWidths.Calendar.DayOfWeek.default": {
    "value": "var(--border-widths--calendar--day-of-week-default)",
    "variable": "var(--border-widths--calendar--day-of-week-default)"
  },
  "borderWidths.Calendar.Day.default": {
    "value": "var(--border-widths--calendar--day-default)",
    "variable": "var(--border-widths--calendar--day-default)"
  },
  "borderWidths.Calendar.Day.selected": {
    "value": "var(--border-widths--calendar--day-selected)",
    "variable": "var(--border-widths--calendar--day-selected)"
  },
  "borderWidths.Card.Footer": {
    "value": "var(--border-widths--card--footer)",
    "variable": "var(--border-widths--card--footer)"
  },
  "borderWidths.Card.Header": {
    "value": "var(--border-widths--card--header)",
    "variable": "var(--border-widths--card--header)"
  },
  "borderWidths.Card.Root": {
    "value": "var(--border-widths--card--root)",
    "variable": "var(--border-widths--card--root)"
  },
  "borderWidths.Checkbox.box": {
    "value": "var(--border-widths--checkbox-box)",
    "variable": "var(--border-widths--checkbox-box)"
  },
  "borderWidths.Chip.default": {
    "value": "var(--border-widths--chip-default)",
    "variable": "var(--border-widths--chip-default)"
  },
  "borderWidths.Chip.selected": {
    "value": "var(--border-widths--chip-selected)",
    "variable": "var(--border-widths--chip-selected)"
  },
  "borderWidths.Combobox.Group": {
    "value": "var(--border-widths--combobox--group)",
    "variable": "var(--border-widths--combobox--group)"
  },
  "borderWidths.Combobox.Trigger": {
    "value": "var(--border-widths--combobox--trigger)",
    "variable": "var(--border-widths--combobox--trigger)"
  },
  "borderWidths.DateInput.active": {
    "value": "var(--border-widths--date-input-active)",
    "variable": "var(--border-widths--date-input-active)"
  },
  "borderWidths.DateInput.default": {
    "value": "var(--border-widths--date-input-default)",
    "variable": "var(--border-widths--date-input-default)"
  },
  "borderWidths.DatePicker.InputGroup.active": {
    "value": "var(--border-widths--date-picker--input-group-active)",
    "variable": "var(--border-widths--date-picker--input-group-active)"
  },
  "borderWidths.DatePicker.InputGroup.default": {
    "value": "var(--border-widths--date-picker--input-group-default)",
    "variable": "var(--border-widths--date-picker--input-group-default)"
  },
  "borderWidths.DatePicker.Trigger.default": {
    "value": "var(--border-widths--date-picker--trigger-default)",
    "variable": "var(--border-widths--date-picker--trigger-default)"
  },
  "borderWidths.IconButton.default": {
    "value": "var(--border-widths--icon-button-default)",
    "variable": "var(--border-widths--icon-button-default)"
  },
  "borderWidths.IconButton.selected": {
    "value": "var(--border-widths--icon-button-selected)",
    "variable": "var(--border-widths--icon-button-selected)"
  },
  "borderWidths.Input.active": {
    "value": "var(--border-widths--input-active)",
    "variable": "var(--border-widths--input-active)"
  },
  "borderWidths.Input.default": {
    "value": "var(--border-widths--input-default)",
    "variable": "var(--border-widths--input-default)"
  },
  "borderWidths.Menu.Group": {
    "value": "var(--border-widths--menu--group)",
    "variable": "var(--border-widths--menu--group)"
  },
  "borderWidths.ProgressMeter.Node.active": {
    "value": "var(--border-widths--progress-meter--node-active)",
    "variable": "var(--border-widths--progress-meter--node-active)"
  },
  "borderWidths.Radio.ring.default": {
    "value": "var(--border-widths--radio-ring-default)",
    "variable": "var(--border-widths--radio-ring-default)"
  },
  "borderWidths.Radio.ring.selected": {
    "value": "var(--border-widths--radio-ring-selected)",
    "variable": "var(--border-widths--radio-ring-selected)"
  },
  "borderWidths.Range.Handle": {
    "value": "var(--border-widths--range--handle)",
    "variable": "var(--border-widths--range--handle)"
  },
  "borderWidths.Slider.Handle": {
    "value": "var(--border-widths--slider--handle)",
    "variable": "var(--border-widths--slider--handle)"
  },
  "borderWidths.Table.Cell": {
    "value": "var(--border-widths--table--cell)",
    "variable": "var(--border-widths--table--cell)"
  },
  "borderWidths.Tabs.default": {
    "value": "var(--border-widths--tabs-default)",
    "variable": "var(--border-widths--tabs-default)"
  },
  "borderWidths.ToggleButton.default": {
    "value": "var(--border-widths--toggle-button-default)",
    "variable": "var(--border-widths--toggle-button-default)"
  },
  "borderWidths.ToggleButton.selected": {
    "value": "var(--border-widths--toggle-button-selected)",
    "variable": "var(--border-widths--toggle-button-selected)"
  },
  "borderWidths.ToggleCard.Footer": {
    "value": "var(--border-widths--toggle-card--footer)",
    "variable": "var(--border-widths--toggle-card--footer)"
  },
  "borderWidths.ToggleCard.Header": {
    "value": "var(--border-widths--toggle-card--header)",
    "variable": "var(--border-widths--toggle-card--header)"
  },
  "borderWidths.ToggleCard.Root.default": {
    "value": "var(--border-widths--toggle-card--root-default)",
    "variable": "var(--border-widths--toggle-card--root-default)"
  },
  "borderWidths.ToggleCard.Root.selected": {
    "value": "var(--border-widths--toggle-card--root-selected)",
    "variable": "var(--border-widths--toggle-card--root-selected)"
  },
  "borderWidths.TriggerText": {
    "value": "var(--border-widths--trigger-text)",
    "variable": "var(--border-widths--trigger-text)"
  },
  "borderWidths.Upsell.Root": {
    "value": "var(--border-widths--upsell--root)",
    "variable": "var(--border-widths--upsell--root)"
  },
  "borderWidths.VerticalNav.Item.indicator": {
    "value": "var(--border-widths--vertical-nav--item-indicator)",
    "variable": "var(--border-widths--vertical-nav--item-indicator)"
  },
  "borderWidths.VerticalNav.Root": {
    "value": "var(--border-widths--vertical-nav--root)",
    "variable": "var(--border-widths--vertical-nav--root)"
  },
  "borderWidths.control.selected": {
    "value": "var(--border-widths-control-selected)",
    "variable": "var(--border-widths-control-selected)"
  },
  "borderWidths.default": {
    "value": "var(--border-widths-default)",
    "variable": "var(--border-widths-default)"
  },
  "borderWidths.none": {
    "value": "var(--border-widths-none)",
    "variable": "var(--border-widths-none)"
  },
  "borderWidths.thick": {
    "value": "var(--border-widths-thick)",
    "variable": "var(--border-widths-thick)"
  },
  "borderWidths.thicker": {
    "value": "var(--border-widths-thicker)",
    "variable": "var(--border-widths-thicker)"
  },
  "borderWidths.selected": {
    "value": "var(--border-widths-selected)",
    "variable": "var(--border-widths-selected)"
  },
  "borderWidths.xs": {
    "value": "var(--border-widths-xs)",
    "variable": "var(--border-widths-xs)"
  },
  "borderWidths.sm": {
    "value": "var(--border-widths-sm)",
    "variable": "var(--border-widths-sm)"
  },
  "borderWidths.md": {
    "value": "var(--border-widths-md)",
    "variable": "var(--border-widths-md)"
  },
  "borderWidths.lg": {
    "value": "var(--border-widths-lg)",
    "variable": "var(--border-widths-lg)"
  },
  "borderWidths.xl": {
    "value": "var(--border-widths-xl)",
    "variable": "var(--border-widths-xl)"
  },
  "radii.Accordion.default": {
    "value": "var(--radii--accordion-default)",
    "variable": "var(--radii--accordion-default)"
  },
  "radii.Accordion.fullWidth": {
    "value": "var(--radii--accordion-full-width)",
    "variable": "var(--radii--accordion-full-width)"
  },
  "radii.Accordion.conjoined": {
    "value": "var(--radii--accordion-conjoined)",
    "variable": "var(--radii--accordion-conjoined)"
  },
  "radii.AdornedInput.sm": {
    "value": "var(--radii--adorned-input-sm)",
    "variable": "var(--radii--adorned-input-sm)"
  },
  "radii.AdornedInput.md.default": {
    "value": "var(--radii--adorned-input-md-default)",
    "variable": "var(--radii--adorned-input-md-default)"
  },
  "radii.AdornedInput.md.messaging": {
    "value": "var(--radii--adorned-input-md-messaging)",
    "variable": "var(--radii--adorned-input-md-messaging)"
  },
  "radii.AdornedInput.lg.default": {
    "value": "var(--radii--adorned-input-lg-default)",
    "variable": "var(--radii--adorned-input-lg-default)"
  },
  "radii.AdornedInput.lg.messaging": {
    "value": "var(--radii--adorned-input-lg-messaging)",
    "variable": "var(--radii--adorned-input-lg-messaging)"
  },
  "radii.Alert": {
    "value": "var(--radii--alert)",
    "variable": "var(--radii--alert)"
  },
  "radii.Avatar.Badge.sm": {
    "value": "var(--radii--avatar--badge-sm)",
    "variable": "var(--radii--avatar--badge-sm)"
  },
  "radii.Avatar.Badge.md": {
    "value": "var(--radii--avatar--badge-md)",
    "variable": "var(--radii--avatar--badge-md)"
  },
  "radii.Avatar.Badge.lg": {
    "value": "var(--radii--avatar--badge-lg)",
    "variable": "var(--radii--avatar--badge-lg)"
  },
  "radii.Avatar.Image.default": {
    "value": "var(--radii--avatar--image-default)",
    "variable": "var(--radii--avatar--image-default)"
  },
  "radii.Avatar.Root.default": {
    "value": "var(--radii--avatar--root-default)",
    "variable": "var(--radii--avatar--root-default)"
  },
  "radii.Badge": {
    "value": "var(--radii--badge)",
    "variable": "var(--radii--badge)"
  },
  "radii.Banner": {
    "value": "var(--radii--banner)",
    "variable": "var(--radii--banner)"
  },
  "radii.ButtonGroup.conjoined": {
    "value": "var(--radii--button-group-conjoined)",
    "variable": "var(--radii--button-group-conjoined)"
  },
  "radii.Button.sm": {
    "value": "var(--radii--button-sm)",
    "variable": "var(--radii--button-sm)"
  },
  "radii.Button.md": {
    "value": "var(--radii--button-md)",
    "variable": "var(--radii--button-md)"
  },
  "radii.Button.lg": {
    "value": "var(--radii--button-lg)",
    "variable": "var(--radii--button-lg)"
  },
  "radii.Calendar.ControlButton": {
    "value": "var(--radii--calendar--control-button)",
    "variable": "var(--radii--calendar--control-button)"
  },
  "radii.Calendar.Day": {
    "value": "var(--radii--calendar--day)",
    "variable": "var(--radii--calendar--day)"
  },
  "radii.Calendar.YearSelect.button": {
    "value": "var(--radii--calendar--year-select-button)",
    "variable": "var(--radii--calendar--year-select-button)"
  },
  "radii.Card.Root": {
    "value": "var(--radii--card--root)",
    "variable": "var(--radii--card--root)"
  },
  "radii.Checkbox.box": {
    "value": "var(--radii--checkbox-box)",
    "variable": "var(--radii--checkbox-box)"
  },
  "radii.Chip": {
    "value": "var(--radii--chip)",
    "variable": "var(--radii--chip)"
  },
  "radii.CloseButton": {
    "value": "var(--radii--close-button)",
    "variable": "var(--radii--close-button)"
  },
  "radii.Combobox.Content": {
    "value": "var(--radii--combobox--content)",
    "variable": "var(--radii--combobox--content)"
  },
  "radii.Combobox.Trigger.sm": {
    "value": "var(--radii--combobox--trigger-sm)",
    "variable": "var(--radii--combobox--trigger-sm)"
  },
  "radii.Combobox.Trigger.md": {
    "value": "var(--radii--combobox--trigger-md)",
    "variable": "var(--radii--combobox--trigger-md)"
  },
  "radii.Combobox.Trigger.lg": {
    "value": "var(--radii--combobox--trigger-lg)",
    "variable": "var(--radii--combobox--trigger-lg)"
  },
  "radii.DateInput.sm": {
    "value": "var(--radii--date-input-sm)",
    "variable": "var(--radii--date-input-sm)"
  },
  "radii.DateInput.md.default": {
    "value": "var(--radii--date-input-md-default)",
    "variable": "var(--radii--date-input-md-default)"
  },
  "radii.DateInput.lg.default": {
    "value": "var(--radii--date-input-lg-default)",
    "variable": "var(--radii--date-input-lg-default)"
  },
  "radii.DatePicker.Content": {
    "value": "var(--radii--date-picker--content)",
    "variable": "var(--radii--date-picker--content)"
  },
  "radii.DatePicker.InputGroup.sm": {
    "value": "var(--radii--date-picker--input-group-sm)",
    "variable": "var(--radii--date-picker--input-group-sm)"
  },
  "radii.DatePicker.InputGroup.md": {
    "value": "var(--radii--date-picker--input-group-md)",
    "variable": "var(--radii--date-picker--input-group-md)"
  },
  "radii.DatePicker.InputGroup.lg": {
    "value": "var(--radii--date-picker--input-group-lg)",
    "variable": "var(--radii--date-picker--input-group-lg)"
  },
  "radii.DatePicker.Trigger.sm.topRight": {
    "value": "var(--radii--date-picker--trigger-sm-top-right)",
    "variable": "var(--radii--date-picker--trigger-sm-top-right)"
  },
  "radii.DatePicker.Trigger.sm.bottomRight": {
    "value": "var(--radii--date-picker--trigger-sm-bottom-right)",
    "variable": "var(--radii--date-picker--trigger-sm-bottom-right)"
  },
  "radii.DatePicker.Trigger.sm.topLeft": {
    "value": "var(--radii--date-picker--trigger-sm-top-left)",
    "variable": "var(--radii--date-picker--trigger-sm-top-left)"
  },
  "radii.DatePicker.Trigger.sm.bottomLeft": {
    "value": "var(--radii--date-picker--trigger-sm-bottom-left)",
    "variable": "var(--radii--date-picker--trigger-sm-bottom-left)"
  },
  "radii.DatePicker.Trigger.md.topRight": {
    "value": "var(--radii--date-picker--trigger-md-top-right)",
    "variable": "var(--radii--date-picker--trigger-md-top-right)"
  },
  "radii.DatePicker.Trigger.md.bottomRight": {
    "value": "var(--radii--date-picker--trigger-md-bottom-right)",
    "variable": "var(--radii--date-picker--trigger-md-bottom-right)"
  },
  "radii.DatePicker.Trigger.md.topLeft": {
    "value": "var(--radii--date-picker--trigger-md-top-left)",
    "variable": "var(--radii--date-picker--trigger-md-top-left)"
  },
  "radii.DatePicker.Trigger.md.bottomLeft": {
    "value": "var(--radii--date-picker--trigger-md-bottom-left)",
    "variable": "var(--radii--date-picker--trigger-md-bottom-left)"
  },
  "radii.DatePicker.Trigger.lg.topRight": {
    "value": "var(--radii--date-picker--trigger-lg-top-right)",
    "variable": "var(--radii--date-picker--trigger-lg-top-right)"
  },
  "radii.DatePicker.Trigger.lg.bottomRight": {
    "value": "var(--radii--date-picker--trigger-lg-bottom-right)",
    "variable": "var(--radii--date-picker--trigger-lg-bottom-right)"
  },
  "radii.DatePicker.Trigger.lg.topLeft": {
    "value": "var(--radii--date-picker--trigger-lg-top-left)",
    "variable": "var(--radii--date-picker--trigger-lg-top-left)"
  },
  "radii.DatePicker.Trigger.lg.bottomLeft": {
    "value": "var(--radii--date-picker--trigger-lg-bottom-left)",
    "variable": "var(--radii--date-picker--trigger-lg-bottom-left)"
  },
  "radii.Divider": {
    "value": "var(--radii--divider)",
    "variable": "var(--radii--divider)"
  },
  "radii.Dropdown.Content": {
    "value": "var(--radii--dropdown--content)",
    "variable": "var(--radii--dropdown--content)"
  },
  "radii.DuoColorIcon.Root.borderRadius": {
    "value": "var(--radii--duo-color-icon--root-border-radius)",
    "variable": "var(--radii--duo-color-icon--root-border-radius)"
  },
  "radii.Gleam.default": {
    "value": "var(--radii--gleam-default)",
    "variable": "var(--radii--gleam-default)"
  },
  "radii.IconButton.circle": {
    "value": "var(--radii--icon-button-circle)",
    "variable": "var(--radii--icon-button-circle)"
  },
  "radii.IconButton.square": {
    "value": "var(--radii--icon-button-square)",
    "variable": "var(--radii--icon-button-square)"
  },
  "radii.Input.sm": {
    "value": "var(--radii--input-sm)",
    "variable": "var(--radii--input-sm)"
  },
  "radii.Input.md.default": {
    "value": "var(--radii--input-md-default)",
    "variable": "var(--radii--input-md-default)"
  },
  "radii.Input.md.messaging": {
    "value": "var(--radii--input-md-messaging)",
    "variable": "var(--radii--input-md-messaging)"
  },
  "radii.Input.lg.default": {
    "value": "var(--radii--input-lg-default)",
    "variable": "var(--radii--input-lg-default)"
  },
  "radii.Input.lg.messaging": {
    "value": "var(--radii--input-lg-messaging)",
    "variable": "var(--radii--input-lg-messaging)"
  },
  "radii.Layout.Content": {
    "value": "var(--radii--layout--content)",
    "variable": "var(--radii--layout--content)"
  },
  "radii.Menu.Content": {
    "value": "var(--radii--menu--content)",
    "variable": "var(--radii--menu--content)"
  },
  "radii.Modal.Content.default": {
    "value": "var(--radii--modal--content-default)",
    "variable": "var(--radii--modal--content-default)"
  },
  "radii.Modal.Content.fullscreen": {
    "value": "var(--radii--modal--content-fullscreen)",
    "variable": "var(--radii--modal--content-fullscreen)"
  },
  "radii.Pagination.PageButton.default": {
    "value": "var(--radii--pagination--page-button-default)",
    "variable": "var(--radii--pagination--page-button-default)"
  },
  "radii.PhotoCarousel.Dot": {
    "value": "var(--radii--photo-carousel--dot)",
    "variable": "var(--radii--photo-carousel--dot)"
  },
  "radii.PhotoCarousel.Dots": {
    "value": "var(--radii--photo-carousel--dots)",
    "variable": "var(--radii--photo-carousel--dots)"
  },
  "radii.Popover.Content": {
    "value": "var(--radii--popover--content)",
    "variable": "var(--radii--popover--content)"
  },
  "radii.ProgressIndicator.bar.sm": {
    "value": "var(--radii--progress-indicator-bar-sm)",
    "variable": "var(--radii--progress-indicator-bar-sm)"
  },
  "radii.ProgressIndicator.bar.md": {
    "value": "var(--radii--progress-indicator-bar-md)",
    "variable": "var(--radii--progress-indicator-bar-md)"
  },
  "radii.ProgressMeter.Node.default": {
    "value": "var(--radii--progress-meter--node-default)",
    "variable": "var(--radii--progress-meter--node-default)"
  },
  "radii.ProgressMeter.Track.default": {
    "value": "var(--radii--progress-meter--track-default)",
    "variable": "var(--radii--progress-meter--track-default)"
  },
  "radii.PropertyCard.Badge": {
    "value": "var(--radii--property-card--badge)",
    "variable": "var(--radii--property-card--badge)"
  },
  "radii.PropertyCard.Body": {
    "value": "var(--radii--property-card--body)",
    "variable": "var(--radii--property-card--body)"
  },
  "radii.Radio": {
    "value": "var(--radii--radio)",
    "variable": "var(--radii--radio)"
  },
  "radii.Range.Handle": {
    "value": "var(--radii--range--handle)",
    "variable": "var(--radii--range--handle)"
  },
  "radii.Range.Track": {
    "value": "var(--radii--range--track)",
    "variable": "var(--radii--range--track)"
  },
  "radii.Slider.Handle": {
    "value": "var(--radii--slider--handle)",
    "variable": "var(--radii--slider--handle)"
  },
  "radii.Slider.Track": {
    "value": "var(--radii--slider--track)",
    "variable": "var(--radii--slider--track)"
  },
  "radii.Switch.Track.md": {
    "value": "var(--radii--switch--track-md)",
    "variable": "var(--radii--switch--track-md)"
  },
  "radii.Switch.Track.lg": {
    "value": "var(--radii--switch--track-lg)",
    "variable": "var(--radii--switch--track-lg)"
  },
  "radii.Switch.Handle.md": {
    "value": "var(--radii--switch--handle-md)",
    "variable": "var(--radii--switch--handle-md)"
  },
  "radii.Switch.Handle.lg": {
    "value": "var(--radii--switch--handle-lg)",
    "variable": "var(--radii--switch--handle-lg)"
  },
  "radii.Table.Cell": {
    "value": "var(--radii--table--cell)",
    "variable": "var(--radii--table--cell)"
  },
  "radii.Tabs.tab": {
    "value": "var(--radii--tabs-tab)",
    "variable": "var(--radii--tabs-tab)"
  },
  "radii.Tabs.indicator": {
    "value": "var(--radii--tabs-indicator)",
    "variable": "var(--radii--tabs-indicator)"
  },
  "radii.Tabs.panel": {
    "value": "var(--radii--tabs-panel)",
    "variable": "var(--radii--tabs-panel)"
  },
  "radii.Tag.sm": {
    "value": "var(--radii--tag-sm)",
    "variable": "var(--radii--tag-sm)"
  },
  "radii.Tag.md": {
    "value": "var(--radii--tag-md)",
    "variable": "var(--radii--tag-md)"
  },
  "radii.Textarea": {
    "value": "var(--radii--textarea)",
    "variable": "var(--radii--textarea)"
  },
  "radii.Toast": {
    "value": "var(--radii--toast)",
    "variable": "var(--radii--toast)"
  },
  "radii.ToggleButton.sm": {
    "value": "var(--radii--toggle-button-sm)",
    "variable": "var(--radii--toggle-button-sm)"
  },
  "radii.ToggleButton.md": {
    "value": "var(--radii--toggle-button-md)",
    "variable": "var(--radii--toggle-button-md)"
  },
  "radii.ToggleButton.lg": {
    "value": "var(--radii--toggle-button-lg)",
    "variable": "var(--radii--toggle-button-lg)"
  },
  "radii.ToggleCard.Root": {
    "value": "var(--radii--toggle-card--root)",
    "variable": "var(--radii--toggle-card--root)"
  },
  "radii.Tooltip": {
    "value": "var(--radii--tooltip)",
    "variable": "var(--radii--tooltip)"
  },
  "radii.TriggerButton": {
    "value": "var(--radii--trigger-button)",
    "variable": "var(--radii--trigger-button)"
  },
  "radii.UpsellBanner.Root": {
    "value": "var(--radii--upsell-banner--root)",
    "variable": "var(--radii--upsell-banner--root)"
  },
  "radii.Upsell.Root": {
    "value": "var(--radii--upsell--root)",
    "variable": "var(--radii--upsell--root)"
  },
  "radii.VerticalNav.Item": {
    "value": "var(--radii--vertical-nav--item)",
    "variable": "var(--radii--vertical-nav--item)"
  },
  "radii.VerticalNav.Root": {
    "value": "var(--radii--vertical-nav--root)",
    "variable": "var(--radii--vertical-nav--root)"
  },
  "radii.none": {
    "value": "var(--radii-none)",
    "variable": "var(--radii-none)"
  },
  "radii.obj.sharp": {
    "value": "var(--radii-obj-sharp)",
    "variable": "var(--radii-obj-sharp)"
  },
  "radii.obj.default": {
    "value": "var(--radii-obj-default)",
    "variable": "var(--radii-obj-default)"
  },
  "radii.obj.soft": {
    "value": "var(--radii-obj-soft)",
    "variable": "var(--radii-obj-soft)"
  },
  "radii.obj.fullWidth": {
    "value": "var(--radii-obj-full-width)",
    "variable": "var(--radii-obj-full-width)"
  },
  "radii.obj.conjoined": {
    "value": "var(--radii-obj-conjoined)",
    "variable": "var(--radii-obj-conjoined)"
  },
  "radii.shape.capsule": {
    "value": "var(--radii-shape-capsule)",
    "variable": "var(--radii-shape-capsule)"
  },
  "radii.shape.ellipse": {
    "value": "var(--radii-shape-ellipse)",
    "variable": "var(--radii-shape-ellipse)"
  },
  "radii.shape.flexCapsule.md": {
    "value": "var(--radii-shape-flex-capsule-md)",
    "variable": "var(--radii-shape-flex-capsule-md)"
  },
  "radii.shape.flexCapsule.lg": {
    "value": "var(--radii-shape-flex-capsule-lg)",
    "variable": "var(--radii-shape-flex-capsule-lg)"
  },
  "radii.sheets.sharp": {
    "value": "var(--radii-sheets-sharp)",
    "variable": "var(--radii-sheets-sharp)"
  },
  "radii.sheets.default": {
    "value": "var(--radii-sheets-default)",
    "variable": "var(--radii-sheets-default)"
  },
  "radii.sm": {
    "value": "var(--radii-sm)",
    "variable": "var(--radii-sm)"
  },
  "radii.md": {
    "value": "var(--radii-md)",
    "variable": "var(--radii-md)"
  },
  "radii.lg": {
    "value": "var(--radii-lg)",
    "variable": "var(--radii-lg)"
  },
  "radii.pill": {
    "value": "var(--radii-pill)",
    "variable": "var(--radii-pill)"
  },
  "spacing.Accordion.gap.header-toPanel": {
    "value": "var(--spacing--accordion-gap-header-to-panel)",
    "variable": "var(--spacing--accordion-gap-header-to-panel)"
  },
  "spacing.Accordion.gap.betweenAccordions": {
    "value": "var(--spacing--accordion-gap-between-accordions)",
    "variable": "var(--spacing--accordion-gap-between-accordions)"
  },
  "spacing.Accordion.Header.gap.leading": {
    "value": "var(--spacing--accordion--header-gap-leading)",
    "variable": "var(--spacing--accordion--header-gap-leading)"
  },
  "spacing.Accordion.Header.gap.trailing": {
    "value": "var(--spacing--accordion--header-gap-trailing)",
    "variable": "var(--spacing--accordion--header-gap-trailing)"
  },
  "spacing.Accordion.Header.gap.trailingLabel-toIcon": {
    "value": "var(--spacing--accordion--header-gap-trailing-label-to-icon)",
    "variable": "var(--spacing--accordion--header-gap-trailing-label-to-icon)"
  },
  "spacing.Accordion.Header.padding.horz": {
    "value": "var(--spacing--accordion--header-padding-horz)",
    "variable": "var(--spacing--accordion--header-padding-horz)"
  },
  "spacing.Accordion.Header.padding.vert": {
    "value": "var(--spacing--accordion--header-padding-vert)",
    "variable": "var(--spacing--accordion--header-padding-vert)"
  },
  "spacing.Accordion.Panel.padding.horz": {
    "value": "var(--spacing--accordion--panel-padding-horz)",
    "variable": "var(--spacing--accordion--panel-padding-horz)"
  },
  "spacing.Accordion.Panel.padding.top": {
    "value": "var(--spacing--accordion--panel-padding-top)",
    "variable": "var(--spacing--accordion--panel-padding-top)"
  },
  "spacing.Accordion.Panel.padding.bottom": {
    "value": "var(--spacing--accordion--panel-padding-bottom)",
    "variable": "var(--spacing--accordion--panel-padding-bottom)"
  },
  "spacing.AdornedInput.sm.gap.input-toAdornment": {
    "value": "var(--spacing--adorned-input-sm-gap-input-to-adornment)",
    "variable": "var(--spacing--adorned-input-sm-gap-input-to-adornment)"
  },
  "spacing.AdornedInput.sm.padding.horz": {
    "value": "var(--spacing--adorned-input-sm-padding-horz)",
    "variable": "var(--spacing--adorned-input-sm-padding-horz)"
  },
  "spacing.AdornedInput.sm.padding.horz-readOnly": {
    "value": "var(--spacing--adorned-input-sm-padding-horz-read-only)",
    "variable": "var(--spacing--adorned-input-sm-padding-horz-read-only)"
  },
  "spacing.AdornedInput.sm.padding.vert": {
    "value": "var(--spacing--adorned-input-sm-padding-vert)",
    "variable": "var(--spacing--adorned-input-sm-padding-vert)"
  },
  "spacing.AdornedInput.md.gap.input-toAdornment": {
    "value": "var(--spacing--adorned-input-md-gap-input-to-adornment)",
    "variable": "var(--spacing--adorned-input-md-gap-input-to-adornment)"
  },
  "spacing.AdornedInput.md.padding.horz": {
    "value": "var(--spacing--adorned-input-md-padding-horz)",
    "variable": "var(--spacing--adorned-input-md-padding-horz)"
  },
  "spacing.AdornedInput.md.padding.horz-readOnly": {
    "value": "var(--spacing--adorned-input-md-padding-horz-read-only)",
    "variable": "var(--spacing--adorned-input-md-padding-horz-read-only)"
  },
  "spacing.AdornedInput.md.padding.vert": {
    "value": "var(--spacing--adorned-input-md-padding-vert)",
    "variable": "var(--spacing--adorned-input-md-padding-vert)"
  },
  "spacing.AdornedInput.lg.gap.input-toAdornment": {
    "value": "var(--spacing--adorned-input-lg-gap-input-to-adornment)",
    "variable": "var(--spacing--adorned-input-lg-gap-input-to-adornment)"
  },
  "spacing.AdornedInput.lg.padding.horz": {
    "value": "var(--spacing--adorned-input-lg-padding-horz)",
    "variable": "var(--spacing--adorned-input-lg-padding-horz)"
  },
  "spacing.AdornedInput.lg.padding.horz-readOnly": {
    "value": "var(--spacing--adorned-input-lg-padding-horz-read-only)",
    "variable": "var(--spacing--adorned-input-lg-padding-horz-read-only)"
  },
  "spacing.AdornedInput.lg.padding.vert": {
    "value": "var(--spacing--adorned-input-lg-padding-vert)",
    "variable": "var(--spacing--adorned-input-lg-padding-vert)"
  },
  "spacing.Alert.gap.content-toActions": {
    "value": "var(--spacing--alert-gap-content-to-actions)",
    "variable": "var(--spacing--alert-gap-content-to-actions)"
  },
  "spacing.Alert.gap.leading": {
    "value": "var(--spacing--alert-gap-leading)",
    "variable": "var(--spacing--alert-gap-leading)"
  },
  "spacing.Alert.gap.trailing": {
    "value": "var(--spacing--alert-gap-trailing)",
    "variable": "var(--spacing--alert-gap-trailing)"
  },
  "spacing.Alert.gap.message.toFlexArea": {
    "value": "var(--spacing--alert-gap-message-to-flex-area)",
    "variable": "var(--spacing--alert-gap-message-to-flex-area)"
  },
  "spacing.Alert.padding.horz": {
    "value": "var(--spacing--alert-padding-horz)",
    "variable": "var(--spacing--alert-padding-horz)"
  },
  "spacing.Alert.padding.vert": {
    "value": "var(--spacing--alert-padding-vert)",
    "variable": "var(--spacing--alert-padding-vert)"
  },
  "spacing.Alert.CloseButton.margin.top": {
    "value": "var(--spacing--alert--close-button-margin-top)",
    "variable": "var(--spacing--alert--close-button-margin-top)"
  },
  "spacing.Alert.CloseButton.margin.right": {
    "value": "var(--spacing--alert--close-button-margin-right)",
    "variable": "var(--spacing--alert--close-button-margin-right)"
  },
  "spacing.Anchor.icon-toLabel": {
    "value": "var(--spacing--anchor-icon-to-label)",
    "variable": "var(--spacing--anchor-icon-to-label)"
  },
  "spacing.Avatar.Badge.padding.sm.default": {
    "value": "var(--spacing--avatar--badge-padding-sm-default)",
    "variable": "var(--spacing--avatar--badge-padding-sm-default)"
  },
  "spacing.Avatar.Badge.padding.sm.bare": {
    "value": "var(--spacing--avatar--badge-padding-sm-bare)",
    "variable": "var(--spacing--avatar--badge-padding-sm-bare)"
  },
  "spacing.Avatar.Badge.padding.md.default": {
    "value": "var(--spacing--avatar--badge-padding-md-default)",
    "variable": "var(--spacing--avatar--badge-padding-md-default)"
  },
  "spacing.Avatar.Badge.padding.md.bare": {
    "value": "var(--spacing--avatar--badge-padding-md-bare)",
    "variable": "var(--spacing--avatar--badge-padding-md-bare)"
  },
  "spacing.Avatar.Badge.padding.lg.default": {
    "value": "var(--spacing--avatar--badge-padding-lg-default)",
    "variable": "var(--spacing--avatar--badge-padding-lg-default)"
  },
  "spacing.Avatar.Badge.padding.lg.bare": {
    "value": "var(--spacing--avatar--badge-padding-lg-bare)",
    "variable": "var(--spacing--avatar--badge-padding-lg-bare)"
  },
  "spacing.Avatar.Badge.offset.sm.horz": {
    "value": "var(--spacing--avatar--badge-offset-sm-horz)",
    "variable": "var(--spacing--avatar--badge-offset-sm-horz)"
  },
  "spacing.Avatar.Badge.offset.sm.vert": {
    "value": "var(--spacing--avatar--badge-offset-sm-vert)",
    "variable": "var(--spacing--avatar--badge-offset-sm-vert)"
  },
  "spacing.Avatar.Badge.offset.md.horz": {
    "value": "var(--spacing--avatar--badge-offset-md-horz)",
    "variable": "var(--spacing--avatar--badge-offset-md-horz)"
  },
  "spacing.Avatar.Badge.offset.md.vert": {
    "value": "var(--spacing--avatar--badge-offset-md-vert)",
    "variable": "var(--spacing--avatar--badge-offset-md-vert)"
  },
  "spacing.Avatar.Badge.offset.lg.horz": {
    "value": "var(--spacing--avatar--badge-offset-lg-horz)",
    "variable": "var(--spacing--avatar--badge-offset-lg-horz)"
  },
  "spacing.Avatar.Badge.offset.lg.vert": {
    "value": "var(--spacing--avatar--badge-offset-lg-vert)",
    "variable": "var(--spacing--avatar--badge-offset-lg-vert)"
  },
  "spacing.Badge.gap.label-toIcon": {
    "value": "var(--spacing--badge-gap-label-to-icon)",
    "variable": "var(--spacing--badge-gap-label-to-icon)"
  },
  "spacing.Badge.padding.horz": {
    "value": "var(--spacing--badge-padding-horz)",
    "variable": "var(--spacing--badge-padding-horz)"
  },
  "spacing.Badge.padding.vert": {
    "value": "var(--spacing--badge-padding-vert)",
    "variable": "var(--spacing--badge-padding-vert)"
  },
  "spacing.Banner.gap.leading": {
    "value": "var(--spacing--banner-gap-leading)",
    "variable": "var(--spacing--banner-gap-leading)"
  },
  "spacing.Banner.gap.trailing": {
    "value": "var(--spacing--banner-gap-trailing)",
    "variable": "var(--spacing--banner-gap-trailing)"
  },
  "spacing.Banner.gap.text-toActions.horz": {
    "value": "var(--spacing--banner-gap-text-to-actions-horz)",
    "variable": "var(--spacing--banner-gap-text-to-actions-horz)"
  },
  "spacing.Banner.gap.text-toActions.vert": {
    "value": "var(--spacing--banner-gap-text-to-actions-vert)",
    "variable": "var(--spacing--banner-gap-text-to-actions-vert)"
  },
  "spacing.Banner.padding.horz": {
    "value": "var(--spacing--banner-padding-horz)",
    "variable": "var(--spacing--banner-padding-horz)"
  },
  "spacing.Banner.padding.vert": {
    "value": "var(--spacing--banner-padding-vert)",
    "variable": "var(--spacing--banner-padding-vert)"
  },
  "spacing.Banner.CloseButton.margin.top": {
    "value": "var(--spacing--banner--close-button-margin-top)",
    "variable": "var(--spacing--banner--close-button-margin-top)"
  },
  "spacing.Banner.CloseButton.margin.right": {
    "value": "var(--spacing--banner--close-button-margin-right)",
    "variable": "var(--spacing--banner--close-button-margin-right)"
  },
  "spacing.ButtonGroup.gap.horz": {
    "value": "var(--spacing--button-group-gap-horz)",
    "variable": "var(--spacing--button-group-gap-horz)"
  },
  "spacing.ButtonGroup.gap.vert": {
    "value": "var(--spacing--button-group-gap-vert)",
    "variable": "var(--spacing--button-group-gap-vert)"
  },
  "spacing.ButtonGroup.conjoined.gap.default": {
    "value": "var(--spacing--button-group-conjoined-gap-default)",
    "variable": "var(--spacing--button-group-conjoined-gap-default)"
  },
  "spacing.ButtonGroup.conjoined.gap.offsetBorder": {
    "value": "var(--spacing--button-group-conjoined-gap-offset-border)",
    "variable": "var(--spacing--button-group-conjoined-gap-offset-border)"
  },
  "spacing.ButtonGroup.bare.gap.horz": {
    "value": "var(--spacing--button-group-bare-gap-horz)",
    "variable": "var(--spacing--button-group-bare-gap-horz)"
  },
  "spacing.ButtonGroup.bare.gap.vert": {
    "value": "var(--spacing--button-group-bare-gap-vert)",
    "variable": "var(--spacing--button-group-bare-gap-vert)"
  },
  "spacing.ButtonGroup.textButton.padding.padding.horz": {
    "value": "var(--spacing--button-group-text-button-padding-padding-horz)",
    "variable": "var(--spacing--button-group-text-button-padding-padding-horz)"
  },
  "spacing.ButtonGroup.textButton.padding.padding.vert": {
    "value": "var(--spacing--button-group-text-button-padding-padding-vert)",
    "variable": "var(--spacing--button-group-text-button-padding-padding-vert)"
  },
  "spacing.Button.xs.gap.label-toIcon": {
    "value": "var(--spacing--button-xs-gap-label-to-icon)",
    "variable": "var(--spacing--button-xs-gap-label-to-icon)"
  },
  "spacing.Button.xs.padding.horz": {
    "value": "var(--spacing--button-xs-padding-horz)",
    "variable": "var(--spacing--button-xs-padding-horz)"
  },
  "spacing.Button.xs.padding.vert": {
    "value": "var(--spacing--button-xs-padding-vert)",
    "variable": "var(--spacing--button-xs-padding-vert)"
  },
  "spacing.Button.sm.gap.label-toIcon": {
    "value": "var(--spacing--button-sm-gap-label-to-icon)",
    "variable": "var(--spacing--button-sm-gap-label-to-icon)"
  },
  "spacing.Button.sm.padding.bare.horz": {
    "value": "var(--spacing--button-sm-padding-bare-horz)",
    "variable": "var(--spacing--button-sm-padding-bare-horz)"
  },
  "spacing.Button.sm.padding.horz": {
    "value": "var(--spacing--button-sm-padding-horz)",
    "variable": "var(--spacing--button-sm-padding-horz)"
  },
  "spacing.Button.sm.padding.vert": {
    "value": "var(--spacing--button-sm-padding-vert)",
    "variable": "var(--spacing--button-sm-padding-vert)"
  },
  "spacing.Button.md.gap.label-toIcon": {
    "value": "var(--spacing--button-md-gap-label-to-icon)",
    "variable": "var(--spacing--button-md-gap-label-to-icon)"
  },
  "spacing.Button.md.padding.bare.horz": {
    "value": "var(--spacing--button-md-padding-bare-horz)",
    "variable": "var(--spacing--button-md-padding-bare-horz)"
  },
  "spacing.Button.md.padding.horz": {
    "value": "var(--spacing--button-md-padding-horz)",
    "variable": "var(--spacing--button-md-padding-horz)"
  },
  "spacing.Button.md.padding.vert": {
    "value": "var(--spacing--button-md-padding-vert)",
    "variable": "var(--spacing--button-md-padding-vert)"
  },
  "spacing.Button.lg.gap.label-toIcon": {
    "value": "var(--spacing--button-lg-gap-label-to-icon)",
    "variable": "var(--spacing--button-lg-gap-label-to-icon)"
  },
  "spacing.Button.lg.padding.bare.horz": {
    "value": "var(--spacing--button-lg-padding-bare-horz)",
    "variable": "var(--spacing--button-lg-padding-bare-horz)"
  },
  "spacing.Button.lg.padding.horz": {
    "value": "var(--spacing--button-lg-padding-horz)",
    "variable": "var(--spacing--button-lg-padding-horz)"
  },
  "spacing.Button.lg.padding.vert": {
    "value": "var(--spacing--button-lg-padding-vert)",
    "variable": "var(--spacing--button-lg-padding-vert)"
  },
  "spacing.Calendar.Body.gap.header-toDays": {
    "value": "var(--spacing--calendar--body-gap-header-to-days)",
    "variable": "var(--spacing--calendar--body-gap-header-to-days)"
  },
  "spacing.Calendar.Body.padding.horz": {
    "value": "var(--spacing--calendar--body-padding-horz)",
    "variable": "var(--spacing--calendar--body-padding-horz)"
  },
  "spacing.Calendar.Controls.gap": {
    "value": "var(--spacing--calendar--controls-gap)",
    "variable": "var(--spacing--calendar--controls-gap)"
  },
  "spacing.Calendar.Controls.padding.horz": {
    "value": "var(--spacing--calendar--controls-padding-horz)",
    "variable": "var(--spacing--calendar--controls-padding-horz)"
  },
  "spacing.Calendar.DayOfWeek.padding.bottom": {
    "value": "var(--spacing--calendar--day-of-week-padding-bottom)",
    "variable": "var(--spacing--calendar--day-of-week-padding-bottom)"
  },
  "spacing.Calendar.Day.margin.horz": {
    "value": "var(--spacing--calendar--day-margin-horz)",
    "variable": "var(--spacing--calendar--day-margin-horz)"
  },
  "spacing.Calendar.Day.margin.vert": {
    "value": "var(--spacing--calendar--day-margin-vert)",
    "variable": "var(--spacing--calendar--day-margin-vert)"
  },
  "spacing.Calendar.Root.gap.controls-toBody": {
    "value": "var(--spacing--calendar--root-gap-controls-to-body)",
    "variable": "var(--spacing--calendar--root-gap-controls-to-body)"
  },
  "spacing.Calendar.YearSelect.padding.left": {
    "value": "var(--spacing--calendar--year-select-padding-left)",
    "variable": "var(--spacing--calendar--year-select-padding-left)"
  },
  "spacing.Calendar.YearSelect.gap.select-toButton": {
    "value": "var(--spacing--calendar--year-select-gap-select-to-button)",
    "variable": "var(--spacing--calendar--year-select-gap-select-to-button)"
  },
  "spacing.Card.Footer.margin.to-Body": {
    "value": "var(--spacing--card--footer-margin-to--body)",
    "variable": "var(--spacing--card--footer-margin-to--body)"
  },
  "spacing.Card.Footer.padding.from-Footer": {
    "value": "var(--spacing--card--footer-padding-from--footer)",
    "variable": "var(--spacing--card--footer-padding-from--footer)"
  },
  "spacing.Card.Header.margin.to-Body": {
    "value": "var(--spacing--card--header-margin-to--body)",
    "variable": "var(--spacing--card--header-margin-to--body)"
  },
  "spacing.Card.Header.padding.from-Header": {
    "value": "var(--spacing--card--header-padding-from--header)",
    "variable": "var(--spacing--card--header-padding-from--header)"
  },
  "spacing.Card.Root.padding": {
    "value": "var(--spacing--card--root-padding)",
    "variable": "var(--spacing--card--root-padding)"
  },
  "spacing.Carousel.Heading.gap.heading-toNav": {
    "value": "var(--spacing--carousel--heading-gap-heading-to-nav)",
    "variable": "var(--spacing--carousel--heading-gap-heading-to-nav)"
  },
  "spacing.Carousel.Heading.gap.heading-toDescription": {
    "value": "var(--spacing--carousel--heading-gap-heading-to-description)",
    "variable": "var(--spacing--carousel--heading-gap-heading-to-description)"
  },
  "spacing.Carousel.Heading.gap.betweenNav": {
    "value": "var(--spacing--carousel--heading-gap-between-nav)",
    "variable": "var(--spacing--carousel--heading-gap-between-nav)"
  },
  "spacing.Carousel.Heading.padding.headingArea-toSlideArray": {
    "value": "var(--spacing--carousel--heading-padding-heading-area-to-slide-array)",
    "variable": "var(--spacing--carousel--heading-padding-heading-area-to-slide-array)"
  },
  "spacing.Carousel.Root.gap-carousel-toButton": {
    "value": "var(--spacing--carousel--root-gap-carousel-to-button)",
    "variable": "var(--spacing--carousel--root-gap-carousel-to-button)"
  },
  "spacing.Carousel.SkipLink.margin": {
    "value": "var(--spacing--carousel--skip-link-margin)",
    "variable": "var(--spacing--carousel--skip-link-margin)"
  },
  "spacing.Carousel.SlideArray.padding.top": {
    "value": "var(--spacing--carousel--slide-array-padding-top)",
    "variable": "var(--spacing--carousel--slide-array-padding-top)"
  },
  "spacing.Carousel.SlideArray.padding.bottom": {
    "value": "var(--spacing--carousel--slide-array-padding-bottom)",
    "variable": "var(--spacing--carousel--slide-array-padding-bottom)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.none.padding-horz": {
    "value": "var(--spacing--carousel--slide-array-scroll-offset-none-padding-horz)",
    "variable": "var(--spacing--carousel--slide-array-scroll-offset-none-padding-horz)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.xs.padding-horz": {
    "value": "var(--spacing--carousel--slide-array-scroll-offset-xs-padding-horz)",
    "variable": "var(--spacing--carousel--slide-array-scroll-offset-xs-padding-horz)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.sm.padding-horz": {
    "value": "var(--spacing--carousel--slide-array-scroll-offset-sm-padding-horz)",
    "variable": "var(--spacing--carousel--slide-array-scroll-offset-sm-padding-horz)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.md.padding-horz": {
    "value": "var(--spacing--carousel--slide-array-scroll-offset-md-padding-horz)",
    "variable": "var(--spacing--carousel--slide-array-scroll-offset-md-padding-horz)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.lg.padding-horz": {
    "value": "var(--spacing--carousel--slide-array-scroll-offset-lg-padding-horz)",
    "variable": "var(--spacing--carousel--slide-array-scroll-offset-lg-padding-horz)"
  },
  "spacing.Carousel.SlideArray.scrollOffset.xl.padding-horz": {
    "value": "var(--spacing--carousel--slide-array-scroll-offset-xl-padding-horz)",
    "variable": "var(--spacing--carousel--slide-array-scroll-offset-xl-padding-horz)"
  },
  "spacing.Carousel.SlideArray.slideGap.xxs": {
    "value": "var(--spacing--carousel--slide-array-slide-gap-xxs)",
    "variable": "var(--spacing--carousel--slide-array-slide-gap-xxs)"
  },
  "spacing.Carousel.SlideArray.slideGap.xs": {
    "value": "var(--spacing--carousel--slide-array-slide-gap-xs)",
    "variable": "var(--spacing--carousel--slide-array-slide-gap-xs)"
  },
  "spacing.Carousel.SlideArray.slideGap.sm": {
    "value": "var(--spacing--carousel--slide-array-slide-gap-sm)",
    "variable": "var(--spacing--carousel--slide-array-slide-gap-sm)"
  },
  "spacing.Carousel.SlideArray.slideGap.md": {
    "value": "var(--spacing--carousel--slide-array-slide-gap-md)",
    "variable": "var(--spacing--carousel--slide-array-slide-gap-md)"
  },
  "spacing.Carousel.SlideArray.slideGap.lg": {
    "value": "var(--spacing--carousel--slide-array-slide-gap-lg)",
    "variable": "var(--spacing--carousel--slide-array-slide-gap-lg)"
  },
  "spacing.Carousel.SlideArray.slideGap.xl": {
    "value": "var(--spacing--carousel--slide-array-slide-gap-xl)",
    "variable": "var(--spacing--carousel--slide-array-slide-gap-xl)"
  },
  "spacing.ChipGroup.gap.horz": {
    "value": "var(--spacing--chip-group-gap-horz)",
    "variable": "var(--spacing--chip-group-gap-horz)"
  },
  "spacing.ChipGroup.gap.vert.default": {
    "value": "var(--spacing--chip-group-gap-vert-default)",
    "variable": "var(--spacing--chip-group-gap-vert-default)"
  },
  "spacing.ChipGroup.gap.vert.tighter": {
    "value": "var(--spacing--chip-group-gap-vert-tighter)",
    "variable": "var(--spacing--chip-group-gap-vert-tighter)"
  },
  "spacing.ChipGroup.padding.horz": {
    "value": "var(--spacing--chip-group-padding-horz)",
    "variable": "var(--spacing--chip-group-padding-horz)"
  },
  "spacing.ChipGroup.padding.vert": {
    "value": "var(--spacing--chip-group-padding-vert)",
    "variable": "var(--spacing--chip-group-padding-vert)"
  },
  "spacing.ChipGroup.padding.screen.leading": {
    "value": "var(--spacing--chip-group-padding-screen-leading)",
    "variable": "var(--spacing--chip-group-padding-screen-leading)"
  },
  "spacing.ChipGroup.padding.screen.trailing": {
    "value": "var(--spacing--chip-group-padding-screen-trailing)",
    "variable": "var(--spacing--chip-group-padding-screen-trailing)"
  },
  "spacing.Chip.padding.horz": {
    "value": "var(--spacing--chip-padding-horz)",
    "variable": "var(--spacing--chip-padding-horz)"
  },
  "spacing.Chip.padding.vert": {
    "value": "var(--spacing--chip-padding-vert)",
    "variable": "var(--spacing--chip-padding-vert)"
  },
  "spacing.Chip.gap.leading": {
    "value": "var(--spacing--chip-gap-leading)",
    "variable": "var(--spacing--chip-gap-leading)"
  },
  "spacing.Chip.gap.trailing": {
    "value": "var(--spacing--chip-gap-trailing)",
    "variable": "var(--spacing--chip-gap-trailing)"
  },
  "spacing.Chip.gap.inputChip-trailing": {
    "value": "var(--spacing--chip-gap-input-chip-trailing)",
    "variable": "var(--spacing--chip-gap-input-chip-trailing)"
  },
  "spacing.Chip.Close.margin.left": {
    "value": "var(--spacing--chip--close-margin-left)",
    "variable": "var(--spacing--chip--close-margin-left)"
  },
  "spacing.Chip.Close.padding": {
    "value": "var(--spacing--chip--close-padding)",
    "variable": "var(--spacing--chip--close-padding)"
  },
  "spacing.CloseButton.padding": {
    "value": "var(--spacing--close-button-padding)",
    "variable": "var(--spacing--close-button-padding)"
  },
  "spacing.CloseButton.margin": {
    "value": "var(--spacing--close-button-margin)",
    "variable": "var(--spacing--close-button-margin)"
  },
  "spacing.Combobox.ChipsOverflow.trailingTextArea.gap.limitNumber-toText": {
    "value": "var(--spacing--combobox--chips-overflow-trailing-text-area-gap-limit-number-to-text)",
    "variable": "var(--spacing--combobox--chips-overflow-trailing-text-area-gap-limit-number-to-text)"
  },
  "spacing.Combobox.Clear.margin.horz": {
    "value": "var(--spacing--combobox--clear-margin-horz)",
    "variable": "var(--spacing--combobox--clear-margin-horz)"
  },
  "spacing.Combobox.Heading.gap.leading": {
    "value": "var(--spacing--combobox--heading-gap-leading)",
    "variable": "var(--spacing--combobox--heading-gap-leading)"
  },
  "spacing.Combobox.Heading.padding.horz": {
    "value": "var(--spacing--combobox--heading-padding-horz)",
    "variable": "var(--spacing--combobox--heading-padding-horz)"
  },
  "spacing.Combobox.Heading.padding.vert": {
    "value": "var(--spacing--combobox--heading-padding-vert)",
    "variable": "var(--spacing--combobox--heading-padding-vert)"
  },
  "spacing.Combobox.Option.gap.leading": {
    "value": "var(--spacing--combobox--option-gap-leading)",
    "variable": "var(--spacing--combobox--option-gap-leading)"
  },
  "spacing.Combobox.Option.padding.horz": {
    "value": "var(--spacing--combobox--option-padding-horz)",
    "variable": "var(--spacing--combobox--option-padding-horz)"
  },
  "spacing.Combobox.Option.padding.vert": {
    "value": "var(--spacing--combobox--option-padding-vert)",
    "variable": "var(--spacing--combobox--option-padding-vert)"
  },
  "spacing.Combobox.Trigger.sm.gap.close-toSelect": {
    "value": "var(--spacing--combobox--trigger-sm-gap-close-to-select)",
    "variable": "var(--spacing--combobox--trigger-sm-gap-close-to-select)"
  },
  "spacing.Combobox.Trigger.sm.gap.default": {
    "value": "var(--spacing--combobox--trigger-sm-gap-default)",
    "variable": "var(--spacing--combobox--trigger-sm-gap-default)"
  },
  "spacing.Combobox.Trigger.sm.gap.trailing": {
    "value": "var(--spacing--combobox--trigger-sm-gap-trailing)",
    "variable": "var(--spacing--combobox--trigger-sm-gap-trailing)"
  },
  "spacing.Combobox.Trigger.sm.padding.horz": {
    "value": "var(--spacing--combobox--trigger-sm-padding-horz)",
    "variable": "var(--spacing--combobox--trigger-sm-padding-horz)"
  },
  "spacing.Combobox.Trigger.sm.padding.vert": {
    "value": "var(--spacing--combobox--trigger-sm-padding-vert)",
    "variable": "var(--spacing--combobox--trigger-sm-padding-vert)"
  },
  "spacing.Combobox.Trigger.md.gap.close-toSelect": {
    "value": "var(--spacing--combobox--trigger-md-gap-close-to-select)",
    "variable": "var(--spacing--combobox--trigger-md-gap-close-to-select)"
  },
  "spacing.Combobox.Trigger.md.gap.default": {
    "value": "var(--spacing--combobox--trigger-md-gap-default)",
    "variable": "var(--spacing--combobox--trigger-md-gap-default)"
  },
  "spacing.Combobox.Trigger.md.gap.trailing": {
    "value": "var(--spacing--combobox--trigger-md-gap-trailing)",
    "variable": "var(--spacing--combobox--trigger-md-gap-trailing)"
  },
  "spacing.Combobox.Trigger.md.padding.horz": {
    "value": "var(--spacing--combobox--trigger-md-padding-horz)",
    "variable": "var(--spacing--combobox--trigger-md-padding-horz)"
  },
  "spacing.Combobox.Trigger.md.padding.vert": {
    "value": "var(--spacing--combobox--trigger-md-padding-vert)",
    "variable": "var(--spacing--combobox--trigger-md-padding-vert)"
  },
  "spacing.Combobox.Trigger.lg.gap.close-toSelect": {
    "value": "var(--spacing--combobox--trigger-lg-gap-close-to-select)",
    "variable": "var(--spacing--combobox--trigger-lg-gap-close-to-select)"
  },
  "spacing.Combobox.Trigger.lg.gap.default": {
    "value": "var(--spacing--combobox--trigger-lg-gap-default)",
    "variable": "var(--spacing--combobox--trigger-lg-gap-default)"
  },
  "spacing.Combobox.Trigger.lg.gap.trailing": {
    "value": "var(--spacing--combobox--trigger-lg-gap-trailing)",
    "variable": "var(--spacing--combobox--trigger-lg-gap-trailing)"
  },
  "spacing.Combobox.Trigger.lg.padding.horz": {
    "value": "var(--spacing--combobox--trigger-lg-padding-horz)",
    "variable": "var(--spacing--combobox--trigger-lg-padding-horz)"
  },
  "spacing.Combobox.Trigger.lg.padding.vert": {
    "value": "var(--spacing--combobox--trigger-lg-padding-vert)",
    "variable": "var(--spacing--combobox--trigger-lg-padding-vert)"
  },
  "spacing.DateInput.sm.gap.input-toAdornment": {
    "value": "var(--spacing--date-input-sm-gap-input-to-adornment)",
    "variable": "var(--spacing--date-input-sm-gap-input-to-adornment)"
  },
  "spacing.DateInput.sm.gap.leading": {
    "value": "var(--spacing--date-input-sm-gap-leading)",
    "variable": "var(--spacing--date-input-sm-gap-leading)"
  },
  "spacing.DateInput.sm.gap.trailing": {
    "value": "var(--spacing--date-input-sm-gap-trailing)",
    "variable": "var(--spacing--date-input-sm-gap-trailing)"
  },
  "spacing.DateInput.sm.padding.horz": {
    "value": "var(--spacing--date-input-sm-padding-horz)",
    "variable": "var(--spacing--date-input-sm-padding-horz)"
  },
  "spacing.DateInput.sm.padding.horz-readOnly": {
    "value": "var(--spacing--date-input-sm-padding-horz-read-only)",
    "variable": "var(--spacing--date-input-sm-padding-horz-read-only)"
  },
  "spacing.DateInput.sm.padding.vert": {
    "value": "var(--spacing--date-input-sm-padding-vert)",
    "variable": "var(--spacing--date-input-sm-padding-vert)"
  },
  "spacing.DateInput.md.gap.input-toAdornment": {
    "value": "var(--spacing--date-input-md-gap-input-to-adornment)",
    "variable": "var(--spacing--date-input-md-gap-input-to-adornment)"
  },
  "spacing.DateInput.md.gap.leading": {
    "value": "var(--spacing--date-input-md-gap-leading)",
    "variable": "var(--spacing--date-input-md-gap-leading)"
  },
  "spacing.DateInput.md.gap.trailing": {
    "value": "var(--spacing--date-input-md-gap-trailing)",
    "variable": "var(--spacing--date-input-md-gap-trailing)"
  },
  "spacing.DateInput.md.padding.horz": {
    "value": "var(--spacing--date-input-md-padding-horz)",
    "variable": "var(--spacing--date-input-md-padding-horz)"
  },
  "spacing.DateInput.md.padding.horz-readOnly": {
    "value": "var(--spacing--date-input-md-padding-horz-read-only)",
    "variable": "var(--spacing--date-input-md-padding-horz-read-only)"
  },
  "spacing.DateInput.md.padding.vert": {
    "value": "var(--spacing--date-input-md-padding-vert)",
    "variable": "var(--spacing--date-input-md-padding-vert)"
  },
  "spacing.DateInput.lg.gap.input-toAdornment": {
    "value": "var(--spacing--date-input-lg-gap-input-to-adornment)",
    "variable": "var(--spacing--date-input-lg-gap-input-to-adornment)"
  },
  "spacing.DateInput.lg.gap.leading": {
    "value": "var(--spacing--date-input-lg-gap-leading)",
    "variable": "var(--spacing--date-input-lg-gap-leading)"
  },
  "spacing.DateInput.lg.gap.trailing": {
    "value": "var(--spacing--date-input-lg-gap-trailing)",
    "variable": "var(--spacing--date-input-lg-gap-trailing)"
  },
  "spacing.DateInput.lg.padding.horz": {
    "value": "var(--spacing--date-input-lg-padding-horz)",
    "variable": "var(--spacing--date-input-lg-padding-horz)"
  },
  "spacing.DateInput.lg.padding.horz-readOnly": {
    "value": "var(--spacing--date-input-lg-padding-horz-read-only)",
    "variable": "var(--spacing--date-input-lg-padding-horz-read-only)"
  },
  "spacing.DateInput.lg.padding.vert": {
    "value": "var(--spacing--date-input-lg-padding-vert)",
    "variable": "var(--spacing--date-input-lg-padding-vert)"
  },
  "spacing.DateInput.HelperArea.gap.icon-toText": {
    "value": "var(--spacing--date-input--helper-area-gap-icon-to-text)",
    "variable": "var(--spacing--date-input--helper-area-gap-icon-to-text)"
  },
  "spacing.DatePicker.Backdrop.padding.default.horz": {
    "value": "var(--spacing--date-picker--backdrop-padding-default-horz)",
    "variable": "var(--spacing--date-picker--backdrop-padding-default-horz)"
  },
  "spacing.DatePicker.Backdrop.padding.default.vert": {
    "value": "var(--spacing--date-picker--backdrop-padding-default-vert)",
    "variable": "var(--spacing--date-picker--backdrop-padding-default-vert)"
  },
  "spacing.DatePicker.Content.padding.vert": {
    "value": "var(--spacing--date-picker--content-padding-vert)",
    "variable": "var(--spacing--date-picker--content-padding-vert)"
  },
  "spacing.DatePicker.Content.padding.horz": {
    "value": "var(--spacing--date-picker--content-padding-horz)",
    "variable": "var(--spacing--date-picker--content-padding-horz)"
  },
  "spacing.DatePicker.Footer.padding.gap-toContent": {
    "value": "var(--spacing--date-picker--footer-padding-gap-to-content)",
    "variable": "var(--spacing--date-picker--footer-padding-gap-to-content)"
  },
  "spacing.DatePicker.Trigger.padding.sm.horz": {
    "value": "var(--spacing--date-picker--trigger-padding-sm-horz)",
    "variable": "var(--spacing--date-picker--trigger-padding-sm-horz)"
  },
  "spacing.DatePicker.Trigger.padding.md.horz": {
    "value": "var(--spacing--date-picker--trigger-padding-md-horz)",
    "variable": "var(--spacing--date-picker--trigger-padding-md-horz)"
  },
  "spacing.DatePicker.Trigger.padding.lg.horz": {
    "value": "var(--spacing--date-picker--trigger-padding-lg-horz)",
    "variable": "var(--spacing--date-picker--trigger-padding-lg-horz)"
  },
  "spacing.DateTimeBlock.Root.gap.toLabel": {
    "value": "var(--spacing--date-time-block--root-gap-to-label)",
    "variable": "var(--spacing--date-time-block--root-gap-to-label)"
  },
  "spacing.DateTimeBlock.Root.gap.toTime": {
    "value": "var(--spacing--date-time-block--root-gap-to-time)",
    "variable": "var(--spacing--date-time-block--root-gap-to-time)"
  },
  "spacing.DateTimeBlock.Dates.gap.toCard": {
    "value": "var(--spacing--date-time-block--dates-gap-to-card)",
    "variable": "var(--spacing--date-time-block--dates-gap-to-card)"
  },
  "spacing.DateTimeBlock.Dates.gap.toNav": {
    "value": "var(--spacing--date-time-block--dates-gap-to-nav)",
    "variable": "var(--spacing--date-time-block--dates-gap-to-nav)"
  },
  "spacing.DateTimeBlock.Day.padding.horz": {
    "value": "var(--spacing--date-time-block--day-padding-horz)",
    "variable": "var(--spacing--date-time-block--day-padding-horz)"
  },
  "spacing.DateTimeBlock.Day.padding.vert": {
    "value": "var(--spacing--date-time-block--day-padding-vert)",
    "variable": "var(--spacing--date-time-block--day-padding-vert)"
  },
  "spacing.DateTimeBlock.Wrap.padding.horz.outer": {
    "value": "var(--spacing--date-time-block--wrap-padding-horz-outer)",
    "variable": "var(--spacing--date-time-block--wrap-padding-horz-outer)"
  },
  "spacing.DateTimeBlock.Wrap.padding.horz.inner": {
    "value": "var(--spacing--date-time-block--wrap-padding-horz-inner)",
    "variable": "var(--spacing--date-time-block--wrap-padding-horz-inner)"
  },
  "spacing.Dropdown.Body.padding.horz": {
    "value": "var(--spacing--dropdown--body-padding-horz)",
    "variable": "var(--spacing--dropdown--body-padding-horz)"
  },
  "spacing.Dropdown.Body.padding.vert": {
    "value": "var(--spacing--dropdown--body-padding-vert)",
    "variable": "var(--spacing--dropdown--body-padding-vert)"
  },
  "spacing.Dropdown.Footer.padding.horz": {
    "value": "var(--spacing--dropdown--footer-padding-horz)",
    "variable": "var(--spacing--dropdown--footer-padding-horz)"
  },
  "spacing.Dropdown.Footer.padding.vert": {
    "value": "var(--spacing--dropdown--footer-padding-vert)",
    "variable": "var(--spacing--dropdown--footer-padding-vert)"
  },
  "spacing.Dropdown.Heading.gap.leading": {
    "value": "var(--spacing--dropdown--heading-gap-leading)",
    "variable": "var(--spacing--dropdown--heading-gap-leading)"
  },
  "spacing.Dropdown.Heading.padding.horz": {
    "value": "var(--spacing--dropdown--heading-padding-horz)",
    "variable": "var(--spacing--dropdown--heading-padding-horz)"
  },
  "spacing.Dropdown.Heading.padding.vert": {
    "value": "var(--spacing--dropdown--heading-padding-vert)",
    "variable": "var(--spacing--dropdown--heading-padding-vert)"
  },
  "spacing.FieldSet.gap.controls-toHelperArea": {
    "value": "var(--spacing--field-set-gap-controls-to-helper-area)",
    "variable": "var(--spacing--field-set-gap-controls-to-helper-area)"
  },
  "spacing.FieldSet.gap.controls-toLegendArea": {
    "value": "var(--spacing--field-set-gap-controls-to-legend-area)",
    "variable": "var(--spacing--field-set-gap-controls-to-legend-area)"
  },
  "spacing.FieldSet.helperArea.gap.text-toIcon": {
    "value": "var(--spacing--field-set-helper-area-gap-text-to-icon)",
    "variable": "var(--spacing--field-set-helper-area-gap-text-to-icon)"
  },
  "spacing.FieldSet.labelArea.gap.legend-toRequred": {
    "value": "var(--spacing--field-set-label-area-gap-legend-to-requred)",
    "variable": "var(--spacing--field-set-label-area-gap-legend-to-requred)"
  },
  "spacing.FieldSet.labelArea.gap.legend-toOptional": {
    "value": "var(--spacing--field-set-label-area-gap-legend-to-optional)",
    "variable": "var(--spacing--field-set-label-area-gap-legend-to-optional)"
  },
  "spacing.FieldSet.labeledControlArea.gap.vert": {
    "value": "var(--spacing--field-set-labeled-control-area-gap-vert)",
    "variable": "var(--spacing--field-set-labeled-control-area-gap-vert)"
  },
  "spacing.FieldSet.labeledControlArea.padding.left": {
    "value": "var(--spacing--field-set-labeled-control-area-padding-left)",
    "variable": "var(--spacing--field-set-labeled-control-area-padding-left)"
  },
  "spacing.FormField.gap.field-toHelperArea": {
    "value": "var(--spacing--form-field-gap-field-to-helper-area)",
    "variable": "var(--spacing--form-field-gap-field-to-helper-area)"
  },
  "spacing.FormField.gap.field-toLabelArea": {
    "value": "var(--spacing--form-field-gap-field-to-label-area)",
    "variable": "var(--spacing--form-field-gap-field-to-label-area)"
  },
  "spacing.FormField.HelperArea.gap.icon-toText": {
    "value": "var(--spacing--form-field--helper-area-gap-icon-to-text)",
    "variable": "var(--spacing--form-field--helper-area-gap-icon-to-text)"
  },
  "spacing.FormField.labelArea.gap.label-toRequired": {
    "value": "var(--spacing--form-field-label-area-gap-label-to-required)",
    "variable": "var(--spacing--form-field-label-area-gap-label-to-required)"
  },
  "spacing.FormField.labelArea.gap.label-toOptional": {
    "value": "var(--spacing--form-field-label-area-gap-label-to-optional)",
    "variable": "var(--spacing--form-field-label-area-gap-label-to-optional)"
  },
  "spacing.Form.FormActions.marginTop": {
    "value": "var(--spacing--form--form-actions-margin-top)",
    "variable": "var(--spacing--form--form-actions-margin-top)"
  },
  "spacing.Form.FormField.marginBottom": {
    "value": "var(--spacing--form--form-field-margin-bottom)",
    "variable": "var(--spacing--form--form-field-margin-bottom)"
  },
  "spacing.Form.FieldSet.marginBottom": {
    "value": "var(--spacing--form--field-set-margin-bottom)",
    "variable": "var(--spacing--form--field-set-margin-bottom)"
  },
  "spacing.Gleam.padding.horz": {
    "value": "var(--spacing--gleam-padding-horz)",
    "variable": "var(--spacing--gleam-padding-horz)"
  },
  "spacing.IconButton.xs.padding": {
    "value": "var(--spacing--icon-button-xs-padding)",
    "variable": "var(--spacing--icon-button-xs-padding)"
  },
  "spacing.IconButton.sm.padding": {
    "value": "var(--spacing--icon-button-sm-padding)",
    "variable": "var(--spacing--icon-button-sm-padding)"
  },
  "spacing.IconButton.md.padding": {
    "value": "var(--spacing--icon-button-md-padding)",
    "variable": "var(--spacing--icon-button-md-padding)"
  },
  "spacing.IconButton.lg.padding": {
    "value": "var(--spacing--icon-button-lg-padding)",
    "variable": "var(--spacing--icon-button-lg-padding)"
  },
  "spacing.InlineFeedback.gap.icon-toText": {
    "value": "var(--spacing--inline-feedback-gap-icon-to-text)",
    "variable": "var(--spacing--inline-feedback-gap-icon-to-text)"
  },
  "spacing.Input.HelperArea.gap.icon-toText": {
    "value": "var(--spacing--input--helper-area-gap-icon-to-text)",
    "variable": "var(--spacing--input--helper-area-gap-icon-to-text)"
  },
  "spacing.Input.sm.gap.leading": {
    "value": "var(--spacing--input-sm-gap-leading)",
    "variable": "var(--spacing--input-sm-gap-leading)"
  },
  "spacing.Input.sm.gap.trailing": {
    "value": "var(--spacing--input-sm-gap-trailing)",
    "variable": "var(--spacing--input-sm-gap-trailing)"
  },
  "spacing.Input.sm.padding.horz": {
    "value": "var(--spacing--input-sm-padding-horz)",
    "variable": "var(--spacing--input-sm-padding-horz)"
  },
  "spacing.Input.sm.padding.horz-readOnly": {
    "value": "var(--spacing--input-sm-padding-horz-read-only)",
    "variable": "var(--spacing--input-sm-padding-horz-read-only)"
  },
  "spacing.Input.sm.padding.vert": {
    "value": "var(--spacing--input-sm-padding-vert)",
    "variable": "var(--spacing--input-sm-padding-vert)"
  },
  "spacing.Input.md.gap.leading": {
    "value": "var(--spacing--input-md-gap-leading)",
    "variable": "var(--spacing--input-md-gap-leading)"
  },
  "spacing.Input.md.gap.trailing": {
    "value": "var(--spacing--input-md-gap-trailing)",
    "variable": "var(--spacing--input-md-gap-trailing)"
  },
  "spacing.Input.md.padding.horz": {
    "value": "var(--spacing--input-md-padding-horz)",
    "variable": "var(--spacing--input-md-padding-horz)"
  },
  "spacing.Input.md.padding.horz-readOnly": {
    "value": "var(--spacing--input-md-padding-horz-read-only)",
    "variable": "var(--spacing--input-md-padding-horz-read-only)"
  },
  "spacing.Input.md.padding.vert": {
    "value": "var(--spacing--input-md-padding-vert)",
    "variable": "var(--spacing--input-md-padding-vert)"
  },
  "spacing.Input.lg.gap.leading": {
    "value": "var(--spacing--input-lg-gap-leading)",
    "variable": "var(--spacing--input-lg-gap-leading)"
  },
  "spacing.Input.lg.gap.trailing": {
    "value": "var(--spacing--input-lg-gap-trailing)",
    "variable": "var(--spacing--input-lg-gap-trailing)"
  },
  "spacing.Input.lg.padding.horz": {
    "value": "var(--spacing--input-lg-padding-horz)",
    "variable": "var(--spacing--input-lg-padding-horz)"
  },
  "spacing.Input.lg.padding.horz-readOnly": {
    "value": "var(--spacing--input-lg-padding-horz-read-only)",
    "variable": "var(--spacing--input-lg-padding-horz-read-only)"
  },
  "spacing.Input.lg.padding.vert": {
    "value": "var(--spacing--input-lg-padding-vert)",
    "variable": "var(--spacing--input-lg-padding-vert)"
  },
  "spacing.LabeledControl.gap.control-toLabel": {
    "value": "var(--spacing--labeled-control-gap-control-to-label)",
    "variable": "var(--spacing--labeled-control-gap-control-to-label)"
  },
  "spacing.LabeledControl.padding.vert.control": {
    "value": "var(--spacing--labeled-control-padding-vert-control)",
    "variable": "var(--spacing--labeled-control-padding-vert-control)"
  },
  "spacing.LabeledControl.padding.vert.label": {
    "value": "var(--spacing--labeled-control-padding-vert-label)",
    "variable": "var(--spacing--labeled-control-padding-vert-label)"
  },
  "spacing.LabeledControl.padding.vert.switch.md": {
    "value": "var(--spacing--labeled-control-padding-vert-switch-md)",
    "variable": "var(--spacing--labeled-control-padding-vert-switch-md)"
  },
  "spacing.LabeledControl.padding.vert.switch.lg": {
    "value": "var(--spacing--labeled-control-padding-vert-switch-lg)",
    "variable": "var(--spacing--labeled-control-padding-vert-switch-lg)"
  },
  "spacing.LabeledInput.LabelArea.padding.top.default": {
    "value": "var(--spacing--labeled-input--label-area-padding-top-default)",
    "variable": "var(--spacing--labeled-input--label-area-padding-top-default)"
  },
  "spacing.LabeledInput.LabelArea.padding.top.active": {
    "value": "var(--spacing--labeled-input--label-area-padding-top-active)",
    "variable": "var(--spacing--labeled-input--label-area-padding-top-active)"
  },
  "spacing.LabeledInput.padding.horz": {
    "value": "var(--spacing--labeled-input-padding-horz)",
    "variable": "var(--spacing--labeled-input-padding-horz)"
  },
  "spacing.LabeledInput.padding.horz-readOnly": {
    "value": "var(--spacing--labeled-input-padding-horz-read-only)",
    "variable": "var(--spacing--labeled-input-padding-horz-read-only)"
  },
  "spacing.LabeledInput.padding.top": {
    "value": "var(--spacing--labeled-input-padding-top)",
    "variable": "var(--spacing--labeled-input-padding-top)"
  },
  "spacing.LabeledInput.padding.bottom": {
    "value": "var(--spacing--labeled-input-padding-bottom)",
    "variable": "var(--spacing--labeled-input-padding-bottom)"
  },
  "spacing.Layout.Content.padding": {
    "value": "var(--spacing--layout--content-padding)",
    "variable": "var(--spacing--layout--content-padding)"
  },
  "spacing.Layout.Root.gap": {
    "value": "var(--spacing--layout--root-gap)",
    "variable": "var(--spacing--layout--root-gap)"
  },
  "spacing.List.Item.padding.horz": {
    "value": "var(--spacing--list--item-padding-horz)",
    "variable": "var(--spacing--list--item-padding-horz)"
  },
  "spacing.List.Item.padding.vert": {
    "value": "var(--spacing--list--item-padding-vert)",
    "variable": "var(--spacing--list--item-padding-vert)"
  },
  "spacing.List.Item.padding.first.top": {
    "value": "var(--spacing--list--item-padding-first-top)",
    "variable": "var(--spacing--list--item-padding-first-top)"
  },
  "spacing.List.Item.padding.last.bottom": {
    "value": "var(--spacing--list--item-padding-last-bottom)",
    "variable": "var(--spacing--list--item-padding-last-bottom)"
  },
  "spacing.List.padding.nested-horz": {
    "value": "var(--spacing--list-padding-nested-horz)",
    "variable": "var(--spacing--list-padding-nested-horz)"
  },
  "spacing.List.group-gap.default": {
    "value": "var(--spacing--list-group-gap-default)",
    "variable": "var(--spacing--list-group-gap-default)"
  },
  "spacing.Menu.Heading.gap.leading": {
    "value": "var(--spacing--menu--heading-gap-leading)",
    "variable": "var(--spacing--menu--heading-gap-leading)"
  },
  "spacing.Menu.Heading.padding.horz": {
    "value": "var(--spacing--menu--heading-padding-horz)",
    "variable": "var(--spacing--menu--heading-padding-horz)"
  },
  "spacing.Menu.Heading.padding.vert": {
    "value": "var(--spacing--menu--heading-padding-vert)",
    "variable": "var(--spacing--menu--heading-padding-vert)"
  },
  "spacing.Menu.Item.gap.leading": {
    "value": "var(--spacing--menu--item-gap-leading)",
    "variable": "var(--spacing--menu--item-gap-leading)"
  },
  "spacing.Menu.Item.padding.horz": {
    "value": "var(--spacing--menu--item-padding-horz)",
    "variable": "var(--spacing--menu--item-padding-horz)"
  },
  "spacing.Menu.Item.padding.vert": {
    "value": "var(--spacing--menu--item-padding-vert)",
    "variable": "var(--spacing--menu--item-padding-vert)"
  },
  "spacing.Modal.Backdrop.padding.default.horz": {
    "value": "var(--spacing--modal--backdrop-padding-default-horz)",
    "variable": "var(--spacing--modal--backdrop-padding-default-horz)"
  },
  "spacing.Modal.Backdrop.padding.default.vert": {
    "value": "var(--spacing--modal--backdrop-padding-default-vert)",
    "variable": "var(--spacing--modal--backdrop-padding-default-vert)"
  },
  "spacing.Modal.Backdrop.padding.fullScreen.horz": {
    "value": "var(--spacing--modal--backdrop-padding-full-screen-horz)",
    "variable": "var(--spacing--modal--backdrop-padding-full-screen-horz)"
  },
  "spacing.Modal.Backdrop.padding.fullScreen.vert": {
    "value": "var(--spacing--modal--backdrop-padding-full-screen-vert)",
    "variable": "var(--spacing--modal--backdrop-padding-full-screen-vert)"
  },
  "spacing.Modal.Body.padding.horz": {
    "value": "var(--spacing--modal--body-padding-horz)",
    "variable": "var(--spacing--modal--body-padding-horz)"
  },
  "spacing.Modal.Body.padding.vert": {
    "value": "var(--spacing--modal--body-padding-vert)",
    "variable": "var(--spacing--modal--body-padding-vert)"
  },
  "spacing.Modal.CloseButton.margin.top": {
    "value": "var(--spacing--modal--close-button-margin-top)",
    "variable": "var(--spacing--modal--close-button-margin-top)"
  },
  "spacing.Modal.CloseButton.margin.right": {
    "value": "var(--spacing--modal--close-button-margin-right)",
    "variable": "var(--spacing--modal--close-button-margin-right)"
  },
  "spacing.Modal.Content.offset": {
    "value": "var(--spacing--modal--content-offset)",
    "variable": "var(--spacing--modal--content-offset)"
  },
  "spacing.Modal.Footer.padding.horz": {
    "value": "var(--spacing--modal--footer-padding-horz)",
    "variable": "var(--spacing--modal--footer-padding-horz)"
  },
  "spacing.Modal.Footer.padding.vert": {
    "value": "var(--spacing--modal--footer-padding-vert)",
    "variable": "var(--spacing--modal--footer-padding-vert)"
  },
  "spacing.Modal.Header.padding.left": {
    "value": "var(--spacing--modal--header-padding-left)",
    "variable": "var(--spacing--modal--header-padding-left)"
  },
  "spacing.Modal.Header.padding.vert": {
    "value": "var(--spacing--modal--header-padding-vert)",
    "variable": "var(--spacing--modal--header-padding-vert)"
  },
  "spacing.Modal.Header.padding.right": {
    "value": "var(--spacing--modal--header-padding-right)",
    "variable": "var(--spacing--modal--header-padding-right)"
  },
  "spacing.NumberRating.gap.star-toNumber": {
    "value": "var(--spacing--number-rating-gap-star-to-number)",
    "variable": "var(--spacing--number-rating-gap-star-to-number)"
  },
  "spacing.Page.padding.horz.desktop": {
    "value": "var(--spacing--page-padding-horz-desktop)",
    "variable": "var(--spacing--page-padding-horz-desktop)"
  },
  "spacing.Page.padding.horz.tablet": {
    "value": "var(--spacing--page-padding-horz-tablet)",
    "variable": "var(--spacing--page-padding-horz-tablet)"
  },
  "spacing.Page.padding.horz.mobile": {
    "value": "var(--spacing--page-padding-horz-mobile)",
    "variable": "var(--spacing--page-padding-horz-mobile)"
  },
  "spacing.Page.padding.bottom": {
    "value": "var(--spacing--page-padding-bottom)",
    "variable": "var(--spacing--page-padding-bottom)"
  },
  "spacing.Page.Breadcrumb.margin.top.desktop": {
    "value": "var(--spacing--page--breadcrumb-margin-top-desktop)",
    "variable": "var(--spacing--page--breadcrumb-margin-top-desktop)"
  },
  "spacing.Page.Breadcrumb.margin.top.tablet": {
    "value": "var(--spacing--page--breadcrumb-margin-top-tablet)",
    "variable": "var(--spacing--page--breadcrumb-margin-top-tablet)"
  },
  "spacing.Page.Breadcrumb.margin.top.mobile": {
    "value": "var(--spacing--page--breadcrumb-margin-top-mobile)",
    "variable": "var(--spacing--page--breadcrumb-margin-top-mobile)"
  },
  "spacing.Page.Breadcrumb.margin.bottom": {
    "value": "var(--spacing--page--breadcrumb-margin-bottom)",
    "variable": "var(--spacing--page--breadcrumb-margin-bottom)"
  },
  "spacing.Page.Content.margin.vert.desktop": {
    "value": "var(--spacing--page--content-margin-vert-desktop)",
    "variable": "var(--spacing--page--content-margin-vert-desktop)"
  },
  "spacing.Page.Content.margin.vert.tablet": {
    "value": "var(--spacing--page--content-margin-vert-tablet)",
    "variable": "var(--spacing--page--content-margin-vert-tablet)"
  },
  "spacing.Page.Content.margin.vert.mobile": {
    "value": "var(--spacing--page--content-margin-vert-mobile)",
    "variable": "var(--spacing--page--content-margin-vert-mobile)"
  },
  "spacing.Page.Header.margin.bottom.desktop": {
    "value": "var(--spacing--page--header-margin-bottom-desktop)",
    "variable": "var(--spacing--page--header-margin-bottom-desktop)"
  },
  "spacing.Page.Header.margin.bottom.tablet": {
    "value": "var(--spacing--page--header-margin-bottom-tablet)",
    "variable": "var(--spacing--page--header-margin-bottom-tablet)"
  },
  "spacing.Page.Header.margin.bottom.mobile": {
    "value": "var(--spacing--page--header-margin-bottom-mobile)",
    "variable": "var(--spacing--page--header-margin-bottom-mobile)"
  },
  "spacing.Page.Header.margin.top.desktop": {
    "value": "var(--spacing--page--header-margin-top-desktop)",
    "variable": "var(--spacing--page--header-margin-top-desktop)"
  },
  "spacing.Page.Header.margin.top.tablet": {
    "value": "var(--spacing--page--header-margin-top-tablet)",
    "variable": "var(--spacing--page--header-margin-top-tablet)"
  },
  "spacing.Page.Header.margin.top.mobile": {
    "value": "var(--spacing--page--header-margin-top-mobile)",
    "variable": "var(--spacing--page--header-margin-top-mobile)"
  },
  "spacing.Pagination.Item.between-pages": {
    "value": "var(--spacing--pagination--item-between-pages)",
    "variable": "var(--spacing--pagination--item-between-pages)"
  },
  "spacing.Pagination.JumpItem.to-controls": {
    "value": "var(--spacing--pagination--jump-item-to-controls)",
    "variable": "var(--spacing--pagination--jump-item-to-controls)"
  },
  "spacing.Pagination.JumpItem.padding.horz": {
    "value": "var(--spacing--pagination--jump-item-padding-horz)",
    "variable": "var(--spacing--pagination--jump-item-padding-horz)"
  },
  "spacing.Pagination.JumpItem.padding.vert": {
    "value": "var(--spacing--pagination--jump-item-padding-vert)",
    "variable": "var(--spacing--pagination--jump-item-padding-vert)"
  },
  "spacing.Pagination.Root.gap-toDivider": {
    "value": "var(--spacing--pagination--root-gap-to-divider)",
    "variable": "var(--spacing--pagination--root-gap-to-divider)"
  },
  "spacing.PhotoCarousel.Dots.gap-betweenMarkers": {
    "value": "var(--spacing--photo-carousel--dots-gap-between-markers)",
    "variable": "var(--spacing--photo-carousel--dots-gap-between-markers)"
  },
  "spacing.PhotoCarousel.Dots.margin.bottom": {
    "value": "var(--spacing--photo-carousel--dots-margin-bottom)",
    "variable": "var(--spacing--photo-carousel--dots-margin-bottom)"
  },
  "spacing.PhotoCarousel.Dots.padding.horz": {
    "value": "var(--spacing--photo-carousel--dots-padding-horz)",
    "variable": "var(--spacing--photo-carousel--dots-padding-horz)"
  },
  "spacing.PhotoCarousel.Dots.padding.vert": {
    "value": "var(--spacing--photo-carousel--dots-padding-vert)",
    "variable": "var(--spacing--photo-carousel--dots-padding-vert)"
  },
  "spacing.Popover.Backdrop.padding.default.horz": {
    "value": "var(--spacing--popover--backdrop-padding-default-horz)",
    "variable": "var(--spacing--popover--backdrop-padding-default-horz)"
  },
  "spacing.Popover.Backdrop.padding.default.vert": {
    "value": "var(--spacing--popover--backdrop-padding-default-vert)",
    "variable": "var(--spacing--popover--backdrop-padding-default-vert)"
  },
  "spacing.Popover.Body.padding.horz": {
    "value": "var(--spacing--popover--body-padding-horz)",
    "variable": "var(--spacing--popover--body-padding-horz)"
  },
  "spacing.Popover.Body.padding.vert": {
    "value": "var(--spacing--popover--body-padding-vert)",
    "variable": "var(--spacing--popover--body-padding-vert)"
  },
  "spacing.Popover.CloseButton.margin.top": {
    "value": "var(--spacing--popover--close-button-margin-top)",
    "variable": "var(--spacing--popover--close-button-margin-top)"
  },
  "spacing.Popover.CloseButton.margin.right": {
    "value": "var(--spacing--popover--close-button-margin-right)",
    "variable": "var(--spacing--popover--close-button-margin-right)"
  },
  "spacing.Popover.Header.gap.leading": {
    "value": "var(--spacing--popover--header-gap-leading)",
    "variable": "var(--spacing--popover--header-gap-leading)"
  },
  "spacing.Popover.Header.padding.left": {
    "value": "var(--spacing--popover--header-padding-left)",
    "variable": "var(--spacing--popover--header-padding-left)"
  },
  "spacing.Popover.Header.padding.vert": {
    "value": "var(--spacing--popover--header-padding-vert)",
    "variable": "var(--spacing--popover--header-padding-vert)"
  },
  "spacing.Popover.Header.padding.right": {
    "value": "var(--spacing--popover--header-padding-right)",
    "variable": "var(--spacing--popover--header-padding-right)"
  },
  "spacing.ProgressMeter.gap.label-toMeta": {
    "value": "var(--spacing--progress-meter-gap-label-to-meta)",
    "variable": "var(--spacing--progress-meter-gap-label-to-meta)"
  },
  "spacing.ProgressMeter.gap.horizontal.node-toLabel": {
    "value": "var(--spacing--progress-meter-gap-horizontal-node-to-label)",
    "variable": "var(--spacing--progress-meter-gap-horizontal-node-to-label)"
  },
  "spacing.ProgressMeter.gap.vertical.node-toLabel": {
    "value": "var(--spacing--progress-meter-gap-vertical-node-to-label)",
    "variable": "var(--spacing--progress-meter-gap-vertical-node-to-label)"
  },
  "spacing.ProgressMeter.padding.tag-top": {
    "value": "var(--spacing--progress-meter-padding-tag-top)",
    "variable": "var(--spacing--progress-meter-padding-tag-top)"
  },
  "spacing.PropertyCard.BadgeArea.gap": {
    "value": "var(--spacing--property-card--badge-area-gap)",
    "variable": "var(--spacing--property-card--badge-area-gap)"
  },
  "spacing.PropertyCard.Badge.padding.horz": {
    "value": "var(--spacing--property-card--badge-padding-horz)",
    "variable": "var(--spacing--property-card--badge-padding-horz)"
  },
  "spacing.PropertyCard.Badge.padding.vert": {
    "value": "var(--spacing--property-card--badge-padding-vert)",
    "variable": "var(--spacing--property-card--badge-padding-vert)"
  },
  "spacing.PropertyCard.DataArea.dataDivider.gap-toDataItem": {
    "value": "var(--spacing--property-card--data-area-data-divider-gap-to-data-item)",
    "variable": "var(--spacing--property-card--data-area-data-divider-gap-to-data-item)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.between-dataItems.default": {
    "value": "var(--spacing--property-card--data-wrapper-large-gap-between-data-items-default)",
    "variable": "var(--spacing--property-card--data-wrapper-large-gap-between-data-items-default)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.between-dataItems.loading": {
    "value": "var(--spacing--property-card--data-wrapper-large-gap-between-data-items-loading)",
    "variable": "var(--spacing--property-card--data-wrapper-large-gap-between-data-items-loading)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.dataArea1-toIcon": {
    "value": "var(--spacing--property-card--data-wrapper-large-gap-data-area1-to-icon)",
    "variable": "var(--spacing--property-card--data-wrapper-large-gap-data-area1-to-icon)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.horz": {
    "value": "var(--spacing--property-card--data-wrapper-large-padding-horz)",
    "variable": "var(--spacing--property-card--data-wrapper-large-padding-horz)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.top": {
    "value": "var(--spacing--property-card--data-wrapper-large-padding-top)",
    "variable": "var(--spacing--property-card--data-wrapper-large-padding-top)"
  },
  "spacing.PropertyCard.DataWrapper.large.padding.bottom": {
    "value": "var(--spacing--property-card--data-wrapper-large-padding-bottom)",
    "variable": "var(--spacing--property-card--data-wrapper-large-padding-bottom)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.between-dataItems.default": {
    "value": "var(--spacing--property-card--data-wrapper-small-gap-between-data-items-default)",
    "variable": "var(--spacing--property-card--data-wrapper-small-gap-between-data-items-default)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.between-dataItems.loading": {
    "value": "var(--spacing--property-card--data-wrapper-small-gap-between-data-items-loading)",
    "variable": "var(--spacing--property-card--data-wrapper-small-gap-between-data-items-loading)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.dataArea1-toIcon": {
    "value": "var(--spacing--property-card--data-wrapper-small-gap-data-area1-to-icon)",
    "variable": "var(--spacing--property-card--data-wrapper-small-gap-data-area1-to-icon)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.horz": {
    "value": "var(--spacing--property-card--data-wrapper-small-padding-horz)",
    "variable": "var(--spacing--property-card--data-wrapper-small-padding-horz)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.top": {
    "value": "var(--spacing--property-card--data-wrapper-small-padding-top)",
    "variable": "var(--spacing--property-card--data-wrapper-small-padding-top)"
  },
  "spacing.PropertyCard.DataWrapper.small.padding.bottom": {
    "value": "var(--spacing--property-card--data-wrapper-small-padding-bottom)",
    "variable": "var(--spacing--property-card--data-wrapper-small-padding-bottom)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.between-dataItems.default": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-gap-between-data-items-default)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-gap-between-data-items-default)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.between-dataItems.loading": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-gap-between-data-items-loading)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-gap-between-data-items-loading)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.dataArea1-toIcon": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-gap-data-area1-to-icon)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-gap-data-area1-to-icon)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.horz": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-padding-horz)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-padding-horz)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.top": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-padding-top)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-padding-top)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.padding.bottom": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-padding-bottom)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-padding-bottom)"
  },
  "spacing.PropertyCard.FlexArea.gap.dataWrapper-toFlexArea": {
    "value": "var(--spacing--property-card--flex-area-gap-data-wrapper-to-flex-area)",
    "variable": "var(--spacing--property-card--flex-area-gap-data-wrapper-to-flex-area)"
  },
  "spacing.PropertyCard.FlexArea.padding.horz": {
    "value": "var(--spacing--property-card--flex-area-padding-horz)",
    "variable": "var(--spacing--property-card--flex-area-padding-horz)"
  },
  "spacing.PropertyCard.FlexArea.padding.vert": {
    "value": "var(--spacing--property-card--flex-area-padding-vert)",
    "variable": "var(--spacing--property-card--flex-area-padding-vert)"
  },
  "spacing.PropertyCard.PhotoHeader.margin.horz": {
    "value": "var(--spacing--property-card--photo-header-margin-horz)",
    "variable": "var(--spacing--property-card--photo-header-margin-horz)"
  },
  "spacing.PropertyCard.PhotoHeader.margin.vert": {
    "value": "var(--spacing--property-card--photo-header-margin-vert)",
    "variable": "var(--spacing--property-card--photo-header-margin-vert)"
  },
  "spacing.PropertyCard.PhotoFooter.logo.padding.horz": {
    "value": "var(--spacing--property-card--photo-footer-logo-padding-horz)",
    "variable": "var(--spacing--property-card--photo-footer-logo-padding-horz)"
  },
  "spacing.PropertyCard.PhotoFooter.logo.padding.vert": {
    "value": "var(--spacing--property-card--photo-footer-logo-padding-vert)",
    "variable": "var(--spacing--property-card--photo-footer-logo-padding-vert)"
  },
  "spacing.PropertyCard.Root.sm.gap.card-toDataArea5": {
    "value": "var(--spacing--property-card--root-sm-gap-card-to-data-area5)",
    "variable": "var(--spacing--property-card--root-sm-gap-card-to-data-area5)"
  },
  "spacing.PropertyCard.Root.horiz.gap.card-toDataArea5": {
    "value": "var(--spacing--property-card--root-horiz-gap-card-to-data-area5)",
    "variable": "var(--spacing--property-card--root-horiz-gap-card-to-data-area5)"
  },
  "spacing.PropertyCard.SaveButton.padding.top": {
    "value": "var(--spacing--property-card--save-button-padding-top)",
    "variable": "var(--spacing--property-card--save-button-padding-top)"
  },
  "spacing.PropertyCard.SaveButton.padding.right": {
    "value": "var(--spacing--property-card--save-button-padding-right)",
    "variable": "var(--spacing--property-card--save-button-padding-right)"
  },
  "spacing.PropertyCard.SaveButton.padding.bottom": {
    "value": "var(--spacing--property-card--save-button-padding-bottom)",
    "variable": "var(--spacing--property-card--save-button-padding-bottom)"
  },
  "spacing.PropertyCard.SaveButton.padding.left": {
    "value": "var(--spacing--property-card--save-button-padding-left)",
    "variable": "var(--spacing--property-card--save-button-padding-left)"
  },
  "spacing.Range.Root.margin.vert": {
    "value": "var(--spacing--range--root-margin-vert)",
    "variable": "var(--spacing--range--root-margin-vert)"
  },
  "spacing.Range.Handle.margin.top": {
    "value": "var(--spacing--range--handle-margin-top)",
    "variable": "var(--spacing--range--handle-margin-top)"
  },
  "spacing.RatingStars.gap.between-stars": {
    "value": "var(--spacing--rating-stars-gap-between-stars)",
    "variable": "var(--spacing--rating-stars-gap-between-stars)"
  },
  "spacing.RatingStars.gap.stars-toContent": {
    "value": "var(--spacing--rating-stars-gap-stars-to-content)",
    "variable": "var(--spacing--rating-stars-gap-stars-to-content)"
  },
  "spacing.RatingStars.gap.star-toNumber": {
    "value": "var(--spacing--rating-stars-gap-star-to-number)",
    "variable": "var(--spacing--rating-stars-gap-star-to-number)"
  },
  "spacing.RatingStars.gap.divider-toContent": {
    "value": "var(--spacing--rating-stars-gap-divider-to-content)",
    "variable": "var(--spacing--rating-stars-gap-divider-to-content)"
  },
  "spacing.ShowHide.gap.label-toIcon": {
    "value": "var(--spacing--show-hide-gap-label-to-icon)",
    "variable": "var(--spacing--show-hide-gap-label-to-icon)"
  },
  "spacing.ShowHide.gap.button-toContent": {
    "value": "var(--spacing--show-hide-gap-button-to-content)",
    "variable": "var(--spacing--show-hide-gap-button-to-content)"
  },
  "spacing.Switch.Track.md.padding.horz": {
    "value": "var(--spacing--switch--track-md-padding-horz)",
    "variable": "var(--spacing--switch--track-md-padding-horz)"
  },
  "spacing.Switch.Track.md.padding.vert": {
    "value": "var(--spacing--switch--track-md-padding-vert)",
    "variable": "var(--spacing--switch--track-md-padding-vert)"
  },
  "spacing.Switch.Track.lg.padding.horz": {
    "value": "var(--spacing--switch--track-lg-padding-horz)",
    "variable": "var(--spacing--switch--track-lg-padding-horz)"
  },
  "spacing.Switch.Track.lg.padding.vert": {
    "value": "var(--spacing--switch--track-lg-padding-vert)",
    "variable": "var(--spacing--switch--track-lg-padding-vert)"
  },
  "spacing.Switch.Handle.md.position.top": {
    "value": "var(--spacing--switch--handle-md-position-top)",
    "variable": "var(--spacing--switch--handle-md-position-top)"
  },
  "spacing.Switch.Handle.md.position.left": {
    "value": "var(--spacing--switch--handle-md-position-left)",
    "variable": "var(--spacing--switch--handle-md-position-left)"
  },
  "spacing.Switch.Handle.lg.position.top": {
    "value": "var(--spacing--switch--handle-lg-position-top)",
    "variable": "var(--spacing--switch--handle-lg-position-top)"
  },
  "spacing.Switch.Handle.lg.position.left": {
    "value": "var(--spacing--switch--handle-lg-position-left)",
    "variable": "var(--spacing--switch--handle-lg-position-left)"
  },
  "spacing.Table.Cell.gap.icon-toLabel": {
    "value": "var(--spacing--table--cell-gap-icon-to-label)",
    "variable": "var(--spacing--table--cell-gap-icon-to-label)"
  },
  "spacing.Table.Cell.padding.size.sm.horz": {
    "value": "var(--spacing--table--cell-padding-size-sm-horz)",
    "variable": "var(--spacing--table--cell-padding-size-sm-horz)"
  },
  "spacing.Table.Cell.padding.size.sm.vert": {
    "value": "var(--spacing--table--cell-padding-size-sm-vert)",
    "variable": "var(--spacing--table--cell-padding-size-sm-vert)"
  },
  "spacing.Table.Cell.padding.size.md.horz": {
    "value": "var(--spacing--table--cell-padding-size-md-horz)",
    "variable": "var(--spacing--table--cell-padding-size-md-horz)"
  },
  "spacing.Table.Cell.padding.size.md.vert": {
    "value": "var(--spacing--table--cell-padding-size-md-vert)",
    "variable": "var(--spacing--table--cell-padding-size-md-vert)"
  },
  "spacing.Table.Cell.padding.size.lg.horz": {
    "value": "var(--spacing--table--cell-padding-size-lg-horz)",
    "variable": "var(--spacing--table--cell-padding-size-lg-horz)"
  },
  "spacing.Table.Cell.padding.size.lg.vert": {
    "value": "var(--spacing--table--cell-padding-size-lg-vert)",
    "variable": "var(--spacing--table--cell-padding-size-lg-vert)"
  },
  "spacing.Tabs.gap.leading": {
    "value": "var(--spacing--tabs-gap-leading)",
    "variable": "var(--spacing--tabs-gap-leading)"
  },
  "spacing.Tabs.gap.trailing": {
    "value": "var(--spacing--tabs-gap-trailing)",
    "variable": "var(--spacing--tabs-gap-trailing)"
  },
  "spacing.Tabs.offsetBorder": {
    "value": "var(--spacing--tabs-offset-border)",
    "variable": "var(--spacing--tabs-offset-border)"
  },
  "spacing.Tabs.padding.panel": {
    "value": "var(--spacing--tabs-padding-panel)",
    "variable": "var(--spacing--tabs-padding-panel)"
  },
  "spacing.Tabs.padding.horz": {
    "value": "var(--spacing--tabs-padding-horz)",
    "variable": "var(--spacing--tabs-padding-horz)"
  },
  "spacing.Tabs.padding.vert": {
    "value": "var(--spacing--tabs-padding-vert)",
    "variable": "var(--spacing--tabs-padding-vert)"
  },
  "spacing.Tabs.padding.file.active.top": {
    "value": "var(--spacing--tabs-padding-file-active-top)",
    "variable": "var(--spacing--tabs-padding-file-active-top)"
  },
  "spacing.Tag.sm.gap.label-toIcon": {
    "value": "var(--spacing--tag-sm-gap-label-to-icon)",
    "variable": "var(--spacing--tag-sm-gap-label-to-icon)"
  },
  "spacing.Tag.sm.padding.horz": {
    "value": "var(--spacing--tag-sm-padding-horz)",
    "variable": "var(--spacing--tag-sm-padding-horz)"
  },
  "spacing.Tag.sm.padding.vert": {
    "value": "var(--spacing--tag-sm-padding-vert)",
    "variable": "var(--spacing--tag-sm-padding-vert)"
  },
  "spacing.Tag.md.gap.label-toIcon": {
    "value": "var(--spacing--tag-md-gap-label-to-icon)",
    "variable": "var(--spacing--tag-md-gap-label-to-icon)"
  },
  "spacing.Tag.md.padding.horz": {
    "value": "var(--spacing--tag-md-padding-horz)",
    "variable": "var(--spacing--tag-md-padding-horz)"
  },
  "spacing.Tag.md.padding.vert": {
    "value": "var(--spacing--tag-md-padding-vert)",
    "variable": "var(--spacing--tag-md-padding-vert)"
  },
  "spacing.TextButton.gap.label-toIcon": {
    "value": "var(--spacing--text-button-gap-label-to-icon)",
    "variable": "var(--spacing--text-button-gap-label-to-icon)"
  },
  "spacing.TextButton.padding.horz": {
    "value": "var(--spacing--text-button-padding-horz)",
    "variable": "var(--spacing--text-button-padding-horz)"
  },
  "spacing.TextButton.padding.vert": {
    "value": "var(--spacing--text-button-padding-vert)",
    "variable": "var(--spacing--text-button-padding-vert)"
  },
  "spacing.Textarea.padding.horz": {
    "value": "var(--spacing--textarea-padding-horz)",
    "variable": "var(--spacing--textarea-padding-horz)"
  },
  "spacing.Textarea.padding.horz-readOnly": {
    "value": "var(--spacing--textarea-padding-horz-read-only)",
    "variable": "var(--spacing--textarea-padding-horz-read-only)"
  },
  "spacing.Textarea.padding.vert": {
    "value": "var(--spacing--textarea-padding-vert)",
    "variable": "var(--spacing--textarea-padding-vert)"
  },
  "spacing.Toast.gap.content-toAction": {
    "value": "var(--spacing--toast-gap-content-to-action)",
    "variable": "var(--spacing--toast-gap-content-to-action)"
  },
  "spacing.Toast.gap.leading": {
    "value": "var(--spacing--toast-gap-leading)",
    "variable": "var(--spacing--toast-gap-leading)"
  },
  "spacing.Toast.gap.trailing": {
    "value": "var(--spacing--toast-gap-trailing)",
    "variable": "var(--spacing--toast-gap-trailing)"
  },
  "spacing.Toast.padding.horz": {
    "value": "var(--spacing--toast-padding-horz)",
    "variable": "var(--spacing--toast-padding-horz)"
  },
  "spacing.Toast.padding.vert": {
    "value": "var(--spacing--toast-padding-vert)",
    "variable": "var(--spacing--toast-padding-vert)"
  },
  "spacing.Toast.CloseButton.margin.top": {
    "value": "var(--spacing--toast--close-button-margin-top)",
    "variable": "var(--spacing--toast--close-button-margin-top)"
  },
  "spacing.Toast.CloseButton.margin.right": {
    "value": "var(--spacing--toast--close-button-margin-right)",
    "variable": "var(--spacing--toast--close-button-margin-right)"
  },
  "spacing.ToggleButton.sm.gap.label-toIcon": {
    "value": "var(--spacing--toggle-button-sm-gap-label-to-icon)",
    "variable": "var(--spacing--toggle-button-sm-gap-label-to-icon)"
  },
  "spacing.ToggleButton.sm.padding.bare.horz": {
    "value": "var(--spacing--toggle-button-sm-padding-bare-horz)",
    "variable": "var(--spacing--toggle-button-sm-padding-bare-horz)"
  },
  "spacing.ToggleButton.sm.padding.bare.horz-narrow": {
    "value": "var(--spacing--toggle-button-sm-padding-bare-horz-narrow)",
    "variable": "var(--spacing--toggle-button-sm-padding-bare-horz-narrow)"
  },
  "spacing.ToggleButton.sm.padding.bare.horz-narrowest": {
    "value": "var(--spacing--toggle-button-sm-padding-bare-horz-narrowest)",
    "variable": "var(--spacing--toggle-button-sm-padding-bare-horz-narrowest)"
  },
  "spacing.ToggleButton.sm.padding.horz": {
    "value": "var(--spacing--toggle-button-sm-padding-horz)",
    "variable": "var(--spacing--toggle-button-sm-padding-horz)"
  },
  "spacing.ToggleButton.sm.padding.vert": {
    "value": "var(--spacing--toggle-button-sm-padding-vert)",
    "variable": "var(--spacing--toggle-button-sm-padding-vert)"
  },
  "spacing.ToggleButton.md.gap.label-toIcon": {
    "value": "var(--spacing--toggle-button-md-gap-label-to-icon)",
    "variable": "var(--spacing--toggle-button-md-gap-label-to-icon)"
  },
  "spacing.ToggleButton.md.padding.bare.horz": {
    "value": "var(--spacing--toggle-button-md-padding-bare-horz)",
    "variable": "var(--spacing--toggle-button-md-padding-bare-horz)"
  },
  "spacing.ToggleButton.md.padding.bare.horz-narrow": {
    "value": "var(--spacing--toggle-button-md-padding-bare-horz-narrow)",
    "variable": "var(--spacing--toggle-button-md-padding-bare-horz-narrow)"
  },
  "spacing.ToggleButton.md.padding.bare.horz-narrowest": {
    "value": "var(--spacing--toggle-button-md-padding-bare-horz-narrowest)",
    "variable": "var(--spacing--toggle-button-md-padding-bare-horz-narrowest)"
  },
  "spacing.ToggleButton.md.padding.horz": {
    "value": "var(--spacing--toggle-button-md-padding-horz)",
    "variable": "var(--spacing--toggle-button-md-padding-horz)"
  },
  "spacing.ToggleButton.md.padding.vert": {
    "value": "var(--spacing--toggle-button-md-padding-vert)",
    "variable": "var(--spacing--toggle-button-md-padding-vert)"
  },
  "spacing.ToggleButton.lg.gap.label-toIcon": {
    "value": "var(--spacing--toggle-button-lg-gap-label-to-icon)",
    "variable": "var(--spacing--toggle-button-lg-gap-label-to-icon)"
  },
  "spacing.ToggleButton.lg.padding.bare.horz": {
    "value": "var(--spacing--toggle-button-lg-padding-bare-horz)",
    "variable": "var(--spacing--toggle-button-lg-padding-bare-horz)"
  },
  "spacing.ToggleButton.lg.padding.bare.horz-narrow": {
    "value": "var(--spacing--toggle-button-lg-padding-bare-horz-narrow)",
    "variable": "var(--spacing--toggle-button-lg-padding-bare-horz-narrow)"
  },
  "spacing.ToggleButton.lg.padding.bare.horz-narrowest": {
    "value": "var(--spacing--toggle-button-lg-padding-bare-horz-narrowest)",
    "variable": "var(--spacing--toggle-button-lg-padding-bare-horz-narrowest)"
  },
  "spacing.ToggleButton.lg.padding.horz": {
    "value": "var(--spacing--toggle-button-lg-padding-horz)",
    "variable": "var(--spacing--toggle-button-lg-padding-horz)"
  },
  "spacing.ToggleButton.lg.padding.vert": {
    "value": "var(--spacing--toggle-button-lg-padding-vert)",
    "variable": "var(--spacing--toggle-button-lg-padding-vert)"
  },
  "spacing.ToggleCard.Footer.margin.to-Body": {
    "value": "var(--spacing--toggle-card--footer-margin-to--body)",
    "variable": "var(--spacing--toggle-card--footer-margin-to--body)"
  },
  "spacing.ToggleCard.Footer.padding.from-Footer": {
    "value": "var(--spacing--toggle-card--footer-padding-from--footer)",
    "variable": "var(--spacing--toggle-card--footer-padding-from--footer)"
  },
  "spacing.ToggleCard.Header.margin.to-Body": {
    "value": "var(--spacing--toggle-card--header-margin-to--body)",
    "variable": "var(--spacing--toggle-card--header-margin-to--body)"
  },
  "spacing.ToggleCard.Header.padding.from-Header": {
    "value": "var(--spacing--toggle-card--header-padding-from--header)",
    "variable": "var(--spacing--toggle-card--header-padding-from--header)"
  },
  "spacing.ToggleCard.Root.padding": {
    "value": "var(--spacing--toggle-card--root-padding)",
    "variable": "var(--spacing--toggle-card--root-padding)"
  },
  "spacing.Tooltip.mWeb.padding.horz": {
    "value": "var(--spacing--tooltip-m-web-padding-horz)",
    "variable": "var(--spacing--tooltip-m-web-padding-horz)"
  },
  "spacing.Tooltip.mWeb.padding.vert": {
    "value": "var(--spacing--tooltip-m-web-padding-vert)",
    "variable": "var(--spacing--tooltip-m-web-padding-vert)"
  },
  "spacing.Tooltip.desktop.padding.horz": {
    "value": "var(--spacing--tooltip-desktop-padding-horz)",
    "variable": "var(--spacing--tooltip-desktop-padding-horz)"
  },
  "spacing.Tooltip.desktop.padding.vert": {
    "value": "var(--spacing--tooltip-desktop-padding-vert)",
    "variable": "var(--spacing--tooltip-desktop-padding-vert)"
  },
  "spacing.TriggerText.padding": {
    "value": "var(--spacing--trigger-text-padding)",
    "variable": "var(--spacing--trigger-text-padding)"
  },
  "spacing.UpsellBanner.Action.margin.content-toActions.horz": {
    "value": "var(--spacing--upsell-banner--action-margin-content-to-actions-horz)",
    "variable": "var(--spacing--upsell-banner--action-margin-content-to-actions-horz)"
  },
  "spacing.UpsellBanner.Action.margin.content-toActions.vert": {
    "value": "var(--spacing--upsell-banner--action-margin-content-to-actions-vert)",
    "variable": "var(--spacing--upsell-banner--action-margin-content-to-actions-vert)"
  },
  "spacing.UpsellBanner.Body.margin.heading-toMessage.horz": {
    "value": "var(--spacing--upsell-banner--body-margin-heading-to-message-horz)",
    "variable": "var(--spacing--upsell-banner--body-margin-heading-to-message-horz)"
  },
  "spacing.UpsellBanner.Body.margin.heading-toMessage.vert": {
    "value": "var(--spacing--upsell-banner--body-margin-heading-to-message-vert)",
    "variable": "var(--spacing--upsell-banner--body-margin-heading-to-message-vert)"
  },
  "spacing.UpsellBanner.Header.margin.content-toClose": {
    "value": "var(--spacing--upsell-banner--header-margin-content-to-close)",
    "variable": "var(--spacing--upsell-banner--header-margin-content-to-close)"
  },
  "spacing.UpsellBanner.Root.gap.leading": {
    "value": "var(--spacing--upsell-banner--root-gap-leading)",
    "variable": "var(--spacing--upsell-banner--root-gap-leading)"
  },
  "spacing.UpsellBanner.Root.gap.trailing": {
    "value": "var(--spacing--upsell-banner--root-gap-trailing)",
    "variable": "var(--spacing--upsell-banner--root-gap-trailing)"
  },
  "spacing.UpsellBanner.Root.padding.horz": {
    "value": "var(--spacing--upsell-banner--root-padding-horz)",
    "variable": "var(--spacing--upsell-banner--root-padding-horz)"
  },
  "spacing.UpsellBanner.Root.padding.vert": {
    "value": "var(--spacing--upsell-banner--root-padding-vert)",
    "variable": "var(--spacing--upsell-banner--root-padding-vert)"
  },
  "spacing.UpsellBanner.CloseButton.margin.top": {
    "value": "var(--spacing--upsell-banner--close-button-margin-top)",
    "variable": "var(--spacing--upsell-banner--close-button-margin-top)"
  },
  "spacing.UpsellBanner.CloseButton.margin.right": {
    "value": "var(--spacing--upsell-banner--close-button-margin-right)",
    "variable": "var(--spacing--upsell-banner--close-button-margin-right)"
  },
  "spacing.Upsell.Action.margin.content-toActions": {
    "value": "var(--spacing--upsell--action-margin-content-to-actions)",
    "variable": "var(--spacing--upsell--action-margin-content-to-actions)"
  },
  "spacing.Upsell.Body.margin.heading-toMessage": {
    "value": "var(--spacing--upsell--body-margin-heading-to-message)",
    "variable": "var(--spacing--upsell--body-margin-heading-to-message)"
  },
  "spacing.Upsell.Header.gap.content-toClose": {
    "value": "var(--spacing--upsell--header-gap-content-to-close)",
    "variable": "var(--spacing--upsell--header-gap-content-to-close)"
  },
  "spacing.Upsell.Legal.margin.content-toActions": {
    "value": "var(--spacing--upsell--legal-margin-content-to-actions)",
    "variable": "var(--spacing--upsell--legal-margin-content-to-actions)"
  },
  "spacing.Upsell.Root.gap.img-toText": {
    "value": "var(--spacing--upsell--root-gap-img-to-text)",
    "variable": "var(--spacing--upsell--root-gap-img-to-text)"
  },
  "spacing.Upsell.Root.gap.icon-toText": {
    "value": "var(--spacing--upsell--root-gap-icon-to-text)",
    "variable": "var(--spacing--upsell--root-gap-icon-to-text)"
  },
  "spacing.Upsell.Root.padding.horz": {
    "value": "var(--spacing--upsell--root-padding-horz)",
    "variable": "var(--spacing--upsell--root-padding-horz)"
  },
  "spacing.Upsell.Root.padding.vert": {
    "value": "var(--spacing--upsell--root-padding-vert)",
    "variable": "var(--spacing--upsell--root-padding-vert)"
  },
  "spacing.Upsell.CloseButton.margin.top": {
    "value": "var(--spacing--upsell--close-button-margin-top)",
    "variable": "var(--spacing--upsell--close-button-margin-top)"
  },
  "spacing.Upsell.CloseButton.margin.right": {
    "value": "var(--spacing--upsell--close-button-margin-right)",
    "variable": "var(--spacing--upsell--close-button-margin-right)"
  },
  "spacing.VerticalNav.Divider.padding.vert": {
    "value": "var(--spacing--vertical-nav--divider-padding-vert)",
    "variable": "var(--spacing--vertical-nav--divider-padding-vert)"
  },
  "spacing.VerticalNav.Divider.gap.toNavItems": {
    "value": "var(--spacing--vertical-nav--divider-gap-to-nav-items)",
    "variable": "var(--spacing--vertical-nav--divider-gap-to-nav-items)"
  },
  "spacing.VerticalNav.Heading.padding.horz": {
    "value": "var(--spacing--vertical-nav--heading-padding-horz)",
    "variable": "var(--spacing--vertical-nav--heading-padding-horz)"
  },
  "spacing.VerticalNav.Heading.padding.vert": {
    "value": "var(--spacing--vertical-nav--heading-padding-vert)",
    "variable": "var(--spacing--vertical-nav--heading-padding-vert)"
  },
  "spacing.VerticalNav.Item.gap.leading": {
    "value": "var(--spacing--vertical-nav--item-gap-leading)",
    "variable": "var(--spacing--vertical-nav--item-gap-leading)"
  },
  "spacing.VerticalNav.Item.padding.horz": {
    "value": "var(--spacing--vertical-nav--item-padding-horz)",
    "variable": "var(--spacing--vertical-nav--item-padding-horz)"
  },
  "spacing.VerticalNav.Item.padding.vert": {
    "value": "var(--spacing--vertical-nav--item-padding-vert)",
    "variable": "var(--spacing--vertical-nav--item-padding-vert)"
  },
  "spacing.VerticalNav.List.gap.betweenItems": {
    "value": "var(--spacing--vertical-nav--list-gap-between-items)",
    "variable": "var(--spacing--vertical-nav--list-gap-between-items)"
  },
  "spacing.VerticalNav.List.padding.vert": {
    "value": "var(--spacing--vertical-nav--list-padding-vert)",
    "variable": "var(--spacing--vertical-nav--list-padding-vert)"
  },
  "spacing.VerticalNav.Root.padding.vert": {
    "value": "var(--spacing--vertical-nav--root-padding-vert)",
    "variable": "var(--spacing--vertical-nav--root-padding-vert)"
  },
  "spacing.VerticalNav.Root.padding.horz": {
    "value": "var(--spacing--vertical-nav--root-padding-horz)",
    "variable": "var(--spacing--vertical-nav--root-padding-horz)"
  },
  "spacing.device.margin.mobile": {
    "value": "var(--spacing-device-margin-mobile)",
    "variable": "var(--spacing-device-margin-mobile)"
  },
  "spacing.device.margin.tablet": {
    "value": "var(--spacing-device-margin-tablet)",
    "variable": "var(--spacing-device-margin-tablet)"
  },
  "spacing.device.margin.desktop": {
    "value": "var(--spacing-device-margin-desktop)",
    "variable": "var(--spacing-device-margin-desktop)"
  },
  "spacing.tightest": {
    "value": "var(--spacing-tightest)",
    "variable": "var(--spacing-tightest)"
  },
  "spacing.tighter": {
    "value": "var(--spacing-tighter)",
    "variable": "var(--spacing-tighter)"
  },
  "spacing.tight": {
    "value": "var(--spacing-tight)",
    "variable": "var(--spacing-tight)"
  },
  "spacing.default": {
    "value": "var(--spacing-default)",
    "variable": "var(--spacing-default)"
  },
  "spacing.loose": {
    "value": "var(--spacing-loose)",
    "variable": "var(--spacing-loose)"
  },
  "spacing.looser": {
    "value": "var(--spacing-looser)",
    "variable": "var(--spacing-looser)"
  },
  "spacing.none": {
    "value": "var(--spacing-none)",
    "variable": "var(--spacing-none)"
  },
  "spacing.conjoined-offsetBorder": {
    "value": "var(--spacing-conjoined-offset-border)",
    "variable": "var(--spacing-conjoined-offset-border)"
  },
  "spacing.layout.tightest": {
    "value": "var(--spacing-layout-tightest)",
    "variable": "var(--spacing-layout-tightest)"
  },
  "spacing.layout.tighter": {
    "value": "var(--spacing-layout-tighter)",
    "variable": "var(--spacing-layout-tighter)"
  },
  "spacing.layout.tight": {
    "value": "var(--spacing-layout-tight)",
    "variable": "var(--spacing-layout-tight)"
  },
  "spacing.layout.default": {
    "value": "var(--spacing-layout-default)",
    "variable": "var(--spacing-layout-default)"
  },
  "spacing.layout.loose": {
    "value": "var(--spacing-layout-loose)",
    "variable": "var(--spacing-layout-loose)"
  },
  "spacing.layout.looser": {
    "value": "var(--spacing-layout-looser)",
    "variable": "var(--spacing-layout-looser)"
  },
  "spacing.layout.loosest": {
    "value": "var(--spacing-layout-loosest)",
    "variable": "var(--spacing-layout-loosest)"
  },
  "spacing.layout.vast.default": {
    "value": "var(--spacing-layout-vast-default)",
    "variable": "var(--spacing-layout-vast-default)"
  },
  "spacing.layout.vast.loose": {
    "value": "var(--spacing-layout-vast-loose)",
    "variable": "var(--spacing-layout-vast-loose)"
  },
  "spacing.layout.vast.looser": {
    "value": "var(--spacing-layout-vast-looser)",
    "variable": "var(--spacing-layout-vast-looser)"
  },
  "spacing.micro.tight": {
    "value": "var(--spacing-micro-tight)",
    "variable": "var(--spacing-micro-tight)"
  },
  "spacing.micro.default": {
    "value": "var(--spacing-micro-default)",
    "variable": "var(--spacing-micro-default)"
  },
  "spacing.xxs": {
    "value": "var(--spacing-xxs)",
    "variable": "var(--spacing-xxs)"
  },
  "spacing.xs": {
    "value": "var(--spacing-xs)",
    "variable": "var(--spacing-xs)"
  },
  "spacing.sm": {
    "value": "var(--spacing-sm)",
    "variable": "var(--spacing-sm)"
  },
  "spacing.md": {
    "value": "var(--spacing-md)",
    "variable": "var(--spacing-md)"
  },
  "spacing.lg": {
    "value": "var(--spacing-lg)",
    "variable": "var(--spacing-lg)"
  },
  "spacing.xl": {
    "value": "var(--spacing-xl)",
    "variable": "var(--spacing-xl)"
  },
  "sizes.Accordion.Header.icon.height": {
    "value": "var(--sizes--accordion--header-icon-height)",
    "variable": "var(--sizes--accordion--header-icon-height)"
  },
  "sizes.Accordion.Header.icon.width": {
    "value": "var(--sizes--accordion--header-icon-width)",
    "variable": "var(--sizes--accordion--header-icon-width)"
  },
  "sizes.AdornedInput.Icon.height": {
    "value": "var(--sizes--adorned-input--icon-height)",
    "variable": "var(--sizes--adorned-input--icon-height)"
  },
  "sizes.AdornedInput.Icon.width": {
    "value": "var(--sizes--adorned-input--icon-width)",
    "variable": "var(--sizes--adorned-input--icon-width)"
  },
  "sizes.Avatar.Badge.sm.icon.default": {
    "value": "var(--sizes--avatar--badge-sm-icon-default)",
    "variable": "var(--sizes--avatar--badge-sm-icon-default)"
  },
  "sizes.Avatar.Badge.sm.icon.bare": {
    "value": "var(--sizes--avatar--badge-sm-icon-bare)",
    "variable": "var(--sizes--avatar--badge-sm-icon-bare)"
  },
  "sizes.Avatar.Badge.md.icon.default": {
    "value": "var(--sizes--avatar--badge-md-icon-default)",
    "variable": "var(--sizes--avatar--badge-md-icon-default)"
  },
  "sizes.Avatar.Badge.md.icon.bare": {
    "value": "var(--sizes--avatar--badge-md-icon-bare)",
    "variable": "var(--sizes--avatar--badge-md-icon-bare)"
  },
  "sizes.Avatar.Badge.lg.icon.default": {
    "value": "var(--sizes--avatar--badge-lg-icon-default)",
    "variable": "var(--sizes--avatar--badge-lg-icon-default)"
  },
  "sizes.Avatar.Badge.lg.icon.bare": {
    "value": "var(--sizes--avatar--badge-lg-icon-bare)",
    "variable": "var(--sizes--avatar--badge-lg-icon-bare)"
  },
  "sizes.Avatar.Icon.xs": {
    "value": "var(--sizes--avatar--icon-xs)",
    "variable": "var(--sizes--avatar--icon-xs)"
  },
  "sizes.Avatar.Icon.sm": {
    "value": "var(--sizes--avatar--icon-sm)",
    "variable": "var(--sizes--avatar--icon-sm)"
  },
  "sizes.Avatar.Icon.md": {
    "value": "var(--sizes--avatar--icon-md)",
    "variable": "var(--sizes--avatar--icon-md)"
  },
  "sizes.Avatar.Icon.lg": {
    "value": "var(--sizes--avatar--icon-lg)",
    "variable": "var(--sizes--avatar--icon-lg)"
  },
  "sizes.Avatar.Icon.xl": {
    "value": "var(--sizes--avatar--icon-xl)",
    "variable": "var(--sizes--avatar--icon-xl)"
  },
  "sizes.Avatar.Icon.xxl": {
    "value": "var(--sizes--avatar--icon-xxl)",
    "variable": "var(--sizes--avatar--icon-xxl)"
  },
  "sizes.Avatar.Root.xs.size": {
    "value": "var(--sizes--avatar--root-xs-size)",
    "variable": "var(--sizes--avatar--root-xs-size)"
  },
  "sizes.Avatar.Root.sm.size": {
    "value": "var(--sizes--avatar--root-sm-size)",
    "variable": "var(--sizes--avatar--root-sm-size)"
  },
  "sizes.Avatar.Root.md.size": {
    "value": "var(--sizes--avatar--root-md-size)",
    "variable": "var(--sizes--avatar--root-md-size)"
  },
  "sizes.Avatar.Root.lg.size": {
    "value": "var(--sizes--avatar--root-lg-size)",
    "variable": "var(--sizes--avatar--root-lg-size)"
  },
  "sizes.Avatar.Root.xl.size": {
    "value": "var(--sizes--avatar--root-xl-size)",
    "variable": "var(--sizes--avatar--root-xl-size)"
  },
  "sizes.Avatar.Root.xxl.size": {
    "value": "var(--sizes--avatar--root-xxl-size)",
    "variable": "var(--sizes--avatar--root-xxl-size)"
  },
  "sizes.Button.xs.tapArea": {
    "value": "var(--sizes--button-xs-tap-area)",
    "variable": "var(--sizes--button-xs-tap-area)"
  },
  "sizes.Button.sm.tapArea": {
    "value": "var(--sizes--button-sm-tap-area)",
    "variable": "var(--sizes--button-sm-tap-area)"
  },
  "sizes.Button.md.tapArea": {
    "value": "var(--sizes--button-md-tap-area)",
    "variable": "var(--sizes--button-md-tap-area)"
  },
  "sizes.Button.lg.tapArea": {
    "value": "var(--sizes--button-lg-tap-area)",
    "variable": "var(--sizes--button-lg-tap-area)"
  },
  "sizes.Calendar.ControlButton.width": {
    "value": "var(--sizes--calendar--control-button-width)",
    "variable": "var(--sizes--calendar--control-button-width)"
  },
  "sizes.Calendar.ControlButton.height": {
    "value": "var(--sizes--calendar--control-button-height)",
    "variable": "var(--sizes--calendar--control-button-height)"
  },
  "sizes.Calendar.Day.width": {
    "value": "var(--sizes--calendar--day-width)",
    "variable": "var(--sizes--calendar--day-width)"
  },
  "sizes.Calendar.Day.height": {
    "value": "var(--sizes--calendar--day-height)",
    "variable": "var(--sizes--calendar--day-height)"
  },
  "sizes.Calendar.YearSelect.button.width": {
    "value": "var(--sizes--calendar--year-select-button-width)",
    "variable": "var(--sizes--calendar--year-select-button-width)"
  },
  "sizes.Calendar.YearSelect.button.height": {
    "value": "var(--sizes--calendar--year-select-button-height)",
    "variable": "var(--sizes--calendar--year-select-button-height)"
  },
  "sizes.Calendar.YearSelect.icon.width": {
    "value": "var(--sizes--calendar--year-select-icon-width)",
    "variable": "var(--sizes--calendar--year-select-icon-width)"
  },
  "sizes.Calendar.YearSelect.icon.height": {
    "value": "var(--sizes--calendar--year-select-icon-height)",
    "variable": "var(--sizes--calendar--year-select-icon-height)"
  },
  "sizes.Carousel.SkipLink.height": {
    "value": "var(--sizes--carousel--skip-link-height)",
    "variable": "var(--sizes--carousel--skip-link-height)"
  },
  "sizes.Checkbox.box": {
    "value": "var(--sizes--checkbox-box)",
    "variable": "var(--sizes--checkbox-box)"
  },
  "sizes.Checkbox.frame": {
    "value": "var(--sizes--checkbox-frame)",
    "variable": "var(--sizes--checkbox-frame)"
  },
  "sizes.Checkbox.icon": {
    "value": "var(--sizes--checkbox-icon)",
    "variable": "var(--sizes--checkbox-icon)"
  },
  "sizes.Chip.height-min": {
    "value": "var(--sizes--chip-height-min)",
    "variable": "var(--sizes--chip-height-min)"
  },
  "sizes.Chip.icon": {
    "value": "var(--sizes--chip-icon)",
    "variable": "var(--sizes--chip-icon)"
  },
  "sizes.Chip.slot": {
    "value": "var(--sizes--chip-slot)",
    "variable": "var(--sizes--chip-slot)"
  },
  "sizes.Chip.tapArea": {
    "value": "var(--sizes--chip-tap-area)",
    "variable": "var(--sizes--chip-tap-area)"
  },
  "sizes.Chip.Close.height": {
    "value": "var(--sizes--chip--close-height)",
    "variable": "var(--sizes--chip--close-height)"
  },
  "sizes.Chip.Close.width": {
    "value": "var(--sizes--chip--close-width)",
    "variable": "var(--sizes--chip--close-width)"
  },
  "sizes.CloseButton": {
    "value": "var(--sizes--close-button)",
    "variable": "var(--sizes--close-button)"
  },
  "sizes.Combobox.Adornment.height": {
    "value": "var(--sizes--combobox--adornment-height)",
    "variable": "var(--sizes--combobox--adornment-height)"
  },
  "sizes.Combobox.Adornment.width": {
    "value": "var(--sizes--combobox--adornment-width)",
    "variable": "var(--sizes--combobox--adornment-width)"
  },
  "sizes.Combobox.Clear.width": {
    "value": "var(--sizes--combobox--clear-width)",
    "variable": "var(--sizes--combobox--clear-width)"
  },
  "sizes.Combobox.Content.height.max": {
    "value": "var(--sizes--combobox--content-height-max)",
    "variable": "var(--sizes--combobox--content-height-max)"
  },
  "sizes.Combobox.Heading.icon.height": {
    "value": "var(--sizes--combobox--heading-icon-height)",
    "variable": "var(--sizes--combobox--heading-icon-height)"
  },
  "sizes.Combobox.Heading.icon.width": {
    "value": "var(--sizes--combobox--heading-icon-width)",
    "variable": "var(--sizes--combobox--heading-icon-width)"
  },
  "sizes.Combobox.InputGroup.height.min": {
    "value": "var(--sizes--combobox--input-group-height-min)",
    "variable": "var(--sizes--combobox--input-group-height-min)"
  },
  "sizes.Combobox.OptionMedia.icon.height": {
    "value": "var(--sizes--combobox--option-media-icon-height)",
    "variable": "var(--sizes--combobox--option-media-icon-height)"
  },
  "sizes.Combobox.OptionMedia.icon.width": {
    "value": "var(--sizes--combobox--option-media-icon-width)",
    "variable": "var(--sizes--combobox--option-media-icon-width)"
  },
  "sizes.DatePicker.Trigger.icon.sm.width": {
    "value": "var(--sizes--date-picker--trigger-icon-sm-width)",
    "variable": "var(--sizes--date-picker--trigger-icon-sm-width)"
  },
  "sizes.DatePicker.Trigger.icon.sm.height": {
    "value": "var(--sizes--date-picker--trigger-icon-sm-height)",
    "variable": "var(--sizes--date-picker--trigger-icon-sm-height)"
  },
  "sizes.DatePicker.Trigger.icon.md.width": {
    "value": "var(--sizes--date-picker--trigger-icon-md-width)",
    "variable": "var(--sizes--date-picker--trigger-icon-md-width)"
  },
  "sizes.DatePicker.Trigger.icon.md.height": {
    "value": "var(--sizes--date-picker--trigger-icon-md-height)",
    "variable": "var(--sizes--date-picker--trigger-icon-md-height)"
  },
  "sizes.DatePicker.Trigger.icon.lg.width": {
    "value": "var(--sizes--date-picker--trigger-icon-lg-width)",
    "variable": "var(--sizes--date-picker--trigger-icon-lg-width)"
  },
  "sizes.DatePicker.Trigger.icon.lg.height": {
    "value": "var(--sizes--date-picker--trigger-icon-lg-height)",
    "variable": "var(--sizes--date-picker--trigger-icon-lg-height)"
  },
  "sizes.DateTimeBlock.Day.minHeight": {
    "value": "var(--sizes--date-time-block--day-min-height)",
    "variable": "var(--sizes--date-time-block--day-min-height)"
  },
  "sizes.Divider.width.horizontal": {
    "value": "var(--sizes--divider-width-horizontal)",
    "variable": "var(--sizes--divider-width-horizontal)"
  },
  "sizes.Divider.width.emphasized": {
    "value": "var(--sizes--divider-width-emphasized)",
    "variable": "var(--sizes--divider-width-emphasized)"
  },
  "sizes.Divider.height.vertical": {
    "value": "var(--sizes--divider-height-vertical)",
    "variable": "var(--sizes--divider-height-vertical)"
  },
  "sizes.Divider.weight.emphasized.horizontal": {
    "value": "var(--sizes--divider-weight-emphasized-horizontal)",
    "variable": "var(--sizes--divider-weight-emphasized-horizontal)"
  },
  "sizes.Divider.weight.horizontal": {
    "value": "var(--sizes--divider-weight-horizontal)",
    "variable": "var(--sizes--divider-weight-horizontal)"
  },
  "sizes.Divider.weight.vertical": {
    "value": "var(--sizes--divider-weight-vertical)",
    "variable": "var(--sizes--divider-weight-vertical)"
  },
  "sizes.Dropdown.Heading.icon.height": {
    "value": "var(--sizes--dropdown--heading-icon-height)",
    "variable": "var(--sizes--dropdown--heading-icon-height)"
  },
  "sizes.Dropdown.Heading.icon.width": {
    "value": "var(--sizes--dropdown--heading-icon-width)",
    "variable": "var(--sizes--dropdown--heading-icon-width)"
  },
  "sizes.DuoColorIcon.Root.size": {
    "value": "var(--sizes--duo-color-icon--root-size)",
    "variable": "var(--sizes--duo-color-icon--root-size)"
  },
  "sizes.DuoColorIcon.Icon.size": {
    "value": "var(--sizes--duo-color-icon--icon-size)",
    "variable": "var(--sizes--duo-color-icon--icon-size)"
  },
  "sizes.FieldSet.HelperArea.icon": {
    "value": "var(--sizes--field-set--helper-area-icon)",
    "variable": "var(--sizes--field-set--helper-area-icon)"
  },
  "sizes.Gleam.height.min": {
    "value": "var(--sizes--gleam-height-min)",
    "variable": "var(--sizes--gleam-height-min)"
  },
  "sizes.Gleam.height.dot": {
    "value": "var(--sizes--gleam-height-dot)",
    "variable": "var(--sizes--gleam-height-dot)"
  },
  "sizes.Gleam.width.min": {
    "value": "var(--sizes--gleam-width-min)",
    "variable": "var(--sizes--gleam-width-min)"
  },
  "sizes.Gleam.width.dot": {
    "value": "var(--sizes--gleam-width-dot)",
    "variable": "var(--sizes--gleam-width-dot)"
  },
  "sizes.Gleam.positioning.default": {
    "value": "var(--sizes--gleam-positioning-default)",
    "variable": "var(--sizes--gleam-positioning-default)"
  },
  "sizes.Gleam.positioning.avatar.md": {
    "value": "var(--sizes--gleam-positioning-avatar-md)",
    "variable": "var(--sizes--gleam-positioning-avatar-md)"
  },
  "sizes.Gleam.positioning.avatar.lg": {
    "value": "var(--sizes--gleam-positioning-avatar-lg)",
    "variable": "var(--sizes--gleam-positioning-avatar-lg)"
  },
  "sizes.Gleam.positioning.avatar.xl": {
    "value": "var(--sizes--gleam-positioning-avatar-xl)",
    "variable": "var(--sizes--gleam-positioning-avatar-xl)"
  },
  "sizes.Gleam.positioning.avatar.xxl": {
    "value": "var(--sizes--gleam-positioning-avatar-xxl)",
    "variable": "var(--sizes--gleam-positioning-avatar-xxl)"
  },
  "sizes.Gleam.positioning.icon.sm": {
    "value": "var(--sizes--gleam-positioning-icon-sm)",
    "variable": "var(--sizes--gleam-positioning-icon-sm)"
  },
  "sizes.Gleam.positioning.icon.xl": {
    "value": "var(--sizes--gleam-positioning-icon-xl)",
    "variable": "var(--sizes--gleam-positioning-icon-xl)"
  },
  "sizes.IconButton.xs": {
    "value": "var(--sizes--icon-button-xs)",
    "variable": "var(--sizes--icon-button-xs)"
  },
  "sizes.IconButton.sm": {
    "value": "var(--sizes--icon-button-sm)",
    "variable": "var(--sizes--icon-button-sm)"
  },
  "sizes.IconButton.md": {
    "value": "var(--sizes--icon-button-md)",
    "variable": "var(--sizes--icon-button-md)"
  },
  "sizes.IconButton.lg": {
    "value": "var(--sizes--icon-button-lg)",
    "variable": "var(--sizes--icon-button-lg)"
  },
  "sizes.Layout.Root.fixed": {
    "value": "var(--sizes--layout--root-fixed)",
    "variable": "var(--sizes--layout--root-fixed)"
  },
  "sizes.Menu.Content.width.max": {
    "value": "var(--sizes--menu--content-width-max)",
    "variable": "var(--sizes--menu--content-width-max)"
  },
  "sizes.Menu.Content.width.min": {
    "value": "var(--sizes--menu--content-width-min)",
    "variable": "var(--sizes--menu--content-width-min)"
  },
  "sizes.Menu.Heading.icon.height": {
    "value": "var(--sizes--menu--heading-icon-height)",
    "variable": "var(--sizes--menu--heading-icon-height)"
  },
  "sizes.Menu.Heading.icon.width": {
    "value": "var(--sizes--menu--heading-icon-width)",
    "variable": "var(--sizes--menu--heading-icon-width)"
  },
  "sizes.Menu.ItemIcon.icon.height": {
    "value": "var(--sizes--menu--item-icon-icon-height)",
    "variable": "var(--sizes--menu--item-icon-icon-height)"
  },
  "sizes.Menu.ItemIcon.icon.width": {
    "value": "var(--sizes--menu--item-icon-icon-width)",
    "variable": "var(--sizes--menu--item-icon-icon-width)"
  },
  "sizes.Modal.Content.minHeight": {
    "value": "var(--sizes--modal--content-min-height)",
    "variable": "var(--sizes--modal--content-min-height)"
  },
  "sizes.Modal.Content.size.xs": {
    "value": "var(--sizes--modal--content-size-xs)",
    "variable": "var(--sizes--modal--content-size-xs)"
  },
  "sizes.Modal.Content.size.sm": {
    "value": "var(--sizes--modal--content-size-sm)",
    "variable": "var(--sizes--modal--content-size-sm)"
  },
  "sizes.Modal.Content.size.md": {
    "value": "var(--sizes--modal--content-size-md)",
    "variable": "var(--sizes--modal--content-size-md)"
  },
  "sizes.Modal.Content.size.lg": {
    "value": "var(--sizes--modal--content-size-lg)",
    "variable": "var(--sizes--modal--content-size-lg)"
  },
  "sizes.Modal.Content.size.xl": {
    "value": "var(--sizes--modal--content-size-xl)",
    "variable": "var(--sizes--modal--content-size-xl)"
  },
  "sizes.Modal.Content.size.fullScreen": {
    "value": "var(--sizes--modal--content-size-full-screen)",
    "variable": "var(--sizes--modal--content-size-full-screen)"
  },
  "sizes.NumberRating.icon.height": {
    "value": "var(--sizes--number-rating-icon-height)",
    "variable": "var(--sizes--number-rating-icon-height)"
  },
  "sizes.NumberRating.icon.width": {
    "value": "var(--sizes--number-rating-icon-width)",
    "variable": "var(--sizes--number-rating-icon-width)"
  },
  "sizes.Page.width.max": {
    "value": "var(--sizes--page-width-max)",
    "variable": "var(--sizes--page-width-max)"
  },
  "sizes.Pagination.PageButton.height": {
    "value": "var(--sizes--pagination--page-button-height)",
    "variable": "var(--sizes--pagination--page-button-height)"
  },
  "sizes.Pagination.PageButton.width": {
    "value": "var(--sizes--pagination--page-button-width)",
    "variable": "var(--sizes--pagination--page-button-width)"
  },
  "sizes.Pagination.PageButton.border": {
    "value": "var(--sizes--pagination--page-button-border)",
    "variable": "var(--sizes--pagination--page-button-border)"
  },
  "sizes.PhotoCarousel.Dot.current": {
    "value": "var(--sizes--photo-carousel--dot-current)",
    "variable": "var(--sizes--photo-carousel--dot-current)"
  },
  "sizes.PhotoCarousel.Dot.sm": {
    "value": "var(--sizes--photo-carousel--dot-sm)",
    "variable": "var(--sizes--photo-carousel--dot-sm)"
  },
  "sizes.PhotoCarousel.Dot.xs": {
    "value": "var(--sizes--photo-carousel--dot-xs)",
    "variable": "var(--sizes--photo-carousel--dot-xs)"
  },
  "sizes.PhotoCarousel.Dots.height": {
    "value": "var(--sizes--photo-carousel--dots-height)",
    "variable": "var(--sizes--photo-carousel--dots-height)"
  },
  "sizes.Popover.Content.height.max": {
    "value": "var(--sizes--popover--content-height-max)",
    "variable": "var(--sizes--popover--content-height-max)"
  },
  "sizes.Popover.Content.width.max": {
    "value": "var(--sizes--popover--content-width-max)",
    "variable": "var(--sizes--popover--content-width-max)"
  },
  "sizes.Popover.Header.icon.height": {
    "value": "var(--sizes--popover--header-icon-height)",
    "variable": "var(--sizes--popover--header-icon-height)"
  },
  "sizes.Popover.Header.icon.width": {
    "value": "var(--sizes--popover--header-icon-width)",
    "variable": "var(--sizes--popover--header-icon-width)"
  },
  "sizes.ProgressIndicator.bar.sm.height": {
    "value": "var(--sizes--progress-indicator-bar-sm-height)",
    "variable": "var(--sizes--progress-indicator-bar-sm-height)"
  },
  "sizes.ProgressIndicator.bar.md.height": {
    "value": "var(--sizes--progress-indicator-bar-md-height)",
    "variable": "var(--sizes--progress-indicator-bar-md-height)"
  },
  "sizes.ProgressMeter.Node.default": {
    "value": "var(--sizes--progress-meter--node-default)",
    "variable": "var(--sizes--progress-meter--node-default)"
  },
  "sizes.ProgressMeter.Node.container.default": {
    "value": "var(--sizes--progress-meter--node-container-default)",
    "variable": "var(--sizes--progress-meter--node-container-default)"
  },
  "sizes.ProgressMeter.Node.container.width.min": {
    "value": "var(--sizes--progress-meter--node-container-width-min)",
    "variable": "var(--sizes--progress-meter--node-container-width-min)"
  },
  "sizes.ProgressMeter.Node.marker.active": {
    "value": "var(--sizes--progress-meter--node-marker-active)",
    "variable": "var(--sizes--progress-meter--node-marker-active)"
  },
  "sizes.ProgressMeter.Node.marker.notStarted": {
    "value": "var(--sizes--progress-meter--node-marker-not-started)",
    "variable": "var(--sizes--progress-meter--node-marker-not-started)"
  },
  "sizes.ProgressMeter.Node.focusRing.active": {
    "value": "var(--sizes--progress-meter--node-focus-ring-active)",
    "variable": "var(--sizes--progress-meter--node-focus-ring-active)"
  },
  "sizes.ProgressMeter.Node.focusRing.vertical.active": {
    "value": "var(--sizes--progress-meter--node-focus-ring-vertical-active)",
    "variable": "var(--sizes--progress-meter--node-focus-ring-vertical-active)"
  },
  "sizes.ProgressMeter.Node.focusRing.default.hover": {
    "value": "var(--sizes--progress-meter--node-focus-ring-default-hover)",
    "variable": "var(--sizes--progress-meter--node-focus-ring-default-hover)"
  },
  "sizes.ProgressMeter.Node.focusRing.default.pressed": {
    "value": "var(--sizes--progress-meter--node-focus-ring-default-pressed)",
    "variable": "var(--sizes--progress-meter--node-focus-ring-default-pressed)"
  },
  "sizes.ProgressMeter.Node.focusRing.notStarted.hover": {
    "value": "var(--sizes--progress-meter--node-focus-ring-not-started-hover)",
    "variable": "var(--sizes--progress-meter--node-focus-ring-not-started-hover)"
  },
  "sizes.ProgressMeter.Node.focusRing.notStarted.pressed": {
    "value": "var(--sizes--progress-meter--node-focus-ring-not-started-pressed)",
    "variable": "var(--sizes--progress-meter--node-focus-ring-not-started-pressed)"
  },
  "sizes.ProgressMeter.Node.icon.default": {
    "value": "var(--sizes--progress-meter--node-icon-default)",
    "variable": "var(--sizes--progress-meter--node-icon-default)"
  },
  "sizes.ProgressMeter.Node.icon.complete": {
    "value": "var(--sizes--progress-meter--node-icon-complete)",
    "variable": "var(--sizes--progress-meter--node-icon-complete)"
  },
  "sizes.ProgressMeter.Node.icon.incomplete": {
    "value": "var(--sizes--progress-meter--node-icon-incomplete)",
    "variable": "var(--sizes--progress-meter--node-icon-incomplete)"
  },
  "sizes.ProgressMeter.Track.weight": {
    "value": "var(--sizes--progress-meter--track-weight)",
    "variable": "var(--sizes--progress-meter--track-weight)"
  },
  "sizes.ProgressMeter.Track.lengthOffset": {
    "value": "var(--sizes--progress-meter--track-length-offset)",
    "variable": "var(--sizes--progress-meter--track-length-offset)"
  },
  "sizes.PropertyCard.ActionArea.large": {
    "value": "var(--sizes--property-card--action-area-large)",
    "variable": "var(--sizes--property-card--action-area-large)"
  },
  "sizes.PropertyCard.ActionArea.small": {
    "value": "var(--sizes--property-card--action-area-small)",
    "variable": "var(--sizes--property-card--action-area-small)"
  },
  "sizes.PropertyCard.ActionArea.horizontal": {
    "value": "var(--sizes--property-card--action-area-horizontal)",
    "variable": "var(--sizes--property-card--action-area-horizontal)"
  },
  "sizes.PropertyCard.DataArea.buttonSlot.height": {
    "value": "var(--sizes--property-card--data-area-button-slot-height)",
    "variable": "var(--sizes--property-card--data-area-button-slot-height)"
  },
  "sizes.PropertyCard.DataArea.buttonSlot.width": {
    "value": "var(--sizes--property-card--data-area-button-slot-width)",
    "variable": "var(--sizes--property-card--data-area-button-slot-width)"
  },
  "sizes.PropertyCard.DataWrapper.large.minHeight": {
    "value": "var(--sizes--property-card--data-wrapper-large-min-height)",
    "variable": "var(--sizes--property-card--data-wrapper-large-min-height)"
  },
  "sizes.PropertyCard.DataWrapper.small.minHeight": {
    "value": "var(--sizes--property-card--data-wrapper-small-min-height)",
    "variable": "var(--sizes--property-card--data-wrapper-small-min-height)"
  },
  "sizes.PropertyCard.DataWrapper.horizontal.minWidth": {
    "value": "var(--sizes--property-card--data-wrapper-horizontal-min-width)",
    "variable": "var(--sizes--property-card--data-wrapper-horizontal-min-width)"
  },
  "sizes.PropertyCard.PhotoFallback.large.icon.height": {
    "value": "var(--sizes--property-card--photo-fallback-large-icon-height)",
    "variable": "var(--sizes--property-card--photo-fallback-large-icon-height)"
  },
  "sizes.PropertyCard.PhotoFallback.large.icon.width": {
    "value": "var(--sizes--property-card--photo-fallback-large-icon-width)",
    "variable": "var(--sizes--property-card--photo-fallback-large-icon-width)"
  },
  "sizes.PropertyCard.PhotoFallback.small.icon.height": {
    "value": "var(--sizes--property-card--photo-fallback-small-icon-height)",
    "variable": "var(--sizes--property-card--photo-fallback-small-icon-height)"
  },
  "sizes.PropertyCard.PhotoFallback.small.icon.width": {
    "value": "var(--sizes--property-card--photo-fallback-small-icon-width)",
    "variable": "var(--sizes--property-card--photo-fallback-small-icon-width)"
  },
  "sizes.PropertyCard.PhotoFallback.horizontal.icon.height": {
    "value": "var(--sizes--property-card--photo-fallback-horizontal-icon-height)",
    "variable": "var(--sizes--property-card--photo-fallback-horizontal-icon-height)"
  },
  "sizes.PropertyCard.PhotoFallback.horizontal.icon.width": {
    "value": "var(--sizes--property-card--photo-fallback-horizontal-icon-width)",
    "variable": "var(--sizes--property-card--photo-fallback-horizontal-icon-width)"
  },
  "sizes.PropertyCard.PhotoFooter.logo.maxHeight": {
    "value": "var(--sizes--property-card--photo-footer-logo-max-height)",
    "variable": "var(--sizes--property-card--photo-footer-logo-max-height)"
  },
  "sizes.PropertyCard.PhotoFooter.logo.maxWidth": {
    "value": "var(--sizes--property-card--photo-footer-logo-max-width)",
    "variable": "var(--sizes--property-card--photo-footer-logo-max-width)"
  },
  "sizes.PropertyCard.PhotoWrapper.large.minHeight": {
    "value": "var(--sizes--property-card--photo-wrapper-large-min-height)",
    "variable": "var(--sizes--property-card--photo-wrapper-large-min-height)"
  },
  "sizes.PropertyCard.PhotoWrapper.small.minHeight": {
    "value": "var(--sizes--property-card--photo-wrapper-small-min-height)",
    "variable": "var(--sizes--property-card--photo-wrapper-small-min-height)"
  },
  "sizes.PropertyCard.PhotoWrapper.horizontal.minHeight": {
    "value": "var(--sizes--property-card--photo-wrapper-horizontal-min-height)",
    "variable": "var(--sizes--property-card--photo-wrapper-horizontal-min-height)"
  },
  "sizes.PropertyCard.PhotoWrapper.horizontal.minWidth": {
    "value": "var(--sizes--property-card--photo-wrapper-horizontal-min-width)",
    "variable": "var(--sizes--property-card--photo-wrapper-horizontal-min-width)"
  },
  "sizes.PropertyCard.Root.large.min": {
    "value": "var(--sizes--property-card--root-large-min)",
    "variable": "var(--sizes--property-card--root-large-min)"
  },
  "sizes.PropertyCard.Root.large.max": {
    "value": "var(--sizes--property-card--root-large-max)",
    "variable": "var(--sizes--property-card--root-large-max)"
  },
  "sizes.PropertyCard.Root.small.min": {
    "value": "var(--sizes--property-card--root-small-min)",
    "variable": "var(--sizes--property-card--root-small-min)"
  },
  "sizes.PropertyCard.Root.small.max": {
    "value": "var(--sizes--property-card--root-small-max)",
    "variable": "var(--sizes--property-card--root-small-max)"
  },
  "sizes.PropertyCard.Root.horizontal.min": {
    "value": "var(--sizes--property-card--root-horizontal-min)",
    "variable": "var(--sizes--property-card--root-horizontal-min)"
  },
  "sizes.PropertyCard.Root.horizontal.max": {
    "value": "var(--sizes--property-card--root-horizontal-max)",
    "variable": "var(--sizes--property-card--root-horizontal-max)"
  },
  "sizes.PropertyCard.SaveButton.height": {
    "value": "var(--sizes--property-card--save-button-height)",
    "variable": "var(--sizes--property-card--save-button-height)"
  },
  "sizes.PropertyCard.SaveButton.width": {
    "value": "var(--sizes--property-card--save-button-width)",
    "variable": "var(--sizes--property-card--save-button-width)"
  },
  "sizes.Radio.ring.height": {
    "value": "var(--sizes--radio-ring-height)",
    "variable": "var(--sizes--radio-ring-height)"
  },
  "sizes.Radio.ring.width": {
    "value": "var(--sizes--radio-ring-width)",
    "variable": "var(--sizes--radio-ring-width)"
  },
  "sizes.Range.Track.height": {
    "value": "var(--sizes--range--track-height)",
    "variable": "var(--sizes--range--track-height)"
  },
  "sizes.Range.Handle": {
    "value": "var(--sizes--range--handle)",
    "variable": "var(--sizes--range--handle)"
  },
  "sizes.RatingStars.icon.height": {
    "value": "var(--sizes--rating-stars-icon-height)",
    "variable": "var(--sizes--rating-stars-icon-height)"
  },
  "sizes.RatingStars.icon.width": {
    "value": "var(--sizes--rating-stars-icon-width)",
    "variable": "var(--sizes--rating-stars-icon-width)"
  },
  "sizes.Select.icon": {
    "value": "var(--sizes--select-icon)",
    "variable": "var(--sizes--select-icon)"
  },
  "sizes.Slider.Root.height": {
    "value": "var(--sizes--slider--root-height)",
    "variable": "var(--sizes--slider--root-height)"
  },
  "sizes.Slider.Track.height": {
    "value": "var(--sizes--slider--track-height)",
    "variable": "var(--sizes--slider--track-height)"
  },
  "sizes.Slider.Handle": {
    "value": "var(--sizes--slider--handle)",
    "variable": "var(--sizes--slider--handle)"
  },
  "sizes.Switch.Track.md.height": {
    "value": "var(--sizes--switch--track-md-height)",
    "variable": "var(--sizes--switch--track-md-height)"
  },
  "sizes.Switch.Track.md.width": {
    "value": "var(--sizes--switch--track-md-width)",
    "variable": "var(--sizes--switch--track-md-width)"
  },
  "sizes.Switch.Track.lg.height": {
    "value": "var(--sizes--switch--track-lg-height)",
    "variable": "var(--sizes--switch--track-lg-height)"
  },
  "sizes.Switch.Track.lg.width": {
    "value": "var(--sizes--switch--track-lg-width)",
    "variable": "var(--sizes--switch--track-lg-width)"
  },
  "sizes.Switch.Handle.md": {
    "value": "var(--sizes--switch--handle-md)",
    "variable": "var(--sizes--switch--handle-md)"
  },
  "sizes.Switch.Handle.lg": {
    "value": "var(--sizes--switch--handle-lg)",
    "variable": "var(--sizes--switch--handle-lg)"
  },
  "sizes.Tabs.indicator": {
    "value": "var(--sizes--tabs-indicator)",
    "variable": "var(--sizes--tabs-indicator)"
  },
  "sizes.Toast.maxWidth": {
    "value": "var(--sizes--toast-max-width)",
    "variable": "var(--sizes--toast-max-width)"
  },
  "sizes.UpsellBanner.Media.icon.height": {
    "value": "var(--sizes--upsell-banner--media-icon-height)",
    "variable": "var(--sizes--upsell-banner--media-icon-height)"
  },
  "sizes.UpsellBanner.Media.icon.width": {
    "value": "var(--sizes--upsell-banner--media-icon-width)",
    "variable": "var(--sizes--upsell-banner--media-icon-width)"
  },
  "sizes.Upsell.Media.icon.height": {
    "value": "var(--sizes--upsell--media-icon-height)",
    "variable": "var(--sizes--upsell--media-icon-height)"
  },
  "sizes.Upsell.Media.icon.width": {
    "value": "var(--sizes--upsell--media-icon-width)",
    "variable": "var(--sizes--upsell--media-icon-width)"
  },
  "sizes.VerticalNav.Root.minWidth": {
    "value": "var(--sizes--vertical-nav--root-min-width)",
    "variable": "var(--sizes--vertical-nav--root-min-width)"
  },
  "sizes.action.xxs": {
    "value": "var(--sizes-action-xxs)",
    "variable": "var(--sizes-action-xxs)"
  },
  "sizes.action.xs": {
    "value": "var(--sizes-action-xs)",
    "variable": "var(--sizes-action-xs)"
  },
  "sizes.action.sm": {
    "value": "var(--sizes-action-sm)",
    "variable": "var(--sizes-action-sm)"
  },
  "sizes.action.md": {
    "value": "var(--sizes-action-md)",
    "variable": "var(--sizes-action-md)"
  },
  "sizes.action.lg": {
    "value": "var(--sizes-action-lg)",
    "variable": "var(--sizes-action-lg)"
  },
  "sizes.handle.xs": {
    "value": "var(--sizes-handle-xs)",
    "variable": "var(--sizes-handle-xs)"
  },
  "sizes.handle.sm": {
    "value": "var(--sizes-handle-sm)",
    "variable": "var(--sizes-handle-sm)"
  },
  "sizes.handle.md": {
    "value": "var(--sizes-handle-md)",
    "variable": "var(--sizes-handle-md)"
  },
  "sizes.handle.lg": {
    "value": "var(--sizes-handle-lg)",
    "variable": "var(--sizes-handle-lg)"
  },
  "sizes.handle.xl": {
    "value": "var(--sizes-handle-xl)",
    "variable": "var(--sizes-handle-xl)"
  },
  "sizes.icon.xs": {
    "value": "var(--sizes-icon-xs)",
    "variable": "var(--sizes-icon-xs)"
  },
  "sizes.icon.sm": {
    "value": "var(--sizes-icon-sm)",
    "variable": "var(--sizes-icon-sm)"
  },
  "sizes.icon.md": {
    "value": "var(--sizes-icon-md)",
    "variable": "var(--sizes-icon-md)"
  },
  "sizes.icon.lg": {
    "value": "var(--sizes-icon-lg)",
    "variable": "var(--sizes-icon-lg)"
  },
  "sizes.icon.xl": {
    "value": "var(--sizes-icon-xl)",
    "variable": "var(--sizes-icon-xl)"
  },
  "sizes.icon.xxl": {
    "value": "var(--sizes-icon-xxl)",
    "variable": "var(--sizes-icon-xxl)"
  },
  "sizes.indicator.xxs": {
    "value": "var(--sizes-indicator-xxs)",
    "variable": "var(--sizes-indicator-xxs)"
  },
  "sizes.indicator.xs": {
    "value": "var(--sizes-indicator-xs)",
    "variable": "var(--sizes-indicator-xs)"
  },
  "sizes.indicator.sm": {
    "value": "var(--sizes-indicator-sm)",
    "variable": "var(--sizes-indicator-sm)"
  },
  "sizes.indicator.md": {
    "value": "var(--sizes-indicator-md)",
    "variable": "var(--sizes-indicator-md)"
  },
  "sizes.indicator.lg": {
    "value": "var(--sizes-indicator-lg)",
    "variable": "var(--sizes-indicator-lg)"
  },
  "sizes.indicator.xl": {
    "value": "var(--sizes-indicator-xl)",
    "variable": "var(--sizes-indicator-xl)"
  },
  "sizes.obj.xxs": {
    "value": "var(--sizes-obj-xxs)",
    "variable": "var(--sizes-obj-xxs)"
  },
  "sizes.obj.xs": {
    "value": "var(--sizes-obj-xs)",
    "variable": "var(--sizes-obj-xs)"
  },
  "sizes.obj.sm": {
    "value": "var(--sizes-obj-sm)",
    "variable": "var(--sizes-obj-sm)"
  },
  "sizes.obj.md": {
    "value": "var(--sizes-obj-md)",
    "variable": "var(--sizes-obj-md)"
  },
  "sizes.obj.lg": {
    "value": "var(--sizes-obj-lg)",
    "variable": "var(--sizes-obj-lg)"
  },
  "sizes.obj.xl": {
    "value": "var(--sizes-obj-xl)",
    "variable": "var(--sizes-obj-xl)"
  },
  "sizes.obj.xxl": {
    "value": "var(--sizes-obj-xxl)",
    "variable": "var(--sizes-obj-xxl)"
  },
  "sizes.pipe.weight.default": {
    "value": "var(--sizes-pipe-weight-default)",
    "variable": "var(--sizes-pipe-weight-default)"
  },
  "sizes.pipe.weight.thick": {
    "value": "var(--sizes-pipe-weight-thick)",
    "variable": "var(--sizes-pipe-weight-thick)"
  },
  "sizes.pipe.weight.thicker": {
    "value": "var(--sizes-pipe-weight-thicker)",
    "variable": "var(--sizes-pipe-weight-thicker)"
  },
  "sizes.pipe.weight.thickest": {
    "value": "var(--sizes-pipe-weight-thickest)",
    "variable": "var(--sizes-pipe-weight-thickest)"
  },
  "sizes.tapArea.mobile.min": {
    "value": "var(--sizes-tap-area-mobile-min)",
    "variable": "var(--sizes-tap-area-mobile-min)"
  },
  "sizes.tapArea.mobile.sm": {
    "value": "var(--sizes-tap-area-mobile-sm)",
    "variable": "var(--sizes-tap-area-mobile-sm)"
  },
  "sizes.tapArea.mobile.default": {
    "value": "var(--sizes-tap-area-mobile-default)",
    "variable": "var(--sizes-tap-area-mobile-default)"
  },
  "sizes.tapArea.mobile.lg": {
    "value": "var(--sizes-tap-area-mobile-lg)",
    "variable": "var(--sizes-tap-area-mobile-lg)"
  },
  "sizes.xs": {
    "value": "var(--sizes-xs)",
    "variable": "var(--sizes-xs)"
  },
  "sizes.sm": {
    "value": "var(--sizes-sm)",
    "variable": "var(--sizes-sm)"
  },
  "sizes.md": {
    "value": "var(--sizes-md)",
    "variable": "var(--sizes-md)"
  },
  "sizes.lg": {
    "value": "var(--sizes-lg)",
    "variable": "var(--sizes-lg)"
  },
  "textDecoration.Anchor.default": {
    "value": "var(--text-decoration--anchor-default)",
    "variable": "var(--text-decoration--anchor-default)"
  },
  "textDecoration.Anchor.hover": {
    "value": "var(--text-decoration--anchor-hover)",
    "variable": "var(--text-decoration--anchor-hover)"
  },
  "textDecoration.TextButton.default": {
    "value": "var(--text-decoration--text-button-default)",
    "variable": "var(--text-decoration--text-button-default)"
  },
  "textDecoration.TextButton.hover": {
    "value": "var(--text-decoration--text-button-hover)",
    "variable": "var(--text-decoration--text-button-hover)"
  },
  "textDecoration.TextButton.onImpact.default": {
    "value": "var(--text-decoration--text-button-on-impact-default)",
    "variable": "var(--text-decoration--text-button-on-impact-default)"
  },
  "textDecoration.TextButton.onImpact.hover": {
    "value": "var(--text-decoration--text-button-on-impact-hover)",
    "variable": "var(--text-decoration--text-button-on-impact-hover)"
  },
  "shadows.Calendar.YearSelect.Button.focus": {
    "value": "var(--shadows--calendar--year-select--button-focus)",
    "variable": "var(--shadows--calendar--year-select--button-focus)"
  },
  "shadows.Card.Root.elevated.default": {
    "value": "var(--shadows--card--root-elevated-default)",
    "variable": "var(--shadows--card--root-elevated-default)"
  },
  "shadows.Card.Root.interactive.default": {
    "value": "var(--shadows--card--root-interactive-default)",
    "variable": "var(--shadows--card--root-interactive-default)"
  },
  "shadows.Card.Root.interactive.hover": {
    "value": "var(--shadows--card--root-interactive-hover)",
    "variable": "var(--shadows--card--root-interactive-hover)"
  },
  "shadows.Card.Root.interactive.pressed": {
    "value": "var(--shadows--card--root-interactive-pressed)",
    "variable": "var(--shadows--card--root-interactive-pressed)"
  },
  "shadows.Chip.elevated.default": {
    "value": "var(--shadows--chip-elevated-default)",
    "variable": "var(--shadows--chip-elevated-default)"
  },
  "shadows.Chip.elevated.hover": {
    "value": "var(--shadows--chip-elevated-hover)",
    "variable": "var(--shadows--chip-elevated-hover)"
  },
  "shadows.Chip.elevated.pressed": {
    "value": "var(--shadows--chip-elevated-pressed)",
    "variable": "var(--shadows--chip-elevated-pressed)"
  },
  "shadows.Chip.elevated.disabled": {
    "value": "var(--shadows--chip-elevated-disabled)",
    "variable": "var(--shadows--chip-elevated-disabled)"
  },
  "shadows.Combobox.Content": {
    "value": "var(--shadows--combobox--content)",
    "variable": "var(--shadows--combobox--content)"
  },
  "shadows.DatePicker.Content": {
    "value": "var(--shadows--date-picker--content)",
    "variable": "var(--shadows--date-picker--content)"
  },
  "shadows.Dropdown.Content": {
    "value": "var(--shadows--dropdown--content)",
    "variable": "var(--shadows--dropdown--content)"
  },
  "shadows.Menu.Content": {
    "value": "var(--shadows--menu--content)",
    "variable": "var(--shadows--menu--content)"
  },
  "shadows.Modal.Content": {
    "value": "var(--shadows--modal--content)",
    "variable": "var(--shadows--modal--content)"
  },
  "shadows.PhotoCarousel.NavControls": {
    "value": "var(--shadows--photo-carousel--nav-controls)",
    "variable": "var(--shadows--photo-carousel--nav-controls)"
  },
  "shadows.Popover.Content": {
    "value": "var(--shadows--popover--content)",
    "variable": "var(--shadows--popover--content)"
  },
  "shadows.PropertyCard.Body.default": {
    "value": "var(--shadows--property-card--body-default)",
    "variable": "var(--shadows--property-card--body-default)"
  },
  "shadows.PropertyCard.Body.hover": {
    "value": "var(--shadows--property-card--body-hover)",
    "variable": "var(--shadows--property-card--body-hover)"
  },
  "shadows.PropertyCard.Body.pressed": {
    "value": "var(--shadows--property-card--body-pressed)",
    "variable": "var(--shadows--property-card--body-pressed)"
  },
  "shadows.PropertyCard.SaveButton.default": {
    "value": "var(--shadows--property-card--save-button-default)",
    "variable": "var(--shadows--property-card--save-button-default)"
  },
  "shadows.PropertyCard.SaveButton.hover": {
    "value": "var(--shadows--property-card--save-button-hover)",
    "variable": "var(--shadows--property-card--save-button-hover)"
  },
  "shadows.PropertyCard.SaveButton.pressed": {
    "value": "var(--shadows--property-card--save-button-pressed)",
    "variable": "var(--shadows--property-card--save-button-pressed)"
  },
  "shadows.PropertyCard.SaveButton.selected": {
    "value": "var(--shadows--property-card--save-button-selected)",
    "variable": "var(--shadows--property-card--save-button-selected)"
  },
  "shadows.PropertyCard.SaveButton.selectedHover": {
    "value": "var(--shadows--property-card--save-button-selected-hover)",
    "variable": "var(--shadows--property-card--save-button-selected-hover)"
  },
  "shadows.PropertyCard.SaveButton.selectedPressed": {
    "value": "var(--shadows--property-card--save-button-selected-pressed)",
    "variable": "var(--shadows--property-card--save-button-selected-pressed)"
  },
  "shadows.Range.Handle.default": {
    "value": "var(--shadows--range--handle-default)",
    "variable": "var(--shadows--range--handle-default)"
  },
  "shadows.Range.Handle.hover": {
    "value": "var(--shadows--range--handle-hover)",
    "variable": "var(--shadows--range--handle-hover)"
  },
  "shadows.Range.Handle.pressed": {
    "value": "var(--shadows--range--handle-pressed)",
    "variable": "var(--shadows--range--handle-pressed)"
  },
  "shadows.Slider.Handle.default": {
    "value": "var(--shadows--slider--handle-default)",
    "variable": "var(--shadows--slider--handle-default)"
  },
  "shadows.Slider.Handle.hover": {
    "value": "var(--shadows--slider--handle-hover)",
    "variable": "var(--shadows--slider--handle-hover)"
  },
  "shadows.Slider.Handle.pressed": {
    "value": "var(--shadows--slider--handle-pressed)",
    "variable": "var(--shadows--slider--handle-pressed)"
  },
  "shadows.Toast": {
    "value": "var(--shadows--toast)",
    "variable": "var(--shadows--toast)"
  },
  "shadows.ToggleCard.Root.default": {
    "value": "var(--shadows--toggle-card--root-default)",
    "variable": "var(--shadows--toggle-card--root-default)"
  },
  "shadows.ToggleCard.Root.hover": {
    "value": "var(--shadows--toggle-card--root-hover)",
    "variable": "var(--shadows--toggle-card--root-hover)"
  },
  "shadows.ToggleCard.Root.pressed": {
    "value": "var(--shadows--toggle-card--root-pressed)",
    "variable": "var(--shadows--toggle-card--root-pressed)"
  },
  "shadows.Tooltip": {
    "value": "var(--shadows--tooltip)",
    "variable": "var(--shadows--tooltip)"
  },
  "shadows.Upsell.Root": {
    "value": "var(--shadows--upsell--root)",
    "variable": "var(--shadows--upsell--root)"
  },
  "shadows.VerticalNav.Root.elevated": {
    "value": "var(--shadows--vertical-nav--root-elevated)",
    "variable": "var(--shadows--vertical-nav--root-elevated)"
  },
  "transitions.Combobox.OptionMedia.control": {
    "value": "var(--transitions--combobox--option-media-control)",
    "variable": "var(--transitions--combobox--option-media-control)"
  },
  "transitions.Combobox.Option": {
    "value": "var(--transitions--combobox--option)",
    "variable": "var(--transitions--combobox--option)"
  },
  "transitions.LabeledInput.Input": {
    "value": "var(--transitions--labeled-input--input)",
    "variable": "var(--transitions--labeled-input--input)"
  },
  "transitions.LabeledInput.Label": {
    "value": "var(--transitions--labeled-input--label)",
    "variable": "var(--transitions--labeled-input--label)"
  },
  "transitions.PhotoCarousel.Dot": {
    "value": "var(--transitions--photo-carousel--dot)",
    "variable": "var(--transitions--photo-carousel--dot)"
  },
  "transitions.PhotoCarousel.NavControls": {
    "value": "var(--transitions--photo-carousel--nav-controls)",
    "variable": "var(--transitions--photo-carousel--nav-controls)"
  },
  "transitions.PhotoCarousel.Slide": {
    "value": "var(--transitions--photo-carousel--slide)",
    "variable": "var(--transitions--photo-carousel--slide)"
  },
  "transitions.ProgressIndicator.bar": {
    "value": "var(--transitions--progress-indicator-bar)",
    "variable": "var(--transitions--progress-indicator-bar)"
  },
  "transitions.ProgressMeter.Node.focusRing": {
    "value": "var(--transitions--progress-meter--node-focus-ring)",
    "variable": "var(--transitions--progress-meter--node-focus-ring)"
  },
  "transitions.PropertyCard.Body": {
    "value": "var(--transitions--property-card--body)",
    "variable": "var(--transitions--property-card--body)"
  },
  "transitions.Switch.Track": {
    "value": "var(--transitions--switch--track)",
    "variable": "var(--transitions--switch--track)"
  },
  "transitions.Switch.Handle": {
    "value": "var(--transitions--switch--handle)",
    "variable": "var(--transitions--switch--handle)"
  },
  "opacity.Modal.Backdrop": {
    "value": "var(--opacity--modal--backdrop)",
    "variable": "var(--opacity--modal--backdrop)"
  },
  "opacity.Popover.Backdrop": {
    "value": "var(--opacity--popover--backdrop)",
    "variable": "var(--opacity--popover--backdrop)"
  },
  "opacity.ProgressMeter.Node.focusRing": {
    "value": "var(--opacity--progress-meter--node-focus-ring)",
    "variable": "var(--opacity--progress-meter--node-focus-ring)"
  },
  "opacity.invisible": {
    "value": "var(--opacity-invisible)",
    "variable": "var(--opacity-invisible)"
  },
  "opacity.disabled": {
    "value": "var(--opacity-disabled)",
    "variable": "var(--opacity-disabled)"
  },
  "opacity.dialogScrim": {
    "value": "var(--opacity-dialog-scrim)",
    "variable": "var(--opacity-dialog-scrim)"
  },
  "opacity.loadingMask": {
    "value": "var(--opacity-loading-mask)",
    "variable": "var(--opacity-loading-mask)"
  },
  "opacity.action.default": {
    "value": "var(--opacity-action-default)",
    "variable": "var(--opacity-action-default)"
  },
  "opacity.action.hover": {
    "value": "var(--opacity-action-hover)",
    "variable": "var(--opacity-action-hover)"
  },
  "opacity.action.pressed": {
    "value": "var(--opacity-action-pressed)",
    "variable": "var(--opacity-action-pressed)"
  },
  "opacity.action.active": {
    "value": "var(--opacity-action-active)",
    "variable": "var(--opacity-action-active)"
  },
  "opacity.action.focus": {
    "value": "var(--opacity-action-focus)",
    "variable": "var(--opacity-action-focus)"
  },
  "opacity.action.disabled": {
    "value": "var(--opacity-action-disabled)",
    "variable": "var(--opacity-action-disabled)"
  },
  "opacity.opacity100": {
    "value": "var(--opacity-opacity100)",
    "variable": "var(--opacity-opacity100)"
  },
  "opacity.opacity200": {
    "value": "var(--opacity-opacity200)",
    "variable": "var(--opacity-opacity200)"
  },
  "opacity.opacity300": {
    "value": "var(--opacity-opacity300)",
    "variable": "var(--opacity-opacity300)"
  },
  "opacity.opacity400": {
    "value": "var(--opacity-opacity400)",
    "variable": "var(--opacity-opacity400)"
  },
  "opacity.opacity500": {
    "value": "var(--opacity-opacity500)",
    "variable": "var(--opacity-opacity500)"
  },
  "opacity.mask": {
    "value": "var(--opacity-mask)",
    "variable": "var(--opacity-mask)"
  },
  "fonts.Page.Header.default": {
    "value": "var(--fonts--page--header-default)",
    "variable": "var(--fonts--page--header-default)"
  },
  "fonts.heading": {
    "value": "var(--fonts-heading)",
    "variable": "var(--fonts-heading)"
  },
  "fonts.heading-alt": {
    "value": "var(--fonts-heading-alt)",
    "variable": "var(--fonts-heading-alt)"
  },
  "fonts.default": {
    "value": "var(--fonts-default)",
    "variable": "var(--fonts-default)"
  },
  "fonts.sansSerif": {
    "value": "var(--fonts-sans-serif)",
    "variable": "var(--fonts-sans-serif)"
  },
  "fonts.serif": {
    "value": "var(--fonts-serif)",
    "variable": "var(--fonts-serif)"
  },
  "lineHeights.ProgressMeter.Label.default": {
    "value": "var(--line-heights--progress-meter--label-default)",
    "variable": "var(--line-heights--progress-meter--label-default)"
  },
  "lineHeights.heading-xl": {
    "value": "var(--line-heights-heading-xl)",
    "variable": "var(--line-heights-heading-xl)"
  },
  "lineHeights.heading-lg": {
    "value": "var(--line-heights-heading-lg)",
    "variable": "var(--line-heights-heading-lg)"
  },
  "lineHeights.heading-md": {
    "value": "var(--line-heights-heading-md)",
    "variable": "var(--line-heights-heading-md)"
  },
  "lineHeights.heading-sm": {
    "value": "var(--line-heights-heading-sm)",
    "variable": "var(--line-heights-heading-sm)"
  },
  "lineHeights.heading-xs": {
    "value": "var(--line-heights-heading-xs)",
    "variable": "var(--line-heights-heading-xs)"
  },
  "lineHeights.body-lg": {
    "value": "var(--line-heights-body-lg)",
    "variable": "var(--line-heights-body-lg)"
  },
  "lineHeights.body": {
    "value": "var(--line-heights-body)",
    "variable": "var(--line-heights-body)"
  },
  "lineHeights.body-sm": {
    "value": "var(--line-heights-body-sm)",
    "variable": "var(--line-heights-body-sm)"
  },
  "lineHeights.body-xs": {
    "value": "var(--line-heights-body-xs)",
    "variable": "var(--line-heights-body-xs)"
  },
  "lineHeights.fineprint": {
    "value": "var(--line-heights-fineprint)",
    "variable": "var(--line-heights-fineprint)"
  },
  "lineHeights.fineprint-sm": {
    "value": "var(--line-heights-fineprint-sm)",
    "variable": "var(--line-heights-fineprint-sm)"
  },
  "lineHeights.responsive.heading-xl.mobile": {
    "value": "var(--line-heights-responsive-heading-xl-mobile)",
    "variable": "var(--line-heights-responsive-heading-xl-mobile)"
  },
  "lineHeights.responsive.heading-xl.tablet": {
    "value": "var(--line-heights-responsive-heading-xl-tablet)",
    "variable": "var(--line-heights-responsive-heading-xl-tablet)"
  },
  "lineHeights.responsive.heading-xl.desktop": {
    "value": "var(--line-heights-responsive-heading-xl-desktop)",
    "variable": "var(--line-heights-responsive-heading-xl-desktop)"
  },
  "lineHeights.responsive.heading-lg.mobile": {
    "value": "var(--line-heights-responsive-heading-lg-mobile)",
    "variable": "var(--line-heights-responsive-heading-lg-mobile)"
  },
  "lineHeights.responsive.heading-lg.tablet": {
    "value": "var(--line-heights-responsive-heading-lg-tablet)",
    "variable": "var(--line-heights-responsive-heading-lg-tablet)"
  },
  "lineHeights.responsive.heading-lg.desktop": {
    "value": "var(--line-heights-responsive-heading-lg-desktop)",
    "variable": "var(--line-heights-responsive-heading-lg-desktop)"
  },
  "lineHeights.responsive.heading-md.mobile": {
    "value": "var(--line-heights-responsive-heading-md-mobile)",
    "variable": "var(--line-heights-responsive-heading-md-mobile)"
  },
  "lineHeights.responsive.heading-md.tablet": {
    "value": "var(--line-heights-responsive-heading-md-tablet)",
    "variable": "var(--line-heights-responsive-heading-md-tablet)"
  },
  "lineHeights.responsive.heading-md.desktop": {
    "value": "var(--line-heights-responsive-heading-md-desktop)",
    "variable": "var(--line-heights-responsive-heading-md-desktop)"
  },
  "lineHeights.responsive.heading-sm.mobile": {
    "value": "var(--line-heights-responsive-heading-sm-mobile)",
    "variable": "var(--line-heights-responsive-heading-sm-mobile)"
  },
  "lineHeights.responsive.heading-sm.tablet": {
    "value": "var(--line-heights-responsive-heading-sm-tablet)",
    "variable": "var(--line-heights-responsive-heading-sm-tablet)"
  },
  "lineHeights.responsive.heading-sm.desktop": {
    "value": "var(--line-heights-responsive-heading-sm-desktop)",
    "variable": "var(--line-heights-responsive-heading-sm-desktop)"
  },
  "lineHeights.responsive.heading-xs.mobile": {
    "value": "var(--line-heights-responsive-heading-xs-mobile)",
    "variable": "var(--line-heights-responsive-heading-xs-mobile)"
  },
  "lineHeights.responsive.heading-xs.tablet": {
    "value": "var(--line-heights-responsive-heading-xs-tablet)",
    "variable": "var(--line-heights-responsive-heading-xs-tablet)"
  },
  "lineHeights.responsive.heading-xs.desktop": {
    "value": "var(--line-heights-responsive-heading-xs-desktop)",
    "variable": "var(--line-heights-responsive-heading-xs-desktop)"
  },
  "lineHeights.responsive.body-lg.mobile": {
    "value": "var(--line-heights-responsive-body-lg-mobile)",
    "variable": "var(--line-heights-responsive-body-lg-mobile)"
  },
  "lineHeights.responsive.body-lg.tablet": {
    "value": "var(--line-heights-responsive-body-lg-tablet)",
    "variable": "var(--line-heights-responsive-body-lg-tablet)"
  },
  "lineHeights.responsive.body-lg.desktop": {
    "value": "var(--line-heights-responsive-body-lg-desktop)",
    "variable": "var(--line-heights-responsive-body-lg-desktop)"
  },
  "lineHeights.responsive.body.mobile": {
    "value": "var(--line-heights-responsive-body-mobile)",
    "variable": "var(--line-heights-responsive-body-mobile)"
  },
  "lineHeights.responsive.body.tablet": {
    "value": "var(--line-heights-responsive-body-tablet)",
    "variable": "var(--line-heights-responsive-body-tablet)"
  },
  "lineHeights.responsive.body.desktop": {
    "value": "var(--line-heights-responsive-body-desktop)",
    "variable": "var(--line-heights-responsive-body-desktop)"
  },
  "lineHeights.responsive.body-sm.mobile": {
    "value": "var(--line-heights-responsive-body-sm-mobile)",
    "variable": "var(--line-heights-responsive-body-sm-mobile)"
  },
  "lineHeights.responsive.body-sm.tablet": {
    "value": "var(--line-heights-responsive-body-sm-tablet)",
    "variable": "var(--line-heights-responsive-body-sm-tablet)"
  },
  "lineHeights.responsive.body-sm.desktop": {
    "value": "var(--line-heights-responsive-body-sm-desktop)",
    "variable": "var(--line-heights-responsive-body-sm-desktop)"
  },
  "lineHeights.responsive.body-xs.mobile": {
    "value": "var(--line-heights-responsive-body-xs-mobile)",
    "variable": "var(--line-heights-responsive-body-xs-mobile)"
  },
  "lineHeights.responsive.body-xs.tablet": {
    "value": "var(--line-heights-responsive-body-xs-tablet)",
    "variable": "var(--line-heights-responsive-body-xs-tablet)"
  },
  "lineHeights.responsive.body-xs.desktop": {
    "value": "var(--line-heights-responsive-body-xs-desktop)",
    "variable": "var(--line-heights-responsive-body-xs-desktop)"
  },
  "lineHeights.responsive.fineprint.mobile": {
    "value": "var(--line-heights-responsive-fineprint-mobile)",
    "variable": "var(--line-heights-responsive-fineprint-mobile)"
  },
  "lineHeights.responsive.fineprint.tablet": {
    "value": "var(--line-heights-responsive-fineprint-tablet)",
    "variable": "var(--line-heights-responsive-fineprint-tablet)"
  },
  "lineHeights.responsive.fineprint.desktop": {
    "value": "var(--line-heights-responsive-fineprint-desktop)",
    "variable": "var(--line-heights-responsive-fineprint-desktop)"
  },
  "lineHeights.responsive.fineprint-sm.mobile": {
    "value": "var(--line-heights-responsive-fineprint-sm-mobile)",
    "variable": "var(--line-heights-responsive-fineprint-sm-mobile)"
  },
  "lineHeights.responsive.fineprint-sm.tablet": {
    "value": "var(--line-heights-responsive-fineprint-sm-tablet)",
    "variable": "var(--line-heights-responsive-fineprint-sm-tablet)"
  },
  "lineHeights.responsive.fineprint-sm.desktop": {
    "value": "var(--line-heights-responsive-fineprint-sm-desktop)",
    "variable": "var(--line-heights-responsive-fineprint-sm-desktop)"
  },
  "lineHeights.h1": {
    "value": "var(--line-heights-h1)",
    "variable": "var(--line-heights-h1)"
  },
  "lineHeights.h2": {
    "value": "var(--line-heights-h2)",
    "variable": "var(--line-heights-h2)"
  },
  "lineHeights.h3": {
    "value": "var(--line-heights-h3)",
    "variable": "var(--line-heights-h3)"
  },
  "lineHeights.h4": {
    "value": "var(--line-heights-h4)",
    "variable": "var(--line-heights-h4)"
  },
  "lineHeights.h5": {
    "value": "var(--line-heights-h5)",
    "variable": "var(--line-heights-h5)"
  },
  "lineHeights.h6": {
    "value": "var(--line-heights-h6)",
    "variable": "var(--line-heights-h6)"
  },
  "lineHeights.bodyHeading": {
    "value": "var(--line-heights-body-heading)",
    "variable": "var(--line-heights-body-heading)"
  },
  "lineHeights.bodySmallHeading": {
    "value": "var(--line-heights-body-small-heading)",
    "variable": "var(--line-heights-body-small-heading)"
  },
  "lineHeights.bodySmall": {
    "value": "var(--line-heights-body-small)",
    "variable": "var(--line-heights-body-small)"
  },
  "lineHeights.finePrintHeading": {
    "value": "var(--line-heights-fine-print-heading)",
    "variable": "var(--line-heights-fine-print-heading)"
  },
  "lineHeights.legal": {
    "value": "var(--line-heights-legal)",
    "variable": "var(--line-heights-legal)"
  },
  "translate.Switch.Handle.md.x": {
    "value": "var(--translate--switch--handle-md-x)",
    "variable": "var(--translate--switch--handle-md-x)"
  },
  "translate.Switch.Handle.lg.x": {
    "value": "var(--translate--switch--handle-lg-x)",
    "variable": "var(--translate--switch--handle-lg-x)"
  },
  "fontWeights.VerticalNav.Item.active": {
    "value": "var(--font-weights--vertical-nav--item-active)",
    "variable": "var(--font-weights--vertical-nav--item-active)"
  },
  "fontWeights.h0": {
    "value": "var(--font-weights-h0)",
    "variable": "var(--font-weights-h0)"
  },
  "fontWeights.h1": {
    "value": "var(--font-weights-h1)",
    "variable": "var(--font-weights-h1)"
  },
  "fontWeights.h2": {
    "value": "var(--font-weights-h2)",
    "variable": "var(--font-weights-h2)"
  },
  "fontWeights.h3": {
    "value": "var(--font-weights-h3)",
    "variable": "var(--font-weights-h3)"
  },
  "fontWeights.h4": {
    "value": "var(--font-weights-h4)",
    "variable": "var(--font-weights-h4)"
  },
  "fontWeights.h5": {
    "value": "var(--font-weights-h5)",
    "variable": "var(--font-weights-h5)"
  },
  "fontWeights.h6": {
    "value": "var(--font-weights-h6)",
    "variable": "var(--font-weights-h6)"
  },
  "fontWeights.bodyHeading": {
    "value": "var(--font-weights-body-heading)",
    "variable": "var(--font-weights-body-heading)"
  },
  "fontWeights.bodySmallHeading": {
    "value": "var(--font-weights-body-small-heading)",
    "variable": "var(--font-weights-body-small-heading)"
  },
  "fontWeights.bodySmall": {
    "value": "var(--font-weights-body-small)",
    "variable": "var(--font-weights-body-small)"
  },
  "fontWeights.finePrintHeading": {
    "value": "var(--font-weights-fine-print-heading)",
    "variable": "var(--font-weights-fine-print-heading)"
  },
  "fontWeights.legal": {
    "value": "var(--font-weights-legal)",
    "variable": "var(--font-weights-legal)"
  },
  "fontSizes.heading-xl": {
    "value": "var(--font-sizes-heading-xl)",
    "variable": "var(--font-sizes-heading-xl)"
  },
  "fontSizes.heading-lg": {
    "value": "var(--font-sizes-heading-lg)",
    "variable": "var(--font-sizes-heading-lg)"
  },
  "fontSizes.heading-md": {
    "value": "var(--font-sizes-heading-md)",
    "variable": "var(--font-sizes-heading-md)"
  },
  "fontSizes.heading-sm": {
    "value": "var(--font-sizes-heading-sm)",
    "variable": "var(--font-sizes-heading-sm)"
  },
  "fontSizes.heading-xs": {
    "value": "var(--font-sizes-heading-xs)",
    "variable": "var(--font-sizes-heading-xs)"
  },
  "fontSizes.body-lg": {
    "value": "var(--font-sizes-body-lg)",
    "variable": "var(--font-sizes-body-lg)"
  },
  "fontSizes.body": {
    "value": "var(--font-sizes-body)",
    "variable": "var(--font-sizes-body)"
  },
  "fontSizes.body-sm": {
    "value": "var(--font-sizes-body-sm)",
    "variable": "var(--font-sizes-body-sm)"
  },
  "fontSizes.body-xs": {
    "value": "var(--font-sizes-body-xs)",
    "variable": "var(--font-sizes-body-xs)"
  },
  "fontSizes.fineprint": {
    "value": "var(--font-sizes-fineprint)",
    "variable": "var(--font-sizes-fineprint)"
  },
  "fontSizes.fineprint-sm": {
    "value": "var(--font-sizes-fineprint-sm)",
    "variable": "var(--font-sizes-fineprint-sm)"
  },
  "fontSizes.responsive.heading-xl.mobile": {
    "value": "var(--font-sizes-responsive-heading-xl-mobile)",
    "variable": "var(--font-sizes-responsive-heading-xl-mobile)"
  },
  "fontSizes.responsive.heading-xl.tablet": {
    "value": "var(--font-sizes-responsive-heading-xl-tablet)",
    "variable": "var(--font-sizes-responsive-heading-xl-tablet)"
  },
  "fontSizes.responsive.heading-xl.desktop": {
    "value": "var(--font-sizes-responsive-heading-xl-desktop)",
    "variable": "var(--font-sizes-responsive-heading-xl-desktop)"
  },
  "fontSizes.responsive.heading-lg.mobile": {
    "value": "var(--font-sizes-responsive-heading-lg-mobile)",
    "variable": "var(--font-sizes-responsive-heading-lg-mobile)"
  },
  "fontSizes.responsive.heading-lg.tablet": {
    "value": "var(--font-sizes-responsive-heading-lg-tablet)",
    "variable": "var(--font-sizes-responsive-heading-lg-tablet)"
  },
  "fontSizes.responsive.heading-lg.desktop": {
    "value": "var(--font-sizes-responsive-heading-lg-desktop)",
    "variable": "var(--font-sizes-responsive-heading-lg-desktop)"
  },
  "fontSizes.responsive.heading-md.mobile": {
    "value": "var(--font-sizes-responsive-heading-md-mobile)",
    "variable": "var(--font-sizes-responsive-heading-md-mobile)"
  },
  "fontSizes.responsive.heading-md.tablet": {
    "value": "var(--font-sizes-responsive-heading-md-tablet)",
    "variable": "var(--font-sizes-responsive-heading-md-tablet)"
  },
  "fontSizes.responsive.heading-md.desktop": {
    "value": "var(--font-sizes-responsive-heading-md-desktop)",
    "variable": "var(--font-sizes-responsive-heading-md-desktop)"
  },
  "fontSizes.responsive.heading-sm.mobile": {
    "value": "var(--font-sizes-responsive-heading-sm-mobile)",
    "variable": "var(--font-sizes-responsive-heading-sm-mobile)"
  },
  "fontSizes.responsive.heading-sm.tablet": {
    "value": "var(--font-sizes-responsive-heading-sm-tablet)",
    "variable": "var(--font-sizes-responsive-heading-sm-tablet)"
  },
  "fontSizes.responsive.heading-sm.desktop": {
    "value": "var(--font-sizes-responsive-heading-sm-desktop)",
    "variable": "var(--font-sizes-responsive-heading-sm-desktop)"
  },
  "fontSizes.responsive.heading-xs.mobile": {
    "value": "var(--font-sizes-responsive-heading-xs-mobile)",
    "variable": "var(--font-sizes-responsive-heading-xs-mobile)"
  },
  "fontSizes.responsive.heading-xs.tablet": {
    "value": "var(--font-sizes-responsive-heading-xs-tablet)",
    "variable": "var(--font-sizes-responsive-heading-xs-tablet)"
  },
  "fontSizes.responsive.heading-xs.desktop": {
    "value": "var(--font-sizes-responsive-heading-xs-desktop)",
    "variable": "var(--font-sizes-responsive-heading-xs-desktop)"
  },
  "fontSizes.responsive.body-lg.mobile": {
    "value": "var(--font-sizes-responsive-body-lg-mobile)",
    "variable": "var(--font-sizes-responsive-body-lg-mobile)"
  },
  "fontSizes.responsive.body-lg.tablet": {
    "value": "var(--font-sizes-responsive-body-lg-tablet)",
    "variable": "var(--font-sizes-responsive-body-lg-tablet)"
  },
  "fontSizes.responsive.body-lg.desktop": {
    "value": "var(--font-sizes-responsive-body-lg-desktop)",
    "variable": "var(--font-sizes-responsive-body-lg-desktop)"
  },
  "fontSizes.responsive.body.mobile": {
    "value": "var(--font-sizes-responsive-body-mobile)",
    "variable": "var(--font-sizes-responsive-body-mobile)"
  },
  "fontSizes.responsive.body.tablet": {
    "value": "var(--font-sizes-responsive-body-tablet)",
    "variable": "var(--font-sizes-responsive-body-tablet)"
  },
  "fontSizes.responsive.body.desktop": {
    "value": "var(--font-sizes-responsive-body-desktop)",
    "variable": "var(--font-sizes-responsive-body-desktop)"
  },
  "fontSizes.responsive.body-sm.mobile": {
    "value": "var(--font-sizes-responsive-body-sm-mobile)",
    "variable": "var(--font-sizes-responsive-body-sm-mobile)"
  },
  "fontSizes.responsive.body-sm.tablet": {
    "value": "var(--font-sizes-responsive-body-sm-tablet)",
    "variable": "var(--font-sizes-responsive-body-sm-tablet)"
  },
  "fontSizes.responsive.body-sm.desktop": {
    "value": "var(--font-sizes-responsive-body-sm-desktop)",
    "variable": "var(--font-sizes-responsive-body-sm-desktop)"
  },
  "fontSizes.responsive.body-xs.mobile": {
    "value": "var(--font-sizes-responsive-body-xs-mobile)",
    "variable": "var(--font-sizes-responsive-body-xs-mobile)"
  },
  "fontSizes.responsive.body-xs.tablet": {
    "value": "var(--font-sizes-responsive-body-xs-tablet)",
    "variable": "var(--font-sizes-responsive-body-xs-tablet)"
  },
  "fontSizes.responsive.body-xs.desktop": {
    "value": "var(--font-sizes-responsive-body-xs-desktop)",
    "variable": "var(--font-sizes-responsive-body-xs-desktop)"
  },
  "fontSizes.responsive.fineprint.mobile": {
    "value": "var(--font-sizes-responsive-fineprint-mobile)",
    "variable": "var(--font-sizes-responsive-fineprint-mobile)"
  },
  "fontSizes.responsive.fineprint.tablet": {
    "value": "var(--font-sizes-responsive-fineprint-tablet)",
    "variable": "var(--font-sizes-responsive-fineprint-tablet)"
  },
  "fontSizes.responsive.fineprint.desktop": {
    "value": "var(--font-sizes-responsive-fineprint-desktop)",
    "variable": "var(--font-sizes-responsive-fineprint-desktop)"
  },
  "fontSizes.responsive.fineprint-sm.mobile": {
    "value": "var(--font-sizes-responsive-fineprint-sm-mobile)",
    "variable": "var(--font-sizes-responsive-fineprint-sm-mobile)"
  },
  "fontSizes.responsive.fineprint-sm.tablet": {
    "value": "var(--font-sizes-responsive-fineprint-sm-tablet)",
    "variable": "var(--font-sizes-responsive-fineprint-sm-tablet)"
  },
  "fontSizes.responsive.fineprint-sm.desktop": {
    "value": "var(--font-sizes-responsive-fineprint-sm-desktop)",
    "variable": "var(--font-sizes-responsive-fineprint-sm-desktop)"
  },
  "fontSizes.h1": {
    "value": "var(--font-sizes-h1)",
    "variable": "var(--font-sizes-h1)"
  },
  "fontSizes.h2": {
    "value": "var(--font-sizes-h2)",
    "variable": "var(--font-sizes-h2)"
  },
  "fontSizes.h3": {
    "value": "var(--font-sizes-h3)",
    "variable": "var(--font-sizes-h3)"
  },
  "fontSizes.h4": {
    "value": "var(--font-sizes-h4)",
    "variable": "var(--font-sizes-h4)"
  },
  "fontSizes.h5": {
    "value": "var(--font-sizes-h5)",
    "variable": "var(--font-sizes-h5)"
  },
  "fontSizes.h6": {
    "value": "var(--font-sizes-h6)",
    "variable": "var(--font-sizes-h6)"
  },
  "fontSizes.bodyHeading": {
    "value": "var(--font-sizes-body-heading)",
    "variable": "var(--font-sizes-body-heading)"
  },
  "fontSizes.bodySmallHeading": {
    "value": "var(--font-sizes-body-small-heading)",
    "variable": "var(--font-sizes-body-small-heading)"
  },
  "fontSizes.bodySmall": {
    "value": "var(--font-sizes-body-small)",
    "variable": "var(--font-sizes-body-small)"
  },
  "fontSizes.finePrintHeading": {
    "value": "var(--font-sizes-fine-print-heading)",
    "variable": "var(--font-sizes-fine-print-heading)"
  },
  "fontSizes.legal": {
    "value": "var(--font-sizes-legal)",
    "variable": "var(--font-sizes-legal)"
  },
  "letterSpacings.heading-xl": {
    "value": "var(--letter-spacings-heading-xl)",
    "variable": "var(--letter-spacings-heading-xl)"
  },
  "letterSpacings.heading-lg": {
    "value": "var(--letter-spacings-heading-lg)",
    "variable": "var(--letter-spacings-heading-lg)"
  },
  "letterSpacings.heading-md": {
    "value": "var(--letter-spacings-heading-md)",
    "variable": "var(--letter-spacings-heading-md)"
  },
  "letterSpacings.heading-sm": {
    "value": "var(--letter-spacings-heading-sm)",
    "variable": "var(--letter-spacings-heading-sm)"
  },
  "letterSpacings.heading-xs": {
    "value": "var(--letter-spacings-heading-xs)",
    "variable": "var(--letter-spacings-heading-xs)"
  },
  "letterSpacings.body-lg": {
    "value": "var(--letter-spacings-body-lg)",
    "variable": "var(--letter-spacings-body-lg)"
  },
  "letterSpacings.body": {
    "value": "var(--letter-spacings-body)",
    "variable": "var(--letter-spacings-body)"
  },
  "letterSpacings.body-sm": {
    "value": "var(--letter-spacings-body-sm)",
    "variable": "var(--letter-spacings-body-sm)"
  },
  "letterSpacings.body-xs": {
    "value": "var(--letter-spacings-body-xs)",
    "variable": "var(--letter-spacings-body-xs)"
  },
  "letterSpacings.fineprint": {
    "value": "var(--letter-spacings-fineprint)",
    "variable": "var(--letter-spacings-fineprint)"
  },
  "letterSpacings.fineprint-sm": {
    "value": "var(--letter-spacings-fineprint-sm)",
    "variable": "var(--letter-spacings-fineprint-sm)"
  },
  "letterSpacings.responsive.heading-xl.mobile": {
    "value": "var(--letter-spacings-responsive-heading-xl-mobile)",
    "variable": "var(--letter-spacings-responsive-heading-xl-mobile)"
  },
  "letterSpacings.responsive.heading-xl.tablet": {
    "value": "var(--letter-spacings-responsive-heading-xl-tablet)",
    "variable": "var(--letter-spacings-responsive-heading-xl-tablet)"
  },
  "letterSpacings.responsive.heading-xl.desktop": {
    "value": "var(--letter-spacings-responsive-heading-xl-desktop)",
    "variable": "var(--letter-spacings-responsive-heading-xl-desktop)"
  },
  "letterSpacings.responsive.heading-lg.mobile": {
    "value": "var(--letter-spacings-responsive-heading-lg-mobile)",
    "variable": "var(--letter-spacings-responsive-heading-lg-mobile)"
  },
  "letterSpacings.responsive.heading-lg.tablet": {
    "value": "var(--letter-spacings-responsive-heading-lg-tablet)",
    "variable": "var(--letter-spacings-responsive-heading-lg-tablet)"
  },
  "letterSpacings.responsive.heading-lg.desktop": {
    "value": "var(--letter-spacings-responsive-heading-lg-desktop)",
    "variable": "var(--letter-spacings-responsive-heading-lg-desktop)"
  },
  "letterSpacings.responsive.heading-md.mobile": {
    "value": "var(--letter-spacings-responsive-heading-md-mobile)",
    "variable": "var(--letter-spacings-responsive-heading-md-mobile)"
  },
  "letterSpacings.responsive.heading-md.tablet": {
    "value": "var(--letter-spacings-responsive-heading-md-tablet)",
    "variable": "var(--letter-spacings-responsive-heading-md-tablet)"
  },
  "letterSpacings.responsive.heading-md.desktop": {
    "value": "var(--letter-spacings-responsive-heading-md-desktop)",
    "variable": "var(--letter-spacings-responsive-heading-md-desktop)"
  },
  "letterSpacings.responsive.heading-sm.mobile": {
    "value": "var(--letter-spacings-responsive-heading-sm-mobile)",
    "variable": "var(--letter-spacings-responsive-heading-sm-mobile)"
  },
  "letterSpacings.responsive.heading-sm.tablet": {
    "value": "var(--letter-spacings-responsive-heading-sm-tablet)",
    "variable": "var(--letter-spacings-responsive-heading-sm-tablet)"
  },
  "letterSpacings.responsive.heading-sm.desktop": {
    "value": "var(--letter-spacings-responsive-heading-sm-desktop)",
    "variable": "var(--letter-spacings-responsive-heading-sm-desktop)"
  },
  "letterSpacings.responsive.heading-xs.mobile": {
    "value": "var(--letter-spacings-responsive-heading-xs-mobile)",
    "variable": "var(--letter-spacings-responsive-heading-xs-mobile)"
  },
  "letterSpacings.responsive.heading-xs.tablet": {
    "value": "var(--letter-spacings-responsive-heading-xs-tablet)",
    "variable": "var(--letter-spacings-responsive-heading-xs-tablet)"
  },
  "letterSpacings.responsive.heading-xs.desktop": {
    "value": "var(--letter-spacings-responsive-heading-xs-desktop)",
    "variable": "var(--letter-spacings-responsive-heading-xs-desktop)"
  },
  "letterSpacings.responsive.body-lg.mobile": {
    "value": "var(--letter-spacings-responsive-body-lg-mobile)",
    "variable": "var(--letter-spacings-responsive-body-lg-mobile)"
  },
  "letterSpacings.responsive.body-lg.tablet": {
    "value": "var(--letter-spacings-responsive-body-lg-tablet)",
    "variable": "var(--letter-spacings-responsive-body-lg-tablet)"
  },
  "letterSpacings.responsive.body-lg.desktop": {
    "value": "var(--letter-spacings-responsive-body-lg-desktop)",
    "variable": "var(--letter-spacings-responsive-body-lg-desktop)"
  },
  "letterSpacings.responsive.body.mobile": {
    "value": "var(--letter-spacings-responsive-body-mobile)",
    "variable": "var(--letter-spacings-responsive-body-mobile)"
  },
  "letterSpacings.responsive.body.tablet": {
    "value": "var(--letter-spacings-responsive-body-tablet)",
    "variable": "var(--letter-spacings-responsive-body-tablet)"
  },
  "letterSpacings.responsive.body.desktop": {
    "value": "var(--letter-spacings-responsive-body-desktop)",
    "variable": "var(--letter-spacings-responsive-body-desktop)"
  },
  "letterSpacings.responsive.body-sm.mobile": {
    "value": "var(--letter-spacings-responsive-body-sm-mobile)",
    "variable": "var(--letter-spacings-responsive-body-sm-mobile)"
  },
  "letterSpacings.responsive.body-sm.tablet": {
    "value": "var(--letter-spacings-responsive-body-sm-tablet)",
    "variable": "var(--letter-spacings-responsive-body-sm-tablet)"
  },
  "letterSpacings.responsive.body-sm.desktop": {
    "value": "var(--letter-spacings-responsive-body-sm-desktop)",
    "variable": "var(--letter-spacings-responsive-body-sm-desktop)"
  },
  "letterSpacings.responsive.body-xs.mobile": {
    "value": "var(--letter-spacings-responsive-body-xs-mobile)",
    "variable": "var(--letter-spacings-responsive-body-xs-mobile)"
  },
  "letterSpacings.responsive.body-xs.tablet": {
    "value": "var(--letter-spacings-responsive-body-xs-tablet)",
    "variable": "var(--letter-spacings-responsive-body-xs-tablet)"
  },
  "letterSpacings.responsive.body-xs.desktop": {
    "value": "var(--letter-spacings-responsive-body-xs-desktop)",
    "variable": "var(--letter-spacings-responsive-body-xs-desktop)"
  },
  "letterSpacings.responsive.fineprint.mobile": {
    "value": "var(--letter-spacings-responsive-fineprint-mobile)",
    "variable": "var(--letter-spacings-responsive-fineprint-mobile)"
  },
  "letterSpacings.responsive.fineprint.tablet": {
    "value": "var(--letter-spacings-responsive-fineprint-tablet)",
    "variable": "var(--letter-spacings-responsive-fineprint-tablet)"
  },
  "letterSpacings.responsive.fineprint.desktop": {
    "value": "var(--letter-spacings-responsive-fineprint-desktop)",
    "variable": "var(--letter-spacings-responsive-fineprint-desktop)"
  },
  "letterSpacings.responsive.fineprint-sm.mobile": {
    "value": "var(--letter-spacings-responsive-fineprint-sm-mobile)",
    "variable": "var(--letter-spacings-responsive-fineprint-sm-mobile)"
  },
  "letterSpacings.responsive.fineprint-sm.tablet": {
    "value": "var(--letter-spacings-responsive-fineprint-sm-tablet)",
    "variable": "var(--letter-spacings-responsive-fineprint-sm-tablet)"
  },
  "letterSpacings.responsive.fineprint-sm.desktop": {
    "value": "var(--letter-spacings-responsive-fineprint-sm-desktop)",
    "variable": "var(--letter-spacings-responsive-fineprint-sm-desktop)"
  },
  "colors.border.action.disabled": {
    "value": "var(--colors-border-action-disabled)",
    "variable": "var(--colors-border-action-disabled)"
  },
  "colors.border.action.disabled-alt": {
    "value": "var(--colors-border-action-disabled-alt)",
    "variable": "var(--colors-border-action-disabled-alt)"
  },
  "colors.icon.onHero.link.fixed.default": {
    "value": "var(--colors-icon-on-hero-link-fixed-default)",
    "variable": "var(--colors-icon-on-hero-link-fixed-default)"
  },
  "colors.icon.onHero.link.fixed.hover": {
    "value": "var(--colors-icon-on-hero-link-fixed-hover)",
    "variable": "var(--colors-icon-on-hero-link-fixed-hover)"
  },
  "colors.icon.onHero.link.fixed.pressed": {
    "value": "var(--colors-icon-on-hero-link-fixed-pressed)",
    "variable": "var(--colors-icon-on-hero-link-fixed-pressed)"
  },
  "colors.icon.onImpact.express.energy.hero": {
    "value": "var(--colors-icon-on-impact-express-energy-hero)",
    "variable": "var(--colors-icon-on-impact-express-energy-hero)"
  },
  "colors.text.link.selected": {
    "value": "var(--colors-text-link-selected)",
    "variable": "var(--colors-text-link-selected)"
  },
  "colors.Accordion.Panel.icon.leading": {
    "value": "var(--colors--accordion--panel-icon-leading)",
    "variable": "var(--colors--accordion--panel-icon-leading)"
  },
  "colors.Accordion.Panel.icon.trailing": {
    "value": "var(--colors--accordion--panel-icon-trailing)",
    "variable": "var(--colors--accordion--panel-icon-trailing)"
  },
  "colors.Accordion.Panel.label.default": {
    "value": "var(--colors--accordion--panel-label-default)",
    "variable": "var(--colors--accordion--panel-label-default)"
  },
  "colors.Accordion.Panel.label.trailing": {
    "value": "var(--colors--accordion--panel-label-trailing)",
    "variable": "var(--colors--accordion--panel-label-trailing)"
  },
  "colors.Anchor.onImpact.active": {
    "value": "var(--colors--anchor-on-impact-active)",
    "variable": "var(--colors--anchor-on-impact-active)"
  },
  "colors.Button.onImpact.bare.neutral-fixed.bg.default": {
    "value": "var(--colors--button-on-impact-bare-neutral-fixed-bg-default)",
    "variable": "var(--colors--button-on-impact-bare-neutral-fixed-bg-default)"
  },
  "colors.Button.onImpact.bare.neutral-fixed.bg.hover": {
    "value": "var(--colors--button-on-impact-bare-neutral-fixed-bg-hover)",
    "variable": "var(--colors--button-on-impact-bare-neutral-fixed-bg-hover)"
  },
  "colors.Button.onImpact.bare.neutral-fixed.bg.pressed": {
    "value": "var(--colors--button-on-impact-bare-neutral-fixed-bg-pressed)",
    "variable": "var(--colors--button-on-impact-bare-neutral-fixed-bg-pressed)"
  },
  "colors.Button.onImpact.bare.neutral-fixed.label.default": {
    "value": "var(--colors--button-on-impact-bare-neutral-fixed-label-default)",
    "variable": "var(--colors--button-on-impact-bare-neutral-fixed-label-default)"
  },
  "colors.Button.onImpact.bare.neutral-fixed.label.hover": {
    "value": "var(--colors--button-on-impact-bare-neutral-fixed-label-hover)",
    "variable": "var(--colors--button-on-impact-bare-neutral-fixed-label-hover)"
  },
  "colors.Button.onImpact.bare.neutral-fixed.label.pressed": {
    "value": "var(--colors--button-on-impact-bare-neutral-fixed-label-pressed)",
    "variable": "var(--colors--button-on-impact-bare-neutral-fixed-label-pressed)"
  },
  "colors.Button.onImpact.bare.neutral-fixed.icon.default": {
    "value": "var(--colors--button-on-impact-bare-neutral-fixed-icon-default)",
    "variable": "var(--colors--button-on-impact-bare-neutral-fixed-icon-default)"
  },
  "colors.Button.onImpact.bare.neutral-fixed.icon.hover": {
    "value": "var(--colors--button-on-impact-bare-neutral-fixed-icon-hover)",
    "variable": "var(--colors--button-on-impact-bare-neutral-fixed-icon-hover)"
  },
  "colors.Button.onImpact.bare.neutral-fixed.icon.pressed": {
    "value": "var(--colors--button-on-impact-bare-neutral-fixed-icon-pressed)",
    "variable": "var(--colors--button-on-impact-bare-neutral-fixed-icon-pressed)"
  },
  "colors.Button.onImpact.bare.critical.bg.default": {
    "value": "var(--colors--button-on-impact-bare-critical-bg-default)",
    "variable": "var(--colors--button-on-impact-bare-critical-bg-default)"
  },
  "colors.DatePicker.InputGroup.bg.autofill": {
    "value": "var(--colors--date-picker--input-group-bg-autofill)",
    "variable": "var(--colors--date-picker--input-group-bg-autofill)"
  },
  "colors.DatePicker.InputGroup.text.adornment.default": {
    "value": "var(--colors--date-picker--input-group-text-adornment-default)",
    "variable": "var(--colors--date-picker--input-group-text-adornment-default)"
  },
  "colors.DatePicker.InputGroup.text.adornment.readOnly": {
    "value": "var(--colors--date-picker--input-group-text-adornment-read-only)",
    "variable": "var(--colors--date-picker--input-group-text-adornment-read-only)"
  },
  "colors.FieldSet.helperArea.icon.default": {
    "value": "var(--colors--field-set-helper-area-icon-default)",
    "variable": "var(--colors--field-set-helper-area-icon-default)"
  },
  "colors.FieldSet.helperArea.icon.error": {
    "value": "var(--colors--field-set-helper-area-icon-error)",
    "variable": "var(--colors--field-set-helper-area-icon-error)"
  },
  "colors.FieldSet.helperArea.text.default": {
    "value": "var(--colors--field-set-helper-area-text-default)",
    "variable": "var(--colors--field-set-helper-area-text-default)"
  },
  "colors.FieldSet.helperArea.text.error": {
    "value": "var(--colors--field-set-helper-area-text-error)",
    "variable": "var(--colors--field-set-helper-area-text-error)"
  },
  "colors.IconButton.onImpact.bare.critical.bg.default": {
    "value": "var(--colors--icon-button-on-impact-bare-critical-bg-default)",
    "variable": "var(--colors--icon-button-on-impact-bare-critical-bg-default)"
  },
  "colors.Input.border.readOnly": {
    "value": "var(--colors--input-border-read-only)",
    "variable": "var(--colors--input-border-read-only)"
  },
  "colors.ProgressIndicator.circular.track.bg.default": {
    "value": "var(--colors--progress-indicator-circular-track-bg-default)",
    "variable": "var(--colors--progress-indicator-circular-track-bg-default)"
  },
  "colors.ProgressIndicator.circular.track.bg.active": {
    "value": "var(--colors--progress-indicator-circular-track-bg-active)",
    "variable": "var(--colors--progress-indicator-circular-track-bg-active)"
  },
  "colors.ProgressIndicator.spinner.text.default": {
    "value": "var(--colors--progress-indicator-spinner-text-default)",
    "variable": "var(--colors--progress-indicator-spinner-text-default)"
  },
  "colors.ProgressIndicator.spinner.text.onImpact": {
    "value": "var(--colors--progress-indicator-spinner-text-on-impact)",
    "variable": "var(--colors--progress-indicator-spinner-text-on-impact)"
  },
  "colors.ProgressMeter.Node.complete.border": {
    "value": "var(--colors--progress-meter--node-complete-border)",
    "variable": "var(--colors--progress-meter--node-complete-border)"
  },
  "colors.ProgressMeter.Node.incomplete.border": {
    "value": "var(--colors--progress-meter--node-incomplete-border)",
    "variable": "var(--colors--progress-meter--node-incomplete-border)"
  },
  "colors.Range.Track.bg.active": {
    "value": "var(--colors--range--track-bg-active)",
    "variable": "var(--colors--range--track-bg-active)"
  },
  "colors.Range.Handle.bg.activeActive": {
    "value": "var(--colors--range--handle-bg-active-active)",
    "variable": "var(--colors--range--handle-bg-active-active)"
  },
  "colors.Range.Handle.border.activeActive": {
    "value": "var(--colors--range--handle-border-active-active)",
    "variable": "var(--colors--range--handle-border-active-active)"
  },
  "colors.Tabs.file.label.hover": {
    "value": "var(--colors--tabs-file-label-hover)",
    "variable": "var(--colors--tabs-file-label-hover)"
  },
  "colors.Tabs.file.label.pressed": {
    "value": "var(--colors--tabs-file-label-pressed)",
    "variable": "var(--colors--tabs-file-label-pressed)"
  },
  "colors.Tabs.file.label.active": {
    "value": "var(--colors--tabs-file-label-active)",
    "variable": "var(--colors--tabs-file-label-active)"
  },
  "colors.Tabs.file.icon.default": {
    "value": "var(--colors--tabs-file-icon-default)",
    "variable": "var(--colors--tabs-file-icon-default)"
  },
  "colors.Tabs.file.icon.hover": {
    "value": "var(--colors--tabs-file-icon-hover)",
    "variable": "var(--colors--tabs-file-icon-hover)"
  },
  "colors.Tabs.file.icon.pressed": {
    "value": "var(--colors--tabs-file-icon-pressed)",
    "variable": "var(--colors--tabs-file-icon-pressed)"
  },
  "colors.Tabs.file.icon.active": {
    "value": "var(--colors--tabs-file-icon-active)",
    "variable": "var(--colors--tabs-file-icon-active)"
  },
  "radii.Button.xs": {
    "value": "var(--radii--button-xs)",
    "variable": "var(--radii--button-xs)"
  },
  "spacing.Accordion.Header.gap.between-tags": {
    "value": "var(--spacing--accordion--header-gap-between-tags)",
    "variable": "var(--spacing--accordion--header-gap-between-tags)"
  },
  "spacing.Alert.gap.message-toFlexArea": {
    "value": "var(--spacing--alert-gap-message-to-flex-area)",
    "variable": "var(--spacing--alert-gap-message-to-flex-area)"
  },
  "spacing.ButtonGroup.textButton.padding.horz": {
    "value": "var(--spacing--button-group-text-button-padding-horz)",
    "variable": "var(--spacing--button-group-text-button-padding-horz)"
  },
  "spacing.ButtonGroup.textButton.padding.vert": {
    "value": "var(--spacing--button-group-text-button-padding-vert)",
    "variable": "var(--spacing--button-group-text-button-padding-vert)"
  },
  "spacing.FormField.HelperArea.gap.text-toCharCount": {
    "value": "var(--spacing--form-field--helper-area-gap-text-to-char-count)",
    "variable": "var(--spacing--form-field--helper-area-gap-text-to-char-count)"
  },
  "spacing.Input.sm.gap.input-toAdornment": {
    "value": "var(--spacing--input-sm-gap-input-to-adornment)",
    "variable": "var(--spacing--input-sm-gap-input-to-adornment)"
  },
  "spacing.Input.md.gap.input-toAdornment": {
    "value": "var(--spacing--input-md-gap-input-to-adornment)",
    "variable": "var(--spacing--input-md-gap-input-to-adornment)"
  },
  "spacing.Input.lg.gap.input-toAdornment": {
    "value": "var(--spacing--input-lg-gap-input-to-adornment)",
    "variable": "var(--spacing--input-lg-gap-input-to-adornment)"
  },
  "spacing.PropertyCard.DataWrapper.large.gap.dataArea1-toSupportRows": {
    "value": "var(--spacing--property-card--data-wrapper-large-gap-data-area1-to-support-rows)",
    "variable": "var(--spacing--property-card--data-wrapper-large-gap-data-area1-to-support-rows)"
  },
  "spacing.PropertyCard.DataWrapper.small.gap.dataArea1-toSupportRows": {
    "value": "var(--spacing--property-card--data-wrapper-small-gap-data-area1-to-support-rows)",
    "variable": "var(--spacing--property-card--data-wrapper-small-gap-data-area1-to-support-rows)"
  },
  "spacing.PropertyCard.DataWrapper.horizontal.gap.dataArea1-toSupportRows": {
    "value": "var(--spacing--property-card--data-wrapper-horizontal-gap-data-area1-to-support-rows)",
    "variable": "var(--spacing--property-card--data-wrapper-horizontal-gap-data-area1-to-support-rows)"
  },
  "sizes.DatePicker.Trigger.width": {
    "value": "var(--sizes--date-picker--trigger-width)",
    "variable": "var(--sizes--date-picker--trigger-width)"
  },
  "sizes.DatePicker.Trigger.height": {
    "value": "var(--sizes--date-picker--trigger-height)",
    "variable": "var(--sizes--date-picker--trigger-height)"
  },
  "sizes.FieldSet.helperArea.icon": {
    "value": "var(--sizes--field-set-helper-area-icon)",
    "variable": "var(--sizes--field-set-helper-area-icon)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar